import * as x from "react";
import vn, { forwardRef as Ba, useContext as ue, createContext as tr, useCallback as Gt, useState as _, useRef as Jt, useEffect as Te, useMemo as yr, createElement as ha } from "react";
import * as qd from "react-dom";
function Et(e) {
  if (e.__esModule) return e;
  var t = e.default;
  if (typeof t == "function") {
    var r = function n() {
      return this instanceof n ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Sl = { exports: {} }, fo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jd = vn, Wd = Symbol.for("react.element"), Ld = Symbol.for("react.fragment"), zd = Object.prototype.hasOwnProperty, Nd = Jd.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, Qd = { key: !0, ref: !0, __self: !0, __source: !0 };
function kl(e, t, r) {
  var n, o = {}, a = null, i = null;
  r !== void 0 && (a = "" + r), t.key !== void 0 && (a = "" + t.key), t.ref !== void 0 && (i = t.ref);
  for (n in t) zd.call(t, n) && !Qd.hasOwnProperty(n) && (o[n] = t[n]);
  if (e && e.defaultProps) for (n in t = e.defaultProps, t) o[n] === void 0 && (o[n] = t[n]);
  return { $$typeof: Wd, type: e, key: a, ref: i, props: o, _owner: Nd.current };
}
fo.Fragment = Ld;
fo.jsx = kl;
fo.jsxs = kl;
Sl.exports = fo;
var c = Sl.exports;
const Wr = {
  grey: {
    50: "#FBFCFE",
    100: "#F0F4F8",
    200: "#DDE7EE",
    300: "#CDD7E1",
    400: "#9FA6AD",
    500: "#636B74",
    600: "#555E68",
    700: "#32383E",
    800: "#171A1C",
    900: "#0B0D0E"
  },
  blue: {
    50: "#EDF5FD",
    100: "#E3EFFB",
    200: "#C7DFF7",
    300: "#97C3F0",
    400: "#4393E4",
    500: "#0B6BCB",
    600: "#185EA5",
    700: "#12467B",
    800: "#0A2744",
    900: "#051423"
  },
  yellow: {
    50: "#FEFAF6",
    100: "#FDF0E1",
    200: "#FCE1C2",
    300: "#F3C896",
    400: "#EA9A3E",
    500: "#9A5B13",
    600: "#72430D",
    700: "#492B08",
    800: "#2E1B05",
    900: "#1D1002"
  },
  red: {
    50: "#FEF6F6",
    100: "#FCE4E4",
    200: "#F7C5C5",
    300: "#F09898",
    400: "#E47474",
    500: "#C41C1C",
    600: "#A51818",
    700: "#7D1212",
    800: "#430A0A",
    900: "#240505"
  },
  green: {
    50: "#F6FEF6",
    100: "#E3FBE3",
    200: "#C7F7C7",
    300: "#A1E8A1",
    400: "#51BC51",
    500: "#1F7A1F",
    600: "#136C13",
    700: "#0A470A",
    800: "#042F04",
    900: "#021D02"
  }
}, bn = "$$joy";
function jt(e) {
  let t = "https://mui.com/production-error/?code=" + e;
  for (let r = 1; r < arguments.length; r += 1)
    t += "&args[]=" + encodeURIComponent(arguments[r]);
  return "Minified MUI error #" + e + "; visit " + t + " for the full message.";
}
const Hd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: jt
}, Symbol.toStringTag, { value: "Module" }));
function y() {
  return y = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) ({}).hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, y.apply(null, arguments);
}
const Gd = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get default() {
    return y;
  }
}, Symbol.toStringTag, { value: "Module" }));
function Zd(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Yd(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Xd = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(o) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, a), n.tags.push(o);
    }, this.isSpeedy = r.speedy === void 0 ? !0 : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Yd(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = Zd(o);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var o;
      return (o = n.parentNode) == null ? void 0 : o.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Xe = "-ms-", _n = "-moz-", pe = "-webkit-", Il = "comm", Da = "rule", Ma = "decl", $d = "@import", wl = "@keyframes", _d = "@layer", eu = Math.abs, go = String.fromCharCode, tu = Object.assign;
function ru(e, t) {
  return Le(e, 0) ^ 45 ? (((t << 2 ^ Le(e, 0)) << 2 ^ Le(e, 1)) << 2 ^ Le(e, 2)) << 2 ^ Le(e, 3) : 0;
}
function Pl(e) {
  return e.trim();
}
function nu(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function fe(e, t, r) {
  return e.replace(t, r);
}
function ma(e, t) {
  return e.indexOf(t);
}
function Le(e, t) {
  return e.charCodeAt(t) | 0;
}
function an(e, t, r) {
  return e.slice(t, r);
}
function It(e) {
  return e.length;
}
function Fa(e) {
  return e.length;
}
function jn(e, t) {
  return t.push(e), e;
}
function ou(e, t) {
  return e.map(t).join("");
}
var ho = 1, Ar = 1, Tl = 0, rt = 0, Re = 0, Vr = "";
function mo(e, t, r, n, o, a, i) {
  return { value: e, root: t, parent: r, type: n, props: o, children: a, line: ho, column: Ar, length: i, return: "" };
}
function Lr(e, t) {
  return tu(mo("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function au() {
  return Re;
}
function iu() {
  return Re = rt > 0 ? Le(Vr, --rt) : 0, Ar--, Re === 10 && (Ar = 1, ho--), Re;
}
function it() {
  return Re = rt < Tl ? Le(Vr, rt++) : 0, Ar++, Re === 10 && (Ar = 1, ho++), Re;
}
function Tt() {
  return Le(Vr, rt);
}
function Nn() {
  return rt;
}
function xn(e, t) {
  return an(Vr, e, t);
}
function sn(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function Ol(e) {
  return ho = Ar = 1, Tl = It(Vr = e), rt = 0, [];
}
function Vl(e) {
  return Vr = "", e;
}
function Qn(e) {
  return Pl(xn(rt - 1, va(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function su(e) {
  for (; (Re = Tt()) && Re < 33; )
    it();
  return sn(e) > 2 || sn(Re) > 3 ? "" : " ";
}
function lu(e, t) {
  for (; --t && it() && !(Re < 48 || Re > 102 || Re > 57 && Re < 65 || Re > 70 && Re < 97); )
    ;
  return xn(e, Nn() + (t < 6 && Tt() == 32 && it() == 32));
}
function va(e) {
  for (; it(); )
    switch (Re) {
      case e:
        return rt;
      case 34:
      case 39:
        e !== 34 && e !== 39 && va(Re);
        break;
      case 40:
        e === 41 && va(e);
        break;
      case 92:
        it();
        break;
    }
  return rt;
}
function cu(e, t) {
  for (; it() && e + Re !== 57; )
    if (e + Re === 84 && Tt() === 47)
      break;
  return "/*" + xn(t, rt - 1) + "*" + go(e === 47 ? e : it());
}
function du(e) {
  for (; !sn(Tt()); )
    it();
  return xn(e, rt);
}
function uu(e) {
  return Vl(Hn("", null, null, null, [""], e = Ol(e), 0, [0], e));
}
function Hn(e, t, r, n, o, a, i, s, l) {
  for (var d = 0, u = 0, p = i, f = 0, g = 0, h = 0, m = 1, A = 1, b = 1, C = 0, v = "", k = o, S = a, I = n, w = v; A; )
    switch (h = C, C = it()) {
      case 40:
        if (h != 108 && Le(w, p - 1) == 58) {
          ma(w += fe(Qn(C), "&", "&\f"), "&\f") != -1 && (b = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        w += Qn(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        w += su(h);
        break;
      case 92:
        w += lu(Nn() - 1, 7);
        continue;
      case 47:
        switch (Tt()) {
          case 42:
          case 47:
            jn(pu(cu(it(), Nn()), t, r), l);
            break;
          default:
            w += "/";
        }
        break;
      case 123 * m:
        s[d++] = It(w) * b;
      case 125 * m:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            A = 0;
          case 59 + u:
            b == -1 && (w = fe(w, /\f/g, "")), g > 0 && It(w) - p && jn(g > 32 ? Zi(w + ";", n, r, p - 1) : Zi(fe(w, " ", "") + ";", n, r, p - 2), l);
            break;
          case 59:
            w += ";";
          default:
            if (jn(I = Gi(w, t, r, d, u, o, s, v, k = [], S = [], p), a), C === 123)
              if (u === 0)
                Hn(w, t, I, I, k, a, p, s, S);
              else
                switch (f === 99 && Le(w, 3) === 110 ? 100 : f) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    Hn(e, I, I, n && jn(Gi(e, I, I, 0, 0, o, s, v, o, k = [], p), S), o, S, p, s, n ? k : S);
                    break;
                  default:
                    Hn(w, I, I, I, [""], S, 0, s, S);
                }
        }
        d = u = g = 0, m = b = 1, v = w = "", p = i;
        break;
      case 58:
        p = 1 + It(w), g = h;
      default:
        if (m < 1) {
          if (C == 123)
            --m;
          else if (C == 125 && m++ == 0 && iu() == 125)
            continue;
        }
        switch (w += go(C), C * m) {
          case 38:
            b = u > 0 ? 1 : (w += "\f", -1);
            break;
          case 44:
            s[d++] = (It(w) - 1) * b, b = 1;
            break;
          case 64:
            Tt() === 45 && (w += Qn(it())), f = Tt(), u = p = It(v = w += du(Nn())), C++;
            break;
          case 45:
            h === 45 && It(w) == 2 && (m = 0);
        }
    }
  return a;
}
function Gi(e, t, r, n, o, a, i, s, l, d, u) {
  for (var p = o - 1, f = o === 0 ? a : [""], g = Fa(f), h = 0, m = 0, A = 0; h < n; ++h)
    for (var b = 0, C = an(e, p + 1, p = eu(m = i[h])), v = e; b < g; ++b)
      (v = Pl(m > 0 ? f[b] + " " + C : fe(C, /&\f/g, f[b]))) && (l[A++] = v);
  return mo(e, t, r, o === 0 ? Da : s, l, d, u);
}
function pu(e, t, r) {
  return mo(e, t, r, Il, go(au()), an(e, 2, -2), 0);
}
function Zi(e, t, r, n) {
  return mo(e, t, r, Ma, an(e, 0, n), an(e, n + 1, -1), n);
}
function gr(e, t) {
  for (var r = "", n = Fa(e), o = 0; o < n; o++)
    r += t(e[o], o, e, t) || "";
  return r;
}
function fu(e, t, r, n) {
  switch (e.type) {
    case _d:
      if (e.children.length) break;
    case $d:
    case Ma:
      return e.return = e.return || e.value;
    case Il:
      return "";
    case wl:
      return e.return = e.value + "{" + gr(e.children, n) + "}";
    case Da:
      e.value = e.props.join(",");
  }
  return It(r = gr(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function gu(e) {
  var t = Fa(e);
  return function(r, n, o, a) {
    for (var i = "", s = 0; s < t; s++)
      i += e[s](r, n, o, a) || "";
    return i;
  };
}
function hu(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function El(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var mu = function(t, r, n) {
  for (var o = 0, a = 0; o = a, a = Tt(), o === 38 && a === 12 && (r[n] = 1), !sn(a); )
    it();
  return xn(t, rt);
}, vu = function(t, r) {
  var n = -1, o = 44;
  do
    switch (sn(o)) {
      case 0:
        o === 38 && Tt() === 12 && (r[n] = 1), t[n] += mu(rt - 1, r, n);
        break;
      case 2:
        t[n] += Qn(o);
        break;
      case 4:
        if (o === 44) {
          t[++n] = Tt() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += go(o);
    }
  while (o = it());
  return t;
}, bu = function(t, r) {
  return Vl(vu(Ol(t), r));
}, Yi = /* @__PURE__ */ new WeakMap(), xu = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, o = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !Yi.get(n)) && !o) {
      Yi.set(t, !0);
      for (var a = [], i = bu(r, a), s = n.props, l = 0, d = 0; l < i.length; l++)
        for (var u = 0; u < s.length; u++, d++)
          t.props[d] = a[l] ? i[l].replace(/&\f/g, s[u]) : s[u] + " " + i[l];
    }
  }
}, yu = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Kl(e, t) {
  switch (ru(e, t)) {
    case 5103:
      return pe + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return pe + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return pe + e + _n + e + Xe + e + e;
    case 6828:
    case 4268:
      return pe + e + Xe + e + e;
    case 6165:
      return pe + e + Xe + "flex-" + e + e;
    case 5187:
      return pe + e + fe(e, /(\w+).+(:[^]+)/, pe + "box-$1$2" + Xe + "flex-$1$2") + e;
    case 5443:
      return pe + e + Xe + "flex-item-" + fe(e, /flex-|-self/, "") + e;
    case 4675:
      return pe + e + Xe + "flex-line-pack" + fe(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return pe + e + Xe + fe(e, "shrink", "negative") + e;
    case 5292:
      return pe + e + Xe + fe(e, "basis", "preferred-size") + e;
    case 6060:
      return pe + "box-" + fe(e, "-grow", "") + pe + e + Xe + fe(e, "grow", "positive") + e;
    case 4554:
      return pe + fe(e, /([^-])(transform)/g, "$1" + pe + "$2") + e;
    case 6187:
      return fe(fe(fe(e, /(zoom-|grab)/, pe + "$1"), /(image-set)/, pe + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return fe(e, /(image-set\([^]*)/, pe + "$1$`$1");
    case 4968:
      return fe(fe(e, /(.+:)(flex-)?(.*)/, pe + "box-pack:$3" + Xe + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + pe + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return fe(e, /(.+)-inline(.+)/, pe + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (It(e) - 1 - t > 6) switch (Le(e, t + 1)) {
        case 109:
          if (Le(e, t + 4) !== 45) break;
        case 102:
          return fe(e, /(.+:)(.+)-([^]+)/, "$1" + pe + "$2-$3$1" + _n + (Le(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~ma(e, "stretch") ? Kl(fe(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Le(e, t + 1) !== 115) break;
    case 6444:
      switch (Le(e, It(e) - 3 - (~ma(e, "!important") && 10))) {
        case 107:
          return fe(e, ":", ":" + pe) + e;
        case 101:
          return fe(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + pe + (Le(e, 14) === 45 ? "inline-" : "") + "box$3$1" + pe + "$2$3$1" + Xe + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Le(e, t + 11)) {
        case 114:
          return pe + e + Xe + fe(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return pe + e + Xe + fe(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return pe + e + Xe + fe(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return pe + e + Xe + e + e;
  }
  return e;
}
var Au = function(t, r, n, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Ma:
      t.return = Kl(t.value, t.length);
      break;
    case wl:
      return gr([Lr(t, {
        value: fe(t.value, "@", "@" + pe)
      })], o);
    case Da:
      if (t.length) return ou(t.props, function(a) {
        switch (nu(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return gr([Lr(t, {
              props: [fe(a, /:(read-\w+)/, ":" + _n + "$1")]
            })], o);
          case "::placeholder":
            return gr([Lr(t, {
              props: [fe(a, /:(plac\w+)/, ":" + pe + "input-$1")]
            }), Lr(t, {
              props: [fe(a, /:(plac\w+)/, ":" + _n + "$1")]
            }), Lr(t, {
              props: [fe(a, /:(plac\w+)/, Xe + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, Cu = [Au], Rl = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(m) {
      var A = m.getAttribute("data-emotion");
      A.indexOf(" ") !== -1 && (document.head.appendChild(m), m.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || Cu, a = {}, i, s = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(m) {
      for (var A = m.getAttribute("data-emotion").split(" "), b = 1; b < A.length; b++)
        a[A[b]] = !0;
      s.push(m);
    }
  );
  var l, d = [xu, yu];
  {
    var u, p = [fu, hu(function(m) {
      u.insert(m);
    })], f = gu(d.concat(o, p)), g = function(A) {
      return gr(uu(A), f);
    };
    l = function(A, b, C, v) {
      u = C, g(A ? A + "{" + b.styles + "}" : b.styles), v && (h.inserted[b.name] = !0);
    };
  }
  var h = {
    key: r,
    sheet: new Xd({
      key: r,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return h.sheet.hydrate(s), h;
}, Ul = { exports: {} }, he = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Je = typeof Symbol == "function" && Symbol.for, qa = Je ? Symbol.for("react.element") : 60103, Ja = Je ? Symbol.for("react.portal") : 60106, vo = Je ? Symbol.for("react.fragment") : 60107, bo = Je ? Symbol.for("react.strict_mode") : 60108, xo = Je ? Symbol.for("react.profiler") : 60114, yo = Je ? Symbol.for("react.provider") : 60109, Ao = Je ? Symbol.for("react.context") : 60110, Wa = Je ? Symbol.for("react.async_mode") : 60111, Co = Je ? Symbol.for("react.concurrent_mode") : 60111, So = Je ? Symbol.for("react.forward_ref") : 60112, ko = Je ? Symbol.for("react.suspense") : 60113, Su = Je ? Symbol.for("react.suspense_list") : 60120, Io = Je ? Symbol.for("react.memo") : 60115, wo = Je ? Symbol.for("react.lazy") : 60116, ku = Je ? Symbol.for("react.block") : 60121, Iu = Je ? Symbol.for("react.fundamental") : 60117, wu = Je ? Symbol.for("react.responder") : 60118, Pu = Je ? Symbol.for("react.scope") : 60119;
function lt(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case qa:
        switch (e = e.type, e) {
          case Wa:
          case Co:
          case vo:
          case xo:
          case bo:
          case ko:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Ao:
              case So:
              case wo:
              case Io:
              case yo:
                return e;
              default:
                return t;
            }
        }
      case Ja:
        return t;
    }
  }
}
function jl(e) {
  return lt(e) === Co;
}
he.AsyncMode = Wa;
he.ConcurrentMode = Co;
he.ContextConsumer = Ao;
he.ContextProvider = yo;
he.Element = qa;
he.ForwardRef = So;
he.Fragment = vo;
he.Lazy = wo;
he.Memo = Io;
he.Portal = Ja;
he.Profiler = xo;
he.StrictMode = bo;
he.Suspense = ko;
he.isAsyncMode = function(e) {
  return jl(e) || lt(e) === Wa;
};
he.isConcurrentMode = jl;
he.isContextConsumer = function(e) {
  return lt(e) === Ao;
};
he.isContextProvider = function(e) {
  return lt(e) === yo;
};
he.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === qa;
};
he.isForwardRef = function(e) {
  return lt(e) === So;
};
he.isFragment = function(e) {
  return lt(e) === vo;
};
he.isLazy = function(e) {
  return lt(e) === wo;
};
he.isMemo = function(e) {
  return lt(e) === Io;
};
he.isPortal = function(e) {
  return lt(e) === Ja;
};
he.isProfiler = function(e) {
  return lt(e) === xo;
};
he.isStrictMode = function(e) {
  return lt(e) === bo;
};
he.isSuspense = function(e) {
  return lt(e) === ko;
};
he.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === vo || e === Co || e === xo || e === bo || e === ko || e === Su || typeof e == "object" && e !== null && (e.$$typeof === wo || e.$$typeof === Io || e.$$typeof === yo || e.$$typeof === Ao || e.$$typeof === So || e.$$typeof === Iu || e.$$typeof === wu || e.$$typeof === Pu || e.$$typeof === ku);
};
he.typeOf = lt;
Ul.exports = he;
var Tu = Ul.exports, Bl = Tu, Ou = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, Vu = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, Dl = {};
Dl[Bl.ForwardRef] = Ou;
Dl[Bl.Memo] = Vu;
var Eu = !0;
function Ml(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : o && (n += o + " ");
  }), n;
}
var La = function(t, r, n) {
  var o = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  Eu === !1) && t.registered[o] === void 0 && (t.registered[o] = r.styles);
}, za = function(t, r, n) {
  La(t, r, n);
  var o = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var a = r;
    do
      t.insert(r === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function Ku(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var Ru = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, Uu = /[A-Z]|^ms/g, ju = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Fl = function(t) {
  return t.charCodeAt(1) === 45;
}, Xi = function(t) {
  return t != null && typeof t != "boolean";
}, ea = /* @__PURE__ */ El(function(e) {
  return Fl(e) ? e : e.replace(Uu, "-$&").toLowerCase();
}), $i = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace(ju, function(n, o, a) {
          return wt = {
            name: o,
            styles: a,
            next: wt
          }, o;
        });
  }
  return Ru[t] !== 1 && !Fl(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
};
function ln(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var o = r;
      if (o.anim === 1)
        return wt = {
          name: o.name,
          styles: o.styles,
          next: wt
        }, o.name;
      var a = r;
      if (a.styles !== void 0) {
        var i = a.next;
        if (i !== void 0)
          for (; i !== void 0; )
            wt = {
              name: i.name,
              styles: i.styles,
              next: wt
            }, i = i.next;
        var s = a.styles + ";";
        return s;
      }
      return Bu(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var l = wt, d = r(e);
        return wt = l, ln(e, t, d);
      }
      break;
    }
  }
  var u = r;
  if (t == null)
    return u;
  var p = t[u];
  return p !== void 0 ? p : u;
}
function Bu(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var o = 0; o < r.length; o++)
      n += ln(e, t, r[o]) + ";";
  else
    for (var a in r) {
      var i = r[a];
      if (typeof i != "object") {
        var s = i;
        t != null && t[s] !== void 0 ? n += a + "{" + t[s] + "}" : Xi(s) && (n += ea(a) + ":" + $i(a, s) + ";");
      } else if (Array.isArray(i) && typeof i[0] == "string" && (t == null || t[i[0]] === void 0))
        for (var l = 0; l < i.length; l++)
          Xi(i[l]) && (n += ea(a) + ":" + $i(a, i[l]) + ";");
      else {
        var d = ln(e, t, i);
        switch (a) {
          case "animation":
          case "animationName": {
            n += ea(a) + ":" + d + ";";
            break;
          }
          default:
            n += a + "{" + d + "}";
        }
      }
    }
  return n;
}
var _i = /label:\s*([^\s;{]+)\s*(;|$)/g, wt;
function yn(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, o = "";
  wt = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    n = !1, o += ln(r, t, a);
  else {
    var i = a;
    o += i[0];
  }
  for (var s = 1; s < e.length; s++)
    if (o += ln(r, t, e[s]), n) {
      var l = a;
      o += l[s];
    }
  _i.lastIndex = 0;
  for (var d = "", u; (u = _i.exec(o)) !== null; )
    d += "-" + u[1];
  var p = Ku(o) + d;
  return {
    name: p,
    styles: o,
    next: wt
  };
}
var Du = function(t) {
  return t();
}, ql = x.useInsertionEffect ? x.useInsertionEffect : !1, Jl = ql || Du, es = ql || x.useLayoutEffect, Wl = /* @__PURE__ */ x.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ Rl({
    key: "css"
  }) : null
), Mu = Wl.Provider, Na = function(t) {
  return /* @__PURE__ */ Ba(function(r, n) {
    var o = ue(Wl);
    return t(r, o, n);
  });
}, Er = /* @__PURE__ */ x.createContext({}), Qa = {}.hasOwnProperty, ba = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Fu = function(t, r) {
  var n = {};
  for (var o in r)
    Qa.call(r, o) && (n[o] = r[o]);
  return n[ba] = t, n;
}, qu = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return La(r, n, o), Jl(function() {
    return za(r, n, o);
  }), null;
}, Ju = /* @__PURE__ */ Na(function(e, t, r) {
  var n = e.css;
  typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
  var o = e[ba], a = [n], i = "";
  typeof e.className == "string" ? i = Ml(t.registered, a, e.className) : e.className != null && (i = e.className + " ");
  var s = yn(a, void 0, x.useContext(Er));
  i += t.key + "-" + s.name;
  var l = {};
  for (var d in e)
    Qa.call(e, d) && d !== "css" && d !== ba && (l[d] = e[d]);
  return l.className = i, r && (l.ref = r), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(qu, {
    cache: t,
    serialized: s,
    isStringTag: typeof o == "string"
  }), /* @__PURE__ */ x.createElement(o, l));
}), Wu = Ju, ts = function(t, r) {
  var n = arguments;
  if (r == null || !Qa.call(r, "css"))
    return x.createElement.apply(void 0, n);
  var o = n.length, a = new Array(o);
  a[0] = Wu, a[1] = Fu(t, r);
  for (var i = 2; i < o; i++)
    a[i] = n[i];
  return x.createElement.apply(null, a);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(ts || (ts = {}));
var Lu = /* @__PURE__ */ Na(function(e, t) {
  var r = e.styles, n = yn([r], void 0, x.useContext(Er)), o = x.useRef();
  return es(function() {
    var a = t.key + "-global", i = new t.sheet.constructor({
      key: a,
      nonce: t.sheet.nonce,
      container: t.sheet.container,
      speedy: t.sheet.isSpeedy
    }), s = !1, l = document.querySelector('style[data-emotion="' + a + " " + n.name + '"]');
    return t.sheet.tags.length && (i.before = t.sheet.tags[0]), l !== null && (s = !0, l.setAttribute("data-emotion", a), i.hydrate([l])), o.current = [i, s], function() {
      i.flush();
    };
  }, [t]), es(function() {
    var a = o.current, i = a[0], s = a[1];
    if (s) {
      a[1] = !1;
      return;
    }
    if (n.next !== void 0 && za(t, n.next, !0), i.tags.length) {
      var l = i.tags[i.tags.length - 1].nextElementSibling;
      i.before = l, i.flush();
    }
    t.insert("", n, i, !1);
  }, [t, n.name]), null;
});
function Ha() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return yn(t);
}
function Po() {
  var e = Ha.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
var zu = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|disableRemotePlayback|download|draggable|encType|enterKeyHint|fetchpriority|fetchPriority|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|popover|popoverTarget|popoverTargetAction|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, Nu = /* @__PURE__ */ El(
  function(e) {
    return zu.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
  /* Z+1 */
), Qu = Nu, Hu = function(t) {
  return t !== "theme";
}, rs = function(t) {
  return typeof t == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  t.charCodeAt(0) > 96 ? Qu : Hu;
}, ns = function(t, r, n) {
  var o;
  if (r) {
    var a = r.shouldForwardProp;
    o = t.__emotion_forwardProp && a ? function(i) {
      return t.__emotion_forwardProp(i) && a(i);
    } : a;
  }
  return typeof o != "function" && n && (o = t.__emotion_forwardProp), o;
}, Gu = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return La(r, n, o), Jl(function() {
    return za(r, n, o);
  }), null;
}, Zu = function e(t, r) {
  var n = t.__emotion_real === t, o = n && t.__emotion_base || t, a, i;
  r !== void 0 && (a = r.label, i = r.target);
  var s = ns(t, r, n), l = s || rs(o), d = !l("as");
  return function() {
    var u = arguments, p = n && t.__emotion_styles !== void 0 ? t.__emotion_styles.slice(0) : [];
    if (a !== void 0 && p.push("label:" + a + ";"), u[0] == null || u[0].raw === void 0)
      p.push.apply(p, u);
    else {
      var f = u[0];
      p.push(f[0]);
      for (var g = u.length, h = 1; h < g; h++)
        p.push(u[h], f[h]);
    }
    var m = Na(function(A, b, C) {
      var v = d && A.as || o, k = "", S = [], I = A;
      if (A.theme == null) {
        I = {};
        for (var w in A)
          I[w] = A[w];
        I.theme = x.useContext(Er);
      }
      typeof A.className == "string" ? k = Ml(b.registered, S, A.className) : A.className != null && (k = A.className + " ");
      var P = yn(p.concat(S), b.registered, I);
      k += b.key + "-" + P.name, i !== void 0 && (k += " " + i);
      var E = d && s === void 0 ? rs(v) : l, K = {};
      for (var R in A)
        d && R === "as" || E(R) && (K[R] = A[R]);
      return K.className = k, C && (K.ref = C), /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(Gu, {
        cache: b,
        serialized: P,
        isStringTag: typeof v == "string"
      }), /* @__PURE__ */ x.createElement(v, K));
    });
    return m.displayName = a !== void 0 ? a : "Styled(" + (typeof o == "string" ? o : o.displayName || o.name || "Component") + ")", m.defaultProps = t.defaultProps, m.__emotion_real = m, m.__emotion_base = o, m.__emotion_styles = p, m.__emotion_forwardProp = s, Object.defineProperty(m, "toString", {
      value: function() {
        return "." + i;
      }
    }), m.withComponent = function(A, b) {
      var C = e(A, y({}, r, b, {
        shouldForwardProp: ns(m, b, !0)
      }));
      return C.apply(void 0, p);
    }, m;
  };
}, Yu = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  // SVG
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], xa = Zu.bind(null);
Yu.forEach(function(e) {
  xa[e] = xa(e);
});
function Xu(e, t) {
  const r = Rl({
    key: "css",
    prepend: e
  });
  if (t) {
    const n = r.insert;
    r.insert = (...o) => (o[1].styles.match(/^@layer\s+[^{]*$/) || (o[1].styles = `@layer mui {${o[1].styles}}`), n(...o));
  }
  return r;
}
const ta = /* @__PURE__ */ new Map();
function $u(e) {
  const {
    injectFirst: t,
    enableCssLayer: r,
    children: n
  } = e, o = x.useMemo(() => {
    const a = `${t}-${r}`;
    if (typeof document == "object" && ta.has(a))
      return ta.get(a);
    const i = Xu(t, r);
    return ta.set(a, i), i;
  }, [t, r]);
  return t || r ? /* @__PURE__ */ c.jsx(Mu, {
    value: o,
    children: n
  }) : n;
}
function _u(e) {
  return e == null || Object.keys(e).length === 0;
}
function $r(e) {
  const {
    styles: t,
    defaultTheme: r = {}
  } = e, n = typeof t == "function" ? (o) => t(_u(o) ? r : o) : t;
  return /* @__PURE__ */ c.jsx(Lu, {
    styles: n
  });
}
function Ga(e, t) {
  return xa(e, t);
}
const Ll = (e, t) => {
  Array.isArray(e.__emotion_styles) && (e.__emotion_styles = t(e.__emotion_styles));
}, os = [];
function eo(e) {
  return os[0] = e, yn(os);
}
const ep = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  GlobalStyles: $r,
  StyledEngineProvider: $u,
  ThemeContext: Er,
  css: Ha,
  default: Ga,
  internal_processStyles: Ll,
  internal_serializeStyles: eo,
  keyframes: Po
}, Symbol.toStringTag, { value: "Module" }));
function ee(e, t) {
  if (e == null) return {};
  var r = {};
  for (var n in e) if ({}.hasOwnProperty.call(e, n)) {
    if (t.indexOf(n) !== -1) continue;
    r[n] = e[n];
  }
  return r;
}
function Ut(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function zl(e) {
  if (/* @__PURE__ */ x.isValidElement(e) || !Ut(e))
    return e;
  const t = {};
  return Object.keys(e).forEach((r) => {
    t[r] = zl(e[r]);
  }), t;
}
function je(e, t, r = {
  clone: !0
}) {
  const n = r.clone ? y({}, e) : e;
  return Ut(e) && Ut(t) && Object.keys(t).forEach((o) => {
    /* @__PURE__ */ x.isValidElement(t[o]) ? n[o] = t[o] : Ut(t[o]) && // Avoid prototype pollution
    Object.prototype.hasOwnProperty.call(e, o) && Ut(e[o]) ? n[o] = je(e[o], t[o], r) : r.clone ? n[o] = Ut(t[o]) ? zl(t[o]) : t[o] : n[o] = t[o];
  }), n;
}
const tp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: je,
  isPlainObject: Ut
}, Symbol.toStringTag, { value: "Module" })), rp = ["values", "unit", "step"], np = (e) => {
  const t = Object.keys(e).map((r) => ({
    key: r,
    val: e[r]
  })) || [];
  return t.sort((r, n) => r.val - n.val), t.reduce((r, n) => y({}, r, {
    [n.key]: n.val
  }), {});
};
function Za(e) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values: t = {
      xs: 0,
      // phone
      sm: 600,
      // tablet
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536
      // large screen
    },
    unit: r = "px",
    step: n = 5
  } = e, o = ee(e, rp), a = np(t), i = Object.keys(a);
  function s(f) {
    return `@media (min-width:${typeof t[f] == "number" ? t[f] : f}${r})`;
  }
  function l(f) {
    return `@media (max-width:${(typeof t[f] == "number" ? t[f] : f) - n / 100}${r})`;
  }
  function d(f, g) {
    const h = i.indexOf(g);
    return `@media (min-width:${typeof t[f] == "number" ? t[f] : f}${r}) and (max-width:${(h !== -1 && typeof t[i[h]] == "number" ? t[i[h]] : g) - n / 100}${r})`;
  }
  function u(f) {
    return i.indexOf(f) + 1 < i.length ? d(f, i[i.indexOf(f) + 1]) : s(f);
  }
  function p(f) {
    const g = i.indexOf(f);
    return g === 0 ? s(i[1]) : g === i.length - 1 ? l(i[g]) : d(f, i[i.indexOf(f) + 1]).replace("@media", "@media not all and");
  }
  return y({
    keys: i,
    values: a,
    up: s,
    down: l,
    between: d,
    only: u,
    not: p,
    unit: r
  }, o);
}
const op = {
  borderRadius: 4
};
function _r(e, t) {
  return t ? je(e, t, {
    clone: !1
    // No need to clone deep, it's way faster.
  }) : e;
}
const Ya = {
  xs: 0,
  // phone
  sm: 600,
  // tablet
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536
  // large screen
}, as = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ["xs", "sm", "md", "lg", "xl"],
  up: (e) => `@media (min-width:${Ya[e]}px)`
};
function At(e, t, r) {
  const n = e.theme || {};
  if (Array.isArray(t)) {
    const a = n.breakpoints || as;
    return t.reduce((i, s, l) => (i[a.up(a.keys[l])] = r(t[l]), i), {});
  }
  if (typeof t == "object") {
    const a = n.breakpoints || as;
    return Object.keys(t).reduce((i, s) => {
      if (Object.keys(a.values || Ya).indexOf(s) !== -1) {
        const l = a.up(s);
        i[l] = r(t[s], s);
      } else {
        const l = s;
        i[l] = t[l];
      }
      return i;
    }, {});
  }
  return r(t);
}
function Nl(e = {}) {
  var t;
  return ((t = e.keys) == null ? void 0 : t.reduce((n, o) => {
    const a = e.up(o);
    return n[a] = {}, n;
  }, {})) || {};
}
function ya(e, t) {
  return e.reduce((r, n) => {
    const o = r[n];
    return (!o || Object.keys(o).length === 0) && delete r[n], r;
  }, t);
}
function ap(e, ...t) {
  const r = Nl(e), n = [r, ...t].reduce((o, a) => je(o, a), {});
  return ya(Object.keys(r), n);
}
function ip(e, t) {
  if (typeof e != "object")
    return {};
  const r = {}, n = Object.keys(t);
  return Array.isArray(e) ? n.forEach((o, a) => {
    a < e.length && (r[o] = !0);
  }) : n.forEach((o) => {
    e[o] != null && (r[o] = !0);
  }), r;
}
function ra({
  values: e,
  breakpoints: t,
  base: r
}) {
  const n = r || ip(e, t), o = Object.keys(n);
  if (o.length === 0)
    return e;
  let a;
  return o.reduce((i, s, l) => (Array.isArray(e) ? (i[s] = e[l] != null ? e[l] : e[a], a = l) : typeof e == "object" ? (i[s] = e[s] != null ? e[s] : e[a], a = s) : i[s] = e, i), {});
}
function z(e) {
  if (typeof e != "string")
    throw new Error(jt(7));
  return e.charAt(0).toUpperCase() + e.slice(1);
}
const sp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: z
}, Symbol.toStringTag, { value: "Module" }));
function Cr(e, t, r = !0) {
  if (!t || typeof t != "string")
    return null;
  if (e && e.vars && r) {
    const n = `vars.${t}`.split(".").reduce((o, a) => o && o[a] ? o[a] : null, e);
    if (n != null)
      return n;
  }
  return t.split(".").reduce((n, o) => n && n[o] != null ? n[o] : null, e);
}
function to(e, t, r, n = r) {
  let o;
  return typeof e == "function" ? o = e(r) : Array.isArray(e) ? o = e[r] || n : o = Cr(e, r) || n, t && (o = t(o, n, e)), o;
}
function Ve(e) {
  const {
    prop: t,
    cssProperty: r = e.prop,
    themeKey: n,
    transform: o
  } = e, a = (i) => {
    if (i[t] == null)
      return null;
    const s = i[t], l = i.theme, d = Cr(l, n) || {};
    return At(i, s, (p) => {
      let f = to(d, o, p);
      return p === f && typeof p == "string" && (f = to(d, o, `${t}${p === "default" ? "" : z(p)}`, p)), r === !1 ? f : {
        [r]: f
      };
    });
  };
  return a.propTypes = {}, a.filterProps = [t], a;
}
function lp(e) {
  const t = {};
  return (r) => (t[r] === void 0 && (t[r] = e(r)), t[r]);
}
const cp = {
  m: "margin",
  p: "padding"
}, dp = {
  t: "Top",
  r: "Right",
  b: "Bottom",
  l: "Left",
  x: ["Left", "Right"],
  y: ["Top", "Bottom"]
}, is = {
  marginX: "mx",
  marginY: "my",
  paddingX: "px",
  paddingY: "py"
}, up = lp((e) => {
  if (e.length > 2)
    if (is[e])
      e = is[e];
    else
      return [e];
  const [t, r] = e.split(""), n = cp[t], o = dp[r] || "";
  return Array.isArray(o) ? o.map((a) => n + a) : [n + o];
}), Xa = ["m", "mt", "mr", "mb", "ml", "mx", "my", "margin", "marginTop", "marginRight", "marginBottom", "marginLeft", "marginX", "marginY", "marginInline", "marginInlineStart", "marginInlineEnd", "marginBlock", "marginBlockStart", "marginBlockEnd"], $a = ["p", "pt", "pr", "pb", "pl", "px", "py", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingX", "paddingY", "paddingInline", "paddingInlineStart", "paddingInlineEnd", "paddingBlock", "paddingBlockStart", "paddingBlockEnd"];
[...Xa, ...$a];
function An(e, t, r, n) {
  var o;
  const a = (o = Cr(e, t, !1)) != null ? o : r;
  return typeof a == "number" ? (i) => typeof i == "string" ? i : a * i : Array.isArray(a) ? (i) => typeof i == "string" ? i : a[i] : typeof a == "function" ? a : () => {
  };
}
function _a(e) {
  return An(e, "spacing", 8);
}
function _t(e, t) {
  if (typeof t == "string" || t == null)
    return t;
  const r = Math.abs(t), n = e(r);
  return t >= 0 ? n : typeof n == "number" ? -n : `-${n}`;
}
function pp(e, t) {
  return (r) => e.reduce((n, o) => (n[o] = _t(t, r), n), {});
}
function fp(e, t, r, n) {
  if (t.indexOf(r) === -1)
    return null;
  const o = up(r), a = pp(o, n), i = e[r];
  return At(e, i, a);
}
function Ql(e, t) {
  const r = _a(e.theme);
  return Object.keys(e).map((n) => fp(e, t, n, r)).reduce(_r, {});
}
function we(e) {
  return Ql(e, Xa);
}
we.propTypes = {};
we.filterProps = Xa;
function Pe(e) {
  return Ql(e, $a);
}
Pe.propTypes = {};
Pe.filterProps = $a;
function Hl(e = 8) {
  if (e.mui)
    return e;
  const t = _a({
    spacing: e
  }), r = (...n) => (n.length === 0 ? [1] : n).map((a) => {
    const i = t(a);
    return typeof i == "number" ? `${i}px` : i;
  }).join(" ");
  return r.mui = !0, r;
}
function To(...e) {
  const t = e.reduce((n, o) => (o.filterProps.forEach((a) => {
    n[a] = o;
  }), n), {}), r = (n) => Object.keys(n).reduce((o, a) => t[a] ? _r(o, t[a](n)) : o, {});
  return r.propTypes = {}, r.filterProps = e.reduce((n, o) => n.concat(o.filterProps), []), r;
}
function ut(e) {
  return typeof e != "number" ? e : `${e}px solid`;
}
function mt(e, t) {
  return Ve({
    prop: e,
    themeKey: "borders",
    transform: t
  });
}
const gp = mt("border", ut), hp = mt("borderTop", ut), mp = mt("borderRight", ut), vp = mt("borderBottom", ut), bp = mt("borderLeft", ut), xp = mt("borderColor"), yp = mt("borderTopColor"), Ap = mt("borderRightColor"), Cp = mt("borderBottomColor"), Sp = mt("borderLeftColor"), kp = mt("outline", ut), Ip = mt("outlineColor"), Oo = (e) => {
  if (e.borderRadius !== void 0 && e.borderRadius !== null) {
    const t = An(e.theme, "shape.borderRadius", 4), r = (n) => ({
      borderRadius: _t(t, n)
    });
    return At(e, e.borderRadius, r);
  }
  return null;
};
Oo.propTypes = {};
Oo.filterProps = ["borderRadius"];
To(gp, hp, mp, vp, bp, xp, yp, Ap, Cp, Sp, Oo, kp, Ip);
const Vo = (e) => {
  if (e.gap !== void 0 && e.gap !== null) {
    const t = An(e.theme, "spacing", 8), r = (n) => ({
      gap: _t(t, n)
    });
    return At(e, e.gap, r);
  }
  return null;
};
Vo.propTypes = {};
Vo.filterProps = ["gap"];
const Eo = (e) => {
  if (e.columnGap !== void 0 && e.columnGap !== null) {
    const t = An(e.theme, "spacing", 8), r = (n) => ({
      columnGap: _t(t, n)
    });
    return At(e, e.columnGap, r);
  }
  return null;
};
Eo.propTypes = {};
Eo.filterProps = ["columnGap"];
const Ko = (e) => {
  if (e.rowGap !== void 0 && e.rowGap !== null) {
    const t = An(e.theme, "spacing", 8), r = (n) => ({
      rowGap: _t(t, n)
    });
    return At(e, e.rowGap, r);
  }
  return null;
};
Ko.propTypes = {};
Ko.filterProps = ["rowGap"];
const wp = Ve({
  prop: "gridColumn"
}), Pp = Ve({
  prop: "gridRow"
}), Tp = Ve({
  prop: "gridAutoFlow"
}), Op = Ve({
  prop: "gridAutoColumns"
}), Vp = Ve({
  prop: "gridAutoRows"
}), Ep = Ve({
  prop: "gridTemplateColumns"
}), Kp = Ve({
  prop: "gridTemplateRows"
}), Rp = Ve({
  prop: "gridTemplateAreas"
}), Up = Ve({
  prop: "gridArea"
});
To(Vo, Eo, Ko, wp, Pp, Tp, Op, Vp, Ep, Kp, Rp, Up);
function hr(e, t) {
  return t === "grey" ? t : e;
}
const jp = Ve({
  prop: "color",
  themeKey: "palette",
  transform: hr
}), Bp = Ve({
  prop: "bgcolor",
  cssProperty: "backgroundColor",
  themeKey: "palette",
  transform: hr
}), Dp = Ve({
  prop: "backgroundColor",
  themeKey: "palette",
  transform: hr
});
To(jp, Bp, Dp);
function at(e) {
  return e <= 1 && e !== 0 ? `${e * 100}%` : e;
}
const Mp = Ve({
  prop: "width",
  transform: at
}), ei = (e) => {
  if (e.maxWidth !== void 0 && e.maxWidth !== null) {
    const t = (r) => {
      var n, o;
      const a = ((n = e.theme) == null || (n = n.breakpoints) == null || (n = n.values) == null ? void 0 : n[r]) || Ya[r];
      return a ? ((o = e.theme) == null || (o = o.breakpoints) == null ? void 0 : o.unit) !== "px" ? {
        maxWidth: `${a}${e.theme.breakpoints.unit}`
      } : {
        maxWidth: a
      } : {
        maxWidth: at(r)
      };
    };
    return At(e, e.maxWidth, t);
  }
  return null;
};
ei.filterProps = ["maxWidth"];
const Fp = Ve({
  prop: "minWidth",
  transform: at
}), qp = Ve({
  prop: "height",
  transform: at
}), Jp = Ve({
  prop: "maxHeight",
  transform: at
}), Wp = Ve({
  prop: "minHeight",
  transform: at
});
Ve({
  prop: "size",
  cssProperty: "width",
  transform: at
});
Ve({
  prop: "size",
  cssProperty: "height",
  transform: at
});
const Lp = Ve({
  prop: "boxSizing"
});
To(Mp, ei, Fp, qp, Jp, Wp, Lp);
const Kr = {
  // borders
  border: {
    themeKey: "borders",
    transform: ut
  },
  borderTop: {
    themeKey: "borders",
    transform: ut
  },
  borderRight: {
    themeKey: "borders",
    transform: ut
  },
  borderBottom: {
    themeKey: "borders",
    transform: ut
  },
  borderLeft: {
    themeKey: "borders",
    transform: ut
  },
  borderColor: {
    themeKey: "palette"
  },
  borderTopColor: {
    themeKey: "palette"
  },
  borderRightColor: {
    themeKey: "palette"
  },
  borderBottomColor: {
    themeKey: "palette"
  },
  borderLeftColor: {
    themeKey: "palette"
  },
  outline: {
    themeKey: "borders",
    transform: ut
  },
  outlineColor: {
    themeKey: "palette"
  },
  borderRadius: {
    themeKey: "shape.borderRadius",
    style: Oo
  },
  // palette
  color: {
    themeKey: "palette",
    transform: hr
  },
  bgcolor: {
    themeKey: "palette",
    cssProperty: "backgroundColor",
    transform: hr
  },
  backgroundColor: {
    themeKey: "palette",
    transform: hr
  },
  // spacing
  p: {
    style: Pe
  },
  pt: {
    style: Pe
  },
  pr: {
    style: Pe
  },
  pb: {
    style: Pe
  },
  pl: {
    style: Pe
  },
  px: {
    style: Pe
  },
  py: {
    style: Pe
  },
  padding: {
    style: Pe
  },
  paddingTop: {
    style: Pe
  },
  paddingRight: {
    style: Pe
  },
  paddingBottom: {
    style: Pe
  },
  paddingLeft: {
    style: Pe
  },
  paddingX: {
    style: Pe
  },
  paddingY: {
    style: Pe
  },
  paddingInline: {
    style: Pe
  },
  paddingInlineStart: {
    style: Pe
  },
  paddingInlineEnd: {
    style: Pe
  },
  paddingBlock: {
    style: Pe
  },
  paddingBlockStart: {
    style: Pe
  },
  paddingBlockEnd: {
    style: Pe
  },
  m: {
    style: we
  },
  mt: {
    style: we
  },
  mr: {
    style: we
  },
  mb: {
    style: we
  },
  ml: {
    style: we
  },
  mx: {
    style: we
  },
  my: {
    style: we
  },
  margin: {
    style: we
  },
  marginTop: {
    style: we
  },
  marginRight: {
    style: we
  },
  marginBottom: {
    style: we
  },
  marginLeft: {
    style: we
  },
  marginX: {
    style: we
  },
  marginY: {
    style: we
  },
  marginInline: {
    style: we
  },
  marginInlineStart: {
    style: we
  },
  marginInlineEnd: {
    style: we
  },
  marginBlock: {
    style: we
  },
  marginBlockStart: {
    style: we
  },
  marginBlockEnd: {
    style: we
  },
  // display
  displayPrint: {
    cssProperty: !1,
    transform: (e) => ({
      "@media print": {
        display: e
      }
    })
  },
  display: {},
  overflow: {},
  textOverflow: {},
  visibility: {},
  whiteSpace: {},
  // flexbox
  flexBasis: {},
  flexDirection: {},
  flexWrap: {},
  justifyContent: {},
  alignItems: {},
  alignContent: {},
  order: {},
  flex: {},
  flexGrow: {},
  flexShrink: {},
  alignSelf: {},
  justifyItems: {},
  justifySelf: {},
  // grid
  gap: {
    style: Vo
  },
  rowGap: {
    style: Ko
  },
  columnGap: {
    style: Eo
  },
  gridColumn: {},
  gridRow: {},
  gridAutoFlow: {},
  gridAutoColumns: {},
  gridAutoRows: {},
  gridTemplateColumns: {},
  gridTemplateRows: {},
  gridTemplateAreas: {},
  gridArea: {},
  // positions
  position: {},
  zIndex: {
    themeKey: "zIndex"
  },
  top: {},
  right: {},
  bottom: {},
  left: {},
  // shadows
  boxShadow: {
    themeKey: "shadows"
  },
  // sizing
  width: {
    transform: at
  },
  maxWidth: {
    style: ei
  },
  minWidth: {
    transform: at
  },
  height: {
    transform: at
  },
  maxHeight: {
    transform: at
  },
  minHeight: {
    transform: at
  },
  boxSizing: {},
  // typography
  fontFamily: {
    themeKey: "typography"
  },
  fontSize: {
    themeKey: "typography"
  },
  fontStyle: {
    themeKey: "typography"
  },
  fontWeight: {
    themeKey: "typography"
  },
  letterSpacing: {},
  textTransform: {},
  lineHeight: {},
  textAlign: {},
  typography: {
    cssProperty: !1,
    themeKey: "typography"
  }
};
function zp(...e) {
  const t = e.reduce((n, o) => n.concat(Object.keys(o)), []), r = new Set(t);
  return e.every((n) => r.size === Object.keys(n).length);
}
function Np(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Gl() {
  function e(r, n, o, a) {
    const i = {
      [r]: n,
      theme: o
    }, s = a[r];
    if (!s)
      return {
        [r]: n
      };
    const {
      cssProperty: l = r,
      themeKey: d,
      transform: u,
      style: p
    } = s;
    if (n == null)
      return null;
    if (d === "typography" && n === "inherit")
      return {
        [r]: n
      };
    const f = Cr(o, d) || {};
    return p ? p(i) : At(i, n, (h) => {
      let m = to(f, u, h);
      return h === m && typeof h == "string" && (m = to(f, u, `${r}${h === "default" ? "" : z(h)}`, h)), l === !1 ? m : {
        [l]: m
      };
    });
  }
  function t(r) {
    var n;
    const {
      sx: o,
      theme: a = {},
      nested: i
    } = r || {};
    if (!o)
      return null;
    const s = (n = a.unstable_sxConfig) != null ? n : Kr;
    function l(d) {
      let u = d;
      if (typeof d == "function")
        u = d(a);
      else if (typeof d != "object")
        return d;
      if (!u)
        return null;
      const p = Nl(a.breakpoints), f = Object.keys(p);
      let g = p;
      return Object.keys(u).forEach((h) => {
        const m = Np(u[h], a);
        if (m != null)
          if (typeof m == "object")
            if (s[h])
              g = _r(g, e(h, m, a, s));
            else {
              const A = At({
                theme: a
              }, m, (b) => ({
                [h]: b
              }));
              zp(A, m) ? g[h] = t({
                sx: m,
                theme: a,
                nested: !0
              }) : g = _r(g, A);
            }
          else
            g = _r(g, e(h, m, a, s));
      }), !i && a.modularCssLayers ? {
        "@layer sx": ya(f, g)
      } : ya(f, g);
    }
    return Array.isArray(o) ? o.map(l) : l(o);
  }
  return t;
}
const rr = Gl();
rr.filterProps = ["sx"];
function ti(e, t) {
  const r = this;
  return r.vars && typeof r.getColorSchemeSelector == "function" ? {
    [r.getColorSchemeSelector(e).replace(/(\[[^\]]+\])/, "*:where($1)")]: t
  } : r.palette.mode === e ? t : {};
}
const Qp = ["breakpoints", "palette", "spacing", "shape"];
function Rr(e = {}, ...t) {
  const {
    breakpoints: r = {},
    palette: n = {},
    spacing: o,
    shape: a = {}
  } = e, i = ee(e, Qp), s = Za(r), l = Hl(o);
  let d = je({
    breakpoints: s,
    direction: "ltr",
    components: {},
    // Inject component definitions.
    palette: y({
      mode: "light"
    }, n),
    spacing: l,
    shape: y({}, op, a)
  }, i);
  return d.applyStyles = ti, d = t.reduce((u, p) => je(u, p), d), d.unstable_sxConfig = y({}, Kr, i == null ? void 0 : i.unstable_sxConfig), d.unstable_sx = function(p) {
    return rr({
      sx: p,
      theme: this
    });
  }, d;
}
const Hp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Rr,
  private_createBreakpoints: Za,
  unstable_applyStyles: ti
}, Symbol.toStringTag, { value: "Module" }));
function Gp(e) {
  return Object.keys(e).length === 0;
}
function ri(e = null) {
  const t = x.useContext(Er);
  return !t || Gp(t) ? e : t;
}
const Zp = Rr();
function Ro(e = Zp) {
  return ri(e);
}
function na(e) {
  const t = eo(e);
  return e !== t && t.styles ? (t.styles.match(/^@layer\s+[^{]*$/) || (t.styles = `@layer global{${t.styles}}`), t) : e;
}
function Zl({
  styles: e,
  themeId: t,
  defaultTheme: r = {}
}) {
  const n = Ro(r), o = t && n[t] || n;
  let a = typeof e == "function" ? e(o) : e;
  return o.modularCssLayers && (Array.isArray(a) ? a = a.map((i) => na(typeof i == "function" ? i(o) : i)) : a = na(a)), /* @__PURE__ */ c.jsx($r, {
    styles: a
  });
}
const Yp = ["sx"], Xp = (e) => {
  var t, r;
  const n = {
    systemProps: {},
    otherProps: {}
  }, o = (t = e == null || (r = e.theme) == null ? void 0 : r.unstable_sxConfig) != null ? t : Kr;
  return Object.keys(e).forEach((a) => {
    o[a] ? n.systemProps[a] = e[a] : n.otherProps[a] = e[a];
  }), n;
};
function Cn(e) {
  const {
    sx: t
  } = e, r = ee(e, Yp), {
    systemProps: n,
    otherProps: o
  } = Xp(r);
  let a;
  return Array.isArray(t) ? a = [n, ...t] : typeof t == "function" ? a = (...i) => {
    const s = t(...i);
    return Ut(s) ? y({}, n, s) : n;
  } : a = y({}, n, t), y({}, o, {
    sx: a
  });
}
const $p = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rr,
  extendSxProp: Cn,
  unstable_createStyleFunctionSx: Gl,
  unstable_defaultSxConfig: Kr
}, Symbol.toStringTag, { value: "Module" })), ss = (e) => e, _p = () => {
  let e = ss;
  return {
    configure(t) {
      e = t;
    },
    generate(t) {
      return e(t);
    },
    reset() {
      e = ss;
    }
  };
}, ni = _p();
function Yl(e) {
  var t, r, n = "";
  if (typeof e == "string" || typeof e == "number") n += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (r = Yl(e[t])) && (n && (n += " "), n += r);
  } else for (r in e) e[r] && (n && (n += " "), n += r);
  return n;
}
function Qe() {
  for (var e, t, r = 0, n = "", o = arguments.length; r < o; r++) (e = arguments[r]) && (t = Yl(e)) && (n && (n += " "), n += t);
  return n;
}
const ef = ["className", "component"];
function tf(e = {}) {
  const {
    themeId: t,
    defaultTheme: r,
    defaultClassName: n = "MuiBox-root",
    generateClassName: o
  } = e, a = Ga("div", {
    shouldForwardProp: (s) => s !== "theme" && s !== "sx" && s !== "as"
  })(rr);
  return /* @__PURE__ */ x.forwardRef(function(l, d) {
    const u = Ro(r), p = Cn(l), {
      className: f,
      component: g = "div"
    } = p, h = ee(p, ef);
    return /* @__PURE__ */ c.jsx(a, y({
      as: g,
      ref: d,
      className: Qe(f, o ? o(n) : n),
      theme: t && u[t] || u
    }, h));
  });
}
const Xl = {
  active: "active",
  checked: "checked",
  completed: "completed",
  disabled: "disabled",
  error: "error",
  expanded: "expanded",
  focused: "focused",
  focusVisible: "focusVisible",
  open: "open",
  readOnly: "readOnly",
  required: "required",
  selected: "selected"
};
function Sn(e, t, r = "Mui") {
  const n = Xl[t];
  return n ? `${r}-${n}` : `${ni.generate(e)}-${t}`;
}
function oi(e, t, r = "Mui") {
  const n = {};
  return t.forEach((o) => {
    n[o] = Sn(e, o, r);
  }), n;
}
var $l = { exports: {} }, ve = {};
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ai = Symbol.for("react.transitional.element"), ii = Symbol.for("react.portal"), Uo = Symbol.for("react.fragment"), jo = Symbol.for("react.strict_mode"), Bo = Symbol.for("react.profiler"), Do = Symbol.for("react.consumer"), Mo = Symbol.for("react.context"), Fo = Symbol.for("react.forward_ref"), qo = Symbol.for("react.suspense"), Jo = Symbol.for("react.suspense_list"), Wo = Symbol.for("react.memo"), Lo = Symbol.for("react.lazy"), rf = Symbol.for("react.view_transition"), nf = Symbol.for("react.client.reference");
function vt(e) {
  if (typeof e == "object" && e !== null) {
    var t = e.$$typeof;
    switch (t) {
      case ai:
        switch (e = e.type, e) {
          case Uo:
          case Bo:
          case jo:
          case qo:
          case Jo:
          case rf:
            return e;
          default:
            switch (e = e && e.$$typeof, e) {
              case Mo:
              case Fo:
              case Lo:
              case Wo:
                return e;
              case Do:
                return e;
              default:
                return t;
            }
        }
      case ii:
        return t;
    }
  }
}
ve.ContextConsumer = Do;
ve.ContextProvider = Mo;
ve.Element = ai;
ve.ForwardRef = Fo;
ve.Fragment = Uo;
ve.Lazy = Lo;
ve.Memo = Wo;
ve.Portal = ii;
ve.Profiler = Bo;
ve.StrictMode = jo;
ve.Suspense = qo;
ve.SuspenseList = Jo;
ve.isContextConsumer = function(e) {
  return vt(e) === Do;
};
ve.isContextProvider = function(e) {
  return vt(e) === Mo;
};
ve.isElement = function(e) {
  return typeof e == "object" && e !== null && e.$$typeof === ai;
};
ve.isForwardRef = function(e) {
  return vt(e) === Fo;
};
ve.isFragment = function(e) {
  return vt(e) === Uo;
};
ve.isLazy = function(e) {
  return vt(e) === Lo;
};
ve.isMemo = function(e) {
  return vt(e) === Wo;
};
ve.isPortal = function(e) {
  return vt(e) === ii;
};
ve.isProfiler = function(e) {
  return vt(e) === Bo;
};
ve.isStrictMode = function(e) {
  return vt(e) === jo;
};
ve.isSuspense = function(e) {
  return vt(e) === qo;
};
ve.isSuspenseList = function(e) {
  return vt(e) === Jo;
};
ve.isValidElementType = function(e) {
  return typeof e == "string" || typeof e == "function" || e === Uo || e === Bo || e === jo || e === qo || e === Jo || typeof e == "object" && e !== null && (e.$$typeof === Lo || e.$$typeof === Wo || e.$$typeof === Mo || e.$$typeof === Do || e.$$typeof === Fo || e.$$typeof === nf || e.getModuleId !== void 0);
};
ve.typeOf = vt;
$l.exports = ve;
var ls = $l.exports;
const of = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function _l(e) {
  const t = `${e}`.match(of);
  return t && t[1] || "";
}
function ec(e, t = "") {
  return e.displayName || e.name || _l(e) || t;
}
function cs(e, t, r) {
  const n = ec(t);
  return e.displayName || (n !== "" ? `${r}(${n})` : r);
}
function af(e) {
  if (e != null) {
    if (typeof e == "string")
      return e;
    if (typeof e == "function")
      return ec(e, "Component");
    if (typeof e == "object")
      switch (e.$$typeof) {
        case ls.ForwardRef:
          return cs(e, e.render, "ForwardRef");
        case ls.Memo:
          return cs(e, e.type, "memo");
        default:
          return;
      }
  }
}
const sf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: af,
  getFunctionName: _l
}, Symbol.toStringTag, { value: "Module" })), lf = ["ownerState"], cf = ["variants"], df = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function uf(e) {
  return Object.keys(e).length === 0;
}
function pf(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function oa(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function ds(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
const ff = Rr(), gf = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function Bn({
  defaultTheme: e,
  theme: t,
  themeId: r
}) {
  return uf(t) ? e : t[r] || t;
}
function hf(e) {
  return e ? (t, r) => r[e] : null;
}
function Gn(e, t, r) {
  let {
    ownerState: n
  } = t, o = ee(t, lf);
  const a = typeof e == "function" ? e(y({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(a))
    return a.flatMap((i) => Gn(i, y({
      ownerState: n
    }, o), r));
  if (a && typeof a == "object" && Array.isArray(a.variants)) {
    const {
      variants: i = []
    } = a;
    let l = ee(a, cf);
    return i.forEach((d) => {
      let u = !0;
      if (typeof d.props == "function" ? u = d.props(y({
        ownerState: n
      }, o, n)) : Object.keys(d.props).forEach((p) => {
        (n == null ? void 0 : n[p]) !== d.props[p] && o[p] !== d.props[p] && (u = !1);
      }), u) {
        Array.isArray(l) || (l = [l]);
        const p = typeof d.style == "function" ? d.style(y({
          ownerState: n
        }, o, n)) : d.style;
        l.push(r ? ds(eo(p), r) : p);
      }
    }), l;
  }
  return r ? ds(eo(a), r) : a;
}
function tc(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = ff,
    rootShouldForwardProp: n = oa,
    slotShouldForwardProp: o = oa
  } = e, a = (i) => rr(y({}, i, {
    theme: Bn(y({}, i, {
      defaultTheme: r,
      themeId: t
    }))
  }));
  return a.__mui_systemSx = !0, (i, s = {}) => {
    Ll(i, (I) => I.filter((w) => !(w != null && w.__mui_systemSx)));
    const {
      name: l,
      slot: d,
      skipVariantsResolver: u,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: f = hf(gf(d))
    } = s, g = ee(s, df), h = l && l.startsWith("Mui") || d ? "components" : "custom", m = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), A = p || !1;
    let b, C = oa;
    d === "Root" || d === "root" ? C = n : d ? C = o : pf(i) && (C = void 0);
    const v = Ga(i, y({
      shouldForwardProp: C,
      label: b
    }, g)), k = (I) => typeof I == "function" && I.__emotion_real !== I || Ut(I) ? (w) => {
      const P = Bn({
        theme: w.theme,
        defaultTheme: r,
        themeId: t
      });
      return Gn(I, y({}, w, {
        theme: P
      }), P.modularCssLayers ? h : void 0);
    } : I, S = (I, ...w) => {
      let P = k(I);
      const E = w ? w.map(k) : [];
      l && f && E.push((B) => {
        const V = Bn(y({}, B, {
          defaultTheme: r,
          themeId: t
        }));
        if (!V.components || !V.components[l] || !V.components[l].styleOverrides)
          return null;
        const M = V.components[l].styleOverrides, j = {};
        return Object.entries(M).forEach(([T, O]) => {
          j[T] = Gn(O, y({}, B, {
            theme: V
          }), V.modularCssLayers ? "theme" : void 0);
        }), f(B, j);
      }), l && !m && E.push((B) => {
        var V;
        const M = Bn(y({}, B, {
          defaultTheme: r,
          themeId: t
        })), j = M == null || (V = M.components) == null || (V = V[l]) == null ? void 0 : V.variants;
        return Gn({
          variants: j
        }, y({}, B, {
          theme: M
        }), M.modularCssLayers ? "theme" : void 0);
      }), A || E.push(a);
      const K = E.length - w.length;
      if (Array.isArray(I) && K > 0) {
        const B = new Array(K).fill("");
        P = [...I, ...B], P.raw = [...I.raw, ...B];
      }
      const R = v(P, ...E);
      return i.muiName && (R.muiName = i.muiName), R;
    };
    return v.withConfig && (S.withConfig = v.withConfig), S;
  };
}
const rc = tc();
function ro(e, t) {
  const r = y({}, t);
  return Object.keys(e).forEach((n) => {
    if (n.toString().match(/^(components|slots)$/))
      r[n] = y({}, e[n], r[n]);
    else if (n.toString().match(/^(componentsProps|slotProps)$/)) {
      const o = e[n] || {}, a = t[n];
      r[n] = {}, !a || !Object.keys(a) ? r[n] = o : !o || !Object.keys(o) ? r[n] = a : (r[n] = y({}, a), Object.keys(o).forEach((i) => {
        r[n][i] = ro(o[i], a[i]);
      }));
    } else r[n] === void 0 && (r[n] = e[n]);
  }), r;
}
function mf(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  return !t || !t.components || !t.components[r] || !t.components[r].defaultProps ? n : ro(t.components[r].defaultProps, n);
}
function si({
  props: e,
  name: t,
  defaultTheme: r,
  themeId: n
}) {
  let o = Ro(r);
  return n && (o = o[n] || o), mf({
    theme: o,
    name: t,
    props: e
  });
}
const Bt = typeof window < "u" ? x.useLayoutEffect : x.useEffect;
function vf(e, t = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER) {
  return Math.max(t, Math.min(e, r));
}
const bf = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: vf
}, Symbol.toStringTag, { value: "Module" }));
function xf(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function nc(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return nc(xf(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error(jt(9, e));
  let n = e.substring(t + 1, e.length - 1), o;
  if (r === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error(jt(10, o));
  } else
    n = n.split(",");
  return n = n.map((a) => parseFloat(a)), {
    type: r,
    values: n,
    colorSpace: o
  };
}
const Nt = (e) => {
  const t = nc(e);
  return t.values.slice(0, 3).map((r, n) => t.type.indexOf("hsl") !== -1 && n !== 0 ? `${r}%` : r).join(" ");
};
function Aa(...e) {
  return e.reduce((t, r) => r == null ? t : function(...o) {
    t.apply(this, o), r.apply(this, o);
  }, () => {
  });
}
function yf(e, t = 166) {
  let r;
  function n(...o) {
    const a = () => {
      e.apply(this, o);
    };
    clearTimeout(r), r = setTimeout(a, t);
  }
  return n.clear = () => {
    clearTimeout(r);
  }, n;
}
function Af(e, t) {
  return () => null;
}
function kn(e, t) {
  var r, n;
  return /* @__PURE__ */ x.isValidElement(e) && t.indexOf(
    // For server components `muiName` is avaialble in element.type._payload.value.muiName
    // relevant info - https://github.com/facebook/react/blob/2807d781a08db8e9873687fccc25c0f12b4fb3d4/packages/react/src/ReactLazy.js#L45
    // eslint-disable-next-line no-underscore-dangle
    (r = e.type.muiName) != null ? r : (n = e.type) == null || (n = n._payload) == null || (n = n.value) == null ? void 0 : n.muiName
  ) !== -1;
}
function _e(e) {
  return e && e.ownerDocument || document;
}
function zo(e) {
  return _e(e).defaultView || window;
}
function Cf(e, t) {
  return () => null;
}
function no(e, t) {
  typeof e == "function" ? e(t) : e && (e.current = t);
}
let us = 0;
function Sf(e) {
  const [t, r] = x.useState(e), n = e || t;
  return x.useEffect(() => {
    t == null && (us += 1, r(`mui-${us}`));
  }, [t]), n;
}
const ps = x.useId;
function Wt(e) {
  if (ps !== void 0) {
    const t = ps();
    return e ?? t;
  }
  return Sf(e);
}
function kf(e, t, r, n, o) {
  return null;
}
function oc({
  controlled: e,
  default: t,
  name: r,
  state: n = "value"
}) {
  const {
    current: o
  } = x.useRef(e !== void 0), [a, i] = x.useState(t), s = o ? e : a, l = x.useCallback((d) => {
    o || i(d);
  }, []);
  return [s, l];
}
function Sr(e) {
  const t = x.useRef(e);
  return Bt(() => {
    t.current = e;
  }), x.useRef((...r) => (
    // @ts-expect-error hide `this`
    (0, t.current)(...r)
  )).current;
}
function ke(...e) {
  return x.useMemo(() => e.every((t) => t == null) ? null : (t) => {
    e.forEach((r) => {
      no(r, t);
    });
  }, e);
}
const fs = {};
function If(e, t) {
  const r = x.useRef(fs);
  return r.current === fs && (r.current = e(t)), r;
}
const wf = [];
function Pf(e) {
  x.useEffect(e, wf);
}
class No {
  constructor() {
    this.currentId = null, this.clear = () => {
      this.currentId !== null && (clearTimeout(this.currentId), this.currentId = null);
    }, this.disposeEffect = () => this.clear;
  }
  static create() {
    return new No();
  }
  /**
   * Executes `fn` after `delay`, clearing any previously scheduled call.
   */
  start(t, r) {
    this.clear(), this.currentId = setTimeout(() => {
      this.currentId = null, r();
    }, t);
  }
}
function Tf() {
  const e = If(No.create).current;
  return Pf(e.disposeEffect), e;
}
let Qo = !0, Ca = !1;
const Of = new No(), Vf = {
  text: !0,
  search: !0,
  url: !0,
  tel: !0,
  email: !0,
  password: !0,
  number: !0,
  date: !0,
  month: !0,
  week: !0,
  time: !0,
  datetime: !0,
  "datetime-local": !0
};
function Ef(e) {
  const {
    type: t,
    tagName: r
  } = e;
  return !!(r === "INPUT" && Vf[t] && !e.readOnly || r === "TEXTAREA" && !e.readOnly || e.isContentEditable);
}
function Kf(e) {
  e.metaKey || e.altKey || e.ctrlKey || (Qo = !0);
}
function aa() {
  Qo = !1;
}
function Rf() {
  this.visibilityState === "hidden" && Ca && (Qo = !0);
}
function Uf(e) {
  e.addEventListener("keydown", Kf, !0), e.addEventListener("mousedown", aa, !0), e.addEventListener("pointerdown", aa, !0), e.addEventListener("touchstart", aa, !0), e.addEventListener("visibilitychange", Rf, !0);
}
function jf(e) {
  const {
    target: t
  } = e;
  try {
    return t.matches(":focus-visible");
  } catch {
  }
  return Qo || Ef(t);
}
function ac() {
  const e = x.useCallback((o) => {
    o != null && Uf(o.ownerDocument);
  }, []), t = x.useRef(!1);
  function r() {
    return t.current ? (Ca = !0, Of.start(100, () => {
      Ca = !1;
    }), t.current = !1, !0) : !1;
  }
  function n(o) {
    return jf(o) ? (t.current = !0, !0) : !1;
  }
  return {
    isFocusVisibleRef: t,
    onFocus: n,
    onBlur: r,
    ref: e
  };
}
function Bf(e) {
  const t = e.documentElement.clientWidth;
  return Math.abs(window.innerWidth - t);
}
const Df = {
  border: 0,
  clip: "rect(0 0 0 0)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px"
};
function me(e, t, r = void 0) {
  const n = {};
  return Object.keys(e).forEach(
    // `Object.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
    // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
    (o) => {
      n[o] = e[o].reduce((a, i) => {
        if (i) {
          const s = t(i);
          s !== "" && a.push(s), r && r[i] && a.push(r[i]);
        }
        return a;
      }, []).join(" ");
    }
  ), n;
}
function Mf(e) {
  return typeof e == "string";
}
function ic(e, t, r) {
  return e === void 0 || Mf(e) ? t : y({}, t, {
    ownerState: y({}, t.ownerState, r)
  });
}
function ze(e, t = []) {
  if (e === void 0)
    return {};
  const r = {};
  return Object.keys(e).filter((n) => n.match(/^on[A-Z]/) && typeof e[n] == "function" && !t.includes(n)).forEach((n) => {
    r[n] = e[n];
  }), r;
}
function gs(e) {
  if (e === void 0)
    return {};
  const t = {};
  return Object.keys(e).filter((r) => !(r.match(/^on[A-Z]/) && typeof e[r] == "function")).forEach((r) => {
    t[r] = e[r];
  }), t;
}
function sc(e) {
  const {
    getSlotProps: t,
    additionalProps: r,
    externalSlotProps: n,
    externalForwardedProps: o,
    className: a
  } = e;
  if (!t) {
    const g = Qe(r == null ? void 0 : r.className, a, o == null ? void 0 : o.className, n == null ? void 0 : n.className), h = y({}, r == null ? void 0 : r.style, o == null ? void 0 : o.style, n == null ? void 0 : n.style), m = y({}, r, o, n);
    return g.length > 0 && (m.className = g), Object.keys(h).length > 0 && (m.style = h), {
      props: m,
      internalRef: void 0
    };
  }
  const i = ze(y({}, o, n)), s = gs(n), l = gs(o), d = t(i), u = Qe(d == null ? void 0 : d.className, r == null ? void 0 : r.className, a, o == null ? void 0 : o.className, n == null ? void 0 : n.className), p = y({}, d == null ? void 0 : d.style, r == null ? void 0 : r.style, o == null ? void 0 : o.style, n == null ? void 0 : n.style), f = y({}, d, r, l, s);
  return u.length > 0 && (f.className = u), Object.keys(p).length > 0 && (f.style = p), {
    props: f,
    internalRef: d.ref
  };
}
function lc(e, t, r) {
  return typeof e == "function" ? e(t, r) : e;
}
const Ff = ["elementType", "externalSlotProps", "ownerState", "skipResolvingSlotProps"];
function qf(e) {
  var t;
  const {
    elementType: r,
    externalSlotProps: n,
    ownerState: o,
    skipResolvingSlotProps: a = !1
  } = e, i = ee(e, Ff), s = a ? {} : lc(n, o), {
    props: l,
    internalRef: d
  } = sc(y({}, i, {
    externalSlotProps: s
  })), u = ke(d, s == null ? void 0 : s.ref, (t = e.additionalProps) == null ? void 0 : t.ref);
  return ic(r, y({}, l, {
    ref: u
  }), o);
}
function li(e) {
  if (parseInt(x.version, 10) >= 19) {
    var t;
    return (e == null || (t = e.props) == null ? void 0 : t.ref) || null;
  }
  return (e == null ? void 0 : e.ref) || null;
}
const cc = /* @__PURE__ */ x.createContext(null);
function ci() {
  return x.useContext(cc);
}
const Jf = typeof Symbol == "function" && Symbol.for, Wf = Jf ? Symbol.for("mui.nested") : "__THEME_NESTED__";
function Lf(e, t) {
  return typeof t == "function" ? t(e) : y({}, e, t);
}
function zf(e) {
  const {
    children: t,
    theme: r
  } = e, n = ci(), o = x.useMemo(() => {
    const a = n === null ? r : Lf(n, r);
    return a != null && (a[Wf] = n !== null), a;
  }, [r, n]);
  return /* @__PURE__ */ c.jsx(cc.Provider, {
    value: o,
    children: t
  });
}
const Nf = ["value"], Qf = /* @__PURE__ */ x.createContext();
function Hf(e) {
  let {
    value: t
  } = e, r = ee(e, Nf);
  return /* @__PURE__ */ c.jsx(Qf.Provider, y({
    value: t ?? !0
  }, r));
}
const dc = /* @__PURE__ */ x.createContext(void 0);
function Gf({
  value: e,
  children: t
}) {
  return /* @__PURE__ */ c.jsx(dc.Provider, {
    value: e,
    children: t
  });
}
function Zf(e) {
  const {
    theme: t,
    name: r,
    props: n
  } = e;
  if (!t || !t.components || !t.components[r])
    return n;
  const o = t.components[r];
  return o.defaultProps ? ro(o.defaultProps, n) : !o.styleOverrides && !o.variants ? ro(o, n) : n;
}
function Yf({
  props: e,
  name: t
}) {
  const r = x.useContext(dc);
  return Zf({
    props: e,
    name: t,
    theme: {
      components: r
    }
  });
}
function Xf(e) {
  const t = ri(), r = Wt() || "", {
    modularCssLayers: n
  } = e;
  let o = "mui.global, mui.components, mui.theme, mui.custom, mui.sx";
  return !n || t !== null ? o = "" : typeof n == "string" ? o = n.replace(/mui(?!\.)/g, o) : o = `@layer ${o};`, Bt(() => {
    const a = document.querySelector("head");
    if (!a)
      return;
    const i = a.firstChild;
    if (o) {
      var s;
      if (i && (s = i.hasAttribute) != null && s.call(i, "data-mui-layer-order") && i.getAttribute("data-mui-layer-order") === r)
        return;
      const d = document.createElement("style");
      d.setAttribute("data-mui-layer-order", r), d.textContent = o, a.prepend(d);
    } else {
      var l;
      (l = a.querySelector(`style[data-mui-layer-order="${r}"]`)) == null || l.remove();
    }
  }, [o, r]), o ? /* @__PURE__ */ c.jsx(Zl, {
    styles: o
  }) : null;
}
const hs = {};
function ms(e, t, r, n = !1) {
  return x.useMemo(() => {
    const o = e && t[e] || t;
    if (typeof r == "function") {
      const a = r(o), i = e ? y({}, t, {
        [e]: a
      }) : a;
      return n ? () => i : i;
    }
    return e ? y({}, t, {
      [e]: r
    }) : y({}, t, r);
  }, [e, t, r, n]);
}
function $f(e) {
  const {
    children: t,
    theme: r,
    themeId: n
  } = e, o = ri(hs), a = ci() || hs, i = ms(n, o, r), s = ms(n, a, r, !0), l = i.direction === "rtl", d = Xf(i);
  return /* @__PURE__ */ c.jsx(zf, {
    theme: s,
    children: /* @__PURE__ */ c.jsx(Er.Provider, {
      value: i,
      children: /* @__PURE__ */ c.jsx(Hf, {
        value: l,
        children: /* @__PURE__ */ c.jsxs(Gf, {
          value: i == null ? void 0 : i.components,
          children: [d, t]
        })
      })
    })
  });
}
const di = "mode", ui = "color-scheme", uc = "data-color-scheme";
function _f(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: r = "light",
    defaultDarkColorScheme: n = "dark",
    modeStorageKey: o = di,
    colorSchemeStorageKey: a = ui,
    attribute: i = uc,
    colorSchemeNode: s = "document.documentElement",
    nonce: l
  } = e || {};
  return /* @__PURE__ */ c.jsx("script", {
    suppressHydrationWarning: !0,
    nonce: typeof window > "u" ? l : "",
    dangerouslySetInnerHTML: {
      __html: `(function() {
try {
  var mode = localStorage.getItem('${o}') || '${t}';
  var colorScheme = '';
  if (mode === 'system') {
    // handle system mode
    var mql = window.matchMedia('(prefers-color-scheme: dark)');
    if (mql.matches) {
      colorScheme = localStorage.getItem('${a}-dark') || '${n}';
    } else {
      colorScheme = localStorage.getItem('${a}-light') || '${r}';
    }
  }
  if (mode === 'light') {
    colorScheme = localStorage.getItem('${a}-light') || '${r}';
  }
  if (mode === 'dark') {
    colorScheme = localStorage.getItem('${a}-dark') || '${n}';
  }
  if (colorScheme) {
    ${s}.setAttribute('${i}', colorScheme);
  }
} catch(e){}})();`
    }
  }, "mui-color-scheme-init");
}
function vs(e) {
  if (typeof window < "u" && e === "system")
    return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}
function pc(e, t) {
  if (e.mode === "light" || e.mode === "system" && e.systemMode === "light")
    return t("light");
  if (e.mode === "dark" || e.mode === "system" && e.systemMode === "dark")
    return t("dark");
}
function eg(e) {
  return pc(e, (t) => {
    if (t === "light")
      return e.lightColorScheme;
    if (t === "dark")
      return e.darkColorScheme;
  });
}
function ia(e, t) {
  if (typeof window > "u")
    return;
  let r;
  try {
    r = localStorage.getItem(e) || void 0, r || localStorage.setItem(e, t);
  } catch {
  }
  return r || t;
}
function tg(e) {
  const {
    defaultMode: t = "light",
    defaultLightColorScheme: r,
    defaultDarkColorScheme: n,
    supportedColorSchemes: o = [],
    modeStorageKey: a = di,
    colorSchemeStorageKey: i = ui,
    storageWindow: s = typeof window > "u" ? void 0 : window
  } = e, l = o.join(","), [d, u] = x.useState(() => {
    const A = ia(a, t), b = ia(`${i}-light`, r), C = ia(`${i}-dark`, n);
    return {
      mode: A,
      systemMode: vs(A),
      lightColorScheme: b,
      darkColorScheme: C
    };
  }), p = eg(d), f = x.useCallback((A) => {
    u((b) => {
      if (A === b.mode)
        return b;
      const C = A ?? t;
      try {
        localStorage.setItem(a, C);
      } catch {
      }
      return y({}, b, {
        mode: C,
        systemMode: vs(C)
      });
    });
  }, [a, t]), g = x.useCallback((A) => {
    A ? typeof A == "string" ? A && !l.includes(A) ? console.error(`\`${A}\` does not exist in \`theme.colorSchemes\`.`) : u((b) => {
      const C = y({}, b);
      return pc(b, (v) => {
        try {
          localStorage.setItem(`${i}-${v}`, A);
        } catch {
        }
        v === "light" && (C.lightColorScheme = A), v === "dark" && (C.darkColorScheme = A);
      }), C;
    }) : u((b) => {
      const C = y({}, b), v = A.light === null ? r : A.light, k = A.dark === null ? n : A.dark;
      if (v)
        if (!l.includes(v))
          console.error(`\`${v}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          C.lightColorScheme = v;
          try {
            localStorage.setItem(`${i}-light`, v);
          } catch {
          }
        }
      if (k)
        if (!l.includes(k))
          console.error(`\`${k}\` does not exist in \`theme.colorSchemes\`.`);
        else {
          C.darkColorScheme = k;
          try {
            localStorage.setItem(`${i}-dark`, k);
          } catch {
          }
        }
      return C;
    }) : u((b) => {
      try {
        localStorage.setItem(`${i}-light`, r), localStorage.setItem(`${i}-dark`, n);
      } catch {
      }
      return y({}, b, {
        lightColorScheme: r,
        darkColorScheme: n
      });
    });
  }, [l, i, r, n]), h = x.useCallback((A) => {
    d.mode === "system" && u((b) => {
      const C = A != null && A.matches ? "dark" : "light";
      return b.systemMode === C ? b : y({}, b, {
        systemMode: C
      });
    });
  }, [d.mode]), m = x.useRef(h);
  return m.current = h, x.useEffect(() => {
    const A = (...C) => m.current(...C), b = window.matchMedia("(prefers-color-scheme: dark)");
    return b.addListener(A), A(b), () => {
      b.removeListener(A);
    };
  }, []), x.useEffect(() => {
    if (s) {
      const A = (b) => {
        const C = b.newValue;
        typeof b.key == "string" && b.key.startsWith(i) && (!C || l.match(C)) && (b.key.endsWith("light") && g({
          light: C
        }), b.key.endsWith("dark") && g({
          dark: C
        })), b.key === a && (!C || ["light", "dark", "system"].includes(C)) && f(C || t);
      };
      return s.addEventListener("storage", A), () => {
        s.removeEventListener("storage", A);
      };
    }
  }, [g, f, a, i, l, t, s]), y({}, d, {
    colorScheme: p,
    setMode: f,
    setColorScheme: g
  });
}
const rg = ["colorSchemes", "components", "generateCssVars", "cssVarPrefix"], ng = "*{-webkit-transition:none!important;-moz-transition:none!important;-o-transition:none!important;-ms-transition:none!important;transition:none!important}";
function og(e) {
  const {
    themeId: t,
    /**
     * This `theme` object needs to follow a certain structure to
     * be used correctly by the finel `CssVarsProvider`. It should have a
     * `colorSchemes` key with the light and dark (and any other) palette.
     * It should also ideally have a vars object created using `prepareCssVars`.
     */
    theme: r = {},
    attribute: n = uc,
    modeStorageKey: o = di,
    colorSchemeStorageKey: a = ui,
    defaultMode: i = "light",
    defaultColorScheme: s,
    disableTransitionOnChange: l = !1,
    resolveTheme: d,
    excludeVariablesFromRoot: u
  } = e;
  (!r.colorSchemes || typeof s == "string" && !r.colorSchemes[s] || typeof s == "object" && !r.colorSchemes[s == null ? void 0 : s.light] || typeof s == "object" && !r.colorSchemes[s == null ? void 0 : s.dark]) && console.error(`MUI: \`${s}\` does not exist in \`theme.colorSchemes\`.`);
  const p = /* @__PURE__ */ x.createContext(void 0), f = () => {
    const b = x.useContext(p);
    if (!b)
      throw new Error(jt(19));
    return b;
  };
  function g(b) {
    const {
      children: C,
      theme: v = r,
      modeStorageKey: k = o,
      colorSchemeStorageKey: S = a,
      attribute: I = n,
      defaultMode: w = i,
      defaultColorScheme: P = s,
      disableTransitionOnChange: E = l,
      storageWindow: K = typeof window > "u" ? void 0 : window,
      documentNode: R = typeof document > "u" ? void 0 : document,
      colorSchemeNode: B = typeof document > "u" ? void 0 : document.documentElement,
      colorSchemeSelector: V = ":root",
      disableNestedContext: M = !1,
      disableStyleSheetGeneration: j = !1
    } = b, T = x.useRef(!1), O = ci(), F = x.useContext(p), N = !!F && !M, te = v[t], G = te || v, {
      colorSchemes: Z = {},
      components: ie = {},
      generateCssVars: le = () => ({
        vars: {},
        css: {}
      }),
      cssVarPrefix: ae
    } = G, ce = ee(G, rg), q = Object.keys(Z), D = typeof P == "string" ? P : P.light, W = typeof P == "string" ? P : P.dark, {
      mode: Q,
      setMode: $,
      systemMode: se,
      lightColorScheme: X,
      darkColorScheme: de,
      colorScheme: Ge,
      setColorScheme: nt
    } = tg({
      supportedColorSchemes: q,
      defaultLightColorScheme: D,
      defaultDarkColorScheme: W,
      modeStorageKey: k,
      colorSchemeStorageKey: S,
      defaultMode: w,
      storageWindow: K
    });
    let Ke = Q, Ae = Ge;
    N && (Ke = F.mode, Ae = F.colorScheme);
    const ct = Ke || (w === "system" ? i : w), ot = Ae || (ct === "dark" ? W : D), {
      css: kt,
      vars: Kt
    } = le(), De = y({}, ce, {
      components: ie,
      colorSchemes: Z,
      cssVarPrefix: ae,
      vars: Kt,
      getColorSchemeSelector: (Ie) => `[${I}="${Ie}"] &`
    }), bt = {}, xt = {};
    Object.entries(Z).forEach(([Ie, Me]) => {
      const {
        css: yt,
        vars: L
      } = le(Ie);
      De.vars = je(De.vars, L), Ie === ot && (Object.keys(Me).forEach((ne) => {
        Me[ne] && typeof Me[ne] == "object" ? De[ne] = y({}, De[ne], Me[ne]) : De[ne] = Me[ne];
      }), De.palette && (De.palette.colorScheme = Ie));
      const Y = typeof P == "string" ? P : w === "dark" ? P.dark : P.light;
      if (Ie === Y) {
        if (u) {
          const ne = {};
          u(ae).forEach((Oe) => {
            ne[Oe] = yt[Oe], delete yt[Oe];
          }), bt[`[${I}="${Ie}"]`] = ne;
        }
        bt[`${V}, [${I}="${Ie}"]`] = yt;
      } else
        xt[`${V === ":root" ? "" : V}[${I}="${Ie}"]`] = yt;
    }), De.vars = je(De.vars, Kt), x.useEffect(() => {
      Ae && B && B.setAttribute(I, Ae);
    }, [Ae, I, B]), x.useEffect(() => {
      let Ie;
      if (E && T.current && R) {
        const Me = R.createElement("style");
        Me.appendChild(R.createTextNode(ng)), R.head.appendChild(Me), window.getComputedStyle(R.body), Ie = setTimeout(() => {
          R.head.removeChild(Me);
        }, 1);
      }
      return () => {
        clearTimeout(Ie);
      };
    }, [Ae, E, R]), x.useEffect(() => (T.current = !0, () => {
      T.current = !1;
    }), []);
    const Rt = x.useMemo(() => ({
      allColorSchemes: q,
      colorScheme: Ae,
      darkColorScheme: de,
      lightColorScheme: X,
      mode: Ke,
      setColorScheme: nt,
      setMode: $,
      systemMode: se
    }), [q, Ae, de, X, Ke, nt, $, se]);
    let Ze = !0;
    (j || N && (O == null ? void 0 : O.cssVarPrefix) === ae) && (Ze = !1);
    const We = /* @__PURE__ */ c.jsxs(x.Fragment, {
      children: [Ze && /* @__PURE__ */ c.jsxs(x.Fragment, {
        children: [/* @__PURE__ */ c.jsx($r, {
          styles: {
            [V]: kt
          }
        }), /* @__PURE__ */ c.jsx($r, {
          styles: bt
        }), /* @__PURE__ */ c.jsx($r, {
          styles: xt
        })]
      }), /* @__PURE__ */ c.jsx($f, {
        themeId: te ? t : void 0,
        theme: d ? d(De) : De,
        children: C
      })]
    });
    return N ? We : /* @__PURE__ */ c.jsx(p.Provider, {
      value: Rt,
      children: We
    });
  }
  const h = typeof s == "string" ? s : s.light, m = typeof s == "string" ? s : s.dark;
  return {
    CssVarsProvider: g,
    useColorScheme: f,
    getInitColorSchemeScript: (b) => _f(y({
      attribute: n,
      colorSchemeStorageKey: a,
      defaultMode: i,
      defaultLightColorScheme: h,
      defaultDarkColorScheme: m,
      modeStorageKey: o
    }, b))
  };
}
function pi(e = "") {
  function t(...n) {
    if (!n.length)
      return "";
    const o = n[0];
    return typeof o == "string" && !o.match(/(#|\(|\)|(-?(\d*\.)?\d+)(px|em|%|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc))|^(-?(\d*\.)?\d+)$|(\d+ \d+ \d+)/) ? `, var(--${e ? `${e}-` : ""}${o}${t(...n.slice(1))})` : `, ${o}`;
  }
  return (n, ...o) => `var(--${e ? `${e}-` : ""}${n}${t(...o)})`;
}
const bs = (e, t, r, n = []) => {
  let o = e;
  t.forEach((a, i) => {
    i === t.length - 1 ? Array.isArray(o) ? o[Number(a)] = r : o && typeof o == "object" && (o[a] = r) : o && typeof o == "object" && (o[a] || (o[a] = n.includes(a) ? [] : {}), o = o[a]);
  });
}, ag = (e, t, r) => {
  function n(o, a = [], i = []) {
    Object.entries(o).forEach(([s, l]) => {
      (!r || r && !r([...a, s])) && l != null && (typeof l == "object" && Object.keys(l).length > 0 ? n(l, [...a, s], Array.isArray(l) ? [...i, s] : i) : t([...a, s], l, i));
    });
  }
  n(e);
}, ig = (e, t) => typeof t == "number" ? ["lineHeight", "fontWeight", "opacity", "zIndex"].some((n) => e.includes(n)) || e[e.length - 1].toLowerCase().indexOf("opacity") >= 0 ? t : `${t}px` : t;
function sa(e, t) {
  const {
    prefix: r,
    shouldSkipGeneratingVar: n
  } = t || {}, o = {}, a = {}, i = {};
  return ag(
    e,
    (s, l, d) => {
      if ((typeof l == "string" || typeof l == "number") && (!n || !n(s, l))) {
        const u = `--${r ? `${r}-` : ""}${s.join("-")}`;
        Object.assign(o, {
          [u]: ig(s, l)
        }), bs(a, s, `var(${u})`, d), bs(i, s, `var(${u}, ${l})`, d);
      }
    },
    (s) => s[0] === "vars"
    // skip 'vars/*' paths
  ), {
    css: o,
    vars: a,
    varsWithDefaults: i
  };
}
function cn(e) {
  "@babel/helpers - typeof";
  return cn = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, cn(e);
}
function sg(e, t) {
  if (cn(e) != "object" || !e) return e;
  var r = e[Symbol.toPrimitive];
  if (r !== void 0) {
    var n = r.call(e, t);
    if (cn(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(e);
}
function lg(e) {
  var t = sg(e, "string");
  return cn(t) == "symbol" ? t : t + "";
}
const cg = ["colorSchemes", "components", "defaultColorScheme"];
function dg(e, t) {
  const {
    colorSchemes: r = {},
    defaultColorScheme: n = "light"
  } = e, o = ee(e, cg), {
    vars: a,
    css: i,
    varsWithDefaults: s
  } = sa(o, t);
  let l = s;
  const d = {}, {
    [n]: u
  } = r, p = ee(r, [n].map(lg));
  if (Object.entries(p || {}).forEach(([g, h]) => {
    const {
      vars: m,
      css: A,
      varsWithDefaults: b
    } = sa(h, t);
    l = je(l, b), d[g] = {
      css: A,
      vars: m
    };
  }), u) {
    const {
      css: g,
      vars: h,
      varsWithDefaults: m
    } = sa(u, t);
    l = je(l, m), d[n] = {
      css: g,
      vars: h
    };
  }
  return {
    vars: l,
    generateCssVars: (g) => {
      var h;
      if (!g) {
        var m;
        const b = y({}, i);
        return {
          css: b,
          vars: a,
          selector: (t == null || (m = t.getSelector) == null ? void 0 : m.call(t, g, b)) || ":root"
        };
      }
      const A = y({}, d[g].css);
      return {
        css: A,
        vars: d[g].vars,
        selector: (t == null || (h = t.getSelector) == null ? void 0 : h.call(t, g, A)) || ":root"
      };
    }
  };
}
const ug = (e, t) => e.filter((r) => t.includes(r)), Ur = (e, t, r) => {
  const n = e.keys[0];
  Array.isArray(t) ? t.forEach((o, a) => {
    r((i, s) => {
      a <= e.keys.length - 1 && (a === 0 ? Object.assign(i, s) : i[e.up(e.keys[a])] = s);
    }, o);
  }) : t && typeof t == "object" ? (Object.keys(t).length > e.keys.length ? e.keys : ug(e.keys, Object.keys(t))).forEach((a) => {
    if (e.keys.indexOf(a) !== -1) {
      const i = t[a];
      i !== void 0 && r((s, l) => {
        n === a ? Object.assign(s, l) : s[e.up(a)] = l;
      }, i);
    }
  }) : (typeof t == "number" || typeof t == "string") && r((o, a) => {
    Object.assign(o, a);
  }, t);
};
function Dt(e) {
  return e ? `Level${e}` : "";
}
function In(e) {
  return e.unstable_level > 0 && e.container;
}
function fc(e) {
  return function(r) {
    return `var(--Grid-${r}Spacing${Dt(e.unstable_level)})`;
  };
}
function fi(e) {
  return function(r) {
    return e.unstable_level === 0 ? `var(--Grid-${r}Spacing)` : `var(--Grid-${r}Spacing${Dt(e.unstable_level - 1)})`;
  };
}
function gi(e) {
  return e.unstable_level === 0 ? "var(--Grid-columns)" : `var(--Grid-columns${Dt(e.unstable_level - 1)})`;
}
const pg = ({
  theme: e,
  ownerState: t
}) => {
  const r = fc(t), n = {};
  return Ur(e.breakpoints, t.gridSize, (o, a) => {
    let i = {};
    a === !0 && (i = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: "100%"
    }), a === "auto" && (i = {
      flexBasis: "auto",
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: "none",
      width: "auto"
    }), typeof a == "number" && (i = {
      flexGrow: 0,
      flexBasis: "auto",
      width: `calc(100% * ${a} / ${gi(t)}${In(t) ? ` + ${r("column")}` : ""})`
    }), o(n, i);
  }), n;
}, fg = ({
  theme: e,
  ownerState: t
}) => {
  const r = {};
  return Ur(e.breakpoints, t.gridOffset, (n, o) => {
    let a = {};
    o === "auto" && (a = {
      marginLeft: "auto"
    }), typeof o == "number" && (a = {
      marginLeft: o === 0 ? "0px" : `calc(100% * ${o} / ${gi(t)})`
    }), n(r, a);
  }), r;
}, gg = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = In(t) ? {
    [`--Grid-columns${Dt(t.unstable_level)}`]: gi(t)
  } : {
    "--Grid-columns": 12
  };
  return Ur(e.breakpoints, t.columns, (n, o) => {
    n(r, {
      [`--Grid-columns${Dt(t.unstable_level)}`]: o
    });
  }), r;
}, hg = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = fi(t), n = In(t) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-rowSpacing${Dt(t.unstable_level)}`]: r("row")
  } : {};
  return Ur(e.breakpoints, t.rowSpacing, (o, a) => {
    var i;
    o(n, {
      [`--Grid-rowSpacing${Dt(t.unstable_level)}`]: typeof a == "string" ? a : (i = e.spacing) == null ? void 0 : i.call(e, a)
    });
  }), n;
}, mg = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = fi(t), n = In(t) ? {
    // Set the default spacing as its parent spacing.
    // It will be overridden if spacing props are provided
    [`--Grid-columnSpacing${Dt(t.unstable_level)}`]: r("column")
  } : {};
  return Ur(e.breakpoints, t.columnSpacing, (o, a) => {
    var i;
    o(n, {
      [`--Grid-columnSpacing${Dt(t.unstable_level)}`]: typeof a == "string" ? a : (i = e.spacing) == null ? void 0 : i.call(e, a)
    });
  }), n;
}, vg = ({
  theme: e,
  ownerState: t
}) => {
  if (!t.container)
    return {};
  const r = {};
  return Ur(e.breakpoints, t.direction, (n, o) => {
    n(r, {
      flexDirection: o
    });
  }), r;
}, bg = ({
  ownerState: e
}) => {
  const t = fc(e), r = fi(e);
  return y({
    minWidth: 0,
    boxSizing: "border-box"
  }, e.container && y({
    display: "flex",
    flexWrap: "wrap"
  }, e.wrap && e.wrap !== "wrap" && {
    flexWrap: e.wrap
  }, {
    margin: `calc(${t("row")} / -2) calc(${t("column")} / -2)`
  }, e.disableEqualOverflow && {
    margin: `calc(${t("row")} * -1) 0px 0px calc(${t("column")} * -1)`
  }), (!e.container || In(e)) && y({
    padding: `calc(${r("row")} / 2) calc(${r("column")} / 2)`
  }, (e.disableEqualOverflow || e.parentDisableEqualOverflow) && {
    padding: `${r("row")} 0px 0px ${r("column")}`
  }));
}, xg = (e) => {
  const t = [];
  return Object.entries(e).forEach(([r, n]) => {
    n !== !1 && n !== void 0 && t.push(`grid-${r}-${String(n)}`);
  }), t;
}, yg = (e, t = "xs") => {
  function r(n) {
    return n === void 0 ? !1 : typeof n == "string" && !Number.isNaN(Number(n)) || typeof n == "number" && n > 0;
  }
  if (r(e))
    return [`spacing-${t}-${String(e)}`];
  if (typeof e == "object" && !Array.isArray(e)) {
    const n = [];
    return Object.entries(e).forEach(([o, a]) => {
      r(a) && n.push(`spacing-${o}-${String(a)}`);
    }), n;
  }
  return [];
}, Ag = (e) => e === void 0 ? [] : typeof e == "object" ? Object.entries(e).map(([t, r]) => `direction-${t}-${r}`) : [`direction-xs-${String(e)}`], Cg = ["className", "children", "columns", "container", "component", "direction", "wrap", "spacing", "rowSpacing", "columnSpacing", "disableEqualOverflow", "unstable_level"], Sg = Rr(), kg = rc("div", {
  name: "MuiGrid",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function Ig(e) {
  return si({
    props: e,
    name: "MuiGrid",
    defaultTheme: Sg
  });
}
function wg(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = kg,
    useThemeProps: r = Ig,
    componentName: n = "MuiGrid"
  } = e, o = /* @__PURE__ */ x.createContext(void 0), a = (l, d) => {
    const {
      container: u,
      direction: p,
      spacing: f,
      wrap: g,
      gridSize: h
    } = l, m = {
      root: ["root", u && "container", g !== "wrap" && `wrap-xs-${String(g)}`, ...Ag(p), ...xg(h), ...u ? yg(f, d.breakpoints.keys[0]) : []]
    };
    return me(m, (A) => Sn(n, A), {});
  }, i = t(gg, mg, hg, pg, vg, bg, fg), s = /* @__PURE__ */ x.forwardRef(function(d, u) {
    var p, f, g, h, m, A, b, C;
    const v = Ro(), k = r(d), S = Cn(k), I = x.useContext(o), {
      className: w,
      children: P,
      columns: E = 12,
      container: K = !1,
      component: R = "div",
      direction: B = "row",
      wrap: V = "wrap",
      spacing: M = 0,
      rowSpacing: j = M,
      columnSpacing: T = M,
      disableEqualOverflow: O,
      unstable_level: F = 0
    } = S, N = ee(S, Cg);
    let te = O;
    F && O !== void 0 && (te = d.disableEqualOverflow);
    const G = {}, Z = {}, ie = {};
    Object.entries(N).forEach(([$, se]) => {
      v.breakpoints.values[$] !== void 0 ? G[$] = se : v.breakpoints.values[$.replace("Offset", "")] !== void 0 ? Z[$.replace("Offset", "")] = se : ie[$] = se;
    });
    const le = (p = d.columns) != null ? p : F ? void 0 : E, ae = (f = d.spacing) != null ? f : F ? void 0 : M, ce = (g = (h = d.rowSpacing) != null ? h : d.spacing) != null ? g : F ? void 0 : j, q = (m = (A = d.columnSpacing) != null ? A : d.spacing) != null ? m : F ? void 0 : T, D = y({}, S, {
      level: F,
      columns: le,
      container: K,
      direction: B,
      wrap: V,
      spacing: ae,
      rowSpacing: ce,
      columnSpacing: q,
      gridSize: G,
      gridOffset: Z,
      disableEqualOverflow: (b = (C = te) != null ? C : I) != null ? b : !1,
      // use context value if exists.
      parentDisableEqualOverflow: I
      // for nested grid
    }), W = a(D, v);
    let Q = /* @__PURE__ */ c.jsx(i, y({
      ref: u,
      as: R,
      ownerState: D,
      className: Qe(W.root, w)
    }, ie, {
      children: x.Children.map(P, ($) => {
        if (/* @__PURE__ */ x.isValidElement($) && kn($, ["Grid"])) {
          var se, X;
          return /* @__PURE__ */ x.cloneElement($, {
            unstable_level: (se = (X = $.props) == null ? void 0 : X.unstable_level) != null ? se : F + 1
          });
        }
        return $;
      })
    }));
    return te !== void 0 && te !== (I ?? !1) && (Q = /* @__PURE__ */ c.jsx(o.Provider, {
      value: te,
      children: Q
    })), Q;
  });
  return s.muiName = "Grid", s;
}
const Pg = ["component", "direction", "spacing", "divider", "children", "className", "useFlexGap"], Tg = Rr(), Og = rc("div", {
  name: "MuiStack",
  slot: "Root",
  overridesResolver: (e, t) => t.root
});
function Vg(e) {
  return si({
    props: e,
    name: "MuiStack",
    defaultTheme: Tg
  });
}
function Eg(e, t) {
  const r = x.Children.toArray(e).filter(Boolean);
  return r.reduce((n, o, a) => (n.push(o), a < r.length - 1 && n.push(/* @__PURE__ */ x.cloneElement(t, {
    key: `separator-${a}`
  })), n), []);
}
const Kg = (e) => ({
  row: "Left",
  "row-reverse": "Right",
  column: "Top",
  "column-reverse": "Bottom"
})[e], Rg = ({
  ownerState: e,
  theme: t
}) => {
  let r = y({
    display: "flex",
    flexDirection: "column"
  }, At({
    theme: t
  }, ra({
    values: e.direction,
    breakpoints: t.breakpoints.values
  }), (n) => ({
    flexDirection: n
  })));
  if (e.spacing) {
    const n = _a(t), o = Object.keys(t.breakpoints.values).reduce((l, d) => ((typeof e.spacing == "object" && e.spacing[d] != null || typeof e.direction == "object" && e.direction[d] != null) && (l[d] = !0), l), {}), a = ra({
      values: e.direction,
      base: o
    }), i = ra({
      values: e.spacing,
      base: o
    });
    typeof a == "object" && Object.keys(a).forEach((l, d, u) => {
      if (!a[l]) {
        const f = d > 0 ? a[u[d - 1]] : "column";
        a[l] = f;
      }
    }), r = je(r, At({
      theme: t
    }, i, (l, d) => e.useFlexGap ? {
      gap: _t(n, l)
    } : {
      // The useFlexGap={false} implement relies on each child to give up control of the margin.
      // We need to reset the margin to avoid double spacing.
      "& > :not(style):not(style)": {
        margin: 0
      },
      "& > :not(style) ~ :not(style)": {
        [`margin${Kg(d ? a[d] : e.direction)}`]: _t(n, l)
      }
    }));
  }
  return r = ap(t.breakpoints, r), r;
};
function Ug(e = {}) {
  const {
    // This will allow adding custom styled fn (for example for custom sx style function)
    createStyledComponent: t = Og,
    useThemeProps: r = Vg,
    componentName: n = "MuiStack"
  } = e, o = () => me({
    root: ["root"]
  }, (l) => Sn(n, l), {}), a = t(Rg);
  return /* @__PURE__ */ x.forwardRef(function(l, d) {
    const u = r(l), p = Cn(u), {
      component: f = "div",
      direction: g = "column",
      spacing: h = 0,
      divider: m,
      children: A,
      className: b,
      useFlexGap: C = !1
    } = p, v = ee(p, Pg), k = {
      direction: g,
      spacing: h,
      useFlexGap: C
    }, S = o();
    return /* @__PURE__ */ c.jsx(a, y({
      as: f,
      ownerState: k,
      ref: d,
      className: Qe(S.root, b)
    }, v, {
      children: m ? Eg(A, m) : A
    }));
  });
}
const jg = y({}, Kr, {
  // The default system themeKey is shape
  borderRadius: {
    themeKey: "radius"
  },
  // The default system themeKey is shadows
  boxShadow: {
    themeKey: "shadow"
  },
  // The default system themeKey is typography
  fontFamily: {
    themeKey: "fontFamily"
  },
  // The default system themeKey is typography
  fontSize: {
    themeKey: "fontSize"
  },
  // The default system themeKey is typography
  fontWeight: {
    themeKey: "fontWeight"
  },
  // The default system themeKey is typography
  letterSpacing: {
    themeKey: "letterSpacing"
  },
  // The default system themeKey is typography
  lineHeight: {
    themeKey: "lineHeight"
  }
});
function Bg(e) {
  var t;
  return !!e[0].match(/^(typography|variants|breakpoints)$/) || !!e[0].match(/sxConfig$/) || // ends with sxConfig
  e[0] === "palette" && !!((t = e[1]) != null && t.match(/^(mode)$/)) || e[0] === "focus" && e[1] !== "thickness";
}
const ye = (e, t) => Sn(e, t, "Mui"), be = (e, t) => oi(e, t, "Mui"), Dg = (e) => e && typeof e == "object" && Object.keys(e).some((t) => {
  var r;
  return (r = t.match) == null ? void 0 : r.call(t, /^(plain(Hover|Active|Disabled)?(Color|Bg)|outlined(Hover|Active|Disabled)?(Color|Border|Bg)|soft(Hover|Active|Disabled)?(Color|Bg)|solid(Hover|Active|Disabled)?(Color|Bg))$/);
}), xs = (e, t, r) => {
  t.includes("Color") && (e.color = r), t.includes("Bg") && (e.backgroundColor = r), t.includes("Border") && (e.borderColor = r);
}, ys = (e, t, r) => {
  const n = {};
  return Object.entries(t || {}).forEach(([o, a]) => {
    if (o.match(new RegExp(`${e}(color|bg|border)`, "i")) && a) {
      const i = r ? r(o) : a;
      o.includes("Disabled") && (n.pointerEvents = "none", n.cursor = "default", n["--Icon-color"] = "currentColor"), o.match(/(Hover|Active|Disabled)/) || (n["--variant-borderWidth"] || (n["--variant-borderWidth"] = "0px"), o.includes("Border") && (n["--variant-borderWidth"] = "1px", n.border = "var(--variant-borderWidth) solid")), xs(n, o, i);
    }
  }), n;
}, Ye = (e, t) => {
  let r = {};
  if (t) {
    const {
      getCssVar: n,
      palette: o
    } = t;
    Object.entries(o).forEach((a) => {
      const [i, s] = a;
      Dg(s) && typeof s == "object" && (r = y({}, r, {
        [i]: ys(e, s, (l) => `var(--variant-${l}, ${n(`palette-${i}-${l}`, o[i][l])})`)
      }));
    });
  }
  return r.context = ys(e, {
    plainColor: "var(--variant-plainColor)",
    plainHoverColor: "var(--variant-plainHoverColor)",
    plainHoverBg: "var(--variant-plainHoverBg)",
    plainActiveBg: "var(--variant-plainActiveBg)",
    plainDisabledColor: "var(--variant-plainDisabledColor)",
    outlinedColor: "var(--variant-outlinedColor)",
    outlinedBorder: "var(--variant-outlinedBorder)",
    outlinedHoverColor: "var(--variant-outlinedHoverColor)",
    outlinedHoverBorder: "var(--variant-outlinedHoverBorder)",
    outlinedHoverBg: "var(--variant-outlinedHoverBg)",
    outlinedActiveBg: "var(--variant-outlinedActiveBg)",
    outlinedDisabledColor: "var(--variant-outlinedDisabledColor)",
    outlinedDisabledBorder: "var(--variant-outlinedDisabledBorder)",
    softColor: "var(--variant-softColor)",
    softBg: "var(--variant-softBg)",
    softHoverColor: "var(--variant-softHoverColor)",
    softHoverBg: "var(--variant-softHoverBg)",
    softActiveBg: "var(--variant-softActiveBg)",
    softDisabledColor: "var(--variant-softDisabledColor)",
    softDisabledBg: "var(--variant-softDisabledBg)",
    solidColor: "var(--variant-solidColor)",
    solidBg: "var(--variant-solidBg)",
    solidHoverBg: "var(--variant-solidHoverBg)",
    solidActiveBg: "var(--variant-solidActiveBg)",
    solidDisabledColor: "var(--variant-solidDisabledColor)",
    solidDisabledBg: "var(--variant-solidDisabledBg)"
  }), r;
}, Mg = ["cssVarPrefix", "breakpoints", "spacing", "components", "variants", "shouldSkipGeneratingVar"], Fg = ["colorSchemes"], qg = (e = "joy") => pi(e);
function gc(e) {
  var t, r, n, o, a, i, s, l, d, u;
  const p = e || {}, {
    cssVarPrefix: f = "joy",
    breakpoints: g,
    spacing: h,
    components: m,
    variants: A,
    shouldSkipGeneratingVar: b = Bg
  } = p, C = ee(p, Mg), v = qg(f), k = {
    primary: Wr.blue,
    neutral: Wr.grey,
    danger: Wr.red,
    success: Wr.green,
    warning: Wr.yellow,
    common: {
      white: "#FFF",
      black: "#000"
    }
  }, S = (D) => {
    var W;
    const Q = D.split("-"), $ = Q[1], se = Q[2];
    return v(D, (W = k[$]) == null ? void 0 : W[se]);
  }, I = (D) => ({
    plainColor: S(`palette-${D}-500`),
    plainHoverBg: S(`palette-${D}-100`),
    plainActiveBg: S(`palette-${D}-200`),
    plainDisabledColor: S("palette-neutral-400"),
    outlinedColor: S(`palette-${D}-500`),
    outlinedBorder: S(`palette-${D}-300`),
    outlinedHoverBg: S(`palette-${D}-100`),
    outlinedActiveBg: S(`palette-${D}-200`),
    outlinedDisabledColor: S("palette-neutral-400"),
    outlinedDisabledBorder: S("palette-neutral-200"),
    softColor: S(`palette-${D}-700`),
    softBg: S(`palette-${D}-100`),
    softHoverBg: S(`palette-${D}-200`),
    softActiveColor: S(`palette-${D}-800`),
    softActiveBg: S(`palette-${D}-300`),
    softDisabledColor: S("palette-neutral-400"),
    softDisabledBg: S("palette-neutral-50"),
    solidColor: S("palette-common-white"),
    solidBg: S(`palette-${D}-500`),
    solidHoverBg: S(`palette-${D}-600`),
    solidActiveBg: S(`palette-${D}-700`),
    solidDisabledColor: S("palette-neutral-400"),
    solidDisabledBg: S("palette-neutral-100")
  }), w = (D) => ({
    plainColor: S(`palette-${D}-300`),
    plainHoverBg: S(`palette-${D}-800`),
    plainActiveBg: S(`palette-${D}-700`),
    plainDisabledColor: S("palette-neutral-500"),
    outlinedColor: S(`palette-${D}-200`),
    outlinedBorder: S(`palette-${D}-700`),
    outlinedHoverBg: S(`palette-${D}-800`),
    outlinedActiveBg: S(`palette-${D}-700`),
    outlinedDisabledColor: S("palette-neutral-500"),
    outlinedDisabledBorder: S("palette-neutral-800"),
    softColor: S(`palette-${D}-200`),
    softBg: S(`palette-${D}-800`),
    softHoverBg: S(`palette-${D}-700`),
    softActiveColor: S(`palette-${D}-100`),
    softActiveBg: S(`palette-${D}-600`),
    softDisabledColor: S("palette-neutral-500"),
    softDisabledBg: S("palette-neutral-800"),
    solidColor: S("palette-common-white"),
    solidBg: S(`palette-${D}-500`),
    solidHoverBg: S(`palette-${D}-600`),
    solidActiveBg: S(`palette-${D}-700`),
    solidDisabledColor: S("palette-neutral-500"),
    solidDisabledBg: S("palette-neutral-800")
  }), P = {
    palette: {
      mode: "light",
      primary: y({}, k.primary, I("primary")),
      neutral: y({}, k.neutral, I("neutral"), {
        plainColor: S("palette-neutral-700"),
        plainHoverColor: S("palette-neutral-900"),
        outlinedColor: S("palette-neutral-700")
      }),
      danger: y({}, k.danger, I("danger")),
      success: y({}, k.success, I("success")),
      warning: y({}, k.warning, I("warning")),
      common: {
        white: "#FFF",
        black: "#000"
      },
      text: {
        primary: S("palette-neutral-800"),
        secondary: S("palette-neutral-700"),
        tertiary: S("palette-neutral-600"),
        icon: S("palette-neutral-500")
      },
      background: {
        body: S("palette-common-white"),
        surface: S("palette-neutral-50"),
        popup: S("palette-common-white"),
        level1: S("palette-neutral-100"),
        level2: S("palette-neutral-200"),
        level3: S("palette-neutral-300"),
        tooltip: S("palette-neutral-500"),
        backdrop: `rgba(${v(
          "palette-neutral-darkChannel",
          Nt(k.neutral[900])
          // should be the same index as in `attachColorChannels`
        )} / 0.25)`
      },
      divider: `rgba(${v(
        "palette-neutral-mainChannel",
        Nt(k.neutral[500])
        // should be the same index as in `attachColorChannels`
      )} / 0.2)`,
      focusVisible: S("palette-primary-500")
    },
    shadowRing: "0 0 #000",
    shadowChannel: "21 21 21",
    shadowOpacity: "0.08"
  }, E = {
    palette: {
      mode: "dark",
      primary: y({}, k.primary, w("primary")),
      neutral: y({}, k.neutral, w("neutral"), {
        plainColor: S("palette-neutral-300"),
        plainHoverColor: S("palette-neutral-300")
      }),
      danger: y({}, k.danger, w("danger")),
      success: y({}, k.success, w("success")),
      warning: y({}, k.warning, w("warning")),
      common: {
        white: "#FFF",
        black: "#000"
      },
      text: {
        primary: S("palette-neutral-100"),
        secondary: S("palette-neutral-300"),
        tertiary: S("palette-neutral-400"),
        icon: S("palette-neutral-400")
      },
      background: {
        body: S("palette-common-black"),
        surface: S("palette-neutral-900"),
        popup: S("palette-common-black"),
        level1: S("palette-neutral-800"),
        level2: S("palette-neutral-700"),
        level3: S("palette-neutral-600"),
        tooltip: S("palette-neutral-600"),
        backdrop: `rgba(${v(
          "palette-neutral-darkChannel",
          Nt(k.neutral[50])
          // should be the same index as in `attachColorChannels`
        )} / 0.25)`
      },
      divider: `rgba(${v(
        "palette-neutral-mainChannel",
        Nt(k.neutral[500])
        // should be the same index as in `attachColorChannels`
      )} / 0.16)`,
      focusVisible: S("palette-primary-500")
    },
    shadowRing: "0 0 #000",
    shadowChannel: "0 0 0",
    shadowOpacity: "0.6"
  }, K = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"', R = y({
    body: `"Inter", ${v(`fontFamily-fallback, ${K}`)}`,
    display: `"Inter", ${v(`fontFamily-fallback, ${K}`)}`,
    code: "Source Code Pro,ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace",
    fallback: K
  }, C.fontFamily), B = y({
    sm: 300,
    // regular
    md: 500,
    // medium
    lg: 600,
    // semi-bold
    xl: 700
  }, C.fontWeight), V = y({
    xs: "0.75rem",
    // 12px
    sm: "0.875rem",
    // 14px
    md: "1rem",
    // 16px
    lg: "1.125rem",
    // 18px
    xl: "1.25rem",
    // 20px
    xl2: "1.5rem",
    // 24px
    xl3: "1.875rem",
    // 30px
    xl4: "2.25rem"
  }, C.fontSize), M = y({
    xs: "1.33334",
    // largest font sizes: h1, h2
    sm: "1.42858",
    // normal font sizes
    md: "1.5",
    // normal font sizes
    lg: "1.55556",
    // large font sizes for components
    xl: "1.66667"
  }, C.lineHeight), j = (t = (r = C.colorSchemes) == null || (r = r.light) == null ? void 0 : r.shadowRing) != null ? t : P.shadowRing, T = (n = (o = C.colorSchemes) == null || (o = o.light) == null ? void 0 : o.shadowChannel) != null ? n : P.shadowChannel, O = (a = (i = C.colorSchemes) == null || (i = i.light) == null ? void 0 : i.shadowOpacity) != null ? a : P.shadowOpacity, F = {
    colorSchemes: {
      light: P,
      dark: E
    },
    fontSize: V,
    fontFamily: R,
    fontWeight: B,
    focus: {
      thickness: "2px",
      selector: `&.${ye("", "focusVisible")}, &:focus-visible`,
      default: {
        outlineOffset: `var(--focus-outline-offset, ${v("focus-thickness", (s = (l = C.focus) == null ? void 0 : l.thickness) != null ? s : "2px")})`,
        outline: `${v("focus-thickness", (d = (u = C.focus) == null ? void 0 : u.thickness) != null ? d : "2px")} solid ${v("palette-focusVisible", k.primary[500])}`
      }
    },
    lineHeight: M,
    radius: {
      xs: "2px",
      sm: "6px",
      md: "8px",
      lg: "12px",
      xl: "16px"
    },
    shadow: {
      xs: `${v("shadowRing", j)}, 0px 1px 2px 0px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)})`,
      sm: `${v("shadowRing", j)}, 0px 1px 2px 0px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)}), 0px 2px 4px 0px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)})`,
      md: `${v("shadowRing", j)}, 0px 2px 8px -2px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)}), 0px 6px 12px -2px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)})`,
      lg: `${v("shadowRing", j)}, 0px 2px 8px -2px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)}), 0px 12px 16px -4px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)})`,
      xl: `${v("shadowRing", j)}, 0px 2px 8px -2px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)}), 0px 20px 24px -4px rgba(${v("shadowChannel", T)} / ${v("shadowOpacity", O)})`
    },
    zIndex: {
      badge: 1,
      table: 10,
      popup: 1e3,
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500
    },
    typography: {
      h1: {
        fontFamily: v(`fontFamily-display, ${R.display}`),
        fontWeight: v(`fontWeight-xl, ${B.xl}`),
        fontSize: v(`fontSize-xl4, ${V.xl4}`),
        lineHeight: v(`lineHeight-xs, ${M.xs}`),
        letterSpacing: "-0.025em",
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      h2: {
        fontFamily: v(`fontFamily-display, ${R.display}`),
        fontWeight: v(`fontWeight-xl, ${B.xl}`),
        fontSize: v(`fontSize-xl3, ${V.xl3}`),
        lineHeight: v(`lineHeight-xs, ${M.xs}`),
        letterSpacing: "-0.025em",
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      h3: {
        fontFamily: v(`fontFamily-display, ${R.display}`),
        fontWeight: v(`fontWeight-lg, ${B.lg}`),
        fontSize: v(`fontSize-xl2, ${V.xl2}`),
        lineHeight: v(`lineHeight-xs, ${M.xs}`),
        letterSpacing: "-0.025em",
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      h4: {
        fontFamily: v(`fontFamily-display, ${R.display}`),
        fontWeight: v(`fontWeight-lg, ${B.lg}`),
        fontSize: v(`fontSize-xl, ${V.xl}`),
        lineHeight: v(`lineHeight-md, ${M.md}`),
        letterSpacing: "-0.025em",
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      "title-lg": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontWeight: v(`fontWeight-lg, ${B.lg}`),
        fontSize: v(`fontSize-lg, ${V.lg}`),
        lineHeight: v(`lineHeight-xs, ${M.xs}`),
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      "title-md": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontWeight: v(`fontWeight-md, ${B.md}`),
        fontSize: v(`fontSize-md, ${V.md}`),
        lineHeight: v(`lineHeight-md, ${M.md}`),
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      "title-sm": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontWeight: v(`fontWeight-md, ${B.md}`),
        fontSize: v(`fontSize-sm, ${V.sm}`),
        lineHeight: v(`lineHeight-sm, ${M.sm}`),
        color: v(`palette-text-primary, ${P.palette.text.primary}`)
      },
      "body-lg": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontSize: v(`fontSize-lg, ${V.lg}`),
        lineHeight: v(`lineHeight-md, ${M.md}`),
        color: v(`palette-text-secondary, ${P.palette.text.secondary}`)
      },
      "body-md": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontSize: v(`fontSize-md, ${V.md}`),
        lineHeight: v(`lineHeight-md, ${M.md}`),
        color: v(`palette-text-secondary, ${P.palette.text.secondary}`)
      },
      "body-sm": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontSize: v(`fontSize-sm, ${V.sm}`),
        lineHeight: v(`lineHeight-md, ${M.md}`),
        color: v(`palette-text-tertiary, ${P.palette.text.tertiary}`)
      },
      "body-xs": {
        fontFamily: v(`fontFamily-body, ${R.body}`),
        fontWeight: v(`fontWeight-md, ${B.md}`),
        fontSize: v(`fontSize-xs, ${V.xs}`),
        lineHeight: v(`lineHeight-md, ${M.md}`),
        color: v(`palette-text-tertiary, ${P.palette.text.tertiary}`)
      }
    }
  }, N = C ? je(F, C) : F, {
    colorSchemes: te
  } = N, G = ee(N, Fg), Z = y({
    colorSchemes: te
  }, G, {
    breakpoints: Za(g ?? {}),
    components: je({
      // TODO: find a way to abstract SvgIcon out of @mui/material
      MuiSvgIcon: {
        defaultProps: {
          fontSize: "xl2"
        },
        styleOverrides: {
          root: ({
            ownerState: D,
            theme: W
          }) => {
            var Q;
            const $ = D.instanceFontSize;
            return y({
              margin: "var(--Icon-margin)"
            }, D.fontSize && D.fontSize !== "inherit" && {
              fontSize: `var(--Icon-fontSize, ${W.vars.fontSize[D.fontSize]})`
            }, !D.htmlColor && y({
              color: `var(--Icon-color, ${Z.vars.palette.text.icon})`
            }, D.color && D.color !== "inherit" && W.vars.palette[D.color] && {
              color: `rgba(${(Q = W.vars.palette[D.color]) == null ? void 0 : Q.mainChannel} / 1)`
            }), $ && $ !== "inherit" && {
              "--Icon-fontSize": W.vars.fontSize[$]
            });
          }
        }
      }
    }, m),
    cssVarPrefix: f,
    getCssVar: v,
    spacing: Hl(h)
  });
  function ie(D, W) {
    Object.keys(W).forEach((Q) => {
      const $ = {
        main: "500",
        light: "200",
        dark: "700"
      };
      D === "dark" && ($.main = 400), !W[Q].mainChannel && W[Q][$.main] && (W[Q].mainChannel = Nt(W[Q][$.main])), !W[Q].lightChannel && W[Q][$.light] && (W[Q].lightChannel = Nt(W[Q][$.light])), !W[Q].darkChannel && W[Q][$.dark] && (W[Q].darkChannel = Nt(W[Q][$.dark]));
    });
  }
  Object.entries(Z.colorSchemes).forEach(([D, W]) => {
    ie(D, W.palette);
  });
  const le = {
    prefix: f,
    shouldSkipGeneratingVar: b
  }, {
    vars: ae,
    generateCssVars: ce
  } = dg(
    // @ts-ignore property truDark is missing from colorSchemes
    y({
      colorSchemes: te
    }, G),
    le
  );
  Z.vars = ae, Z.generateCssVars = ce, Z.unstable_sxConfig = y({}, jg, e == null ? void 0 : e.unstable_sxConfig), Z.unstable_sx = function(W) {
    return rr({
      sx: W,
      theme: this
    });
  }, Z.getColorSchemeSelector = (D) => D === "light" ? "&" : `&[data-joy-color-scheme="${D}"], [data-joy-color-scheme="${D}"] &`;
  const q = {
    getCssVar: v,
    palette: Z.colorSchemes.light.palette
  };
  return Z.variants = je({
    plain: Ye("plain", q),
    plainHover: Ye("plainHover", q),
    plainActive: Ye("plainActive", q),
    plainDisabled: Ye("plainDisabled", q),
    outlined: Ye("outlined", q),
    outlinedHover: Ye("outlinedHover", q),
    outlinedActive: Ye("outlinedActive", q),
    outlinedDisabled: Ye("outlinedDisabled", q),
    soft: Ye("soft", q),
    softHover: Ye("softHover", q),
    softActive: Ye("softActive", q),
    softDisabled: Ye("softDisabled", q),
    solid: Ye("solid", q),
    solidHover: Ye("solidHover", q),
    solidActive: Ye("solidActive", q),
    solidDisabled: Ye("solidDisabled", q)
  }, A), Z.palette = y({}, Z.colorSchemes.light.palette, {
    colorScheme: "light"
  }), Z.shouldSkipGeneratingVar = b, Z.applyStyles = ti, Z;
}
const jr = gc(), zr = {
  attribute: "data-joy-color-scheme",
  colorSchemeStorageKey: "joy-color-scheme",
  defaultLightColorScheme: "light",
  defaultDarkColorScheme: "dark",
  modeStorageKey: "joy-mode"
}, {
  CssVarsProvider: Jg
} = og({
  themeId: bn,
  theme: jr,
  attribute: zr.attribute,
  modeStorageKey: zr.modeStorageKey,
  colorSchemeStorageKey: zr.colorSchemeStorageKey,
  defaultColorScheme: {
    light: zr.defaultLightColorScheme,
    dark: zr.defaultDarkColorScheme
  }
}), H = tc({
  defaultTheme: jr,
  themeId: bn
});
function xe({
  props: e,
  name: t
}) {
  return si({
    props: e,
    name: t,
    defaultTheme: y({}, jr, {
      components: {}
    }),
    themeId: bn
  });
}
function Wg(e) {
  return /* @__PURE__ */ c.jsx(Zl, y({}, e, {
    defaultTheme: jr,
    themeId: bn
  }));
}
function As(e, t, r = (n, o) => n === o) {
  return e.length === t.length && e.every((n, o) => r(n, t[o]));
}
const Lg = {
  disableDefaultClasses: !1
}, zg = /* @__PURE__ */ x.createContext(Lg);
function Ng(e) {
  const {
    disableDefaultClasses: t
  } = x.useContext(zg);
  return (r) => t ? "" : e(r);
}
function Qg(e) {
  const {
    rootElementName: t = ""
  } = e, [r, n] = x.useState(t.toUpperCase()), o = x.useCallback((a) => {
    var i;
    n((i = a == null ? void 0 : a.tagName) != null ? i : "");
  }, []);
  return [r, o];
}
const hc = "base";
function Hg(e) {
  return `${hc}--${e}`;
}
function Gg(e, t) {
  return `${hc}-${e}-${t}`;
}
function Zg(e, t) {
  const r = Xl[t];
  return r ? Hg(r) : Gg(e, t);
}
function nr(e = {}) {
  const {
    disabled: t = !1,
    focusableWhenDisabled: r,
    href: n,
    rootRef: o,
    tabIndex: a,
    to: i,
    type: s,
    rootElementName: l
  } = e, d = x.useRef(null), [u, p] = x.useState(!1), {
    isFocusVisibleRef: f,
    onFocus: g,
    onBlur: h,
    ref: m
  } = ac(), [A, b] = x.useState(!1);
  t && !r && A && b(!1), x.useEffect(() => {
    f.current = A;
  }, [A, f]);
  const [C, v] = Qg({
    rootElementName: l ?? (n || i ? "a" : void 0)
  }), k = (j) => (T) => {
    var O;
    A && T.preventDefault(), (O = j.onMouseLeave) == null || O.call(j, T);
  }, S = (j) => (T) => {
    var O;
    h(T), f.current === !1 && b(!1), (O = j.onBlur) == null || O.call(j, T);
  }, I = (j) => (T) => {
    var O;
    if (d.current || (d.current = T.currentTarget), g(T), f.current === !0) {
      var F;
      b(!0), (F = j.onFocusVisible) == null || F.call(j, T);
    }
    (O = j.onFocus) == null || O.call(j, T);
  }, w = () => {
    const j = d.current;
    return C === "BUTTON" || C === "INPUT" && ["button", "submit", "reset"].includes(j == null ? void 0 : j.type) || C === "A" && (j == null ? void 0 : j.href);
  }, P = (j) => (T) => {
    if (!t) {
      var O;
      (O = j.onClick) == null || O.call(j, T);
    }
  }, E = (j) => (T) => {
    var O;
    t || (p(!0), document.addEventListener("mouseup", () => {
      p(!1);
    }, {
      once: !0
    })), (O = j.onMouseDown) == null || O.call(j, T);
  }, K = (j) => (T) => {
    var O;
    if ((O = j.onKeyDown) == null || O.call(j, T), !T.defaultMuiPrevented && (T.target === T.currentTarget && !w() && T.key === " " && T.preventDefault(), T.target === T.currentTarget && T.key === " " && !t && p(!0), T.target === T.currentTarget && !w() && T.key === "Enter" && !t)) {
      var F;
      (F = j.onClick) == null || F.call(j, T), T.preventDefault();
    }
  }, R = (j) => (T) => {
    var O;
    if (T.target === T.currentTarget && p(!1), (O = j.onKeyUp) == null || O.call(j, T), T.target === T.currentTarget && !w() && !t && T.key === " " && !T.defaultMuiPrevented) {
      var F;
      (F = j.onClick) == null || F.call(j, T);
    }
  }, B = ke(v, o, m, d), V = {};
  return a !== void 0 && (V.tabIndex = a), C === "BUTTON" ? (V.type = s ?? "button", r ? V["aria-disabled"] = t : V.disabled = t) : C === "INPUT" ? s && ["button", "submit", "reset"].includes(s) && (r ? V["aria-disabled"] = t : V.disabled = t) : C !== "" && (!n && !i && (V.role = "button", V.tabIndex = a ?? 0), t && (V["aria-disabled"] = t, V.tabIndex = r ? a ?? 0 : -1)), {
    getRootProps: (j = {}) => {
      const T = y({}, ze(e), ze(j)), O = y({
        type: s
      }, T, V, j, {
        onBlur: S(T),
        onClick: P(T),
        onFocus: I(T),
        onKeyDown: K(T),
        onKeyUp: R(T),
        onMouseDown: E(T),
        onMouseLeave: k(T),
        ref: B
      });
      return delete O.onFocusVisible, O;
    },
    focusVisible: A,
    setFocusVisible: b,
    active: u,
    rootRef: B
  };
}
function Cs(e) {
  return e.substring(2).toLowerCase();
}
function Yg(e, t) {
  return t.documentElement.clientWidth < e.clientX || t.documentElement.clientHeight < e.clientY;
}
function Xg(e) {
  const {
    children: t,
    disableReactTree: r = !1,
    mouseEvent: n = "onClick",
    onClickAway: o,
    touchEvent: a = "onTouchEnd"
  } = e, i = x.useRef(!1), s = x.useRef(null), l = x.useRef(!1), d = x.useRef(!1);
  x.useEffect(() => (setTimeout(() => {
    l.current = !0;
  }, 0), () => {
    l.current = !1;
  }), []);
  const u = ke(li(t), s), p = Sr((h) => {
    const m = d.current;
    d.current = !1;
    const A = _e(s.current);
    if (!l.current || !s.current || "clientX" in h && Yg(h, A))
      return;
    if (i.current) {
      i.current = !1;
      return;
    }
    let b;
    h.composedPath ? b = h.composedPath().indexOf(s.current) > -1 : b = !A.documentElement.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      h.target
    ) || s.current.contains(
      // @ts-expect-error returns `false` as intended when not dispatched from a Node
      h.target
    ), !b && (r || !m) && o(h);
  }), f = (h) => (m) => {
    d.current = !0;
    const A = t.props[h];
    A && A(m);
  }, g = {
    ref: u
  };
  return a !== !1 && (g[a] = f(a)), x.useEffect(() => {
    if (a !== !1) {
      const h = Cs(a), m = _e(s.current), A = () => {
        i.current = !0;
      };
      return m.addEventListener(h, p), m.addEventListener("touchmove", A), () => {
        m.removeEventListener(h, p), m.removeEventListener("touchmove", A);
      };
    }
  }, [p, a]), n !== !1 && (g[n] = f(n)), x.useEffect(() => {
    if (n !== !1) {
      const h = Cs(n), m = _e(s.current);
      return m.addEventListener(h, p), () => {
        m.removeEventListener(h, p);
      };
    }
  }, [p, n]), /* @__PURE__ */ c.jsx(x.Fragment, {
    children: /* @__PURE__ */ x.cloneElement(t, g)
  });
}
const mc = /* @__PURE__ */ x.createContext(null);
function $g(e, t) {
  return e === t;
}
const la = {}, Ss = () => {
};
function Sa(e, t) {
  const r = y({}, e);
  return Object.keys(t).forEach((n) => {
    t[n] !== void 0 && (r[n] = t[n]);
  }), r;
}
function _g(e) {
  const {
    nextState: t,
    initialState: r,
    stateComparers: n,
    onStateChange: o,
    controlledProps: a,
    lastActionRef: i
  } = e, s = x.useRef(r);
  x.useEffect(() => {
    if (i.current === null)
      return;
    const l = Sa(s.current, a);
    Object.keys(t).forEach((d) => {
      var u;
      const p = (u = n[d]) != null ? u : $g, f = t[d], g = l[d];
      if (g == null && f != null || g != null && f == null || g != null && f != null && !p(f, g)) {
        var h, m;
        o == null || o((h = i.current.event) != null ? h : null, d, f, (m = i.current.type) != null ? m : "", t);
      }
    }), s.current = t, i.current = null;
  }, [s, t, i, o, n, a]);
}
function vc(e) {
  const t = x.useRef(null), {
    reducer: r,
    initialState: n,
    controlledProps: o = la,
    stateComparers: a = la,
    onStateChange: i = Ss,
    actionContext: s,
    componentName: l = ""
  } = e;
  x.useRef(o);
  const d = x.useCallback((g, h) => {
    t.current = h;
    const m = Sa(g, o);
    return r(m, h);
  }, [o, r]), [u, p] = x.useReducer(d, n), f = x.useCallback((g) => {
    p(y({}, g, {
      context: s
    }));
  }, [s]);
  return _g({
    nextState: u,
    initialState: n,
    stateComparers: a ?? la,
    onStateChange: i ?? Ss,
    controlledProps: o,
    lastActionRef: t
  }), [Sa(u, o), f];
}
const qt = {
  blur: "dropdown:blur",
  escapeKeyDown: "dropdown:escapeKeyDown",
  toggle: "dropdown:toggle",
  open: "dropdown:open",
  close: "dropdown:close"
};
function eh(e, t) {
  switch (t.type) {
    case qt.blur:
      return {
        open: !1,
        changeReason: t.event
      };
    case qt.escapeKeyDown:
      return {
        open: !1,
        changeReason: t.event
      };
    case qt.toggle:
      return {
        open: !e.open,
        changeReason: t.event
      };
    case qt.open:
      return {
        open: !0,
        changeReason: t.event
      };
    case qt.close:
      return {
        open: !1,
        changeReason: t.event
      };
    default:
      throw new Error("Unhandled action");
  }
}
function th(e = {}) {
  const {
    defaultOpen: t,
    onOpenChange: r,
    open: n,
    componentName: o = "useDropdown"
  } = e, [a, i] = x.useState(""), [s, l] = x.useState(null), d = x.useRef(null), u = x.useCallback((m, A, b, C) => {
    A === "open" && (r == null || r(m, b)), d.current = C;
  }, [r]), p = x.useMemo(() => n !== void 0 ? {
    open: n
  } : {}, [n]), [f, g] = vc({
    controlledProps: p,
    initialState: t ? {
      open: !0,
      changeReason: null
    } : {
      open: !1,
      changeReason: null
    },
    onStateChange: u,
    reducer: eh,
    componentName: o
  });
  return x.useEffect(() => {
    !f.open && d.current !== null && d.current !== qt.blur && (s == null || s.focus());
  }, [f.open, s]), {
    contextValue: {
      state: f,
      dispatch: g,
      popupId: a,
      registerPopup: i,
      registerTrigger: l,
      triggerElement: s
    },
    open: f.open
  };
}
function rh(e) {
  const {
    children: t,
    open: r,
    defaultOpen: n,
    onOpenChange: o
  } = e, {
    contextValue: a
  } = th({
    defaultOpen: n,
    onOpenChange: o,
    open: r
  });
  return /* @__PURE__ */ c.jsx(mc.Provider, {
    value: a,
    children: t
  });
}
const nh = ["input", "select", "textarea", "a[href]", "button", "[tabindex]", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])'].join(",");
function oh(e) {
  const t = parseInt(e.getAttribute("tabindex") || "", 10);
  return Number.isNaN(t) ? e.contentEditable === "true" || (e.nodeName === "AUDIO" || e.nodeName === "VIDEO" || e.nodeName === "DETAILS") && e.getAttribute("tabindex") === null ? 0 : e.tabIndex : t;
}
function ah(e) {
  if (e.tagName !== "INPUT" || e.type !== "radio" || !e.name)
    return !1;
  const t = (n) => e.ownerDocument.querySelector(`input[type="radio"]${n}`);
  let r = t(`[name="${e.name}"]:checked`);
  return r || (r = t(`[name="${e.name}"]`)), r !== e;
}
function ih(e) {
  return !(e.disabled || e.tagName === "INPUT" && e.type === "hidden" || ah(e));
}
function sh(e) {
  const t = [], r = [];
  return Array.from(e.querySelectorAll(nh)).forEach((n, o) => {
    const a = oh(n);
    a === -1 || !ih(n) || (a === 0 ? t.push(n) : r.push({
      documentOrder: o,
      tabIndex: a,
      node: n
    }));
  }), r.sort((n, o) => n.tabIndex === o.tabIndex ? n.documentOrder - o.documentOrder : n.tabIndex - o.tabIndex).map((n) => n.node).concat(t);
}
function lh() {
  return !0;
}
function ch(e) {
  const {
    children: t,
    disableAutoFocus: r = !1,
    disableEnforceFocus: n = !1,
    disableRestoreFocus: o = !1,
    getTabbable: a = sh,
    isEnabled: i = lh,
    open: s
  } = e, l = x.useRef(!1), d = x.useRef(null), u = x.useRef(null), p = x.useRef(null), f = x.useRef(null), g = x.useRef(!1), h = x.useRef(null), m = ke(li(t), h), A = x.useRef(null);
  x.useEffect(() => {
    !s || !h.current || (g.current = !r);
  }, [r, s]), x.useEffect(() => {
    if (!s || !h.current)
      return;
    const v = _e(h.current);
    return h.current.contains(v.activeElement) || (h.current.hasAttribute("tabIndex") || h.current.setAttribute("tabIndex", "-1"), g.current && h.current.focus()), () => {
      o || (p.current && p.current.focus && (l.current = !0, p.current.focus()), p.current = null);
    };
  }, [s]), x.useEffect(() => {
    if (!s || !h.current)
      return;
    const v = _e(h.current), k = (w) => {
      A.current = w, !(n || !i() || w.key !== "Tab") && v.activeElement === h.current && w.shiftKey && (l.current = !0, u.current && u.current.focus());
    }, S = () => {
      const w = h.current;
      if (w === null)
        return;
      if (!v.hasFocus() || !i() || l.current) {
        l.current = !1;
        return;
      }
      if (w.contains(v.activeElement) || n && v.activeElement !== d.current && v.activeElement !== u.current)
        return;
      if (v.activeElement !== f.current)
        f.current = null;
      else if (f.current !== null)
        return;
      if (!g.current)
        return;
      let P = [];
      if ((v.activeElement === d.current || v.activeElement === u.current) && (P = a(h.current)), P.length > 0) {
        var E, K;
        const R = !!((E = A.current) != null && E.shiftKey && ((K = A.current) == null ? void 0 : K.key) === "Tab"), B = P[0], V = P[P.length - 1];
        typeof B != "string" && typeof V != "string" && (R ? V.focus() : B.focus());
      } else
        w.focus();
    };
    v.addEventListener("focusin", S), v.addEventListener("keydown", k, !0);
    const I = setInterval(() => {
      v.activeElement && v.activeElement.tagName === "BODY" && S();
    }, 50);
    return () => {
      clearInterval(I), v.removeEventListener("focusin", S), v.removeEventListener("keydown", k, !0);
    };
  }, [r, n, o, i, s, a]);
  const b = (v) => {
    p.current === null && (p.current = v.relatedTarget), g.current = !0, f.current = v.target;
    const k = t.props.onFocus;
    k && k(v);
  }, C = (v) => {
    p.current === null && (p.current = v.relatedTarget), g.current = !0;
  };
  return /* @__PURE__ */ c.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ c.jsx("div", {
      tabIndex: s ? 0 : -1,
      onFocus: C,
      ref: d,
      "data-testid": "sentinelStart"
    }), /* @__PURE__ */ x.cloneElement(t, {
      ref: m,
      onFocus: b
    }), /* @__PURE__ */ c.jsx("div", {
      tabIndex: s ? 0 : -1,
      onFocus: C,
      ref: u,
      "data-testid": "sentinelEnd"
    })]
  });
}
const dh = /* @__PURE__ */ x.createContext(void 0);
function uh() {
  return x.useContext(dh);
}
function ph(e = {}) {
  const {
    defaultValue: t,
    disabled: r = !1,
    error: n = !1,
    onBlur: o,
    onChange: a,
    onFocus: i,
    required: s = !1,
    value: l,
    inputRef: d
  } = e, u = uh();
  let p, f, g, h, m;
  if (u) {
    var A, b, C;
    p = void 0, f = (A = u.disabled) != null ? A : !1, g = (b = u.error) != null ? b : !1, h = (C = u.required) != null ? C : !1, m = u.value;
  } else
    p = t, f = r, g = n, h = s, m = l;
  const {
    current: v
  } = x.useRef(m != null), k = x.useCallback((j) => {
  }, []), S = x.useRef(null), I = ke(S, d, k), [w, P] = x.useState(!1);
  x.useEffect(() => {
    !u && f && w && (P(!1), o == null || o());
  }, [u, f, w, o]);
  const E = (j) => (T) => {
    var O;
    if (u != null && u.disabled) {
      T.stopPropagation();
      return;
    }
    if ((O = j.onFocus) == null || O.call(j, T), u && u.onFocus) {
      var F;
      u == null || (F = u.onFocus) == null || F.call(u);
    } else
      P(!0);
  }, K = (j) => (T) => {
    var O;
    (O = j.onBlur) == null || O.call(j, T), u && u.onBlur ? u.onBlur() : P(!1);
  }, R = (j) => (T, ...O) => {
    var F, N;
    if (!v && (T.target || S.current) == null)
      throw new Error(jt(17));
    u == null || (F = u.onChange) == null || F.call(u, T), (N = j.onChange) == null || N.call(j, T, ...O);
  }, B = (j) => (T) => {
    var O;
    S.current && T.currentTarget === T.target && S.current.focus(), (O = j.onClick) == null || O.call(j, T);
  };
  return {
    disabled: f,
    error: g,
    focused: w,
    formControlContext: u,
    getInputProps: (j = {}) => {
      const O = y({}, {
        onBlur: o,
        onChange: a,
        onFocus: i
      }, ze(j)), F = y({}, O, {
        onBlur: K(O),
        onChange: R(O),
        onFocus: E(O)
      });
      return y({}, F, {
        "aria-invalid": g || void 0,
        defaultValue: p,
        value: m,
        required: h,
        disabled: f
      }, j, {
        ref: I
      }, F);
    },
    getRootProps: (j = {}) => {
      const T = ze(e, ["onBlur", "onChange", "onFocus"]), O = y({}, T, ze(j));
      return y({}, j, O, {
        onClick: B(O)
      });
    },
    inputRef: I,
    required: h,
    value: m
  };
}
const Se = {
  blur: "list:blur",
  itemClick: "list:itemClick",
  itemHover: "list:itemHover",
  itemsChange: "list:itemsChange",
  keyDown: "list:keyDown",
  resetHighlight: "list:resetHighlight",
  highlightLast: "list:highlightLast",
  textNavigation: "list:textNavigation",
  clearSelection: "list:clearSelection"
};
function fh(e, t, r, n, o, a) {
  if (r.length === 0 || !n && r.every((s, l) => o(s, l)))
    return -1;
  let i = e;
  for (; ; ) {
    if (!a && t === "next" && i === r.length || !a && t === "previous" && i === -1)
      return -1;
    if (n ? !1 : o(r[i], i))
      i += t === "next" ? 1 : -1, a && (i = (i + r.length) % r.length);
    else
      return i;
  }
}
function qe(e, t, r) {
  var n;
  const {
    items: o,
    isItemDisabled: a,
    disableListWrap: i,
    disabledItemsFocusable: s,
    itemComparer: l,
    focusManagement: d
  } = r, u = d === "DOM" ? 0 : -1, p = o.length - 1, f = e == null ? -1 : o.findIndex((b) => l(b, e));
  let g, h, m = !i;
  switch (t) {
    case "reset":
      if (u === -1)
        return null;
      g = 0, h = "next", m = !1;
      break;
    case "start":
      g = 0, h = "next", m = !1;
      break;
    case "end":
      g = p, h = "previous", m = !1;
      break;
    default: {
      const b = f + t;
      b < 0 ? !m && f !== -1 || Math.abs(t) > 1 ? (g = 0, h = "next") : (g = p, h = "previous") : b > p ? !m || Math.abs(t) > 1 ? (g = p, h = "previous") : (g = 0, h = "next") : (g = b, h = t >= 0 ? "next" : "previous");
    }
  }
  const A = fh(g, h, o, s, a, m);
  return A === -1 && e !== null && !a(e, f) ? e : (n = o[A]) != null ? n : null;
}
function gh(e, t, r, n) {
  return r === "none" ? [] : r === "single" ? n(t[0], e) ? t : [e] : t.some((o) => n(o, e)) ? t.filter((o) => !n(o, e)) : [...t, e];
}
function hi(e, t, r) {
  const {
    itemComparer: n,
    isItemDisabled: o,
    selectionMode: a,
    items: i
  } = r, {
    selectedValues: s
  } = t, l = i.findIndex((u) => n(e, u));
  if (o(e, l))
    return t;
  const d = gh(e, s, a, n);
  return y({}, t, {
    selectedValues: d,
    highlightedValue: e
  });
}
function hh(e, t, r) {
  const n = t.highlightedValue, {
    orientation: o,
    pageSize: a
  } = r;
  switch (e) {
    case "Home":
      return y({}, t, {
        highlightedValue: qe(n, "start", r)
      });
    case "End":
      return y({}, t, {
        highlightedValue: qe(n, "end", r)
      });
    case "PageUp":
      return y({}, t, {
        highlightedValue: qe(n, -a, r)
      });
    case "PageDown":
      return y({}, t, {
        highlightedValue: qe(n, a, r)
      });
    case "ArrowUp":
      if (o !== "vertical")
        break;
      return y({}, t, {
        highlightedValue: qe(n, -1, r)
      });
    case "ArrowDown":
      if (o !== "vertical")
        break;
      return y({}, t, {
        highlightedValue: qe(n, 1, r)
      });
    case "ArrowLeft": {
      if (o === "vertical")
        break;
      return y({}, t, {
        highlightedValue: qe(n, o === "horizontal-ltr" ? -1 : 1, r)
      });
    }
    case "ArrowRight": {
      if (o === "vertical")
        break;
      return y({}, t, {
        highlightedValue: qe(n, o === "horizontal-ltr" ? 1 : -1, r)
      });
    }
    case "Enter":
    case " ":
      return t.highlightedValue === null ? t : hi(t.highlightedValue, t, r);
  }
  return t;
}
function mh(e, t) {
  return t.focusManagement === "DOM" ? e : y({}, e, {
    highlightedValue: null
  });
}
function vh(e, t, r) {
  var n;
  const o = (n = r(e)) == null ? void 0 : n.trim().toLowerCase();
  return !o || o.length === 0 ? !1 : o.indexOf(t) === 0;
}
function bh(e, t, r) {
  const {
    items: n,
    isItemDisabled: o,
    disabledItemsFocusable: a,
    getItemAsString: i
  } = r, s = t.length > 1;
  let l = s ? e.highlightedValue : qe(e.highlightedValue, 1, r);
  for (let d = 0; d < n.length; d += 1) {
    if (!l || !s && e.highlightedValue === l)
      return e;
    if (vh(l, t, i) && (!o(l, n.indexOf(l)) || a))
      return y({}, e, {
        highlightedValue: l
      });
    l = qe(l, 1, r);
  }
  return e;
}
function xh(e, t, r, n) {
  var o;
  const {
    itemComparer: a,
    focusManagement: i
  } = n;
  let s = null;
  if (r.highlightedValue != null) {
    var l;
    s = (l = e.find((p) => a(p, r.highlightedValue))) != null ? l : null;
  } else i === "DOM" && t.length === 0 && (s = qe(null, "reset", n));
  const u = ((o = r.selectedValues) != null ? o : []).filter((p) => e.some((f) => a(f, p)));
  return y({}, r, {
    highlightedValue: s,
    selectedValues: u
  });
}
function yh(e, t) {
  return y({}, e, {
    highlightedValue: qe(null, "reset", t)
  });
}
function Ah(e, t) {
  return y({}, e, {
    highlightedValue: qe(null, "end", t)
  });
}
function Ch(e, t) {
  return y({}, e, {
    selectedValues: [],
    highlightedValue: qe(null, "reset", t)
  });
}
function mi(e, t) {
  const {
    type: r,
    context: n
  } = t;
  switch (r) {
    case Se.keyDown:
      return hh(t.key, e, n);
    case Se.itemClick:
      return hi(t.item, e, n);
    case Se.blur:
      return mh(e, n);
    case Se.textNavigation:
      return bh(e, t.searchString, n);
    case Se.itemsChange:
      return xh(t.items, t.previousItems, e, n);
    case Se.resetHighlight:
      return yh(e, n);
    case Se.highlightLast:
      return Ah(e, n);
    case Se.clearSelection:
      return Ch(e, n);
    default:
      return e;
  }
}
const Sh = 500;
function kh(e) {
  const t = x.useRef({
    searchString: "",
    lastTime: null
  });
  return x.useCallback((r) => {
    if (r.key.length === 1 && r.key !== " ") {
      const n = t.current, o = r.key.toLowerCase(), a = performance.now();
      n.searchString.length > 0 && n.lastTime && a - n.lastTime > Sh ? n.searchString = o : (n.searchString.length !== 1 || o !== n.searchString) && (n.searchString += o), n.lastTime = a, e(n.searchString, r);
    }
  }, [e]);
}
const ks = {}, Ih = () => {
}, wh = (e, t) => e === t, Ph = () => !1, Th = (e) => typeof e == "string" ? e : String(e), Oh = () => ({
  highlightedValue: null,
  selectedValues: []
});
function bc(e) {
  const {
    controlledProps: t = ks,
    disabledItemsFocusable: r = !1,
    disableListWrap: n = !1,
    focusManagement: o = "activeDescendant",
    getInitialState: a = Oh,
    getItemDomElement: i,
    getItemId: s,
    isItemDisabled: l = Ph,
    rootRef: d,
    onStateChange: u = Ih,
    items: p,
    itemComparer: f = wh,
    getItemAsString: g = Th,
    onChange: h,
    onHighlightChange: m,
    onItemsChange: A,
    orientation: b = "vertical",
    pageSize: C = 5,
    reducerActionContext: v = ks,
    selectionMode: k = "single",
    stateReducer: S,
    componentName: I = "useList"
  } = e, w = x.useRef(null), P = ke(d, w), E = x.useCallback((q, D, W) => {
    if (m == null || m(q, D, W), o === "DOM" && D != null && (W === Se.itemClick || W === Se.keyDown || W === Se.textNavigation)) {
      var Q;
      i == null || (Q = i(D)) == null || Q.focus();
    }
  }, [i, m, o]), K = x.useMemo(() => ({
    highlightedValue: f,
    selectedValues: (q, D) => As(q, D, f)
  }), [f]), R = x.useCallback((q, D, W, Q, $) => {
    switch (u == null || u(q, D, W, Q, $), D) {
      case "highlightedValue":
        E(q, W, Q);
        break;
      case "selectedValues":
        h == null || h(q, W, Q);
        break;
    }
  }, [E, h, u]), B = x.useMemo(() => ({
    disabledItemsFocusable: r,
    disableListWrap: n,
    focusManagement: o,
    isItemDisabled: l,
    itemComparer: f,
    items: p,
    getItemAsString: g,
    onHighlightChange: E,
    orientation: b,
    pageSize: C,
    selectionMode: k,
    stateComparers: K
  }), [r, n, o, l, f, p, g, E, b, C, k, K]), V = a(), M = S ?? mi, j = x.useMemo(() => y({}, v, B), [v, B]), [T, O] = vc({
    reducer: M,
    actionContext: j,
    initialState: V,
    controlledProps: t,
    stateComparers: K,
    onStateChange: R,
    componentName: I
  }), {
    highlightedValue: F,
    selectedValues: N
  } = T, te = kh((q, D) => O({
    type: Se.textNavigation,
    event: D,
    searchString: q
  })), G = x.useRef([]);
  x.useEffect(() => {
    As(G.current, p, f) || (O({
      type: Se.itemsChange,
      event: null,
      items: p,
      previousItems: G.current
    }), G.current = p, A == null || A(p));
  }, [p, f, O, A]);
  const Z = (q) => (D) => {
    var W;
    if ((W = q.onKeyDown) == null || W.call(q, D), D.defaultMuiPrevented)
      return;
    const Q = ["Home", "End", "PageUp", "PageDown"];
    b === "vertical" ? Q.push("ArrowUp", "ArrowDown") : Q.push("ArrowLeft", "ArrowRight"), o === "activeDescendant" && Q.push(" ", "Enter"), Q.includes(D.key) && D.preventDefault(), O({
      type: Se.keyDown,
      key: D.key,
      event: D
    }), te(D);
  }, ie = (q) => (D) => {
    var W, Q;
    (W = q.onBlur) == null || W.call(q, D), !D.defaultMuiPrevented && ((Q = w.current) != null && Q.contains(D.relatedTarget) || O({
      type: Se.blur,
      event: D
    }));
  }, le = (q = {}) => {
    const D = ze(q);
    return y({}, q, {
      "aria-activedescendant": o === "activeDescendant" && F != null ? s(F) : void 0,
      tabIndex: o === "DOM" ? -1 : 0,
      ref: P
    }, D, {
      onBlur: ie(D),
      onKeyDown: Z(D)
    });
  }, ae = x.useCallback((q) => {
    const D = (N ?? []).some(($) => $ != null && f(q, $)), W = F != null && f(q, F);
    return {
      focusable: o === "DOM",
      highlighted: W,
      selected: D
    };
  }, [f, N, F, o]), ce = x.useMemo(() => ({
    dispatch: O,
    getItemState: ae
  }), [O, ae]);
  return x.useDebugValue({
    state: T
  }), {
    contextValue: ce,
    dispatch: O,
    getRootProps: le,
    rootRef: P,
    state: T
  };
}
const wn = /* @__PURE__ */ x.createContext(null);
function xc(e) {
  const {
    handlePointerOverEvents: t = !1,
    item: r
  } = e, n = x.useContext(wn);
  if (!n)
    throw new Error("useListItem must be used within a ListProvider");
  const {
    dispatch: o,
    getItemState: a
  } = n, {
    highlighted: i,
    selected: s,
    focusable: l
  } = a(r), d = x.useCallback((g) => (h) => {
    var m;
    (m = g.onClick) == null || m.call(g, h), !h.defaultPrevented && o({
      type: Se.itemClick,
      item: r,
      event: h
    });
  }, [o, r]), u = x.useCallback((g) => (h) => {
    var m;
    (m = g.onMouseOver) == null || m.call(g, h), !h.defaultPrevented && o({
      type: Se.itemHover,
      item: r,
      event: h
    });
  }, [o, r]);
  let p;
  return l && (p = i ? 0 : -1), {
    getRootProps: (g = {}) => {
      const h = ze(g);
      return y({}, g, {
        onClick: d(h),
        onPointerOver: t ? u(h) : void 0,
        tabIndex: p
      });
    },
    highlighted: i,
    selected: s
  };
}
const Ho = /* @__PURE__ */ x.createContext(null);
function Vh(e) {
  const t = Array.from(e.keys()).map((r) => {
    const n = e.get(r);
    return {
      key: r,
      subitem: n
    };
  });
  return t.sort((r, n) => {
    const o = r.subitem.ref.current, a = n.subitem.ref.current;
    return o === null || a === null || o === a ? 0 : o.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING ? 1 : -1;
  }), new Map(t.map((r) => [r.key, r.subitem]));
}
function vi() {
  const [e, t] = x.useState(/* @__PURE__ */ new Map()), r = x.useRef(/* @__PURE__ */ new Set()), n = x.useCallback(function(d) {
    r.current.delete(d), t((u) => {
      const p = new Map(u);
      return p.delete(d), p;
    });
  }, []), o = x.useCallback(function(d, u) {
    let p;
    return typeof d == "function" ? p = d(r.current) : p = d, r.current.add(p), t((f) => {
      const g = new Map(f);
      return g.set(p, u), g;
    }), {
      id: p,
      deregister: () => n(p)
    };
  }, [n]), a = x.useMemo(() => Vh(e), [e]), i = x.useCallback(function(d) {
    return Array.from(a.keys()).indexOf(d);
  }, [a]);
  return {
    contextValue: x.useMemo(() => ({
      getItemIndex: i,
      registerItem: o,
      totalSubitemCount: e.size
    }), [i, o, e.size]),
    subitems: a
  };
}
function bi(e, t) {
  const r = x.useContext(Ho);
  if (r === null)
    throw new Error("useCompoundItem must be used within a useCompoundParent");
  const {
    registerItem: n
  } = r, [o, a] = x.useState(typeof e == "function" ? void 0 : e);
  return Bt(() => {
    const {
      id: i,
      deregister: s
    } = n(e, t);
    return a(i), s;
  }, [n, t, e]), {
    id: o,
    index: o !== void 0 ? r.getItemIndex(o) : -1,
    totalItemCount: r.totalSubitemCount
  };
}
function kr(e, t) {
  return function(n = {}) {
    const o = y({}, n, e(n));
    return y({}, o, t(o));
  };
}
function Eh(e) {
  return typeof e == "function" ? e() : e;
}
const yc = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    children: n,
    container: o,
    disablePortal: a = !1
  } = t, [i, s] = x.useState(null), l = ke(/* @__PURE__ */ x.isValidElement(n) ? li(n) : null, r);
  if (Bt(() => {
    a || s(Eh(o) || document.body);
  }, [o, a]), Bt(() => {
    if (i && !a)
      return no(r, i), () => {
        no(r, null);
      };
  }, [r, i, a]), a) {
    if (/* @__PURE__ */ x.isValidElement(n)) {
      const d = {
        ref: l
      };
      return /* @__PURE__ */ x.cloneElement(n, d);
    }
    return /* @__PURE__ */ c.jsx(x.Fragment, {
      children: n
    });
  }
  return /* @__PURE__ */ c.jsx(x.Fragment, {
    children: i && /* @__PURE__ */ qd.createPortal(n, i)
  });
});
function Kh(e = {}) {
  const {
    disabled: t = !1,
    focusableWhenDisabled: r,
    rootRef: n
  } = e, o = x.useContext(mc);
  if (o === null)
    throw new Error("useMenuButton: no menu context available.");
  const {
    state: a,
    dispatch: i,
    registerTrigger: s,
    popupId: l
  } = o, {
    getRootProps: d,
    rootRef: u,
    active: p
  } = nr({
    disabled: t,
    focusableWhenDisabled: r,
    rootRef: n
  }), f = ke(u, s), g = (b) => (C) => {
    var v;
    (v = b.onClick) == null || v.call(b, C), !C.defaultMuiPrevented && i({
      type: qt.toggle,
      event: C
    });
  }, h = (b) => (C) => {
    var v;
    (v = b.onKeyDown) == null || v.call(b, C), !C.defaultMuiPrevented && (C.key === "ArrowDown" || C.key === "ArrowUp") && (C.preventDefault(), i({
      type: qt.open,
      event: C
    }));
  }, m = (b = {}) => ({
    onClick: g(b),
    onKeyDown: h(b)
  });
  return {
    active: p,
    getRootProps: (b = {}) => {
      const C = ze(b), v = kr(m, d);
      return y({
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": l
      }, b, C, v(C), {
        tabIndex: 0,
        // this is needed to make the button focused after click in Safari
        ref: f
      });
    },
    open: a.open,
    rootRef: f
  };
}
function Rh(e) {
  const t = _e(e);
  return t.body === e ? zo(e).innerWidth > t.documentElement.clientWidth : e.scrollHeight > e.clientHeight;
}
function en(e, t) {
  t ? e.setAttribute("aria-hidden", "true") : e.removeAttribute("aria-hidden");
}
function Is(e) {
  return parseInt(zo(e).getComputedStyle(e).paddingRight, 10) || 0;
}
function Uh(e) {
  const r = ["TEMPLATE", "SCRIPT", "STYLE", "LINK", "MAP", "META", "NOSCRIPT", "PICTURE", "COL", "COLGROUP", "PARAM", "SLOT", "SOURCE", "TRACK"].indexOf(e.tagName) !== -1, n = e.tagName === "INPUT" && e.getAttribute("type") === "hidden";
  return r || n;
}
function ws(e, t, r, n, o) {
  const a = [t, r, ...n];
  [].forEach.call(e.children, (i) => {
    const s = a.indexOf(i) === -1, l = !Uh(i);
    s && l && en(i, o);
  });
}
function ca(e, t) {
  let r = -1;
  return e.some((n, o) => t(n) ? (r = o, !0) : !1), r;
}
function jh(e, t) {
  const r = [], n = e.container;
  if (!t.disableScrollLock) {
    if (Rh(n)) {
      const i = Bf(_e(n));
      r.push({
        value: n.style.paddingRight,
        property: "padding-right",
        el: n
      }), n.style.paddingRight = `${Is(n) + i}px`;
      const s = _e(n).querySelectorAll(".mui-fixed");
      [].forEach.call(s, (l) => {
        r.push({
          value: l.style.paddingRight,
          property: "padding-right",
          el: l
        }), l.style.paddingRight = `${Is(l) + i}px`;
      });
    }
    let a;
    if (n.parentNode instanceof DocumentFragment)
      a = _e(n).body;
    else {
      const i = n.parentElement, s = zo(n);
      a = (i == null ? void 0 : i.nodeName) === "HTML" && s.getComputedStyle(i).overflowY === "scroll" ? i : n;
    }
    r.push({
      value: a.style.overflow,
      property: "overflow",
      el: a
    }, {
      value: a.style.overflowX,
      property: "overflow-x",
      el: a
    }, {
      value: a.style.overflowY,
      property: "overflow-y",
      el: a
    }), a.style.overflow = "hidden";
  }
  return () => {
    r.forEach(({
      value: a,
      el: i,
      property: s
    }) => {
      a ? i.style.setProperty(s, a) : i.style.removeProperty(s);
    });
  };
}
function Bh(e) {
  const t = [];
  return [].forEach.call(e.children, (r) => {
    r.getAttribute("aria-hidden") === "true" && t.push(r);
  }), t;
}
class Dh {
  constructor() {
    this.containers = void 0, this.modals = void 0, this.modals = [], this.containers = [];
  }
  add(t, r) {
    let n = this.modals.indexOf(t);
    if (n !== -1)
      return n;
    n = this.modals.length, this.modals.push(t), t.modalRef && en(t.modalRef, !1);
    const o = Bh(r);
    ws(r, t.mount, t.modalRef, o, !0);
    const a = ca(this.containers, (i) => i.container === r);
    return a !== -1 ? (this.containers[a].modals.push(t), n) : (this.containers.push({
      modals: [t],
      container: r,
      restore: null,
      hiddenSiblings: o
    }), n);
  }
  mount(t, r) {
    const n = ca(this.containers, (a) => a.modals.indexOf(t) !== -1), o = this.containers[n];
    o.restore || (o.restore = jh(o, r));
  }
  remove(t, r = !0) {
    const n = this.modals.indexOf(t);
    if (n === -1)
      return n;
    const o = ca(this.containers, (i) => i.modals.indexOf(t) !== -1), a = this.containers[o];
    if (a.modals.splice(a.modals.indexOf(t), 1), this.modals.splice(n, 1), a.modals.length === 0)
      a.restore && a.restore(), t.modalRef && en(t.modalRef, r), ws(a.container, t.mount, t.modalRef, a.hiddenSiblings, !1), this.containers.splice(o, 1);
    else {
      const i = a.modals[a.modals.length - 1];
      i.modalRef && en(i.modalRef, !1);
    }
    return n;
  }
  isTopModal(t) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === t;
  }
}
function Mh(e) {
  return typeof e == "function" ? e() : e;
}
function Fh(e) {
  return e ? e.props.hasOwnProperty("in") : !1;
}
const qh = new Dh();
function Jh(e) {
  const {
    container: t,
    disableEscapeKeyDown: r = !1,
    disableScrollLock: n = !1,
    // @ts-ignore internal logic - Base UI supports the manager as a prop too
    manager: o = qh,
    closeAfterTransition: a = !1,
    onTransitionEnter: i,
    onTransitionExited: s,
    children: l,
    onClose: d,
    open: u,
    rootRef: p
  } = e, f = x.useRef({}), g = x.useRef(null), h = x.useRef(null), m = ke(h, p), [A, b] = x.useState(!u), C = Fh(l);
  let v = !0;
  (e["aria-hidden"] === "false" || e["aria-hidden"] === !1) && (v = !1);
  const k = () => _e(g.current), S = () => (f.current.modalRef = h.current, f.current.mount = g.current, f.current), I = () => {
    o.mount(S(), {
      disableScrollLock: n
    }), h.current && (h.current.scrollTop = 0);
  }, w = Sr(() => {
    const T = Mh(t) || k().body;
    o.add(S(), T), h.current && I();
  }), P = x.useCallback(() => o.isTopModal(S()), [o]), E = Sr((T) => {
    g.current = T, T && (u && P() ? I() : h.current && en(h.current, v));
  }), K = x.useCallback(() => {
    o.remove(S(), v);
  }, [v, o]);
  x.useEffect(() => () => {
    K();
  }, [K]), x.useEffect(() => {
    u ? w() : (!C || !a) && K();
  }, [u, K, C, a, w]);
  const R = (T) => (O) => {
    var F;
    (F = T.onKeyDown) == null || F.call(T, O), !(O.key !== "Escape" || O.which === 229 || // Wait until IME is settled.
    !P()) && (r || (O.stopPropagation(), d && d(O, "escapeKeyDown")));
  }, B = (T) => (O) => {
    var F;
    (F = T.onClick) == null || F.call(T, O), O.target === O.currentTarget && d && d(O, "backdropClick");
  };
  return {
    getRootProps: (T = {}) => {
      const O = ze(e);
      delete O.onTransitionEnter, delete O.onTransitionExited;
      const F = y({}, O, T);
      return y({
        role: "presentation"
      }, F, {
        onKeyDown: R(F),
        ref: m
      });
    },
    getBackdropProps: (T = {}) => {
      const O = T;
      return y({
        "aria-hidden": !0
      }, O, {
        onClick: B(O),
        open: u
      });
    },
    getTransitionProps: () => {
      const T = () => {
        b(!1), i && i();
      }, O = () => {
        b(!0), s && s(), a && K();
      };
      return {
        onEnter: Aa(T, l == null ? void 0 : l.props.onEnter),
        onExited: Aa(O, l == null ? void 0 : l.props.onExited)
      };
    },
    rootRef: m,
    portalRef: E,
    isTopModal: P,
    exited: A,
    hasTransition: C
  };
}
function Wh(e) {
  const {
    value: t,
    label: r,
    disabled: n,
    rootRef: o,
    id: a
  } = e, {
    getRootProps: i,
    highlighted: s,
    selected: l
  } = xc({
    item: t
  }), {
    getRootProps: d,
    rootRef: u
  } = nr({
    disabled: n,
    focusableWhenDisabled: !0
  }), p = Wt(a), f = x.useRef(null), g = x.useMemo(() => ({
    disabled: n,
    label: r,
    value: t,
    ref: f,
    id: p
  }), [n, r, t, p]), {
    index: h
  } = bi(t, g), m = ke(o, f, u), A = (C) => (v) => {
    var k;
    (k = C.onKeyDown) == null || k.call(C, v), !v.defaultMuiPrevented && [" ", "Enter"].includes(v.key) && (v.defaultMuiPrevented = !0);
  }, b = (C = {}) => ({
    onKeyDown: A(C)
  });
  return {
    getRootProps: (C = {}) => {
      const v = ze(C), k = kr(i, kr(d, b));
      return y({}, C, v, k(v), {
        id: p,
        ref: m,
        role: "option",
        "aria-selected": l
      });
    },
    highlighted: s,
    index: h,
    selected: l,
    rootRef: m
  };
}
function Lh(e) {
  const t = x.useContext(wn);
  if (!t)
    throw new Error("Option: ListContext was not found.");
  const {
    getItemState: r,
    dispatch: n
  } = t, {
    highlighted: o,
    selected: a,
    focusable: i
  } = r(e), s = x.useCallback((d) => {
    if (d !== e)
      throw new Error(["Base UI Option: Tried to access the state of another Option.", "This is unsupported when the Option uses the OptionContextStabilizer as a performance optimization."].join("/n"));
    return {
      highlighted: o,
      selected: a,
      focusable: i
    };
  }, [o, a, i, e]);
  return {
    contextValue: x.useMemo(() => ({
      dispatch: n,
      getItemState: s
    }), [n, s])
  };
}
var et = "top", ft = "bottom", gt = "right", tt = "left", xi = "auto", Pn = [et, ft, gt, tt], Ir = "start", dn = "end", zh = "clippingParents", Ac = "viewport", Nr = "popper", Nh = "reference", Ps = /* @__PURE__ */ Pn.reduce(function(e, t) {
  return e.concat([t + "-" + Ir, t + "-" + dn]);
}, []), Cc = /* @__PURE__ */ [].concat(Pn, [xi]).reduce(function(e, t) {
  return e.concat([t, t + "-" + Ir, t + "-" + dn]);
}, []), Qh = "beforeRead", Hh = "read", Gh = "afterRead", Zh = "beforeMain", Yh = "main", Xh = "afterMain", $h = "beforeWrite", _h = "write", em = "afterWrite", tm = [Qh, Hh, Gh, Zh, Yh, Xh, $h, _h, em];
function Vt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function st(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function er(e) {
  var t = st(e).Element;
  return e instanceof t || e instanceof Element;
}
function pt(e) {
  var t = st(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function yi(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = st(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function rm(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, o = t.attributes[r] || {}, a = t.elements[r];
    !pt(a) || !Vt(a) || (Object.assign(a.style, n), Object.keys(o).forEach(function(i) {
      var s = o[i];
      s === !1 ? a.removeAttribute(i) : a.setAttribute(i, s === !0 ? "" : s);
    }));
  });
}
function nm(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var o = t.elements[n], a = t.attributes[n] || {}, i = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = i.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !pt(o) || !Vt(o) || (Object.assign(o.style, s), Object.keys(a).forEach(function(l) {
        o.removeAttribute(l);
      }));
    });
  };
}
const om = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: rm,
  effect: nm,
  requires: ["computeStyles"]
};
function Ot(e) {
  return e.split("-")[0];
}
var Zt = Math.max, oo = Math.min, wr = Math.round;
function ka() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Sc() {
  return !/^((?!chrome|android).)*safari/i.test(ka());
}
function Pr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), o = 1, a = 1;
  t && pt(e) && (o = e.offsetWidth > 0 && wr(n.width) / e.offsetWidth || 1, a = e.offsetHeight > 0 && wr(n.height) / e.offsetHeight || 1);
  var i = er(e) ? st(e) : window, s = i.visualViewport, l = !Sc() && r, d = (n.left + (l && s ? s.offsetLeft : 0)) / o, u = (n.top + (l && s ? s.offsetTop : 0)) / a, p = n.width / o, f = n.height / a;
  return {
    width: p,
    height: f,
    top: u,
    right: d + p,
    bottom: u + f,
    left: d,
    x: d,
    y: u
  };
}
function Ai(e) {
  var t = Pr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function kc(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && yi(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Mt(e) {
  return st(e).getComputedStyle(e);
}
function am(e) {
  return ["table", "td", "th"].indexOf(Vt(e)) >= 0;
}
function zt(e) {
  return ((er(e) ? e.ownerDocument : (
    // $FlowFixMe[prop-missing]
    e.document
  )) || window.document).documentElement;
}
function Go(e) {
  return Vt(e) === "html" ? e : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    e.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    e.parentNode || // DOM Element detected
    (yi(e) ? e.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    zt(e)
  );
}
function Ts(e) {
  return !pt(e) || // https://github.com/popperjs/popper-core/issues/837
  Mt(e).position === "fixed" ? null : e.offsetParent;
}
function im(e) {
  var t = /firefox/i.test(ka()), r = /Trident/i.test(ka());
  if (r && pt(e)) {
    var n = Mt(e);
    if (n.position === "fixed")
      return null;
  }
  var o = Go(e);
  for (yi(o) && (o = o.host); pt(o) && ["html", "body"].indexOf(Vt(o)) < 0; ) {
    var a = Mt(o);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || t && a.willChange === "filter" || t && a.filter && a.filter !== "none")
      return o;
    o = o.parentNode;
  }
  return null;
}
function Tn(e) {
  for (var t = st(e), r = Ts(e); r && am(r) && Mt(r).position === "static"; )
    r = Ts(r);
  return r && (Vt(r) === "html" || Vt(r) === "body" && Mt(r).position === "static") ? t : r || im(e) || t;
}
function Ci(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function tn(e, t, r) {
  return Zt(e, oo(t, r));
}
function sm(e, t, r) {
  var n = tn(e, t, r);
  return n > r ? r : n;
}
function Ic() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function wc(e) {
  return Object.assign({}, Ic(), e);
}
function Pc(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var lm = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, wc(typeof t != "number" ? t : Pc(t, Pn));
};
function cm(e) {
  var t, r = e.state, n = e.name, o = e.options, a = r.elements.arrow, i = r.modifiersData.popperOffsets, s = Ot(r.placement), l = Ci(s), d = [tt, gt].indexOf(s) >= 0, u = d ? "height" : "width";
  if (!(!a || !i)) {
    var p = lm(o.padding, r), f = Ai(a), g = l === "y" ? et : tt, h = l === "y" ? ft : gt, m = r.rects.reference[u] + r.rects.reference[l] - i[l] - r.rects.popper[u], A = i[l] - r.rects.reference[l], b = Tn(a), C = b ? l === "y" ? b.clientHeight || 0 : b.clientWidth || 0 : 0, v = m / 2 - A / 2, k = p[g], S = C - f[u] - p[h], I = C / 2 - f[u] / 2 + v, w = tn(k, I, S), P = l;
    r.modifiersData[n] = (t = {}, t[P] = w, t.centerOffset = w - I, t);
  }
}
function dm(e) {
  var t = e.state, r = e.options, n = r.element, o = n === void 0 ? "[data-popper-arrow]" : n;
  o != null && (typeof o == "string" && (o = t.elements.popper.querySelector(o), !o) || kc(t.elements.popper, o) && (t.elements.arrow = o));
}
const um = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: cm,
  effect: dm,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Tr(e) {
  return e.split("-")[1];
}
var pm = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function fm(e, t) {
  var r = e.x, n = e.y, o = t.devicePixelRatio || 1;
  return {
    x: wr(r * o) / o || 0,
    y: wr(n * o) / o || 0
  };
}
function Os(e) {
  var t, r = e.popper, n = e.popperRect, o = e.placement, a = e.variation, i = e.offsets, s = e.position, l = e.gpuAcceleration, d = e.adaptive, u = e.roundOffsets, p = e.isFixed, f = i.x, g = f === void 0 ? 0 : f, h = i.y, m = h === void 0 ? 0 : h, A = typeof u == "function" ? u({
    x: g,
    y: m
  }) : {
    x: g,
    y: m
  };
  g = A.x, m = A.y;
  var b = i.hasOwnProperty("x"), C = i.hasOwnProperty("y"), v = tt, k = et, S = window;
  if (d) {
    var I = Tn(r), w = "clientHeight", P = "clientWidth";
    if (I === st(r) && (I = zt(r), Mt(I).position !== "static" && s === "absolute" && (w = "scrollHeight", P = "scrollWidth")), I = I, o === et || (o === tt || o === gt) && a === dn) {
      k = ft;
      var E = p && I === S && S.visualViewport ? S.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        I[w]
      );
      m -= E - n.height, m *= l ? 1 : -1;
    }
    if (o === tt || (o === et || o === ft) && a === dn) {
      v = gt;
      var K = p && I === S && S.visualViewport ? S.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        I[P]
      );
      g -= K - n.width, g *= l ? 1 : -1;
    }
  }
  var R = Object.assign({
    position: s
  }, d && pm), B = u === !0 ? fm({
    x: g,
    y: m
  }, st(r)) : {
    x: g,
    y: m
  };
  if (g = B.x, m = B.y, l) {
    var V;
    return Object.assign({}, R, (V = {}, V[k] = C ? "0" : "", V[v] = b ? "0" : "", V.transform = (S.devicePixelRatio || 1) <= 1 ? "translate(" + g + "px, " + m + "px)" : "translate3d(" + g + "px, " + m + "px, 0)", V));
  }
  return Object.assign({}, R, (t = {}, t[k] = C ? m + "px" : "", t[v] = b ? g + "px" : "", t.transform = "", t));
}
function gm(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, o = n === void 0 ? !0 : n, a = r.adaptive, i = a === void 0 ? !0 : a, s = r.roundOffsets, l = s === void 0 ? !0 : s, d = {
    placement: Ot(t.placement),
    variation: Tr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: o,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, Os(Object.assign({}, d, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: i,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, Os(Object.assign({}, d, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const hm = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: gm,
  data: {}
};
var Dn = {
  passive: !0
};
function mm(e) {
  var t = e.state, r = e.instance, n = e.options, o = n.scroll, a = o === void 0 ? !0 : o, i = n.resize, s = i === void 0 ? !0 : i, l = st(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return a && d.forEach(function(u) {
    u.addEventListener("scroll", r.update, Dn);
  }), s && l.addEventListener("resize", r.update, Dn), function() {
    a && d.forEach(function(u) {
      u.removeEventListener("scroll", r.update, Dn);
    }), s && l.removeEventListener("resize", r.update, Dn);
  };
}
const vm = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: mm,
  data: {}
};
var bm = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Zn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return bm[t];
  });
}
var xm = {
  start: "end",
  end: "start"
};
function Vs(e) {
  return e.replace(/start|end/g, function(t) {
    return xm[t];
  });
}
function Si(e) {
  var t = st(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function ki(e) {
  return Pr(zt(e)).left + Si(e).scrollLeft;
}
function ym(e, t) {
  var r = st(e), n = zt(e), o = r.visualViewport, a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    var d = Sc();
    (d || !d && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s + ki(e),
    y: l
  };
}
function Am(e) {
  var t, r = zt(e), n = Si(e), o = (t = e.ownerDocument) == null ? void 0 : t.body, a = Zt(r.scrollWidth, r.clientWidth, o ? o.scrollWidth : 0, o ? o.clientWidth : 0), i = Zt(r.scrollHeight, r.clientHeight, o ? o.scrollHeight : 0, o ? o.clientHeight : 0), s = -n.scrollLeft + ki(e), l = -n.scrollTop;
  return Mt(o || r).direction === "rtl" && (s += Zt(r.clientWidth, o ? o.clientWidth : 0) - a), {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function Ii(e) {
  var t = Mt(e), r = t.overflow, n = t.overflowX, o = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + o + n);
}
function Tc(e) {
  return ["html", "body", "#document"].indexOf(Vt(e)) >= 0 ? e.ownerDocument.body : pt(e) && Ii(e) ? e : Tc(Go(e));
}
function rn(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = Tc(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), a = st(n), i = o ? [a].concat(a.visualViewport || [], Ii(n) ? n : []) : n, s = t.concat(i);
  return o ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(rn(Go(i)))
  );
}
function Ia(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function Cm(e, t) {
  var r = Pr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function Es(e, t, r) {
  return t === Ac ? Ia(ym(e, r)) : er(t) ? Cm(t, r) : Ia(Am(zt(e)));
}
function Sm(e) {
  var t = rn(Go(e)), r = ["absolute", "fixed"].indexOf(Mt(e).position) >= 0, n = r && pt(e) ? Tn(e) : e;
  return er(n) ? t.filter(function(o) {
    return er(o) && kc(o, n) && Vt(o) !== "body";
  }) : [];
}
function km(e, t, r, n) {
  var o = t === "clippingParents" ? Sm(e) : [].concat(t), a = [].concat(o, [r]), i = a[0], s = a.reduce(function(l, d) {
    var u = Es(e, d, n);
    return l.top = Zt(u.top, l.top), l.right = oo(u.right, l.right), l.bottom = oo(u.bottom, l.bottom), l.left = Zt(u.left, l.left), l;
  }, Es(e, i, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function Oc(e) {
  var t = e.reference, r = e.element, n = e.placement, o = n ? Ot(n) : null, a = n ? Tr(n) : null, i = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (o) {
    case et:
      l = {
        x: i,
        y: t.y - r.height
      };
      break;
    case ft:
      l = {
        x: i,
        y: t.y + t.height
      };
      break;
    case gt:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case tt:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var d = o ? Ci(o) : null;
  if (d != null) {
    var u = d === "y" ? "height" : "width";
    switch (a) {
      case Ir:
        l[d] = l[d] - (t[u] / 2 - r[u] / 2);
        break;
      case dn:
        l[d] = l[d] + (t[u] / 2 - r[u] / 2);
        break;
    }
  }
  return l;
}
function un(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = n === void 0 ? e.placement : n, a = r.strategy, i = a === void 0 ? e.strategy : a, s = r.boundary, l = s === void 0 ? zh : s, d = r.rootBoundary, u = d === void 0 ? Ac : d, p = r.elementContext, f = p === void 0 ? Nr : p, g = r.altBoundary, h = g === void 0 ? !1 : g, m = r.padding, A = m === void 0 ? 0 : m, b = wc(typeof A != "number" ? A : Pc(A, Pn)), C = f === Nr ? Nh : Nr, v = e.rects.popper, k = e.elements[h ? C : f], S = km(er(k) ? k : k.contextElement || zt(e.elements.popper), l, u, i), I = Pr(e.elements.reference), w = Oc({
    reference: I,
    element: v,
    placement: o
  }), P = Ia(Object.assign({}, v, w)), E = f === Nr ? P : I, K = {
    top: S.top - E.top + b.top,
    bottom: E.bottom - S.bottom + b.bottom,
    left: S.left - E.left + b.left,
    right: E.right - S.right + b.right
  }, R = e.modifiersData.offset;
  if (f === Nr && R) {
    var B = R[o];
    Object.keys(K).forEach(function(V) {
      var M = [gt, ft].indexOf(V) >= 0 ? 1 : -1, j = [et, ft].indexOf(V) >= 0 ? "y" : "x";
      K[V] += B[j] * M;
    });
  }
  return K;
}
function Im(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, o = r.boundary, a = r.rootBoundary, i = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, d = l === void 0 ? Cc : l, u = Tr(n), p = u ? s ? Ps : Ps.filter(function(h) {
    return Tr(h) === u;
  }) : Pn, f = p.filter(function(h) {
    return d.indexOf(h) >= 0;
  });
  f.length === 0 && (f = p);
  var g = f.reduce(function(h, m) {
    return h[m] = un(e, {
      placement: m,
      boundary: o,
      rootBoundary: a,
      padding: i
    })[Ot(m)], h;
  }, {});
  return Object.keys(g).sort(function(h, m) {
    return g[h] - g[m];
  });
}
function wm(e) {
  if (Ot(e) === xi)
    return [];
  var t = Zn(e);
  return [Vs(e), t, Vs(t)];
}
function Pm(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var o = r.mainAxis, a = o === void 0 ? !0 : o, i = r.altAxis, s = i === void 0 ? !0 : i, l = r.fallbackPlacements, d = r.padding, u = r.boundary, p = r.rootBoundary, f = r.altBoundary, g = r.flipVariations, h = g === void 0 ? !0 : g, m = r.allowedAutoPlacements, A = t.options.placement, b = Ot(A), C = b === A, v = l || (C || !h ? [Zn(A)] : wm(A)), k = [A].concat(v).reduce(function(le, ae) {
      return le.concat(Ot(ae) === xi ? Im(t, {
        placement: ae,
        boundary: u,
        rootBoundary: p,
        padding: d,
        flipVariations: h,
        allowedAutoPlacements: m
      }) : ae);
    }, []), S = t.rects.reference, I = t.rects.popper, w = /* @__PURE__ */ new Map(), P = !0, E = k[0], K = 0; K < k.length; K++) {
      var R = k[K], B = Ot(R), V = Tr(R) === Ir, M = [et, ft].indexOf(B) >= 0, j = M ? "width" : "height", T = un(t, {
        placement: R,
        boundary: u,
        rootBoundary: p,
        altBoundary: f,
        padding: d
      }), O = M ? V ? gt : tt : V ? ft : et;
      S[j] > I[j] && (O = Zn(O));
      var F = Zn(O), N = [];
      if (a && N.push(T[B] <= 0), s && N.push(T[O] <= 0, T[F] <= 0), N.every(function(le) {
        return le;
      })) {
        E = R, P = !1;
        break;
      }
      w.set(R, N);
    }
    if (P)
      for (var te = h ? 3 : 1, G = function(ae) {
        var ce = k.find(function(q) {
          var D = w.get(q);
          if (D)
            return D.slice(0, ae).every(function(W) {
              return W;
            });
        });
        if (ce)
          return E = ce, "break";
      }, Z = te; Z > 0; Z--) {
        var ie = G(Z);
        if (ie === "break") break;
      }
    t.placement !== E && (t.modifiersData[n]._skip = !0, t.placement = E, t.reset = !0);
  }
}
const Tm = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: Pm,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function Ks(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function Rs(e) {
  return [et, gt, ft, tt].some(function(t) {
    return e[t] >= 0;
  });
}
function Om(e) {
  var t = e.state, r = e.name, n = t.rects.reference, o = t.rects.popper, a = t.modifiersData.preventOverflow, i = un(t, {
    elementContext: "reference"
  }), s = un(t, {
    altBoundary: !0
  }), l = Ks(i, n), d = Ks(s, o, a), u = Rs(l), p = Rs(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: u,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": p
  });
}
const Vm = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Om
};
function Em(e, t, r) {
  var n = Ot(e), o = [tt, et].indexOf(n) >= 0 ? -1 : 1, a = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, i = a[0], s = a[1];
  return i = i || 0, s = (s || 0) * o, [tt, gt].indexOf(n) >= 0 ? {
    x: s,
    y: i
  } : {
    x: i,
    y: s
  };
}
function Km(e) {
  var t = e.state, r = e.options, n = e.name, o = r.offset, a = o === void 0 ? [0, 0] : o, i = Cc.reduce(function(u, p) {
    return u[p] = Em(p, t.rects, a), u;
  }, {}), s = i[t.placement], l = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += d), t.modifiersData[n] = i;
}
const Rm = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Km
};
function Um(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = Oc({
    reference: t.rects.reference,
    element: t.rects.popper,
    placement: t.placement
  });
}
const jm = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: Um,
  data: {}
};
function Bm(e) {
  return e === "x" ? "y" : "x";
}
function Dm(e) {
  var t = e.state, r = e.options, n = e.name, o = r.mainAxis, a = o === void 0 ? !0 : o, i = r.altAxis, s = i === void 0 ? !1 : i, l = r.boundary, d = r.rootBoundary, u = r.altBoundary, p = r.padding, f = r.tether, g = f === void 0 ? !0 : f, h = r.tetherOffset, m = h === void 0 ? 0 : h, A = un(t, {
    boundary: l,
    rootBoundary: d,
    padding: p,
    altBoundary: u
  }), b = Ot(t.placement), C = Tr(t.placement), v = !C, k = Ci(b), S = Bm(k), I = t.modifiersData.popperOffsets, w = t.rects.reference, P = t.rects.popper, E = typeof m == "function" ? m(Object.assign({}, t.rects, {
    placement: t.placement
  })) : m, K = typeof E == "number" ? {
    mainAxis: E,
    altAxis: E
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, E), R = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, B = {
    x: 0,
    y: 0
  };
  if (I) {
    if (a) {
      var V, M = k === "y" ? et : tt, j = k === "y" ? ft : gt, T = k === "y" ? "height" : "width", O = I[k], F = O + A[M], N = O - A[j], te = g ? -P[T] / 2 : 0, G = C === Ir ? w[T] : P[T], Z = C === Ir ? -P[T] : -w[T], ie = t.elements.arrow, le = g && ie ? Ai(ie) : {
        width: 0,
        height: 0
      }, ae = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : Ic(), ce = ae[M], q = ae[j], D = tn(0, w[T], le[T]), W = v ? w[T] / 2 - te - D - ce - K.mainAxis : G - D - ce - K.mainAxis, Q = v ? -w[T] / 2 + te + D + q + K.mainAxis : Z + D + q + K.mainAxis, $ = t.elements.arrow && Tn(t.elements.arrow), se = $ ? k === "y" ? $.clientTop || 0 : $.clientLeft || 0 : 0, X = (V = R == null ? void 0 : R[k]) != null ? V : 0, de = O + W - X - se, Ge = O + Q - X, nt = tn(g ? oo(F, de) : F, O, g ? Zt(N, Ge) : N);
      I[k] = nt, B[k] = nt - O;
    }
    if (s) {
      var Ke, Ae = k === "x" ? et : tt, ct = k === "x" ? ft : gt, ot = I[S], kt = S === "y" ? "height" : "width", Kt = ot + A[Ae], De = ot - A[ct], bt = [et, tt].indexOf(b) !== -1, xt = (Ke = R == null ? void 0 : R[S]) != null ? Ke : 0, Rt = bt ? Kt : ot - w[kt] - P[kt] - xt + K.altAxis, Ze = bt ? ot + w[kt] + P[kt] - xt - K.altAxis : De, We = g && bt ? sm(Rt, ot, Ze) : tn(g ? Rt : Kt, ot, g ? Ze : De);
      I[S] = We, B[S] = We - ot;
    }
    t.modifiersData[n] = B;
  }
}
const Mm = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Dm,
  requiresIfExists: ["offset"]
};
function Fm(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function qm(e) {
  return e === st(e) || !pt(e) ? Si(e) : Fm(e);
}
function Jm(e) {
  var t = e.getBoundingClientRect(), r = wr(t.width) / e.offsetWidth || 1, n = wr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function Wm(e, t, r) {
  r === void 0 && (r = !1);
  var n = pt(t), o = pt(t) && Jm(t), a = zt(t), i = Pr(e, o, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((Vt(t) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  Ii(a)) && (s = qm(t)), pt(t) ? (l = Pr(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : a && (l.x = ki(a))), {
    x: i.left + s.scrollLeft - l.x,
    y: i.top + s.scrollTop - l.y,
    width: i.width,
    height: i.height
  };
}
function Lm(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(a) {
    t.set(a.name, a);
  });
  function o(a) {
    r.add(a.name);
    var i = [].concat(a.requires || [], a.requiresIfExists || []);
    i.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && o(l);
      }
    }), n.push(a);
  }
  return e.forEach(function(a) {
    r.has(a.name) || o(a);
  }), n;
}
function zm(e) {
  var t = Lm(e);
  return tm.reduce(function(r, n) {
    return r.concat(t.filter(function(o) {
      return o.phase === n;
    }));
  }, []);
}
function Nm(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function Qm(e) {
  var t = e.reduce(function(r, n) {
    var o = r[n.name];
    return r[n.name] = o ? Object.assign({}, o, n, {
      options: Object.assign({}, o.options, n.options),
      data: Object.assign({}, o.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var Us = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function js() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Hm(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, o = t.defaultOptions, a = o === void 0 ? Us : o;
  return function(s, l, d) {
    d === void 0 && (d = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, Us, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], f = !1, g = {
      state: u,
      setOptions: function(b) {
        var C = typeof b == "function" ? b(u.options) : b;
        m(), u.options = Object.assign({}, a, u.options, C), u.scrollParents = {
          reference: er(s) ? rn(s) : s.contextElement ? rn(s.contextElement) : [],
          popper: rn(l)
        };
        var v = zm(Qm([].concat(n, u.options.modifiers)));
        return u.orderedModifiers = v.filter(function(k) {
          return k.enabled;
        }), h(), g.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!f) {
          var b = u.elements, C = b.reference, v = b.popper;
          if (js(C, v)) {
            u.rects = {
              reference: Wm(C, Tn(v), u.options.strategy === "fixed"),
              popper: Ai(v)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(K) {
              return u.modifiersData[K.name] = Object.assign({}, K.data);
            });
            for (var k = 0; k < u.orderedModifiers.length; k++) {
              if (u.reset === !0) {
                u.reset = !1, k = -1;
                continue;
              }
              var S = u.orderedModifiers[k], I = S.fn, w = S.options, P = w === void 0 ? {} : w, E = S.name;
              typeof I == "function" && (u = I({
                state: u,
                options: P,
                name: E,
                instance: g
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: Nm(function() {
        return new Promise(function(A) {
          g.forceUpdate(), A(u);
        });
      }),
      destroy: function() {
        m(), f = !0;
      }
    };
    if (!js(s, l))
      return g;
    g.setOptions(d).then(function(A) {
      !f && d.onFirstUpdate && d.onFirstUpdate(A);
    });
    function h() {
      u.orderedModifiers.forEach(function(A) {
        var b = A.name, C = A.options, v = C === void 0 ? {} : C, k = A.effect;
        if (typeof k == "function") {
          var S = k({
            state: u,
            name: b,
            instance: g,
            options: v
          }), I = function() {
          };
          p.push(S || I);
        }
      });
    }
    function m() {
      p.forEach(function(A) {
        return A();
      }), p = [];
    }
    return g;
  };
}
var Gm = [vm, jm, hm, om, Rm, Tm, Mm, um, Vm], Zm = /* @__PURE__ */ Hm({
  defaultModifiers: Gm
});
const Ym = "Popper";
function Xm(e) {
  return Zg(Ym, e);
}
const $m = ["anchorEl", "children", "direction", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "slotProps", "slots", "TransitionProps", "ownerState"], _m = ["anchorEl", "children", "container", "direction", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition", "slotProps", "slots"];
function e0(e, t) {
  if (t === "ltr")
    return e;
  switch (e) {
    case "bottom-end":
      return "bottom-start";
    case "bottom-start":
      return "bottom-end";
    case "top-end":
      return "top-start";
    case "top-start":
      return "top-end";
    default:
      return e;
  }
}
function wa(e) {
  return typeof e == "function" ? e() : e;
}
function t0(e) {
  return e.nodeType !== void 0;
}
const r0 = () => me({
  root: ["root"]
}, Ng(Xm)), n0 = {}, o0 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n;
  const {
    anchorEl: o,
    children: a,
    direction: i,
    disablePortal: s,
    modifiers: l,
    open: d,
    placement: u,
    popperOptions: p,
    popperRef: f,
    slotProps: g = {},
    slots: h = {},
    TransitionProps: m
    // @ts-ignore internal logic
    // prevent from spreading to DOM, it can come from the parent component e.g. Select.
  } = t, A = ee(t, $m), b = x.useRef(null), C = ke(b, r), v = x.useRef(null), k = ke(v, f), S = x.useRef(k);
  Bt(() => {
    S.current = k;
  }, [k]), x.useImperativeHandle(f, () => v.current, []);
  const I = e0(u, i), [w, P] = x.useState(I), [E, K] = x.useState(wa(o));
  x.useEffect(() => {
    v.current && v.current.forceUpdate();
  }), x.useEffect(() => {
    o && K(wa(o));
  }, [o]), Bt(() => {
    if (!E || !d)
      return;
    const j = (F) => {
      P(F.placement);
    };
    let T = [{
      name: "preventOverflow",
      options: {
        altBoundary: s
      }
    }, {
      name: "flip",
      options: {
        altBoundary: s
      }
    }, {
      name: "onUpdate",
      enabled: !0,
      phase: "afterWrite",
      fn: ({
        state: F
      }) => {
        j(F);
      }
    }];
    l != null && (T = T.concat(l)), p && p.modifiers != null && (T = T.concat(p.modifiers));
    const O = Zm(E, b.current, y({
      placement: I
    }, p, {
      modifiers: T
    }));
    return S.current(O), () => {
      O.destroy(), S.current(null);
    };
  }, [E, s, l, d, p, I]);
  const R = {
    placement: w
  };
  m !== null && (R.TransitionProps = m);
  const B = r0(), V = (n = h.root) != null ? n : "div", M = qf({
    elementType: V,
    externalSlotProps: g.root,
    externalForwardedProps: A,
    additionalProps: {
      role: "tooltip",
      ref: C
    },
    ownerState: t,
    className: B.root
  });
  return /* @__PURE__ */ c.jsx(V, y({}, M, {
    children: typeof a == "function" ? a(R) : a
  }));
}), a0 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    anchorEl: n,
    children: o,
    container: a,
    direction: i = "ltr",
    disablePortal: s = !1,
    keepMounted: l = !1,
    modifiers: d,
    open: u,
    placement: p = "bottom",
    popperOptions: f = n0,
    popperRef: g,
    style: h,
    transition: m = !1,
    slotProps: A = {},
    slots: b = {}
  } = t, C = ee(t, _m), [v, k] = x.useState(!0), S = () => {
    k(!1);
  }, I = () => {
    k(!0);
  };
  if (!l && !u && (!m || v))
    return null;
  let w;
  if (a)
    w = a;
  else if (n) {
    const K = wa(n);
    w = K && t0(K) ? _e(K).body : _e(null).body;
  }
  const P = !u && l && (!m || v) ? "none" : void 0, E = m ? {
    in: u,
    onEnter: S,
    onExited: I
  } : void 0;
  return /* @__PURE__ */ c.jsx(yc, {
    disablePortal: s,
    container: w,
    children: /* @__PURE__ */ c.jsx(o0, y({
      anchorEl: n,
      direction: i,
      disablePortal: s,
      modifiers: d,
      ref: r,
      open: m ? !v : u,
      placement: p,
      popperOptions: f,
      popperRef: g,
      slotProps: A,
      slots: b
    }, C, {
      style: y({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: "fixed",
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: P
      }, h),
      TransitionProps: E,
      children: o
    }))
  });
}), ao = {
  buttonClick: "buttonClick",
  browserAutoFill: "browserAutoFill"
}, i0 = (e) => {
  const {
    label: t,
    value: r
  } = e;
  return typeof t == "string" ? t : typeof r == "string" ? r : String(e);
};
function s0(e, t) {
  const {
    open: r
  } = e, {
    context: {
      selectionMode: n
    }
  } = t;
  if (t.type === ao.buttonClick) {
    var o;
    const l = (o = e.selectedValues[0]) != null ? o : qe(null, "start", t.context);
    return y({}, e, {
      open: !r,
      highlightedValue: r ? null : l
    });
  }
  if (t.type === ao.browserAutoFill)
    return hi(t.item, e, t.context);
  const a = mi(e, t);
  switch (t.type) {
    case Se.keyDown:
      if (e.open) {
        if (t.event.key === "Escape")
          return y({}, a, {
            open: !1
          });
      } else {
        if (t.event.key === "ArrowDown") {
          var i;
          return y({}, e, {
            open: !0,
            highlightedValue: (i = e.selectedValues[0]) != null ? i : qe(null, "start", t.context)
          });
        }
        if (t.event.key === "ArrowUp") {
          var s;
          return y({}, e, {
            open: !0,
            highlightedValue: (s = e.selectedValues[0]) != null ? s : qe(null, "end", t.context)
          });
        }
      }
      break;
    case Se.itemClick:
      if (n === "single")
        return y({}, a, {
          open: !1
        });
      break;
    case Se.blur:
      return y({}, a, {
        open: !1
      });
    default:
      return a;
  }
  return a;
}
function l0(e) {
  return Array.isArray(e) ? e.length === 0 ? "" : JSON.stringify(e.map((t) => t.value)) : (e == null ? void 0 : e.value) == null ? "" : typeof e.value == "string" || typeof e.value == "number" ? e.value : JSON.stringify(e.value);
}
function c0(e) {
  const {
    areOptionsEqual: t,
    buttonRef: r,
    defaultOpen: n = !1,
    defaultValue: o,
    disabled: a = !1,
    listboxId: i,
    listboxRef: s,
    multiple: l = !1,
    name: d,
    required: u,
    onChange: p,
    onHighlightChange: f,
    onOpenChange: g,
    open: h,
    options: m,
    getOptionAsString: A = i0,
    getSerializedValue: b = l0,
    value: C,
    componentName: v = "useSelect"
  } = e, k = x.useRef(null), S = ke(r, k), I = x.useRef(null), w = Wt(i);
  let P;
  C === void 0 && o === void 0 ? P = [] : o !== void 0 && (l ? P = o : P = o == null ? [] : [o]);
  const E = x.useMemo(() => {
    if (C !== void 0)
      return l ? C : C == null ? [] : [C];
  }, [C, l]), {
    subitems: K,
    contextValue: R
  } = vi(), B = x.useMemo(() => m != null ? new Map(m.map((L, Y) => [L.value, {
    value: L.value,
    label: L.label,
    disabled: L.disabled,
    ref: /* @__PURE__ */ x.createRef(),
    id: `${w}_${Y}`
  }])) : K, [m, K, w]), V = ke(s, I), {
    getRootProps: M,
    active: j,
    focusVisible: T,
    rootRef: O
  } = nr({
    disabled: a,
    rootRef: S
  }), F = x.useMemo(() => Array.from(B.keys()), [B]), N = x.useCallback((L) => {
    if (t !== void 0) {
      const Y = F.find((ne) => t(ne, L));
      return B.get(Y);
    }
    return B.get(L);
  }, [B, t, F]), te = x.useCallback((L) => {
    var Y;
    const ne = N(L);
    return (Y = ne == null ? void 0 : ne.disabled) != null ? Y : !1;
  }, [N]), G = x.useCallback((L) => {
    const Y = N(L);
    return Y ? A(Y) : "";
  }, [N, A]), Z = x.useMemo(() => ({
    selectedValues: E,
    open: h
  }), [E, h]), ie = x.useCallback((L) => {
    var Y;
    return (Y = B.get(L)) == null ? void 0 : Y.id;
  }, [B]), le = x.useCallback((L, Y) => {
    if (l)
      p == null || p(L, Y);
    else {
      var ne;
      p == null || p(L, (ne = Y[0]) != null ? ne : null);
    }
  }, [l, p]), ae = x.useCallback((L, Y) => {
    f == null || f(L, Y ?? null);
  }, [f]), ce = x.useCallback((L, Y, ne) => {
    if (Y === "open" && (g == null || g(ne), ne === !1 && (L == null ? void 0 : L.type) !== "blur")) {
      var Oe;
      (Oe = k.current) == null || Oe.focus();
    }
  }, [g]), q = x.useCallback((L) => {
    var Y, ne;
    return L == null ? null : (Y = (ne = K.get(L)) == null ? void 0 : ne.ref.current) != null ? Y : null;
  }, [K]), D = {
    getInitialState: () => {
      var L;
      return {
        highlightedValue: null,
        selectedValues: (L = P) != null ? L : [],
        open: n
      };
    },
    getItemId: ie,
    controlledProps: Z,
    focusManagement: "DOM",
    getItemDomElement: q,
    itemComparer: t,
    isItemDisabled: te,
    rootRef: V,
    onChange: le,
    onHighlightChange: ae,
    onStateChange: ce,
    reducerActionContext: x.useMemo(() => ({
      multiple: l
    }), [l]),
    items: F,
    getItemAsString: G,
    selectionMode: l ? "multiple" : "single",
    stateReducer: s0,
    componentName: v
  }, {
    dispatch: W,
    getRootProps: Q,
    contextValue: $,
    state: {
      open: se,
      highlightedValue: X,
      selectedValues: de
    },
    rootRef: Ge
  } = bc(D), nt = x.useRef(se);
  Bt(() => {
    if (se && X !== null) {
      var L;
      const Y = (L = N(X)) == null ? void 0 : L.ref;
      if (!I.current || !(Y != null && Y.current))
        return;
      nt.current || Y.current.focus({
        preventScroll: !0
      });
      const ne = I.current.getBoundingClientRect(), Oe = Y.current.getBoundingClientRect();
      Oe.top < ne.top ? I.current.scrollTop -= ne.top - Oe.top : Oe.bottom > ne.bottom && (I.current.scrollTop += Oe.bottom - ne.bottom);
    }
  }, [se, X, N]);
  const Ke = x.useCallback((L) => N(L), [N]), Ae = (L) => (Y) => {
    var ne;
    if (L == null || (ne = L.onClick) == null || ne.call(L, Y), !Y.defaultMuiPrevented) {
      const Oe = {
        type: ao.buttonClick,
        event: Y
      };
      W(Oe);
    }
  }, ct = (L) => (Y) => {
    var ne;
    (ne = L.onKeyDown) == null || ne.call(L, Y), !Y.defaultMuiPrevented && (Y.key === "ArrowDown" || Y.key === "ArrowUp") && (Y.preventDefault(), W({
      type: Se.keyDown,
      key: Y.key,
      event: Y
    }));
  }, ot = (L = {}) => ({
    onClick: Ae(L),
    onKeyDown: ct(L)
  }), kt = (L = {}) => y({}, L, ot(L), {
    role: "combobox",
    "aria-expanded": se,
    "aria-controls": w
  }), Kt = (L = {}) => {
    const Y = ze(L), ne = kr(kt, M);
    return y({}, L, ne(Y));
  }, De = (L) => (Y) => {
    var ne, Oe;
    (ne = L.onBlur) == null || ne.call(L, Y), !Y.defaultMuiPrevented && ((Oe = I.current) != null && Oe.contains(Y.relatedTarget) || Y.relatedTarget === k.current) && (Y.defaultMuiPrevented = !0);
  }, bt = (L = {}) => ({
    onBlur: De(L)
  }), xt = (L = {}) => {
    const Y = ze(L), ne = kr(bt, Q);
    return y({
      id: w,
      role: "listbox",
      "aria-multiselectable": l ? "true" : void 0
    }, L, ne(Y));
  };
  x.useDebugValue({
    selectedOptions: de,
    highlightedOption: X,
    open: se
  });
  const Rt = x.useMemo(() => y({}, $, R), [$, R]);
  let Ze;
  e.multiple ? Ze = de : Ze = de.length > 0 ? de[0] : null;
  let We;
  if (l)
    We = Ze.map((L) => Ke(L)).filter((L) => L !== void 0);
  else {
    var Ie;
    We = (Ie = Ke(Ze)) != null ? Ie : null;
  }
  const Me = (L) => (Y) => {
    var ne;
    if (L == null || (ne = L.onChange) == null || ne.call(L, Y), Y.defaultMuiPrevented)
      return;
    const Oe = B.get(Y.target.value);
    Y.target.value === "" ? W({
      type: Se.clearSelection
    }) : Oe !== void 0 && W({
      type: ao.browserAutoFill,
      item: Oe.value,
      event: Y
    });
  };
  return {
    buttonActive: j,
    buttonFocusVisible: T,
    buttonRef: O,
    contextValue: Rt,
    disabled: a,
    dispatch: W,
    getButtonProps: Kt,
    getHiddenInputProps: (L = {}) => {
      const Y = ze(L);
      return y({
        name: d,
        tabIndex: -1,
        "aria-hidden": !0,
        required: u ? !0 : void 0,
        value: b(We),
        style: Df
      }, L, {
        onChange: Me(Y)
      });
    },
    getListboxProps: xt,
    getOptionMetadata: Ke,
    listboxRef: Ge,
    open: se,
    options: F,
    value: Ze,
    highlightedOption: X
  };
}
function d0(e) {
  const {
    value: t,
    children: r
  } = e, {
    dispatch: n,
    getItemIndex: o,
    getItemState: a,
    registerItem: i,
    totalSubitemCount: s
  } = t, l = x.useMemo(() => ({
    dispatch: n,
    getItemState: a,
    getItemIndex: o
  }), [n, o, a]), d = x.useMemo(() => ({
    getItemIndex: o,
    registerItem: i,
    totalSubitemCount: s
  }), [i, o, s]);
  return /* @__PURE__ */ c.jsx(Ho.Provider, {
    value: d,
    children: /* @__PURE__ */ c.jsx(wn.Provider, {
      value: l,
      children: r
    })
  });
}
function u0(e = {}) {
  const {
    autoHideDuration: t = null,
    disableWindowBlurListener: r = !1,
    onClose: n,
    open: o,
    resumeHideDuration: a
  } = e, i = Tf();
  x.useEffect(() => {
    if (!o)
      return;
    function b(C) {
      C.defaultPrevented || (C.key === "Escape" || C.key === "Esc") && (n == null || n(C, "escapeKeyDown"));
    }
    return document.addEventListener("keydown", b), () => {
      document.removeEventListener("keydown", b);
    };
  }, [o, n]);
  const s = Sr((b, C) => {
    n == null || n(b, C);
  }), l = Sr((b) => {
    !n || b == null || i.start(b, () => {
      s(null, "timeout");
    });
  });
  x.useEffect(() => (o && l(t), i.clear), [o, t, l, i]);
  const d = (b) => {
    n == null || n(b, "clickaway");
  }, u = i.clear, p = x.useCallback(() => {
    t != null && l(a ?? t * 0.5);
  }, [t, a, l]), f = (b) => (C) => {
    const v = b.onBlur;
    v == null || v(C), p();
  }, g = (b) => (C) => {
    const v = b.onFocus;
    v == null || v(C), u();
  }, h = (b) => (C) => {
    const v = b.onMouseEnter;
    v == null || v(C), u();
  }, m = (b) => (C) => {
    const v = b.onMouseLeave;
    v == null || v(C), p();
  };
  return x.useEffect(() => {
    if (!r && o)
      return window.addEventListener("focus", p), window.addEventListener("blur", u), () => {
        window.removeEventListener("focus", p), window.removeEventListener("blur", u);
      };
  }, [r, o, p, u]), {
    getRootProps: (b = {}) => {
      const C = y({}, ze(e), ze(b));
      return y({
        // ClickAwayListener adds an `onClick` prop which results in the alert not being announced.
        // See https://github.com/mui/material-ui/issues/29080
        role: "presentation"
      }, b, C, {
        onBlur: f(C),
        onFocus: g(C),
        onMouseEnter: h(C),
        onMouseLeave: m(C)
      });
    },
    onClickAway: d
  };
}
function p0(e) {
  const {
    value: t,
    defaultValue: r,
    onChange: n,
    orientation: o = "horizontal",
    direction: a = "ltr",
    selectionFollowsFocus: i = !1
  } = e, [s, l] = oc({
    controlled: t,
    default: r,
    name: "Tabs",
    state: "value"
  }), d = x.useCallback((A, b) => {
    l(b), n == null || n(A, b);
  }, [n, l]), {
    subitems: u,
    contextValue: p
  } = vi(), f = x.useRef(() => {
  }), g = x.useCallback((A) => {
    var b;
    return (b = u.get(A)) == null ? void 0 : b.id;
  }, [u]), h = x.useCallback((A) => f.current(A), []), m = x.useCallback((A) => {
    f.current = A;
  }, []);
  return {
    contextValue: y({
      direction: a,
      getTabId: h,
      getTabPanelId: g,
      onSelected: d,
      orientation: o,
      registerTabIdLookup: m,
      selectionFollowsFocus: i,
      value: s
    }, p)
  };
}
const Vc = /* @__PURE__ */ x.createContext(null);
function Zo() {
  const e = x.useContext(Vc);
  if (e == null)
    throw new Error("No TabsContext provided");
  return e;
}
function f0(e) {
  const {
    value: t,
    children: r
  } = e, {
    direction: n,
    getItemIndex: o,
    onSelected: a,
    orientation: i,
    registerItem: s,
    registerTabIdLookup: l,
    selectionFollowsFocus: d,
    totalSubitemCount: u,
    value: p,
    getTabId: f,
    getTabPanelId: g
  } = t, h = x.useMemo(() => ({
    getItemIndex: o,
    registerItem: s,
    totalSubitemCount: u
  }), [s, o, u]), m = x.useMemo(() => ({
    direction: n,
    getTabId: f,
    getTabPanelId: g,
    onSelected: a,
    orientation: i,
    registerTabIdLookup: l,
    selectionFollowsFocus: d,
    value: p
  }), [n, f, g, a, i, l, d, p]);
  return /* @__PURE__ */ c.jsx(Ho.Provider, {
    value: h,
    children: /* @__PURE__ */ c.jsx(Vc.Provider, {
      value: m,
      children: r
    })
  });
}
function g0(e) {
  return e.size;
}
function h0(e) {
  const {
    value: t,
    id: r,
    rootRef: n
  } = e, o = Zo();
  if (o === null)
    throw new Error("No TabContext provided");
  const {
    value: a,
    getTabId: i
  } = o, s = Wt(r), l = x.useRef(null), d = ke(l, n), u = x.useMemo(() => ({
    id: s,
    ref: l
  }), [s]), {
    id: p
  } = bi(t ?? g0, u), f = p !== a, g = p !== void 0 ? i(p) : void 0;
  return {
    hidden: f,
    getRootProps: (m = {}) => y({
      "aria-labelledby": g ?? void 0,
      hidden: f,
      id: s ?? void 0
    }, m, {
      ref: d
    }),
    rootRef: d
  };
}
const Ec = {
  valueChange: "valueChange"
};
function m0(e, t) {
  if (t.type === Ec.valueChange)
    return y({}, e, {
      highlightedValue: t.value
    });
  const r = mi(e, t), {
    context: {
      selectionFollowsFocus: n
    }
  } = t;
  if (t.type === Se.itemsChange) {
    if (r.selectedValues.length > 0)
      return y({}, r, {
        highlightedValue: r.selectedValues[0]
      });
    qe(null, "reset", t.context);
  }
  return n && r.highlightedValue != null ? y({}, r, {
    selectedValues: [r.highlightedValue]
  }) : r;
}
function v0(e) {
  var t;
  const {
    rootRef: r
  } = e, {
    direction: n = "ltr",
    onSelected: o,
    orientation: a = "horizontal",
    value: i,
    registerTabIdLookup: s,
    selectionFollowsFocus: l
  } = Zo(), {
    subitems: d,
    contextValue: u
  } = vi(), p = x.useCallback((R) => {
    var B;
    return (B = d.get(R)) == null ? void 0 : B.id;
  }, [d]);
  s(p);
  const f = x.useMemo(() => Array.from(d.keys()), [d]), g = x.useCallback((R) => {
    var B, V;
    return R == null ? null : (B = (V = d.get(R)) == null ? void 0 : V.ref.current) != null ? B : null;
  }, [d]), h = n === "rtl";
  let m;
  a === "vertical" ? m = "vertical" : m = h ? "horizontal-rtl" : "horizontal-ltr";
  const A = x.useCallback((R, B) => {
    var V;
    o(R, (V = B[0]) != null ? V : null);
  }, [o]), b = x.useMemo(() => i === void 0 ? {} : i != null ? {
    selectedValues: [i]
  } : {
    selectedValues: []
  }, [i]), C = x.useCallback((R) => {
    var B, V;
    return (B = (V = d.get(R)) == null ? void 0 : V.disabled) != null ? B : !1;
  }, [d]), {
    contextValue: v,
    dispatch: k,
    getRootProps: S,
    state: {
      highlightedValue: I,
      selectedValues: w
    },
    rootRef: P
  } = bc({
    controlledProps: b,
    disabledItemsFocusable: !l,
    focusManagement: "DOM",
    getItemDomElement: g,
    isItemDisabled: C,
    items: f,
    rootRef: r,
    onChange: A,
    orientation: m,
    reducerActionContext: x.useMemo(() => ({
      selectionFollowsFocus: l || !1
    }), [l]),
    selectionMode: "single",
    stateReducer: m0
  });
  x.useEffect(() => {
    i !== void 0 && i != null && k({
      type: Ec.valueChange,
      value: i
    });
  }, [k, i]);
  const E = (R = {}) => y({}, R, S(R), {
    "aria-orientation": a === "vertical" ? "vertical" : void 0,
    role: "tablist"
  });
  return {
    contextValue: x.useMemo(() => y({}, u, v), [u, v]),
    dispatch: k,
    getRootProps: E,
    highlightedValue: I,
    isRtl: h,
    orientation: a,
    rootRef: P,
    selectedValue: (t = w[0]) != null ? t : null
  };
}
function b0(e) {
  const {
    value: t,
    children: r
  } = e, {
    dispatch: n,
    getItemIndex: o,
    getItemState: a,
    registerItem: i,
    totalSubitemCount: s
  } = t, l = x.useMemo(() => ({
    dispatch: n,
    getItemState: a,
    getItemIndex: o
  }), [n, o, a]), d = x.useMemo(() => ({
    getItemIndex: o,
    registerItem: i,
    totalSubitemCount: s
  }), [i, o, s]);
  return /* @__PURE__ */ c.jsx(Ho.Provider, {
    value: d,
    children: /* @__PURE__ */ c.jsx(wn.Provider, {
      value: l,
      children: r
    })
  });
}
function x0(e) {
  return e.size;
}
function y0(e) {
  const {
    value: t,
    rootRef: r,
    disabled: n = !1,
    id: o
  } = e, a = x.useRef(null), i = Wt(o), {
    value: s,
    selectionFollowsFocus: l,
    getTabPanelId: d
  } = Zo(), u = x.useMemo(() => ({
    disabled: n,
    ref: a,
    id: i
  }), [n, a, i]), {
    id: p,
    index: f,
    totalItemCount: g
  } = bi(t ?? x0, u), {
    getRootProps: h,
    highlighted: m,
    selected: A
  } = xc({
    item: p
  }), {
    getRootProps: b,
    rootRef: C,
    active: v,
    focusVisible: k,
    setFocusVisible: S
  } = nr({
    disabled: n,
    focusableWhenDisabled: !l,
    type: "button"
  }), I = ke(a, r, C), w = p !== void 0 ? d(p) : void 0;
  return {
    getRootProps: (E = {}) => {
      const K = ze(E), R = kr(h, b);
      return y({}, E, R(K), {
        role: "tab",
        "aria-controls": w,
        "aria-selected": A,
        id: i,
        ref: I
      });
    },
    active: v,
    focusVisible: k,
    highlighted: m,
    index: f,
    rootRef: I,
    // the `selected` state isn't set on the server (it relies on effects to be calculated),
    // so we fall back to checking the `value` prop with the selectedValue from the TabsContext
    selected: A || p === s,
    setFocusVisible: S,
    totalTabsCount: g
  };
}
const A0 = ["className", "elementType", "ownerState", "externalForwardedProps", "getSlotOwnerState", "internalForwardedProps"], C0 = ["component", "slots", "slotProps"], S0 = ["component"];
function re(e, t) {
  const {
    className: r,
    elementType: n,
    ownerState: o,
    externalForwardedProps: a,
    getSlotOwnerState: i,
    internalForwardedProps: s
  } = t, l = ee(t, A0), {
    component: d,
    slots: u = {
      [e]: void 0
    },
    slotProps: p = {
      [e]: void 0
    }
  } = a, f = ee(a, C0), g = u[e] || n, h = lc(p[e], o), m = sc(y({
    className: r
  }, l, {
    externalForwardedProps: e === "root" ? f : void 0,
    externalSlotProps: h
  })), {
    props: {
      component: A
    },
    internalRef: b
  } = m, C = ee(m.props, S0), v = ke(b, h == null ? void 0 : h.ref, t.ref), k = i ? i(C) : {}, S = y({}, o, k), I = e === "root" ? A || d : A, w = ic(g, y({}, e === "root" && !d && !u[e] && s, e !== "root" && !u[e] && s, C, I && {
    as: I
  }, {
    ref: v
  }), S);
  return Object.keys(k).forEach((P) => {
    delete w[P];
  }), [g, w];
}
const k0 = be("MuiListItem", ["root", "startAction", "endAction", "nested", "nesting", "sticky", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantSoft", "variantOutlined", "variantSolid"]), I0 = /* @__PURE__ */ x.createContext(!1), wi = /* @__PURE__ */ x.createContext(!1), w0 = /* @__PURE__ */ x.createContext(!1), P0 = /* @__PURE__ */ x.createContext(void 0), Kc = {
  "--NestedList-marginRight": "0px",
  "--NestedList-marginLeft": "0px",
  "--NestedListItem-paddingLeft": "var(--ListItem-paddingX)",
  // reset ListItem, ListItemButton negative margin (caused by NestedListItem)
  "--ListItemButton-marginBlock": "0px",
  "--ListItemButton-marginInline": "0px",
  "--ListItem-marginBlock": "0px",
  "--ListItem-marginInline": "0px"
};
function Rc(e) {
  const {
    children: t,
    nested: r,
    row: n = !1,
    wrap: o = !1
  } = e, a = /* @__PURE__ */ c.jsx(wi.Provider, {
    value: n,
    children: /* @__PURE__ */ c.jsx(w0.Provider, {
      value: o,
      children: x.Children.map(t, (i, s) => /* @__PURE__ */ x.isValidElement(i) ? /* @__PURE__ */ x.cloneElement(i, y({}, s === 0 && {
        "data-first-child": ""
      }, s === x.Children.count(t) - 1 && {
        "data-last-child": ""
      })) : i)
    })
  });
  return r === void 0 ? a : /* @__PURE__ */ c.jsx(I0.Provider, {
    value: r,
    children: a
  });
}
const On = ({
  theme: e,
  ownerState: t
}, r) => {
  let n = {};
  function o(a) {
    if (typeof a == "function") {
      const i = a(e);
      o(i);
    } else Array.isArray(a) ? a.forEach((i) => {
      typeof i != "boolean" && o(i);
    }) : typeof a == "object" && (n = y({}, n, a));
  }
  return t.sx && (o(t.sx), r.forEach((a) => {
    const i = n[a];
    if (typeof i == "string" || typeof i == "number")
      if (a === "borderRadius")
        if (typeof i == "number")
          n[a] = `${i}px`;
        else {
          var s;
          n[a] = ((s = e.vars) == null ? void 0 : s.radius[i]) || i;
        }
      else ["p", "padding", "m", "margin"].indexOf(a) !== -1 && typeof i == "number" ? n[a] = e.spacing(i) : n[a] = i;
    else typeof i == "function" ? n[a] = i(e) : n[a] = void 0;
  })), n;
}, Pi = H("ul")(({
  theme: e,
  ownerState: t
}) => {
  var r;
  const {
    p: n,
    padding: o,
    borderRadius: a
  } = On({
    theme: e,
    ownerState: t
  }, ["p", "padding", "borderRadius"]);
  function i(s) {
    return s === "sm" ? {
      "--ListDivider-gap": "0.25rem",
      "--ListItem-minHeight": "2rem",
      "--ListItem-paddingY": "3px",
      "--ListItem-paddingX": t.marker ? "3px" : "0.5rem",
      "--ListItem-gap": "0.5rem",
      "--ListItemDecorator-size": t.orientation === "horizontal" ? "1.5rem" : "2rem",
      "--Icon-fontSize": e.vars.fontSize.lg
    } : s === "md" ? {
      "--ListDivider-gap": "0.375rem",
      "--ListItem-minHeight": "2.25rem",
      "--ListItem-paddingY": "0.25rem",
      "--ListItem-paddingX": t.marker ? "0.25rem" : "0.75rem",
      "--ListItem-gap": "0.625rem",
      "--ListItemDecorator-size": t.orientation === "horizontal" ? "1.75rem" : "2.5rem",
      "--Icon-fontSize": e.vars.fontSize.xl
    } : s === "lg" ? {
      "--ListDivider-gap": "0.5rem",
      "--ListItem-minHeight": "2.75rem",
      "--ListItem-paddingY": "0.375rem",
      "--ListItem-paddingX": t.marker ? "0.5rem" : "1rem",
      "--ListItem-gap": "0.75rem",
      "--ListItemDecorator-size": t.orientation === "horizontal" ? "2.25rem" : "3rem",
      "--Icon-fontSize": e.vars.fontSize.xl2
    } : {};
  }
  return [t.nesting && y({}, i(t.instanceSize), {
    "--ListItem-paddingRight": "var(--ListItem-paddingX)",
    "--ListItem-paddingLeft": "var(--NestedListItem-paddingLeft)",
    // reset ListItem, ListItemButton negative margin (caused by NestedListItem)
    "--ListItemButton-marginBlock": "0px",
    "--ListItemButton-marginInline": "0px",
    "--ListItem-marginBlock": "0px",
    "--ListItem-marginInline": "0px",
    padding: 0
  }, t.marker && {
    paddingInlineStart: "calc(3ch - var(--_List-markerDeduct, 0px))"
    // the width of the marker
  }, {
    marginInlineStart: "var(--NestedList-marginLeft)",
    marginInlineEnd: "var(--NestedList-marginRight)",
    marginBlockStart: "var(--List-gap)",
    marginBlockEnd: "initial"
    // reset user agent stylesheet.
  }), !t.nesting && y({}, i(t.size), {
    "--List-gap": "0px",
    "--List-nestedInsetStart": "0px",
    "--ListItem-paddingLeft": "var(--ListItem-paddingX)",
    "--ListItem-paddingRight": "var(--ListItem-paddingX)"
  }, t.marker && {
    "--_List-markerDeduct": "1ch"
  }, {
    // Automatic radius adjustment kicks in only if '--List-padding' and '--List-radius' are provided.
    "--unstable_List-childRadius": "calc(max(var(--List-radius) - var(--List-padding), min(var(--List-padding) / 2, var(--List-radius) / 2)) - var(--variant-borderWidth, 0px))",
    "--ListItem-radius": "var(--unstable_List-childRadius)",
    // by default, The ListItem & ListItemButton use automatic radius adjustment based on the parent List.
    "--ListItem-startActionTranslateX": "calc(0.5 * var(--ListItem-paddingLeft))",
    "--ListItem-endActionTranslateX": "calc(-0.5 * var(--ListItem-paddingRight))",
    margin: "initial"
  }, e.typography[`body-${t.size}`], t.orientation === "horizontal" ? y({}, t.wrap ? {
    padding: "var(--List-padding)",
    // Fallback is not needed for row-wrap List
    marginInlineStart: "calc(-1 * var(--List-gap))",
    marginBlockStart: "calc(-1 * var(--List-gap))"
  } : {
    paddingInline: "var(--List-padding, var(--ListDivider-gap))",
    paddingBlock: "var(--List-padding)"
  }) : {
    paddingBlock: "var(--List-padding, var(--ListDivider-gap))",
    paddingInline: "var(--List-padding)"
  }, t.marker && {
    paddingInlineStart: "3ch"
    // the width of the marker
  }), y({
    boxSizing: "border-box",
    borderRadius: "var(--List-radius)",
    listStyle: "none",
    display: "flex",
    flexDirection: t.orientation === "horizontal" ? "row" : "column"
  }, t.wrap && {
    flexWrap: "wrap"
  }, t.marker && {
    "--_List-markerDisplay": "list-item",
    "--_List-markerType": t.marker,
    lineHeight: "calc(var(--ListItem-minHeight) - 2 * var(--ListItem-paddingY))"
  }, {
    flexGrow: 1,
    position: "relative"
  }, (r = e.variants[t.variant]) == null ? void 0 : r[t.color], {
    "--unstable_List-borderWidth": "var(--variant-borderWidth, 0px)"
  }, a !== void 0 && {
    "--List-radius": a
  }, n !== void 0 && {
    "--List-padding": n
  }, o !== void 0 && {
    "--List-padding": o
  })];
});
H(Pi, {
  name: "JoyList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({});
const Yn = be("MuiListItemButton", ["root", "horizontal", "vertical", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "focusVisible", "disabled", "selected", "variantPlain", "variantSoft", "variantOutlined", "variantSolid"]), Uc = /* @__PURE__ */ x.createContext("horizontal"), Ti = H("div")(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i, s;
  return y({
    "--Icon-margin": "initial",
    // reset the icon's margin.
    "--Icon-color": t.color !== "neutral" || t.variant === "solid" ? "currentColor" : e.vars.palette.text.icon,
    WebkitTapHighlightColor: "transparent",
    boxSizing: "border-box",
    position: "relative",
    font: "inherit",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "stretch",
    // always stretch itself to fill the parent (List|ListItem)
    gap: "var(--ListItem-gap)"
  }, t.orientation === "vertical" && {
    flexDirection: "column",
    justifyContent: "center"
  }, {
    textAlign: "initial",
    textDecoration: "initial",
    // reset native anchor tag
    backgroundColor: "initial",
    // reset button background
    cursor: "pointer",
    // In some cases, ListItemButton is a child of ListItem so the margin needs to be controlled by the ListItem. The value is negative to account for the ListItem's padding
    marginInline: "var(--ListItemButton-marginInline)",
    marginBlock: "var(--ListItemButton-marginBlock)"
  }, t["data-first-child"] === void 0 && {
    marginInlineStart: t.row ? "var(--List-gap)" : void 0,
    marginBlockStart: t.row ? void 0 : "var(--List-gap)"
  }, {
    // account for the border width, so that all of the ListItemButtons content aligned horizontally
    paddingBlock: "calc(var(--ListItem-paddingY) - var(--variant-borderWidth, 0px))",
    // account for the border width, so that all of the ListItemButtons content aligned vertically
    paddingInlineStart: "calc(var(--ListItem-paddingLeft) + var(--ListItem-startActionWidth, var(--unstable_startActionWidth, 0px)))",
    // --internal variable makes it possible to customize the actionWidth from the top List
    paddingInlineEnd: "calc(var(--ListItem-paddingRight) + var(--ListItem-endActionWidth, var(--unstable_endActionWidth, 0px)))",
    // --internal variable makes it possible to customize the actionWidth from the top List
    minBlockSize: "var(--ListItem-minHeight)",
    border: "1px solid transparent",
    // use `transparent` as a placeholder to prevent the button from jumping when switching to `outlined` variant
    borderRadius: "var(--ListItem-radius)",
    flex: "var(--unstable_ListItem-flex, none)",
    // prevent children from shrinking when the List's height is limited.
    fontSize: "inherit",
    // prevent user agent style when component="button"
    lineHeight: "inherit",
    // prevent user agent style when component="button"
    minInlineSize: 0,
    [e.focus.selector]: y({}, e.focus.default, {
      zIndex: 1
      // to be above of the next element. For example, the first Tab item should be above the second so that the outline is above the second Tab.
    })
  }, (r = e.variants[t.variant]) == null ? void 0 : r[t.color], {
    "&:active": (n = e.variants[`${t.variant}Active`]) == null ? void 0 : n[t.color],
    [`.${k0.root} > &`]: {
      "--unstable_ListItem-flex": "1 0 0%"
      // grow to fill the available space of ListItem
    },
    [`&.${Yn.selected}`]: y({}, (o = e.variants[`${t.variant}Active`]) == null ? void 0 : o[t.color], {
      "--Icon-color": "currentColor"
    }),
    [`&:not(.${Yn.selected}, [aria-selected="true"])`]: {
      "&:hover": (a = e.variants[`${t.variant}Hover`]) == null ? void 0 : a[t.color],
      "&:active": (i = e.variants[`${t.variant}Active`]) == null ? void 0 : i[t.color]
    },
    [`&.${Yn.disabled}`]: y({}, (s = e.variants[`${t.variant}Disabled`]) == null ? void 0 : s[t.color])
  });
});
H(Ti, {
  name: "JoyListItemButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e,
  theme: t
}) => y({}, !e.row && {
  [`&.${Yn.selected}`]: {
    fontWeight: t.vars.fontWeight.md
  }
}));
function T0(e) {
  return ye("MuiSvgIcon", e);
}
be("MuiSvgIcon", ["root", "colorInherit", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "fontSizeInherit", "fontSizeXs", "fontSizeSm", "fontSizeMd", "fontSizeLg", "fontSizeXl", "fontSizeXl2", "fontSizeXl3", "fontSizeXl4", "sizeSm", "sizeMd", "sizeLg"]);
const O0 = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox", "size", "slots", "slotProps"], V0 = (e) => {
  const {
    color: t,
    size: r,
    fontSize: n
  } = e, o = {
    root: ["root", t && t !== "inherit" && `color${z(t)}`, r && `size${z(r)}`, n && `fontSize${z(n)}`]
  };
  return me(o, T0, {});
}, Bs = {
  sm: "xl",
  md: "xl2",
  lg: "xl3"
}, E0 = H("svg", {
  name: "JoySvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  return y({}, t.instanceSize && {
    "--Icon-fontSize": e.vars.fontSize[Bs[t.instanceSize]]
  }, t.instanceFontSize && t.instanceFontSize !== "inherit" && {
    "--Icon-fontSize": e.vars.fontSize[t.instanceFontSize]
  }, {
    userSelect: "none",
    margin: "var(--Icon-margin)",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    fontSize: `var(--Icon-fontSize, ${e.vars.fontSize[Bs[t.size]] || "unset"})`
  }, t.fontSize && t.fontSize !== "inherit" && {
    fontSize: `var(--Icon-fontSize, ${e.fontSize[t.fontSize]})`
  }, !t.htmlColor && y({
    color: `var(--Icon-color, ${e.vars.palette.text.icon})`
  }, t.color === "inherit" && {
    color: "inherit"
  }, t.color !== "inherit" && e.vars.palette[t.color] && {
    color: `rgba(${(r = e.vars.palette[t.color]) == null ? void 0 : r.mainChannel} / 1)`
  }));
}), Ds = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoySvgIcon"
  }), {
    children: o,
    className: a,
    color: i,
    component: s = "svg",
    fontSize: l,
    htmlColor: d,
    inheritViewBox: u = !1,
    titleAccess: p,
    viewBox: f = "0 0 24 24",
    size: g = "md",
    slots: h = {},
    slotProps: m = {}
  } = n, A = ee(n, O0), b = /* @__PURE__ */ x.isValidElement(o) && o.type === "svg", C = y({}, n, {
    color: i,
    component: s,
    size: g,
    instanceSize: t.size,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: f,
    hasSvgAsChild: b
  }), v = V0(C), k = y({}, A, {
    component: s,
    slots: h,
    slotProps: m
  }), [S, I] = re("root", {
    ref: r,
    className: Qe(v.root, a),
    elementType: E0,
    externalForwardedProps: k,
    ownerState: C,
    additionalProps: y({
      color: d,
      focusable: !1
    }, p && {
      role: "img"
    }, !p && {
      "aria-hidden": !0
    }, !u && {
      viewBox: f
    }, b && o.props)
  });
  return /* @__PURE__ */ c.jsxs(S, y({}, I, {
    children: [b ? o.props.children : o, p ? /* @__PURE__ */ c.jsx("title", {
      children: p
    }) : null]
  }));
});
function Oi(e, t) {
  function r(n, o) {
    return /* @__PURE__ */ c.jsx(Ds, y({
      "data-testid": `${t}Icon`,
      ref: o
    }, n, {
      children: e
    }));
  }
  return r.muiName = Ds.muiName, /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(r));
}
const Vi = (e) => (t) => `--${e ? `${e}-` : ""}${t.replace(/^--/, "")}`, pn = "data-skip-inverted-colors", jc = `& :not([${pn}], [${pn}] *)`, Bc = (e) => {
  var t, r, n, o, a, i, s, l, d, u, p, f, g, h, m, A, b, C, v, k, S, I;
  const w = Vi(e.cssVarPrefix);
  return {
    "--variant-plainColor": "var(--variant-plainColor) !important",
    "--variant-plainHoverColor": "var(--variant-plainHoverColor) !important",
    "--variant-plainHoverBg": "var(--variant-plainHoverBg) !important",
    "--variant-plainActiveBg": "var(--variant-plainActiveBg) !important",
    "--variant-plainDisabledColor": "var(--variant-plainDisabledColor) !important",
    "--variant-outlinedColor": "var(--variant-outlinedColor) !important",
    "--variant-outlinedBorder": "var(--variant-outlinedBorder) !important",
    "--variant-outlinedHoverColor": "var(--variant-outlinedHoverColor) !important",
    "--variant-outlinedHoverBorder": "var(--variant-outlinedHoverBorder) !important",
    "--variant-outlinedHoverBg": "var(--variant-outlinedHoverBg) !important",
    "--variant-outlinedActiveBg": "var(--variant-outlinedActiveBg) !important",
    "--variant-outlinedDisabledColor": "var(--variant-outlinedDisabledColor) !important",
    "--variant-outlinedDisabledBorder": "var(--variant-outlinedDisabledBorder) !important",
    "--variant-softColor": "var(--variant-softColor) !important",
    "--variant-softHoverColor": "var(--variant-softHoverColor) !important",
    "--variant-softBg": "var(--variant-softBg) !important",
    "--variant-softHoverBg": "var(--variant-softHoverBg) !important",
    "--variant-softActiveBg": "var(--variant-softActiveBg) !important",
    "--variant-softActiveColor": "var(--variant-softActiveColor) !important",
    "--variant-softDisabledColor": "var(--variant-softDisabledColor) !important",
    "--variant-softDisabledBg": "var(--variant-softDisabledBg) !important",
    "--variant-solidColor": "var(--variant-solidColor) !important",
    "--variant-solidBg": "var(--variant-solidBg) !important",
    "--variant-solidHoverBg": "var(--variant-solidHoverBg) !important",
    "--variant-solidActiveBg": "var(--variant-solidActiveBg) !important",
    "--variant-solidDisabledColor": "var(--variant-solidDisabledColor) !important",
    "--variant-solidDisabledBg": "var(--variant-solidDisabledBg) !important",
    "--Badge-ringColor": "var(--Badge-ringColor) !important",
    colorScheme: "unset",
    [e.getColorSchemeSelector("light")]: {
      [w("--palette-focusVisible")]: `${(t = e.colorSchemes.light) == null ? void 0 : t.palette.focusVisible} !important`,
      [w("--palette-background-body")]: `${(r = e.colorSchemes.light) == null ? void 0 : r.palette.background.body} !important`,
      [w("--palette-background-surface")]: `${(n = e.colorSchemes.light) == null ? void 0 : n.palette.background.surface} !important`,
      [w("--palette-background-popup")]: `${(o = e.colorSchemes.light) == null ? void 0 : o.palette.background.popup} !important`,
      [w("--palette-background-level1")]: `${(a = e.colorSchemes.light) == null ? void 0 : a.palette.background.level1} !important`,
      [w("--palette-background-level2")]: `${(i = e.colorSchemes.light) == null ? void 0 : i.palette.background.level2} !important`,
      [w("--palette-background-level3")]: `${(s = e.colorSchemes.light) == null ? void 0 : s.palette.background.level3} !important`,
      [w("--palette-text-primary")]: `${(l = e.colorSchemes.light) == null ? void 0 : l.palette.text.primary} !important`,
      [w("--palette-text-secondary")]: `${(d = e.colorSchemes.light) == null ? void 0 : d.palette.text.secondary} !important`,
      [w("--palette-text-tertiary")]: `${(u = e.colorSchemes.light) == null ? void 0 : u.palette.text.tertiary} !important`,
      [w("--palette-divider")]: `${(p = e.colorSchemes.light) == null ? void 0 : p.palette.divider} !important`
    },
    [e.getColorSchemeSelector("dark")]: {
      [w("--palette-focusVisible")]: `${(f = e.colorSchemes.dark) == null ? void 0 : f.palette.focusVisible} !important`,
      [w("--palette-background-body")]: `${(g = e.colorSchemes.dark) == null ? void 0 : g.palette.background.body} !important`,
      [w("--palette-background-surface")]: `${(h = e.colorSchemes.dark) == null ? void 0 : h.palette.background.surface} !important`,
      [w("--palette-background-popup")]: `${(m = e.colorSchemes.dark) == null ? void 0 : m.palette.background.popup} !important`,
      [w("--palette-background-level1")]: `${(A = e.colorSchemes.dark) == null ? void 0 : A.palette.background.level1} !important`,
      [w("--palette-background-level2")]: `${(b = e.colorSchemes.dark) == null ? void 0 : b.palette.background.level2} !important`,
      [w("--palette-background-level3")]: `${(C = e.colorSchemes.dark) == null ? void 0 : C.palette.background.level3} !important`,
      [w("--palette-text-primary")]: `${(v = e.colorSchemes.dark) == null ? void 0 : v.palette.text.primary} !important`,
      [w("--palette-text-secondary")]: `${(k = e.colorSchemes.dark) == null ? void 0 : k.palette.text.secondary} !important`,
      [w("--palette-text-tertiary")]: `${(S = e.colorSchemes.dark) == null ? void 0 : S.palette.text.tertiary} !important`,
      [w("--palette-divider")]: `${(I = e.colorSchemes.dark) == null ? void 0 : I.palette.divider} !important`
    }
  };
};
function K0(e) {
  return e.theme !== void 0;
}
const Dc = (e) => (t) => {
  const r = K0(t) ? t.theme : t, n = pi(r.cssVarPrefix), o = Vi(r.cssVarPrefix), a = (i) => {
    const s = i.split("-");
    return n(i, r.palette[s[1]][s[2]]);
  };
  return {
    [jc]: {
      "--Badge-ringColor": a(`palette-${e}-solidBg`),
      "--Icon-color": "currentColor",
      [`${r.getColorSchemeSelector("light")}, ${r.getColorSchemeSelector("dark")}`]: {
        colorScheme: "dark",
        [o("--palette-focusVisible")]: a(`palette-${e}-200`),
        [o("--palette-background-body")]: "rgba(0 0 0 / 0.1)",
        [o("--palette-background-surface")]: "rgba(0 0 0 / 0.06)",
        [o("--palette-background-popup")]: a(`palette-${e}-700`),
        [o("--palette-background-level1")]: `rgba(${a(`palette-${e}-darkChannel`)} / 0.2)`,
        [o("--palette-background-level2")]: `rgba(${a(`palette-${e}-darkChannel`)} / 0.36)`,
        [o("--palette-background-level3")]: `rgba(${a(`palette-${e}-darkChannel`)} / 0.6)`,
        [o("--palette-text-primary")]: a("palette-common-white"),
        [o("--palette-text-secondary")]: a(`palette-${e}-200`),
        [o("--palette-text-tertiary")]: a(`palette-${e}-300`),
        [o("--palette-text-icon")]: a(`palette-${e}-200`),
        [o("--palette-divider")]: `rgba(${a(`palette-${e}-lightChannel`)} / 0.32)`,
        "--variant-plainColor": a(`palette-${e}-50`),
        "--variant-plainHoverColor": "#fff",
        "--variant-plainHoverBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.12)`,
        "--variant-plainActiveBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.32)`,
        "--variant-plainDisabledColor": `rgba(${a(`palette-${e}-lightChannel`)} / 0.72)`,
        "--variant-outlinedColor": a(`palette-${e}-50`),
        "--variant-outlinedBorder": `rgba(${a(`palette-${e}-lightChannel`)} / 0.5)`,
        "--variant-outlinedHoverColor": "#fff",
        "--variant-outlinedHoverBorder": a(`palette-${e}-300`),
        "--variant-outlinedHoverBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.12)`,
        "--variant-outlinedActiveBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.32)`,
        "--variant-outlinedDisabledColor": `rgba(${a(`palette-${e}-lightChannel`)} / 0.72)`,
        "--variant-outlinedDisabledBorder": "rgba(255 255 255 / 0.2)",
        "--variant-softColor": a("palette-common-white"),
        "--variant-softHoverColor": a("palette-common-white"),
        "--variant-softBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.24)`,
        "--variant-softHoverBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.36)`,
        "--variant-softActiveBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.16)`,
        "--variant-softActiveColor": "#fff",
        "--variant-softDisabledColor": `rgba(${a(`palette-${e}-lightChannel`)} / 0.72)`,
        "--variant-softDisabledBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.1)`,
        "--variant-solidColor": a(`palette-${e}-${e === "neutral" ? "600" : "500"}`),
        "--variant-solidBg": a("palette-common-white"),
        "--variant-solidHoverBg": a("palette-common-white"),
        "--variant-solidActiveBg": a(`palette-${e}-100`),
        "--variant-solidDisabledColor": `rgba(${a(`palette-${e}-lightChannel`)} / 0.72)`,
        "--variant-solidDisabledBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.1)`
      }
    },
    [`&, & [${pn}]`]: Bc(r)
  };
}, Mc = (e) => (t) => {
  const {
    theme: r = t
  } = t, n = pi(r.cssVarPrefix), o = Vi(r.cssVarPrefix), a = (i) => {
    const s = i.split("-");
    return n(i, r.palette[s[1]][s[2]]);
  };
  return {
    [jc]: {
      "--Badge-ringColor": a(`palette-${e}-softBg`),
      "--Icon-color": "currentColor",
      [r.getColorSchemeSelector("dark")]: {
        [o("--palette-focusVisible")]: a(`palette-${e}-300`),
        [o("--palette-background-body")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.1)`,
        [o("--palette-background-surface")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.08)`,
        [o("--palette-background-level1")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.2)`,
        [o("--palette-background-level2")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.4)`,
        [o("--palette-background-level3")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.6)`,
        [o("--palette-text-primary")]: a(`palette-${e}-100`),
        [o("--palette-text-secondary")]: `rgba(${a(`palette-${e}-lightChannel`)} / 0.72)`,
        [o("--palette-text-tertiary")]: `rgba(${a(`palette-${e}-lightChannel`)} / 0.6)`,
        [o("--palette-text-icon")]: `rgba(${a(`palette-${e}-lightChannel`)} / 0.6)`,
        [o("--palette-divider")]: `rgba(${a(`palette-${e}-lightChannel`)} / 0.2)`,
        "--variant-plainColor": `rgba(${a(`palette-${e}-lightChannel`)} / 1)`,
        "--variant-plainHoverColor": a(`palette-${e}-50`),
        "--variant-plainHoverBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.16)`,
        "--variant-plainActiveBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.32)`,
        "--variant-plainDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.72)`,
        "--variant-outlinedColor": `rgba(${a(`palette-${e}-lightChannel`)} / 1)`,
        "--variant-outlinedHoverColor": a(`palette-${e}-50`),
        "--variant-outlinedBg": "initial",
        "--variant-outlinedBorder": `rgba(${a(`palette-${e}-mainChannel`)} / 0.4)`,
        "--variant-outlinedHoverBorder": a(`palette-${e}-600`),
        "--variant-outlinedHoverBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.16)`,
        "--variant-outlinedActiveBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.32)`,
        "--variant-outlinedDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.72)`,
        "--variant-outlinedDisabledBorder": `rgba(${a(`palette-${e}-mainChannel`)} / 0.2)`,
        "--variant-softColor": a(`palette-${e}-200`),
        "--variant-softBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.24)`,
        "--variant-softHoverColor": "#fff",
        "--variant-softHoverBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.32)`,
        "--variant-softActiveBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.48)`,
        "--variant-softDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.72)`,
        "--variant-softDisabledBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.12)`,
        "--variant-solidColor": "#fff",
        "--variant-solidBg": a(`palette-${e}-500`),
        "--variant-solidHoverColor": "#fff",
        "--variant-solidHoverBg": a(`palette-${e}-600`),
        "--variant-solidActiveBg": a(`palette-${e}-600`),
        "--variant-solidDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.72)`,
        "--variant-solidDisabledBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.12)`
      },
      // `light` (default color scheme) should come last in case that `theme.getColorSchemeSelector()` return the same value
      [r.getColorSchemeSelector("light")]: {
        [o("--palette-focusVisible")]: a(`palette-${e}-500`),
        [o("--palette-background-body")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.1)`,
        [o("--palette-background-surface")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.08)`,
        [o("--palette-background-level1")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.2)`,
        [o("--palette-background-level2")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.32)`,
        [o("--palette-background-level3")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.48)`,
        [o("--palette-text-primary")]: a(`palette-${e}-700`),
        [o("--palette-text-secondary")]: `rgba(${a(`palette-${e}-darkChannel`)} / 0.8)`,
        [o("--palette-text-tertiary")]: `rgba(${a(`palette-${e}-darkChannel`)} / 0.68)`,
        [o("--palette-text-icon")]: a(`palette-${e}-500`),
        [o("--palette-divider")]: `rgba(${a(`palette-${e}-mainChannel`)} / 0.32)`,
        "--variant-plainColor": `rgba(${a(`palette-${e}-darkChannel`)} / 0.8)`,
        "--variant-plainHoverColor": `rgba(${a(`palette-${e}-darkChannel`)} / 1)`,
        "--variant-plainHoverBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.12)`,
        "--variant-plainActiveBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.24)`,
        "--variant-plainDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.6)`,
        "--variant-outlinedColor": `rgba(${a(`palette-${e}-mainChannel`)} / 1)`,
        "--variant-outlinedBorder": `rgba(${a(`palette-${e}-mainChannel`)} / 0.4)`,
        "--variant-outlinedHoverColor": a(`palette-${e}-600`),
        "--variant-outlinedHoverBorder": a(`palette-${e}-300`),
        "--variant-outlinedHoverBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.12)`,
        "--variant-outlinedActiveBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.24)`,
        "--variant-outlinedDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.6)`,
        "--variant-outlinedDisabledBorder": `rgba(${a(`palette-${e}-mainChannel`)} / 0.12)`,
        "--variant-softColor": a(`palette-${e}-600`),
        "--variant-softBg": `rgba(${a(`palette-${e}-lightChannel`)} / 0.8)`,
        "--variant-softHoverColor": a(`palette-${e}-700`),
        "--variant-softHoverBg": a(`palette-${e}-200`),
        "--variant-softActiveBg": a(`palette-${e}-300`),
        "--variant-softDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.6)`,
        "--variant-softDisabledBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.08)`,
        "--variant-solidColor": a("palette-common-white"),
        "--variant-solidBg": a(`palette-${e}-${e === "neutral" ? "700" : "500"}`),
        "--variant-solidHoverColor": a("palette-common-white"),
        "--variant-solidHoverBg": a(`palette-${e}-600`),
        "--variant-solidActiveBg": a(`palette-${e}-600`),
        "--variant-solidDisabledColor": `rgba(${a(`palette-${e}-mainChannel`)} / 0.6)`,
        "--variant-solidDisabledBg": `rgba(${a(`palette-${e}-mainChannel`)} / 0.08)`
      }
    },
    [`&, & [${pn}]`]: Bc(r)
  };
}, R0 = Oi(/* @__PURE__ */ c.jsx("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), "Close"), Fc = /* @__PURE__ */ x.createContext(void 0);
function U0(e, t) {
  let r = t, n = e;
  return e === "outlined" && (r = "neutral", n = "plain"), e === "plain" && (r = "neutral"), {
    variant: n,
    color: r
  };
}
function j0(e, t, r = !1) {
  const n = x.useContext(Fc), [o, a] = typeof n == "string" ? n.split(":") : [], i = U0(o || void 0, a || void 0);
  return i.variant = e || i.variant, i.color = t || (r ? a : i.color), i;
}
function B0({
  children: e,
  color: t,
  variant: r
}) {
  return /* @__PURE__ */ c.jsx(Fc.Provider, {
    value: `${r || ""}:${t || ""}`,
    children: e
  });
}
function D0(e) {
  return ye("MuiIconButton", e);
}
be("MuiIconButton", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "focusVisible", "disabled", "sizeSm", "sizeMd", "sizeLg", "loading", "loadingIndicator"]);
const Ei = /* @__PURE__ */ x.createContext({}), qc = /* @__PURE__ */ x.createContext(void 0);
function M0(e) {
  return ye("MuiCircularProgress", e);
}
be("MuiCircularProgress", ["root", "determinate", "svg", "track", "progress", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "sizeSm", "sizeMd", "sizeLg", "variantPlain", "variantOutlined", "variantSoft", "variantSolid"]);
let F0 = (e) => e, Ms;
const q0 = ["color", "backgroundColor"], J0 = ["children", "className", "color", "size", "variant", "thickness", "determinate", "value", "component", "slots", "slotProps"], W0 = Po({
  "0%": {
    // let the progress start at the top of the ring
    transform: "rotate(-90deg)"
  },
  "100%": {
    transform: "rotate(270deg)"
  }
}), L0 = (e) => {
  const {
    determinate: t,
    color: r,
    variant: n,
    size: o
  } = e, a = {
    root: ["root", t && "determinate", r && `color${z(r)}`, n && `variant${z(n)}`, o && `size${z(o)}`],
    svg: ["svg"],
    track: ["track"],
    progress: ["progress"]
  };
  return me(a, M0, {});
};
function ar(e, t) {
  return `var(--CircularProgress-${e}Thickness, var(--CircularProgress-thickness, ${t}))`;
}
const z0 = H("span", {
  name: "JoyCircularProgress",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e,
  theme: t
}) => {
  var r, n, o, a;
  const i = ((r = t.variants[e.variant]) == null ? void 0 : r[e.color]) || {}, {
    color: s,
    backgroundColor: l
  } = i, d = ee(i, q0);
  return y({
    // integration with icon
    "--Icon-fontSize": "calc(0.4 * var(--_root-size))",
    // public variables
    "--CircularProgress-trackColor": l,
    "--CircularProgress-progressColor": s,
    "--CircularProgress-percent": e.value,
    // 0 - 100
    "--CircularProgress-linecap": "round"
  }, e.size === "sm" && {
    "--_root-size": "var(--CircularProgress-size, 24px)",
    // use --_root-size to let other components overrides via --CircularProgress-size
    "--_track-thickness": ar("track", "3px"),
    "--_progress-thickness": ar("progress", "3px")
  }, e.instanceSize === "sm" && {
    "--CircularProgress-size": "24px"
  }, e.size === "md" && {
    "--_track-thickness": ar("track", "6px"),
    "--_progress-thickness": ar("progress", "6px"),
    "--_root-size": "var(--CircularProgress-size, 40px)"
  }, e.instanceSize === "md" && {
    "--CircularProgress-size": "40px"
  }, e.size === "lg" && {
    "--_track-thickness": ar("track", "8px"),
    "--_progress-thickness": ar("progress", "8px"),
    "--_root-size": "var(--CircularProgress-size, 64px)"
  }, e.instanceSize === "lg" && {
    "--CircularProgress-size": "64px"
  }, e.thickness && {
    "--_track-thickness": `${e.thickness}px`,
    "--_progress-thickness": `${e.thickness}px`
  }, {
    // internal variables
    "--_thickness-diff": "calc(var(--_track-thickness) - var(--_progress-thickness))",
    "--_inner-size": "calc(var(--_root-size) - 2 * var(--variant-borderWidth, 0px))",
    "--_outlined-inset": "max(var(--_track-thickness), var(--_progress-thickness))",
    width: "var(--_root-size)",
    height: "var(--_root-size)",
    borderRadius: "var(--_root-size)",
    margin: "var(--CircularProgress-margin)",
    boxSizing: "border-box",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    // prevent from shrinking when CircularProgress is in a flex container.
    position: "relative",
    color: s
  }, e.children && {
    // only add font related properties when there is a child.
    // so that when there is no child, the size can be controlled by the parent font-size e.g. Link
    fontFamily: t.vars.fontFamily.body,
    fontWeight: t.vars.fontWeight.md,
    fontSize: "calc(0.2 * var(--_root-size))"
  }, d, e.variant === "outlined" && {
    "&::before": y({
      content: '""',
      display: "block",
      position: "absolute",
      borderRadius: "inherit",
      top: "var(--_outlined-inset)",
      left: "var(--_outlined-inset)",
      right: "var(--_outlined-inset)",
      bottom: "var(--_outlined-inset)"
    }, d)
  }, e.variant === "soft" && {
    "--CircularProgress-trackColor": t.variants.soft.neutral.backgroundColor,
    "--CircularProgress-progressColor": (n = t.variants.solid) == null ? void 0 : n[e.color].backgroundColor
  }, e.variant === "solid" && {
    "--CircularProgress-trackColor": (o = t.variants.softHover) == null ? void 0 : o[e.color].backgroundColor,
    "--CircularProgress-progressColor": (a = t.variants.solid) == null ? void 0 : a[e.color].backgroundColor
  });
}), N0 = H("svg", {
  name: "JoyCircularProgress",
  slot: "Svg",
  overridesResolver: (e, t) => t.svg
})({
  width: "inherit",
  height: "inherit",
  display: "inherit",
  boxSizing: "inherit",
  position: "absolute",
  top: "calc(-1 * var(--variant-borderWidth, 0px))",
  // centered align
  left: "calc(-1 * var(--variant-borderWidth, 0px))"
  // centered align
}), Q0 = H("circle", {
  name: "JoyCircularProgress",
  slot: "track",
  overridesResolver: (e, t) => t.track
})({
  cx: "50%",
  cy: "50%",
  r: "calc(var(--_inner-size) / 2 - var(--_track-thickness) / 2 + min(0px, var(--_thickness-diff) / 2))",
  fill: "transparent",
  strokeWidth: "var(--_track-thickness)",
  stroke: "var(--CircularProgress-trackColor)"
}), H0 = H("circle", {
  name: "JoyCircularProgress",
  slot: "progress",
  overridesResolver: (e, t) => t.progress
})({
  "--_progress-radius": "calc(var(--_inner-size) / 2 - var(--_progress-thickness) / 2 - max(0px, var(--_thickness-diff) / 2))",
  "--_progress-length": "calc(2 * 3.1415926535 * var(--_progress-radius))",
  // the circumference around the progress
  cx: "50%",
  cy: "50%",
  r: "var(--_progress-radius)",
  fill: "transparent",
  strokeWidth: "var(--_progress-thickness)",
  stroke: "var(--CircularProgress-progressColor)",
  strokeLinecap: "var(--CircularProgress-linecap, round)",
  // can't use CSS variable directly, need to cast type.
  strokeDasharray: "var(--_progress-length)",
  strokeDashoffset: "calc(var(--_progress-length) - var(--CircularProgress-percent) * var(--_progress-length) / 100)",
  transformOrigin: "center",
  transform: "rotate(-90deg)"
  // to initially appear at the top-center of the circle.
}, ({
  ownerState: e
}) => !e.determinate && Ha(Ms || (Ms = F0`
      animation: var(--CircularProgress-circulation, 0.8s linear 0s infinite normal none running)
        ${0};
    `), W0)), Br = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyCircularProgress"
  }), {
    children: o,
    className: a,
    color: i = "primary",
    size: s = "md",
    variant: l = "soft",
    thickness: d,
    determinate: u = !1,
    value: p = u ? 0 : 25,
    // `25` is the 1/4 of the circle.
    component: f,
    slots: g = {},
    slotProps: h = {}
  } = n, m = ee(n, J0), A = y({}, n, {
    color: i,
    size: s,
    variant: l,
    thickness: d,
    value: p,
    determinate: u,
    instanceSize: t.size
  }), b = L0(A), C = y({}, m, {
    component: f,
    slots: g,
    slotProps: h
  }), [v, k] = re("root", {
    ref: r,
    className: Qe(b.root, a),
    elementType: z0,
    externalForwardedProps: C,
    ownerState: A,
    additionalProps: y({
      role: "progressbar",
      style: {
        // Setting this CSS variable via inline-style
        // prevents the generation of new CSS every time
        // `value` prop updates
        "--CircularProgress-percent": p
      }
    }, p && u && {
      "aria-valuenow": Math.round(typeof p == "number" ? p : Number(p || 0))
    })
  }), [S, I] = re("svg", {
    className: b.svg,
    elementType: N0,
    externalForwardedProps: C,
    ownerState: A
  }), [w, P] = re("track", {
    className: b.track,
    elementType: Q0,
    externalForwardedProps: C,
    ownerState: A
  }), [E, K] = re("progress", {
    className: b.progress,
    elementType: H0,
    externalForwardedProps: C,
    ownerState: A
  });
  return /* @__PURE__ */ c.jsxs(v, y({}, k, {
    children: [/* @__PURE__ */ c.jsxs(S, y({}, I, {
      children: [/* @__PURE__ */ c.jsx(w, y({}, P)), /* @__PURE__ */ c.jsx(E, y({}, K))]
    })), o]
  }));
}), G0 = ["children", "action", "component", "color", "disabled", "variant", "loading", "loadingIndicator", "size", "slots", "slotProps"], Z0 = (e) => {
  const {
    color: t,
    disabled: r,
    focusVisible: n,
    focusVisibleClassName: o,
    size: a,
    variant: i,
    loading: s
  } = e, l = {
    root: ["root", r && "disabled", n && "focusVisible", i && `variant${z(i)}`, t && `color${z(t)}`, a && `size${z(a)}`, s && "loading"],
    loadingIndicator: ["loadingIndicator"]
  }, d = me(l, D0, {});
  return n && o && (d.root += ` ${o}`), d;
}, Jc = H("button")(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a;
  return [y({
    "--Icon-margin": "initial",
    // reset the icon's margin.
    "--Icon-color": t.color !== "neutral" || t.variant === "solid" ? "currentColor" : e.vars.palette.text.icon
  }, t.instanceSize && {
    "--IconButton-size": {
      sm: "2rem",
      md: "2.25rem",
      lg: "2.75rem"
    }[t.instanceSize]
  }, t.size === "sm" && {
    "--Icon-fontSize": "calc(var(--IconButton-size, 2rem) / 1.6)",
    // 1.25rem by default
    "--CircularProgress-size": "20px",
    "--CircularProgress-thickness": "2px",
    minWidth: "var(--IconButton-size, 2rem)",
    // use min-width instead of height to make the button resilient to its content
    minHeight: "var(--IconButton-size, 2rem)",
    // use min-height instead of height to make the button resilient to its content
    fontSize: e.vars.fontSize.sm,
    paddingInline: "2px"
    // add a gap, in case the content is long, for example multiple icons
  }, t.size === "md" && {
    "--Icon-fontSize": "calc(var(--IconButton-size, 2.25rem) / 1.5)",
    // 1.5rem by default
    "--CircularProgress-size": "20px",
    "--CircularProgress-thickness": "2px",
    minWidth: "var(--IconButton-size, 2.25rem)",
    minHeight: "var(--IconButton-size, 2.25rem)",
    fontSize: e.vars.fontSize.md,
    paddingInline: "0.25rem"
  }, t.size === "lg" && {
    "--Icon-fontSize": "calc(var(--IconButton-size, 2.75rem) / 1.571)",
    // 1.75rem by default
    "--CircularProgress-size": "28px",
    "--CircularProgress-thickness": "4px",
    minWidth: "var(--IconButton-size, 2.75rem)",
    minHeight: "var(--IconButton-size, 2.75rem)",
    fontSize: e.vars.fontSize.lg,
    paddingInline: "0.375rem"
  }, {
    WebkitTapHighlightColor: "transparent",
    paddingBlock: 0,
    fontFamily: e.vars.fontFamily.body,
    fontWeight: e.vars.fontWeight.md,
    margin: "var(--IconButton-margin)",
    // to be controlled by other components, for example Input
    borderRadius: `var(--IconButton-radius, ${e.vars.radius.sm})`,
    // to be controlled by other components, for example Input
    border: "none",
    boxSizing: "border-box",
    backgroundColor: "transparent",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    [e.focus.selector]: y({
      "--Icon-color": "currentColor"
    }, e.focus.default)
  }), y({}, (r = e.variants[t.variant]) == null ? void 0 : r[t.color], {
    "&:hover": {
      "@media (hover: hover)": y({
        "--Icon-color": "currentColor"
      }, (n = e.variants[`${t.variant}Hover`]) == null ? void 0 : n[t.color])
    },
    '&:active, &[aria-pressed="true"]': y({
      "--Icon-color": "currentColor"
    }, (o = e.variants[`${t.variant}Active`]) == null ? void 0 : o[t.color]),
    "&:disabled": (a = e.variants[`${t.variant}Disabled`]) == null ? void 0 : a[t.color]
  })];
}), Y0 = H(Jc, {
  name: "JoyIconButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), X0 = H("span", {
  name: "JoyIconButton",
  slot: "LoadingIndicator",
  overridesResolver: (e, t) => t.loadingIndicator
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n;
  return y({
    display: "inherit",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    color: (r = e.variants[t.variant]) == null || (r = r[t.color]) == null ? void 0 : r.color
  }, t.disabled && {
    color: (n = e.variants[`${t.variant}Disabled`]) == null || (n = n[t.color]) == null ? void 0 : n.color
  });
}), $0 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n;
  const o = xe({
    props: t,
    name: "JoyIconButton"
  }), {
    children: a,
    action: i,
    component: s = "button",
    color: l = "neutral",
    disabled: d,
    variant: u = "plain",
    loading: p = !1,
    loadingIndicator: f,
    size: g = "md",
    slots: h = {},
    slotProps: m = {}
  } = o, A = ee(o, G0), b = x.useContext(Ei), C = x.useContext(qc), v = t.variant || b.variant || u, k = t.size || b.size || g, S = t.color || b.color || l, I = (n = t.loading || t.disabled) != null ? n : b.disabled || p || d, w = x.useRef(null), P = ke(w, r), {
    focusVisible: E,
    setFocusVisible: K,
    getRootProps: R
  } = nr(y({}, o, {
    disabled: I,
    rootRef: P
  })), B = f ?? /* @__PURE__ */ c.jsx(Br, {
    color: S,
    thickness: {
      sm: 2,
      md: 3,
      lg: 4
    }[k] || 3
  });
  x.useImperativeHandle(i, () => ({
    focusVisible: () => {
      var Z;
      K(!0), (Z = w.current) == null || Z.focus();
    }
  }), [K]);
  const V = y({}, o, {
    component: s,
    color: S,
    disabled: I,
    variant: v,
    loading: p,
    size: k,
    focusVisible: E,
    instanceSize: t.size
  }), M = Z0(V), j = (Z) => {
    var ie;
    let le = o.onClick;
    if (typeof m.root == "function" ? le = m.root(V).onClick : m.root && (le = m.root.onClick), (ie = le) == null || ie(Z), C) {
      var ae;
      (ae = C.onClick) == null || ae.call(C, Z, o.value);
    }
  };
  let T = o["aria-pressed"];
  typeof m.root == "function" ? T = m.root(V)["aria-pressed"] : m.root && (T = m.root["aria-pressed"]), C != null && C.value && (Array.isArray(C.value) ? T = C.value.indexOf(o.value) !== -1 : T = C.value === o.value);
  const O = y({}, A, {
    component: s,
    slots: h,
    slotProps: m
  }), [F, N] = re("root", {
    ref: r,
    className: M.root,
    elementType: Y0,
    getSlotProps: R,
    externalForwardedProps: O,
    ownerState: V,
    additionalProps: {
      onClick: j,
      "aria-pressed": T
    }
  }), [te, G] = re("loadingIndicator", {
    className: M.loadingIndicator,
    elementType: X0,
    externalForwardedProps: O,
    ownerState: V
  });
  return /* @__PURE__ */ c.jsx(F, y({}, N, {
    children: p ? /* @__PURE__ */ c.jsx(te, y({}, G, {
      children: B
    })) : a
  }));
});
$0.muiName = "IconButton";
function _0(e) {
  return ye("MuiInput", e);
}
const Wc = be("MuiInput", ["root", "input", "formControl", "focused", "disabled", "error", "adornedStart", "adornedEnd", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "sizeSm", "sizeMd", "sizeLg", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "fullWidth", "startDecorator", "endDecorator"]), Lc = /* @__PURE__ */ x.createContext(void 0), ev = ["aria-describedby", "aria-label", "aria-labelledby", "autoComplete", "autoFocus", "className", "defaultValue", "disabled", "disabledInProp", "error", "id", "name", "onClick", "onChange", "onKeyDown", "onKeyUp", "onFocus", "onBlur", "placeholder", "readOnly", "required", "type", "value"];
function tv(e, t) {
  var r;
  const n = x.useContext(Lc), {
    "aria-describedby": o,
    "aria-label": a,
    "aria-labelledby": i,
    autoComplete: s,
    autoFocus: l,
    className: d,
    defaultValue: u,
    disabled: p,
    disabledInProp: f,
    error: g,
    id: h,
    name: m,
    onClick: A,
    onChange: b,
    onKeyDown: C,
    onKeyUp: v,
    onFocus: k,
    onBlur: S,
    placeholder: I,
    readOnly: w,
    required: P,
    type: E,
    value: K
  } = e, R = ee(e, ev), {
    getRootProps: B,
    getInputProps: V,
    focused: M,
    error: j,
    disabled: T
  } = ph({
    disabled: (r = f ?? (n == null ? void 0 : n.disabled)) != null ? r : p,
    defaultValue: u,
    error: g,
    onBlur: S,
    onClick: A,
    onChange: b,
    onFocus: k,
    required: P ?? (n == null ? void 0 : n.required),
    value: K
  }), O = {
    [t.disabled]: T,
    [t.error]: j,
    [t.focused]: M,
    [t.formControl]: !!n,
    [d]: d
  }, F = {
    [t.disabled]: T
  };
  return y({
    formControl: n,
    propsToForward: {
      "aria-describedby": o,
      "aria-label": a,
      "aria-labelledby": i,
      autoComplete: s,
      autoFocus: l,
      disabled: T,
      id: h,
      onKeyDown: C,
      onKeyUp: v,
      name: m,
      placeholder: I,
      readOnly: w,
      type: E
    },
    rootStateClasses: O,
    inputStateClasses: F,
    getRootProps: B,
    getInputProps: V,
    focused: M,
    error: j,
    disabled: T
  }, R);
}
const rv = ["propsToForward", "rootStateClasses", "inputStateClasses", "getRootProps", "getInputProps", "formControl", "focused", "error", "disabled", "fullWidth", "size", "color", "variant", "startDecorator", "endDecorator", "component", "slots", "slotProps"], nv = (e) => {
  const {
    disabled: t,
    fullWidth: r,
    variant: n,
    color: o,
    size: a
  } = e, i = {
    root: ["root", t && "disabled", r && "fullWidth", n && `variant${z(n)}`, o && `color${z(o)}`, a && `size${z(a)}`],
    input: ["input"],
    startDecorator: ["startDecorator"],
    endDecorator: ["endDecorator"]
  };
  return me(i, _0, {});
}, ov = H("div")(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i, s;
  const l = (r = e.variants[`${t.variant}`]) == null ? void 0 : r[t.color];
  return [y({
    "--Input-radius": e.vars.radius.sm,
    "--Input-gap": "0.5rem",
    "--Input-placeholderColor": "inherit",
    "--Input-placeholderOpacity": 0.64,
    "--Input-decoratorColor": e.vars.palette.text.icon,
    "--Input-focused": "0",
    "--Input-focusedThickness": e.vars.focus.thickness,
    "--Input-focusedHighlight": (n = e.vars.palette[t.color === "neutral" ? "primary" : t.color]) == null ? void 0 : n[500],
    [`&:not([${pn}])`]: y({}, t.instanceColor && {
      "--_Input-focusedHighlight": (o = e.vars.palette[t.instanceColor === "neutral" ? "primary" : t.instanceColor]) == null ? void 0 : o[500]
    }, {
      "--Input-focusedHighlight": `var(--_Input-focusedHighlight, ${e.vars.palette.focusVisible})`
    })
  }, t.size === "sm" && {
    "--Input-minHeight": "2rem",
    "--Input-paddingInline": "0.5rem",
    "--Input-decoratorChildHeight": "min(1.5rem, var(--Input-minHeight))",
    "--Icon-fontSize": e.vars.fontSize.xl
  }, t.size === "md" && {
    "--Input-minHeight": "2.25rem",
    "--Input-paddingInline": "0.75rem",
    "--Input-decoratorChildHeight": "min(1.75rem, var(--Input-minHeight))",
    "--Icon-fontSize": e.vars.fontSize.xl2
  }, t.size === "lg" && {
    "--Input-minHeight": "2.75rem",
    "--Input-paddingInline": "1rem",
    "--Input-gap": "0.75rem",
    "--Input-decoratorChildHeight": "min(2.25rem, var(--Input-minHeight))",
    "--Icon-fontSize": e.vars.fontSize.xl2
  }, {
    // variables for controlling child components
    "--Input-decoratorChildOffset": "min(calc(var(--Input-paddingInline) - (var(--Input-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Input-decoratorChildHeight)) / 2), var(--Input-paddingInline))",
    "--_Input-paddingBlock": "max((var(--Input-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Input-decoratorChildHeight)) / 2, 0px)",
    "--Input-decoratorChildRadius": "max(var(--Input-radius) - var(--variant-borderWidth, 0px) - var(--_Input-paddingBlock), min(var(--_Input-paddingBlock) + var(--variant-borderWidth, 0px), var(--Input-radius) / 2))",
    "--Button-minHeight": "var(--Input-decoratorChildHeight)",
    "--Button-paddingBlock": "0px",
    // to ensure that the height of the button is equal to --Button-minHeight
    "--IconButton-size": "var(--Input-decoratorChildHeight)",
    "--Button-radius": "var(--Input-decoratorChildRadius)",
    "--IconButton-radius": "var(--Input-decoratorChildRadius)",
    boxSizing: "border-box"
  }, t.variant !== "plain" && {
    boxShadow: e.shadow.xs
  }, {
    minWidth: 0,
    minHeight: "var(--Input-minHeight)"
  }, t.fullWidth && {
    width: "100%"
  }, {
    cursor: "text",
    position: "relative",
    display: "flex",
    paddingInline: "var(--Input-paddingInline)",
    borderRadius: "var(--Input-radius)"
  }, e.typography[`body-${t.size}`], l, {
    backgroundColor: (a = l == null ? void 0 : l.backgroundColor) != null ? a : e.vars.palette.background.surface,
    "&::before": {
      boxSizing: "border-box",
      content: '""',
      display: "block",
      position: "absolute",
      pointerEvents: "none",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      borderRadius: "inherit",
      margin: "calc(var(--variant-borderWidth, 0px) * -1)",
      // for outlined variant
      boxShadow: "var(--Input-focusedInset, inset) 0 0 0 calc(var(--Input-focused) * var(--Input-focusedThickness)) var(--Input-focusedHighlight)"
    }
  }), {
    "&:hover": y({}, (i = e.variants[`${t.variant}Hover`]) == null ? void 0 : i[t.color], {
      backgroundColor: null
      // it is not common to change background on hover for Input
    }),
    [`&.${Wc.disabled}`]: (s = e.variants[`${t.variant}Disabled`]) == null ? void 0 : s[t.color],
    "&:focus-within::before": {
      "--Input-focused": "1"
    }
  }];
}), av = H("input")(({
  ownerState: e
}) => ({
  border: "none",
  // remove the native input width
  minWidth: 0,
  // remove the native input width
  outline: 0,
  // remove the native input outline
  padding: 0,
  // remove the native input padding
  flex: 1,
  color: "inherit",
  backgroundColor: "transparent",
  fontFamily: "inherit",
  fontSize: "inherit",
  fontStyle: "inherit",
  fontWeight: "inherit",
  lineHeight: "inherit",
  textOverflow: "ellipsis",
  "&:-webkit-autofill": y({
    paddingInline: "var(--Input-paddingInline)"
  }, !e.startDecorator && {
    marginInlineStart: "calc(-1 * var(--Input-paddingInline))",
    paddingInlineStart: "var(--Input-paddingInline)",
    borderTopLeftRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))",
    borderBottomLeftRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))"
  }, !e.endDecorator && {
    marginInlineEnd: "calc(-1 * var(--Input-paddingInline))",
    paddingInlineEnd: "var(--Input-paddingInline)",
    borderTopRightRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))",
    borderBottomRightRadius: "calc(var(--Input-radius) - var(--variant-borderWidth, 0px))"
  }),
  "&::-webkit-input-placeholder": {
    color: "var(--Input-placeholderColor)",
    opacity: "var(--Input-placeholderOpacity)"
  },
  "&::-moz-placeholder": {
    // Firefox 19+
    color: "var(--Input-placeholderColor)",
    opacity: "var(--Input-placeholderOpacity)"
  },
  "&:-ms-input-placeholder": {
    // IE11
    color: "var(--Input-placeholderColor)",
    opacity: "var(--Input-placeholderOpacity)"
  },
  "&::-ms-input-placeholder": {
    // Edge
    color: "var(--Input-placeholderColor)",
    opacity: "var(--Input-placeholderOpacity)"
  }
})), iv = H("div")({
  "--Button-margin": "0 0 0 calc(var(--Input-decoratorChildOffset) * -1)",
  "--IconButton-margin": "0 0 0 calc(var(--Input-decoratorChildOffset) * -1)",
  "--Icon-margin": "0 0 0 calc(var(--Input-paddingInline) / -4)",
  display: "inherit",
  alignItems: "center",
  paddingBlock: "var(--unstable_InputPaddingBlock)",
  // for wrapping Autocomplete's tags
  flexWrap: "wrap",
  // for wrapping Autocomplete's tags
  marginInlineEnd: "var(--Input-gap)",
  color: "var(--Input-decoratorColor)",
  cursor: "initial"
}), sv = H("div")({
  "--Button-margin": "0 calc(var(--Input-decoratorChildOffset) * -1) 0 0",
  "--IconButton-margin": "0 calc(var(--Input-decoratorChildOffset) * -1) 0 0",
  "--Icon-margin": "0 calc(var(--Input-paddingInline) / -4) 0 0",
  display: "inherit",
  alignItems: "center",
  marginInlineStart: "var(--Input-gap)",
  color: "var(--Input-decoratorColor)",
  cursor: "initial"
}), lv = H(ov, {
  name: "JoyInput",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), cv = H(av, {
  name: "JoyInput",
  slot: "Input",
  overridesResolver: (e, t) => t.input
})({}), dv = H(iv, {
  name: "JoyInput",
  slot: "StartDecorator",
  overridesResolver: (e, t) => t.startDecorator
})({}), uv = H(sv, {
  name: "JoyInput",
  slot: "EndDecorator",
  overridesResolver: (e, t) => t.endDecorator
})({}), pv = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n, o, a, i, s, l;
  const d = xe({
    props: t,
    name: "JoyInput"
  }), u = tv(y({}, d, {
    disabledInProp: t.disabled
  }), Wc), {
    propsToForward: p,
    rootStateClasses: f,
    inputStateClasses: g,
    getRootProps: h,
    getInputProps: m,
    formControl: A,
    focused: b,
    error: C = !1,
    disabled: v,
    fullWidth: k = !1,
    size: S = "md",
    color: I = "neutral",
    variant: w = "outlined",
    startDecorator: P,
    endDecorator: E,
    component: K,
    slots: R = {},
    slotProps: B = {}
  } = u, V = ee(u, rv), M = (n = (o = t.error) != null ? o : A == null ? void 0 : A.error) != null ? n : C, j = (a = (i = t.size) != null ? i : A == null ? void 0 : A.size) != null ? a : S, T = (s = t.color) != null ? s : M ? "danger" : (l = A == null ? void 0 : A.color) != null ? l : I, O = y({
    instanceColor: M ? "danger" : t.color
  }, d, {
    fullWidth: k,
    color: T,
    disabled: v,
    error: M,
    focused: b,
    size: j,
    variant: w
  }), F = nv(O), N = y({}, V, {
    component: K,
    slots: R,
    slotProps: B
  }), [te, G] = re("root", {
    ref: r,
    className: [F.root, f],
    elementType: lv,
    getSlotProps: h,
    externalForwardedProps: N,
    ownerState: O
  }), [Z, ie] = re("input", y({}, A && {
    additionalProps: {
      id: A.htmlFor,
      "aria-describedby": A["aria-describedby"]
    }
  }, {
    className: [F.input, g],
    elementType: cv,
    getSlotProps: m,
    internalForwardedProps: p,
    externalForwardedProps: N,
    ownerState: O
  })), [le, ae] = re("startDecorator", {
    className: F.startDecorator,
    elementType: dv,
    externalForwardedProps: N,
    ownerState: O
  }), [ce, q] = re("endDecorator", {
    className: F.endDecorator,
    elementType: uv,
    externalForwardedProps: N,
    ownerState: O
  });
  return /* @__PURE__ */ c.jsxs(te, y({}, G, {
    children: [P && /* @__PURE__ */ c.jsx(le, y({}, ae, {
      children: P
    })), /* @__PURE__ */ c.jsx(Z, y({}, ie)), E && /* @__PURE__ */ c.jsx(ce, y({}, q, {
      children: E
    }))]
  }));
}), fv = Oi(/* @__PURE__ */ c.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), "Person");
function gv(e) {
  return ye("MuiAvatar", e);
}
be("MuiAvatar", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "fallback", "sizeSm", "sizeMd", "sizeLg", "img", "variantOutlined", "variantSoft", "variantSolid"]);
const hv = /* @__PURE__ */ x.createContext(void 0);
H("div", {
  name: "JoyAvatarGroup",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e,
  theme: t
}) => y({}, e.size === "sm" && {
  "--AvatarGroup-gap": "-0.375rem",
  "--Avatar-ringSize": "2px"
}, e.size === "md" && {
  "--AvatarGroup-gap": "-0.5rem",
  "--Avatar-ringSize": "2px"
}, e.size === "lg" && {
  "--AvatarGroup-gap": "-0.625rem",
  "--Avatar-ringSize": "4px"
}, {
  "--Avatar-ring": `0 0 0 var(--Avatar-ringSize) var(--Avatar-ringColor, ${t.vars.palette.background.surface})`,
  "--Avatar-marginInlineStart": "var(--AvatarGroup-gap)",
  display: "flex",
  marginInlineStart: "calc(-1 * var(--AvatarGroup-gap))"
}));
const mv = ["alt", "color", "size", "variant", "src", "srcSet", "children", "component", "slots", "slotProps"], vv = (e) => {
  const {
    size: t,
    variant: r,
    color: n,
    src: o,
    srcSet: a
  } = e, i = {
    root: ["root", r && `variant${z(r)}`, n && `color${z(n)}`, t && `size${z(t)}`],
    img: [(o || a) && "img"],
    fallback: ["fallback"]
  };
  return me(i, gv, {});
}, bv = H("div", {
  name: "JoyAvatar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  return y({
    "--Icon-color": t.color !== "neutral" || t.variant === "solid" ? "currentColor" : e.vars.palette.text.icon
  }, e.typography[`title-${t.size}`], t.size === "sm" && {
    width: "var(--Avatar-size, 2rem)",
    height: "var(--Avatar-size, 2rem)",
    fontSize: "calc(var(--Avatar-size, 2rem) * 0.4375)"
    // default as 14px
  }, t.size === "md" && {
    width: "var(--Avatar-size, 2.5rem)",
    height: "var(--Avatar-size, 2.5rem)",
    fontSize: "calc(var(--Avatar-size, 2.5rem) * 0.4)"
    // default as 16px
  }, t.size === "lg" && {
    width: "var(--Avatar-size, 3rem)",
    height: "var(--Avatar-size, 3rem)",
    fontSize: "calc(var(--Avatar-size, 3rem) * 0.375)"
    // default as 18px
  }, {
    marginInlineStart: "var(--Avatar-marginInlineStart)",
    boxShadow: "var(--Avatar-ring)",
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    lineHeight: 1,
    overflow: "hidden",
    borderRadius: "var(--Avatar-radius, 50%)",
    userSelect: "none"
  }, (r = e.variants[t.variant]) == null ? void 0 : r[t.color]);
}), xv = H("img", {
  name: "JoyAvatar",
  slot: "Img",
  overridesResolver: (e, t) => t.img
})({
  width: "100%",
  height: "100%",
  textAlign: "center",
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: "cover",
  // Hide alt text.
  color: "transparent",
  // Hide the image broken icon, only works on Chrome.
  textIndent: 1e4
}), yv = H(fv, {
  name: "JoyAvatar",
  slot: "Fallback",
  overridesResolver: (e, t) => t.fallback
})({
  width: "64%",
  height: "64%"
});
function Av({
  crossOrigin: e,
  referrerPolicy: t,
  src: r,
  srcSet: n
}) {
  const [o, a] = x.useState(!1);
  return x.useEffect(() => {
    if (!r && !n)
      return;
    a(!1);
    let i = !0;
    const s = new Image();
    return s.onload = () => {
      i && a("loaded");
    }, s.onerror = () => {
      i && a("error");
    }, s.crossOrigin = e, s.referrerPolicy = t, r && (s.src = r), n && (s.srcset = n), () => {
      i = !1;
    };
  }, [e, t, r, n]), o;
}
const Vn = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyAvatar"
  }), o = x.useContext(hv), {
    alt: a,
    color: i = "neutral",
    size: s = "md",
    variant: l = "soft",
    src: d,
    srcSet: u,
    children: p,
    component: f,
    slots: g = {},
    slotProps: h = {}
  } = n, m = ee(n, mv), A = t.variant || (o == null ? void 0 : o.variant) || l, b = t.color || (o == null ? void 0 : o.color) || i, C = t.size || (o == null ? void 0 : o.size) || s;
  let v = null;
  const k = y({}, n, {
    color: b,
    size: C,
    variant: A,
    grouped: !!o
  }), S = vv(k), I = y({}, m, {
    component: f,
    slots: g,
    slotProps: h
  }), [w, P] = re("root", {
    ref: r,
    className: S.root,
    elementType: bv,
    externalForwardedProps: I,
    ownerState: k
  }), [E, K] = re("img", {
    additionalProps: {
      alt: a,
      src: d,
      srcSet: u
    },
    className: S.img,
    elementType: xv,
    externalForwardedProps: I,
    ownerState: k
  }), [R, B] = re("fallback", {
    className: S.fallback,
    elementType: yv,
    externalForwardedProps: I,
    ownerState: k
  }), V = Av(y({}, K, {
    src: d,
    srcSet: u
  }));
  return (d || u) && V !== "error" ? v = /* @__PURE__ */ c.jsx(E, y({}, K)) : p != null ? v = p : a ? v = a[0] : v = /* @__PURE__ */ c.jsx(R, y({}, B)), /* @__PURE__ */ c.jsx(w, y({}, P, {
    children: v
  }));
}), Cv = oi("MuiBox", ["root"]), U = tf({
  themeId: bn,
  defaultTheme: jr,
  defaultClassName: Cv.root,
  generateClassName: ni.generate
});
function Sv(e) {
  return ye("MuiTypography", e);
}
be("MuiTypography", ["root", "h1", "h2", "h3", "h4", "title-lg", "title-md", "title-sm", "body-lg", "body-md", "body-sm", "body-xs", "noWrap", "gutterBottom", "startDecorator", "endDecorator", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid"]);
const kv = ["color", "textColor"], Iv = ["component", "gutterBottom", "noWrap", "level", "levelMapping", "children", "endDecorator", "startDecorator", "variant", "slots", "slotProps"], Fs = /* @__PURE__ */ x.createContext(!1), zc = /* @__PURE__ */ x.createContext(!1), wv = (e) => {
  const {
    gutterBottom: t,
    noWrap: r,
    level: n,
    color: o,
    variant: a
  } = e, i = {
    root: ["root", n, t && "gutterBottom", r && "noWrap", o && `color${z(o)}`, a && `variant${z(a)}`],
    startDecorator: ["startDecorator"],
    endDecorator: ["endDecorator"]
  };
  return me(i, Sv, {});
}, Pv = H("span", {
  name: "JoyTypography",
  slot: "StartDecorator",
  overridesResolver: (e, t) => t.startDecorator
})({
  display: "inline-flex",
  marginInlineEnd: "clamp(4px, var(--Typography-gap, 0.375em), 0.75rem)"
}), Tv = H("span", {
  name: "JoyTypography",
  slot: "endDecorator",
  overridesResolver: (e, t) => t.endDecorator
})({
  display: "inline-flex",
  marginInlineStart: "clamp(4px, var(--Typography-gap, 0.375em), 0.75rem)"
}), Ov = H("span", {
  name: "JoyTypography",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i;
  const s = t.level !== "inherit" ? (r = e.typography[t.level]) == null ? void 0 : r.lineHeight : "1";
  return y({
    "--Icon-fontSize": `calc(1em * ${s})`
  }, t.color && {
    "--Icon-color": "currentColor"
  }, {
    margin: "var(--Typography-margin, 0px)"
  }, t.nesting ? {
    display: "inline"
    // looks better than `inline-block` when using with `variant` prop.
  } : y({
    display: "block"
  }, t.unstable_hasSkeleton && {
    position: "relative"
  }), (t.startDecorator || t.endDecorator) && y({
    display: "flex",
    alignItems: "center"
  }, t.nesting && y({
    display: "inline-flex"
  }, t.startDecorator && {
    verticalAlign: "bottom"
    // to make the text align with the parent's content
  })), t.level && t.level !== "inherit" && e.typography[t.level], {
    fontSize: `var(--Typography-fontSize, ${t.level && t.level !== "inherit" && (n = (o = e.typography[t.level]) == null ? void 0 : o.fontSize) != null ? n : "inherit"})`
  }, t.noWrap && {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, t.gutterBottom && {
    marginBottom: "0.35em"
  }, t.color && {
    color: `var(--variant-plainColor, rgba(${(a = e.vars.palette[t.color]) == null ? void 0 : a.mainChannel} / 1))`
  }, t.variant && y({
    borderRadius: e.vars.radius.xs,
    paddingBlock: "min(0.1em, 4px)",
    paddingInline: "0.25em"
  }, !t.nesting && {
    marginInline: "-0.25em"
  }, (i = e.variants[t.variant]) == null ? void 0 : i[t.color]));
}), qs = {
  h1: "h1",
  h2: "h2",
  h3: "h3",
  h4: "h4",
  "title-lg": "p",
  "title-md": "p",
  "title-sm": "p",
  "body-lg": "p",
  "body-md": "p",
  "body-sm": "p",
  "body-xs": "span",
  inherit: "p"
}, J = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n;
  const o = xe({
    props: t,
    name: "JoyTypography"
  }), {
    color: a,
    textColor: i
  } = o, s = ee(o, kv), l = x.useContext(Fs), d = x.useContext(zc), u = Cn(y({}, s, {
    color: i
  })), {
    component: p,
    gutterBottom: f = !1,
    noWrap: g = !1,
    level: h = "body-md",
    levelMapping: m = qs,
    children: A,
    endDecorator: b,
    startDecorator: C,
    variant: v,
    slots: k = {},
    slotProps: S = {}
  } = u, I = ee(u, Iv), w = (n = t.color) != null ? n : v ? a ?? "neutral" : a, P = l || d ? t.level || "inherit" : h, E = kn(A, ["Skeleton"]), K = p || (l ? "span" : m[P] || qs[P] || "span"), R = y({}, u, {
    level: P,
    component: K,
    color: w,
    gutterBottom: f,
    noWrap: g,
    nesting: l,
    variant: v,
    unstable_hasSkeleton: E
  }), B = wv(R), V = y({}, I, {
    component: K,
    slots: k,
    slotProps: S
  }), [M, j] = re("root", {
    ref: r,
    className: B.root,
    elementType: Ov,
    externalForwardedProps: V,
    ownerState: R
  }), [T, O] = re("startDecorator", {
    className: B.startDecorator,
    elementType: Pv,
    externalForwardedProps: V,
    ownerState: R
  }), [F, N] = re("endDecorator", {
    className: B.endDecorator,
    elementType: Tv,
    externalForwardedProps: V,
    ownerState: R
  });
  return /* @__PURE__ */ c.jsx(Fs.Provider, {
    value: !0,
    children: /* @__PURE__ */ c.jsxs(M, y({}, j, {
      children: [C && /* @__PURE__ */ c.jsx(T, y({}, O, {
        children: C
      })), E ? /* @__PURE__ */ x.cloneElement(A, {
        variant: A.props.variant || "inline"
      }) : A, b && /* @__PURE__ */ c.jsx(F, y({}, N, {
        children: b
      }))]
    }))
  });
});
J.muiName = "Typography";
function Vv(e) {
  return ye("MuiButton", e);
}
const io = be("MuiButton", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "focusVisible", "disabled", "sizeSm", "sizeMd", "sizeLg", "fullWidth", "startDecorator", "endDecorator", "loading", "loadingIndicatorCenter"]), Ev = ["children", "action", "color", "variant", "size", "fullWidth", "startDecorator", "endDecorator", "loading", "loadingPosition", "loadingIndicator", "disabled", "component", "slots", "slotProps"], Kv = (e) => {
  const {
    color: t,
    disabled: r,
    focusVisible: n,
    focusVisibleClassName: o,
    fullWidth: a,
    size: i,
    variant: s,
    loading: l
  } = e, d = {
    root: ["root", r && "disabled", n && "focusVisible", a && "fullWidth", s && `variant${z(s)}`, t && `color${z(t)}`, i && `size${z(i)}`, l && "loading"],
    startDecorator: ["startDecorator"],
    endDecorator: ["endDecorator"],
    loadingIndicatorCenter: ["loadingIndicatorCenter"]
  }, u = me(d, Vv, {});
  return n && o && (u.root += ` ${o}`), u;
}, Rv = H("span", {
  name: "JoyButton",
  slot: "StartDecorator",
  overridesResolver: (e, t) => t.startDecorator
})({
  "--Icon-margin": "0 0 0 calc(var(--Button-gap) / -2)",
  "--CircularProgress-margin": "0 0 0 calc(var(--Button-gap) / -2)",
  display: "inherit",
  marginRight: "var(--Button-gap)"
}), Uv = H("span", {
  name: "JoyButton",
  slot: "EndDecorator",
  overridesResolver: (e, t) => t.endDecorator
})({
  "--Icon-margin": "0 calc(var(--Button-gap) / -2) 0 0",
  "--CircularProgress-margin": "0 calc(var(--Button-gap) / -2) 0 0",
  display: "inherit",
  marginLeft: "var(--Button-gap)"
}), jv = H("span", {
  name: "JoyButton",
  slot: "LoadingCenter",
  overridesResolver: (e, t) => t.loadingIndicatorCenter
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n;
  return y({
    display: "inherit",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    color: (r = e.variants[t.variant]) == null || (r = r[t.color]) == null ? void 0 : r.color
  }, t.disabled && {
    color: (n = e.variants[`${t.variant}Disabled`]) == null || (n = n[t.color]) == null ? void 0 : n.color
  });
}), Nc = ({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a;
  return [y({
    "--Icon-margin": "initial",
    // reset the icon's margin.
    "--Icon-color": t.color !== "neutral" || t.variant === "solid" ? "currentColor" : e.vars.palette.text.icon
  }, t.size === "sm" && {
    "--Icon-fontSize": e.vars.fontSize.lg,
    "--CircularProgress-size": "20px",
    // must be `px` unit, otherwise the CircularProgress is broken in Safari
    "--CircularProgress-thickness": "2px",
    "--Button-gap": "0.375rem",
    minHeight: "var(--Button-minHeight, 2rem)",
    fontSize: e.vars.fontSize.sm,
    paddingBlock: "var(--Button-paddingBlock, 0.25rem)",
    paddingInline: "0.75rem"
  }, t.size === "md" && {
    "--Icon-fontSize": e.vars.fontSize.xl,
    "--CircularProgress-size": "20px",
    // must be `px` unit, otherwise the CircularProgress is broken in Safari
    "--CircularProgress-thickness": "2px",
    "--Button-gap": "0.5rem",
    minHeight: "var(--Button-minHeight, 2.25rem)",
    // use min-height instead of height to make the button resilient to its content
    fontSize: e.vars.fontSize.sm,
    // internal --Button-paddingBlock is used to control the padding-block of the button from the outside, for example as a decorator of an Input
    paddingBlock: "var(--Button-paddingBlock, 0.375rem)",
    // the padding-block act as a minimum spacing between content and root element
    paddingInline: "1rem"
  }, t.size === "lg" && {
    "--Icon-fontSize": e.vars.fontSize.xl2,
    "--CircularProgress-size": "28px",
    // must be `px` unit, otherwise the CircularProgress is broken in Safari
    "--CircularProgress-thickness": "4px",
    "--Button-gap": "0.75rem",
    minHeight: "var(--Button-minHeight, 2.75rem)",
    fontSize: e.vars.fontSize.md,
    paddingBlock: "var(--Button-paddingBlock, 0.5rem)",
    paddingInline: "1.5rem"
  }, {
    WebkitTapHighlightColor: "transparent",
    boxSizing: "border-box",
    borderRadius: `var(--Button-radius, ${e.vars.radius.sm})`,
    // to be controlled by other components, for example Input
    margin: "var(--Button-margin)",
    // to be controlled by other components, for example Input
    border: "none",
    backgroundColor: "transparent",
    cursor: "pointer",
    userSelect: "none",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    textDecoration: "none",
    // prevent user agent underline when used as anchor
    fontFamily: e.vars.fontFamily.body,
    fontWeight: e.vars.fontWeight.lg,
    lineHeight: e.vars.lineHeight.md
  }, t.fullWidth && {
    width: "100%"
  }, {
    [e.focus.selector]: e.focus.default
  }), y({}, (r = e.variants[t.variant]) == null ? void 0 : r[t.color], {
    "&:hover": {
      "@media (hover: hover)": (n = e.variants[`${t.variant}Hover`]) == null ? void 0 : n[t.color]
    },
    '&:active, &[aria-pressed="true"]': (o = e.variants[`${t.variant}Active`]) == null ? void 0 : o[t.color],
    [`&.${io.disabled}`]: (a = e.variants[`${t.variant}Disabled`]) == null ? void 0 : a[t.color]
  }, t.loadingPosition === "center" && {
    // this has to come after the variant styles to take effect.
    [`&.${io.loading}`]: {
      color: "transparent"
    }
  })];
}, Bv = H("button", {
  name: "JoyButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Nc), ge = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n;
  const o = xe({
    props: t,
    name: "JoyButton"
  }), {
    children: a,
    action: i,
    color: s = "primary",
    variant: l = "solid",
    size: d = "md",
    fullWidth: u = !1,
    startDecorator: p,
    endDecorator: f,
    loading: g = !1,
    loadingPosition: h = "center",
    loadingIndicator: m,
    disabled: A,
    component: b,
    slots: C = {},
    slotProps: v = {}
  } = o, k = ee(o, Ev), S = x.useContext(Ei), I = x.useContext(qc), w = t.variant || S.variant || l, P = t.size || S.size || d, E = t.color || S.color || s, K = (n = t.loading || t.disabled) != null ? n : S.disabled || g || A, R = x.useRef(null), B = ke(R, r), {
    focusVisible: V,
    setFocusVisible: M,
    getRootProps: j
  } = nr(y({}, o, {
    disabled: K,
    rootRef: B
  })), T = m ?? /* @__PURE__ */ c.jsx(Br, {
    color: E,
    thickness: {
      sm: 2,
      md: 3,
      lg: 4
    }[P] || 3
  });
  x.useImperativeHandle(i, () => ({
    focusVisible: () => {
      var Q;
      M(!0), (Q = R.current) == null || Q.focus();
    }
  }), [M]);
  const O = y({}, o, {
    color: E,
    fullWidth: u,
    variant: w,
    size: P,
    focusVisible: V,
    loading: g,
    loadingPosition: h,
    disabled: K
  }), F = Kv(O), N = (Q) => {
    var $;
    let se = o.onClick;
    if (typeof v.root == "function" ? se = v.root(O).onClick : v.root && (se = v.root.onClick), ($ = se) == null || $(Q), I) {
      var X;
      (X = I.onClick) == null || X.call(I, Q, o.value);
    }
  };
  let te = o["aria-pressed"];
  typeof v.root == "function" ? te = v.root(O)["aria-pressed"] : v.root && (te = v.root["aria-pressed"]), I != null && I.value && (Array.isArray(I.value) ? te = I.value.indexOf(o.value) !== -1 : te = I.value === o.value);
  const G = y({}, k, {
    component: b,
    slots: C,
    slotProps: v
  }), [Z, ie] = re("root", {
    ref: r,
    className: F.root,
    elementType: Bv,
    externalForwardedProps: G,
    getSlotProps: j,
    ownerState: O,
    additionalProps: {
      onClick: N,
      "aria-pressed": te
    }
  }), [le, ae] = re("startDecorator", {
    className: F.startDecorator,
    elementType: Rv,
    externalForwardedProps: G,
    ownerState: O
  }), [ce, q] = re("endDecorator", {
    className: F.endDecorator,
    elementType: Uv,
    externalForwardedProps: G,
    ownerState: O
  }), [D, W] = re("loadingIndicatorCenter", {
    className: F.loadingIndicatorCenter,
    elementType: jv,
    externalForwardedProps: G,
    ownerState: O
  });
  return /* @__PURE__ */ c.jsxs(Z, y({}, ie, {
    children: [(p || g && h === "start") && /* @__PURE__ */ c.jsx(le, y({}, ae, {
      children: g && h === "start" ? T : p
    })), a, g && h === "center" && /* @__PURE__ */ c.jsx(D, y({}, W, {
      children: T
    })), (f || g && h === "end") && /* @__PURE__ */ c.jsx(ce, y({}, q, {
      children: g && h === "end" ? T : f
    }))]
  }));
});
ge.muiName = "Button";
function Dv(e) {
  return ye("MuiCard", e);
}
const ir = be("MuiCard", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg", "horizontal", "vertical"]), Mv = ["className", "color", "component", "invertedColors", "size", "variant", "children", "orientation", "slots", "slotProps"], Fv = (e) => {
  const {
    size: t,
    variant: r,
    color: n,
    orientation: o
  } = e, a = {
    root: ["root", o, r && `variant${z(r)}`, n && `color${z(n)}`, t && `size${z(t)}`]
  };
  return me(a, Dv, {});
}, Qc = H("div")(({
  theme: e,
  ownerState: t
}) => {
  var r;
  const {
    p: n,
    padding: o,
    borderRadius: a
  } = On({
    theme: e,
    ownerState: t
  }, ["p", "padding", "borderRadius"]);
  return [y({
    "--Icon-color": t.color !== "neutral" || t.variant === "solid" ? "currentColor" : e.vars.palette.text.icon,
    // a context variable for any child component
    "--Card-childRadius": "max((var(--Card-radius) - var(--variant-borderWidth, 0px)) - var(--Card-padding), min(var(--Card-padding) / 2, (var(--Card-radius) - var(--variant-borderWidth, 0px)) / 2))",
    // AspectRatio integration
    "--AspectRatio-radius": "var(--Card-childRadius)",
    // Link integration
    "--unstable_actionMargin": "calc(-1 * var(--variant-borderWidth, 0px))",
    // Link, Radio, Checkbox integration
    "--unstable_actionRadius": "var(--Card-radius)",
    // CardCover integration
    "--CardCover-radius": "calc(var(--Card-radius) - var(--variant-borderWidth, 0px))",
    // CardOverflow integration
    "--CardOverflow-offset": "calc(-1 * var(--Card-padding))",
    "--CardOverflow-radius": "calc(var(--Card-radius) - var(--variant-borderWidth, 0px))",
    // Divider integration
    "--Divider-inset": "calc(-1 * var(--Card-padding))"
  }, t.size === "sm" && {
    "--Card-radius": e.vars.radius.sm,
    "--Card-padding": "0.625rem",
    gap: "0.5rem"
  }, t.size === "md" && {
    "--Card-radius": e.vars.radius.md,
    "--Card-padding": "1rem",
    gap: "0.75rem 1rem"
  }, t.size === "lg" && {
    "--Card-radius": e.vars.radius.lg,
    "--Card-padding": "1.5rem",
    gap: "1rem 1.5rem"
  }, {
    padding: "var(--Card-padding)",
    borderRadius: "var(--Card-radius)",
    backgroundColor: e.vars.palette.background.surface,
    position: "relative",
    display: "flex",
    flexDirection: t.orientation === "horizontal" ? "row" : "column"
  }, e.typography[`body-${t.size}`], t.variant === "solid" && t.color && t.invertedColors && Dc(t.color)(e), t.variant === "soft" && t.color && t.invertedColors && Mc(t.color)(e), (r = e.variants[t.variant]) == null ? void 0 : r[t.color]), n !== void 0 && {
    "--Card-padding": n
  }, o !== void 0 && {
    "--Card-padding": o
  }, a !== void 0 && {
    "--Card-radius": a
  }];
}), qv = H(Qc, {
  name: "JoyCard",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Ct = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyCard"
  }), {
    className: o,
    color: a = "neutral",
    component: i = "div",
    invertedColors: s = !1,
    size: l = "md",
    variant: d = "outlined",
    children: u,
    orientation: p = "vertical",
    slots: f = {},
    slotProps: g = {}
  } = n, h = ee(n, Mv), m = y({}, n, {
    color: a,
    component: i,
    orientation: p,
    size: l,
    variant: d,
    invertedColors: s
  }), A = Fv(m), b = y({}, h, {
    component: i,
    slots: f,
    slotProps: g
  }), [C, v] = re("root", {
    ref: r,
    className: Qe(A.root, o),
    elementType: qv,
    externalForwardedProps: b,
    ownerState: m
  });
  return /* @__PURE__ */ c.jsx(C, y({}, v, {
    children: x.Children.map(u, (k, S) => {
      if (!/* @__PURE__ */ x.isValidElement(k))
        return k;
      const I = {};
      if (kn(k, ["Divider"])) {
        var w, P;
        const E = k.props;
        I.inset = (w = E == null ? void 0 : E.inset) != null ? w : "context";
        const K = p === "vertical" ? "horizontal" : "vertical";
        I.orientation = (P = E == null ? void 0 : E.orientation) != null ? P : K;
      }
      return S === 0 && (I["data-first-child"] = ""), S === x.Children.count(u) - 1 && (I["data-last-child"] = ""), /* @__PURE__ */ x.cloneElement(k, I);
    })
  }));
});
function Jv(e) {
  return ye("MuiCardOverflow", e);
}
const Wv = be("MuiCardOverflow", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid"]);
function Lv(e) {
  return ye("MuiDivider", e);
}
be("MuiDivider", ["root", "horizontal", "vertical", "insetContext", "insetNone"]);
function zv(e) {
  return ye("MuiCardContent", e);
}
be("MuiCardContent", ["root"]);
const Nv = ["className", "component", "children", "orientation", "slots", "slotProps"], Qv = () => me({
  root: ["root"]
}, zv, {}), Hv = H("div")(({
  ownerState: e
}) => ({
  display: "flex",
  flexDirection: e.orientation === "horizontal" ? "row" : "column",
  flex: 9999,
  // fill the available space in the Card and also shrink if needed
  zIndex: 1,
  columnGap: "var(--Card-padding)",
  rowGap: "max(2px, calc(0.1875 * var(--Card-padding)))",
  padding: "var(--unstable_padding)",
  [`.${Wv.root} > &`]: {
    "--unstable_padding": "calc(var(--Card-padding) * 0.75) 0px"
  }
})), Gv = H(Hv, {
  name: "JoyCardContent",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), Ki = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyCardContent"
  }), {
    className: o,
    component: a = "div",
    children: i,
    orientation: s = "vertical",
    slots: l = {},
    slotProps: d = {}
  } = n, u = ee(n, Nv), p = y({}, u, {
    component: a,
    slots: l,
    slotProps: d
  }), f = y({}, n, {
    component: a,
    orientation: s
  }), g = Qv(), [h, m] = re("root", {
    ref: r,
    className: Qe(g.root, o),
    elementType: Gv,
    externalForwardedProps: p,
    ownerState: f
  });
  return /* @__PURE__ */ c.jsx(h, y({}, m, {
    children: i
  }));
});
function Zv(e) {
  return ye("MuiModalDialog", e);
}
const Pa = be("MuiModalDialog", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg", "layoutCenter", "layoutFullscreen"]), Yv = ["className", "component", "children", "color", "variant", "slots", "slotProps"], Xv = (e) => {
  const {
    variant: t,
    color: r
  } = e, n = {
    root: ["root", t && `variant${z(t)}`, r && `color${z(r)}`]
  };
  return me(n, Jv, {});
}, $v = H("div", {
  name: "JoyCardOverflow",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  const n = "calc(var(--CardOverflow-radius) - var(--variant-borderWidth, 0px))";
  return y({
    alignSelf: "stretch",
    // prevent shrinking if parent's align-items is not initial
    position: "relative",
    display: "flex",
    flexDirection: "var(--_CardOverflow-flexDirection)",
    margin: "var(--_CardOverflow-margin)",
    borderRadius: "var(--_CardOverflow-radius)",
    padding: "var(--_CardOverflow-padding)",
    [`.${ir.vertical} &, .${ir.horizontal} .${ir.vertical} &, .${Pa.root} &`]: {
      "--_CardOverflow-flexDirection": "column",
      // required to make AspectRatio works
      "--AspectRatio-margin": "0 calc(-1 * var(--Card-padding))",
      "--_CardOverflow-margin": "0 var(--CardOverflow-offset)",
      "--_CardOverflow-padding": "0 var(--Card-padding)",
      "&[data-first-child]": {
        "--AspectRatio-radius": `${n} ${n} 0 0`,
        "--_CardOverflow-radius": "var(--CardOverflow-radius) var(--CardOverflow-radius) 0 0",
        "--_CardOverflow-margin": "var(--CardOverflow-offset) var(--CardOverflow-offset) 0"
      },
      "&[data-last-child]": {
        "--AspectRatio-radius": `0 0 ${n} ${n}`,
        "--_CardOverflow-radius": "0 0 var(--CardOverflow-radius) var(--CardOverflow-radius)",
        "--_CardOverflow-margin": "0 var(--CardOverflow-offset) var(--CardOverflow-offset)"
      },
      "&[data-last-child][data-first-child]": {
        "--AspectRatio-radius": n,
        "--_CardOverflow-margin": "var(--CardOverflow-offset)"
      },
      [`& > .${io.root}:only-child`]: {
        zIndex: 1,
        // prevent button from being covered Link overlay. This can be improved in the future with :has() selector
        width: "calc(100% + -2 * var(--CardOverflow-offset))",
        "--Button-margin": "0 var(--CardOverflow-offset)",
        "--Button-radius": "0 0 var(--CardOverflow-radius) var(--CardOverflow-radius)"
      }
    },
    [`.${ir.horizontal} &, .${ir.vertical} .${ir.horizontal} &`]: {
      "--_CardOverflow-flexDirection": "row",
      "--AspectRatio-margin": "calc(-1 * var(--Card-padding)) 0px",
      "--_CardOverflow-margin": "var(--CardOverflow-offset) 0px",
      "--_CardOverflow-padding": "var(--Card-padding) 0px",
      "&[data-first-child]": {
        "--AspectRatio-radius": `${n} 0 0 ${n}`,
        "--_CardOverflow-radius": "var(--CardOverflow-radius) 0 0 var(--CardOverflow-radius)",
        "--_CardOverflow-margin": "var(--CardOverflow-offset) 0px var(--CardOverflow-offset) var(--CardOverflow-offset)"
      },
      "&[data-last-child]": {
        "--AspectRatio-radius": `0 ${n} ${n} 0`,
        "--_CardOverflow-radius": "0 var(--CardOverflow-radius) var(--CardOverflow-radius) 0",
        "--_CardOverflow-margin": "var(--CardOverflow-offset) var(--CardOverflow-offset) var(--CardOverflow-offset) 0px"
      },
      "&[data-last-child][data-first-child]": {
        "--AspectRatio-radius": n,
        "--_CardOverflow-margin": "var(--CardOverflow-offset)"
      },
      [`& > .${io.root}:only-child`]: {
        height: "calc(100% + -2 * var(--CardOverflow-offset))",
        "--Button-margin": "var(--CardOverflow-offset) 0",
        "--Button-radius": "0 var(--CardOverflow-radius) var(--CardOverflow-radius) 0"
      }
    }
  }, (r = e.variants[t.variant]) == null ? void 0 : r[t.color]);
}), Ri = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyCardOverflow"
  }), {
    className: o,
    component: a = "div",
    children: i,
    color: s = "neutral",
    variant: l = "plain",
    slots: d = {},
    slotProps: u = {}
  } = n, p = ee(n, Yv), f = y({}, n, {
    component: a,
    color: s,
    variant: l
  }), g = Xv(f), h = y({}, p, {
    component: a,
    slots: d,
    slotProps: u
  }), [m, A] = re("root", {
    ref: r,
    className: Qe(g.root, o),
    elementType: $v,
    externalForwardedProps: h,
    ownerState: f
  });
  return /* @__PURE__ */ c.jsx(m, y({}, A, {
    children: i
  }));
});
Ri.muiName = "CardOverflow";
function _v(e) {
  const {
    children: t,
    disableColorScheme: r = !1
  } = e;
  return /* @__PURE__ */ c.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ c.jsx(Wg, {
      styles: (n) => {
        var o, a;
        const i = {};
        r || Object.entries(n.colorSchemes).forEach(([l, d]) => {
          var u;
          i[n.getColorSchemeSelector(l).replace(/\s*&/, "")] = {
            colorScheme: (u = d.palette) == null ? void 0 : u.mode
          };
        });
        const s = (o = (a = n.components) == null || (a = a.JoyTypography) == null || (a = a.defaultProps) == null ? void 0 : a.level) != null ? o : "body-md";
        return y({
          html: {
            WebkitFontSmoothing: "antialiased",
            MozOsxFontSmoothing: "grayscale",
            // Change from `box-sizing: content-box` so that `width`
            // is not affected by `padding` or `border`.
            boxSizing: "border-box",
            // Fix font resize problem in iOS
            WebkitTextSizeAdjust: "100%"
          },
          "*, *::before, *::after": {
            boxSizing: "inherit"
          },
          "strong, b": {
            fontWeight: n.vars.fontWeight.lg
          },
          body: y({
            margin: 0,
            // Remove the margin in all browsers.
            color: n.vars.palette.text.primary,
            fontFamily: n.vars.fontFamily.body
          }, n.typography[s], {
            backgroundColor: n.vars.palette.background.body,
            "@media print": {
              // Save printer ink.
              backgroundColor: n.vars.palette.common.white
            },
            // Add support for document.body.requestFullScreen().
            // Other elements, if background transparent, are not supported.
            "&::backdrop": {
              backgroundColor: n.vars.palette.background.backdrop
            }
          })
        }, i);
      },
      defaultTheme: jr
    }), t]
  });
}
const Hc = /* @__PURE__ */ x.createContext(void 0), Gc = /* @__PURE__ */ x.createContext(void 0), e1 = ["className", "children", "component", "inset", "orientation", "role", "slots", "slotProps"], t1 = (e) => {
  const {
    orientation: t,
    inset: r
  } = e, n = {
    root: ["root", t, r && `inset${z(r)}`]
  };
  return me(n, Lv, {});
}, r1 = H("hr", {
  name: "JoyDivider",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => y({
  "--Divider-thickness": "1px",
  "--Divider-lineColor": e.vars.palette.divider
}, t.inset === "none" && {
  "--_Divider-inset": "0px"
}, t.inset === "context" && {
  "--_Divider-inset": "var(--Divider-inset, 0px)"
}, {
  margin: "initial",
  // reset margin for `hr` tag
  marginInline: t.orientation === "vertical" ? "initial" : "var(--_Divider-inset)",
  marginBlock: t.orientation === "vertical" ? "var(--_Divider-inset)" : "initial",
  position: "relative",
  alignSelf: "stretch",
  flexShrink: 0
}, t.children ? y({
  "--Divider-gap": e.spacing(1),
  "--Divider-childPosition": "50%",
  display: "flex",
  flexDirection: t.orientation === "vertical" ? "column" : "row",
  alignItems: "center",
  whiteSpace: "nowrap",
  textAlign: "center",
  border: 0
}, e.typography["body-sm"], {
  "&::before, &::after": {
    position: "relative",
    inlineSize: t.orientation === "vertical" ? "var(--Divider-thickness)" : "initial",
    blockSize: t.orientation === "vertical" ? "initial" : "var(--Divider-thickness)",
    backgroundColor: "var(--Divider-lineColor)",
    // use logical size + background is better than border because they work with gradient.
    content: '""'
  },
  "&::before": {
    marginInlineEnd: t.orientation === "vertical" ? "initial" : "min(var(--Divider-childPosition) * 999, var(--Divider-gap))",
    marginBlockEnd: t.orientation === "vertical" ? "min(var(--Divider-childPosition) * 999, var(--Divider-gap))" : "initial",
    flexBasis: "var(--Divider-childPosition)"
  },
  "&::after": {
    marginInlineStart: t.orientation === "vertical" ? "initial" : "min((100% - var(--Divider-childPosition)) * 999, var(--Divider-gap))",
    marginBlockStart: t.orientation === "vertical" ? "min((100% - var(--Divider-childPosition)) * 999, var(--Divider-gap))" : "initial",
    flexBasis: "calc(100% - var(--Divider-childPosition))"
  }
}) : {
  border: "none",
  // reset the border for `hr` tag
  listStyle: "none",
  backgroundColor: "var(--Divider-lineColor)",
  // use logical size + background is better than border because they work with gradient.
  inlineSize: t.orientation === "vertical" ? "var(--Divider-thickness)" : "initial",
  blockSize: t.orientation === "vertical" ? "initial" : "var(--Divider-thickness)"
})), Ne = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyDivider"
  }), {
    className: o,
    children: a,
    component: i = a != null ? "div" : "hr",
    inset: s,
    orientation: l = "horizontal",
    role: d = i !== "hr" ? "separator" : void 0,
    slots: u = {},
    slotProps: p = {}
  } = n, f = ee(n, e1), g = y({}, n, {
    inset: s,
    role: d,
    orientation: l,
    component: i
  }), h = t1(g), m = y({}, f, {
    component: i,
    slots: u,
    slotProps: p
  }), [A, b] = re("root", {
    ref: r,
    className: Qe(h.root, o),
    elementType: r1,
    externalForwardedProps: m,
    ownerState: g,
    additionalProps: y({
      as: i,
      role: d
    }, d === "separator" && l === "vertical" && {
      // The implicit aria-orientation of separator is 'horizontal'
      // https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/separator_role
      "aria-orientation": "vertical"
    })
  });
  return /* @__PURE__ */ c.jsx(A, y({}, b, {
    children: a
  }));
});
Ne.muiName = "Divider";
function n1(e) {
  return ye("MuiModal", e);
}
be("MuiModal", ["root", "hidden", "backdrop"]);
const Ui = /* @__PURE__ */ x.createContext(void 0), o1 = ["children", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "onClose", "onKeyDown", "open", "component", "slots", "slotProps"], a1 = (e) => {
  const {
    open: t
  } = e;
  return me({
    root: ["root", !t && "hidden"],
    backdrop: ["backdrop"]
  }, n1, {});
}, i1 = H("div")(({
  ownerState: e,
  theme: t
}) => y({
  "--unstable_popup-zIndex": `calc(${t.vars.zIndex.modal} + 1)`,
  '& ~ [role="listbox"]': {
    // target all the listbox (Autocomplete, Menu, Select, etc.) that uses portal
    "--unstable_popup-zIndex": `calc(${t.vars.zIndex.modal} + 1)`
  },
  position: "fixed",
  zIndex: t.vars.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !e.open && {
  visibility: "hidden"
})), s1 = H(i1, {
  name: "JoyModal",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({}), l1 = H("div")(({
  theme: e
}) => ({
  zIndex: -1,
  position: "fixed",
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: e.vars.palette.background.backdrop,
  WebkitTapHighlightColor: "transparent",
  backdropFilter: "blur(8px)"
})), c1 = H(l1, {
  name: "JoyModal",
  slot: "Backdrop",
  overridesResolver: (e, t) => t.backdrop
})({}), Yo = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyModal"
  }), {
    children: o,
    container: a,
    disableAutoFocus: i = !1,
    disableEnforceFocus: s = !1,
    disableEscapeKeyDown: l = !1,
    disablePortal: d = !1,
    disableRestoreFocus: u = !1,
    disableScrollLock: p = !1,
    hideBackdrop: f = !1,
    keepMounted: g = !1,
    onClose: h,
    open: m,
    component: A,
    slots: b = {},
    slotProps: C = {}
  } = n, v = ee(n, o1), k = y({}, n, {
    disableAutoFocus: i,
    disableEnforceFocus: s,
    disableEscapeKeyDown: l,
    disablePortal: d,
    disableRestoreFocus: u,
    disableScrollLock: p,
    hideBackdrop: f,
    keepMounted: g
  }), {
    getRootProps: S,
    getBackdropProps: I,
    rootRef: w,
    portalRef: P,
    isTopModal: E
  } = Jh(y({}, k, {
    rootRef: r
  })), K = a1(k), R = y({}, v, {
    component: A,
    slots: b,
    slotProps: C
  }), [B, V] = re("root", {
    ref: w,
    className: K.root,
    elementType: s1,
    externalForwardedProps: R,
    getSlotProps: S,
    ownerState: k
  }), [M, j] = re("backdrop", {
    className: K.backdrop,
    elementType: c1,
    externalForwardedProps: R,
    getSlotProps: I,
    ownerState: k
  });
  return !g && !m ? null : /* @__PURE__ */ c.jsx(Ui.Provider, {
    value: h,
    children: /* @__PURE__ */ c.jsx(yc, {
      ref: P,
      container: a,
      disablePortal: d,
      children: /* @__PURE__ */ c.jsxs(B, y({}, V, {
        children: [f ? null : /* @__PURE__ */ c.jsx(M, y({}, j)), /* @__PURE__ */ c.jsx(ch, {
          disableEnforceFocus: s,
          disableAutoFocus: i,
          disableRestoreFocus: u,
          isEnabled: E,
          open: m,
          children: x.Children.only(o) && /* @__PURE__ */ x.cloneElement(o, y({}, o.props.tabIndex === void 0 && {
            tabIndex: -1
          }))
        })]
      }))
    })
  });
}), mr = wg({
  createStyledComponent: H("div", {
    name: "JoyGrid",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => xe({
    props: e,
    name: "JoyGrid"
  })
});
function d1(e) {
  return ye("MuiListItemDecorator", e);
}
be("MuiListItemDecorator", ["root"]);
const u1 = ["component", "className", "children", "slots", "slotProps"], p1 = () => me({
  root: ["root"]
}, d1, {}), f1 = H("span", {
  name: "JoyListItemDecorator",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => y({
  boxSizing: "border-box",
  display: "inline-flex",
  alignItems: `var(--unstable_ListItemDecorator-alignItems, ${e.parentOrientation === "horizontal" ? "center" : "initial"})`
}, e.parentOrientation === "horizontal" ? {
  minInlineSize: "var(--ListItemDecorator-size)",
  marginInlineEnd: "calc(-1 * var(--ListItem-gap))"
} : {
  minBlockSize: "var(--ListItemDecorator-size)",
  justifyContent: "center",
  marginBlockEnd: "calc(-1 * var(--ListItem-gap))"
})), g1 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyListItemDecorator"
  }), {
    component: o,
    className: a,
    children: i,
    slots: s = {},
    slotProps: l = {}
  } = n, d = ee(n, u1), u = x.useContext(Uc), p = y({
    parentOrientation: u
  }, n), f = p1(), g = y({}, d, {
    component: o,
    slots: s,
    slotProps: l
  }), [h, m] = re("root", {
    ref: r,
    className: Qe(f.root, a),
    elementType: f1,
    externalForwardedProps: g,
    ownerState: p
  });
  return /* @__PURE__ */ c.jsx(h, y({}, m, {
    children: i
  }));
});
function h1(e) {
  return ye("MuiMenuButton", e);
}
be("MuiMenuButton", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorInfo", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "disabled", "sizeSm", "sizeMd", "sizeLg", "fullWidth", "startDecorator", "endDecorator", "loading", "loadingIndicatorCenter"]);
const m1 = ["children", "color", "component", "disabled", "endDecorator", "loading", "loadingPosition", "loadingIndicator", "size", "slotProps", "slots", "startDecorator", "variant"], v1 = (e) => {
  const {
    color: t,
    disabled: r,
    fullWidth: n,
    size: o,
    variant: a,
    loading: i
  } = e, s = {
    root: ["root", r && "disabled", n && "fullWidth", a && `variant${z(a)}`, t && `color${z(t)}`, o && `size${z(o)}`, i && "loading"],
    startDecorator: ["startDecorator"],
    endDecorator: ["endDecorator"],
    loadingIndicatorCenter: ["loadingIndicatorCenter"]
  };
  return me(s, h1, {});
}, b1 = H("button", {
  name: "JoyMenuButton",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(Nc), x1 = H("span", {
  name: "JoyMenuButton",
  slot: "StartDecorator",
  overridesResolver: (e, t) => t.startDecorator
})({
  "--Icon-margin": "0 0 0 calc(var(--Button-gap) / -2)",
  "--CircularProgress-margin": "0 0 0 calc(var(--Button-gap) / -2)",
  display: "inherit",
  marginRight: "var(--Button-gap)"
}), y1 = H("span", {
  name: "JoyMenuButton",
  slot: "EndDecorator",
  overridesResolver: (e, t) => t.endDecorator
})({
  "--Icon-margin": "0 calc(var(--Button-gap) / -2) 0 0",
  "--CircularProgress-margin": "0 calc(var(--Button-gap) / -2) 0 0",
  display: "inherit",
  marginLeft: "var(--Button-gap)"
}), A1 = H("span", {
  name: "JoyMenuButton",
  slot: "LoadingCenter",
  overridesResolver: (e, t) => t.loadingIndicatorCenter
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n;
  return y({
    display: "inherit",
    position: "absolute",
    left: "50%",
    transform: "translateX(-50%)",
    color: (r = e.variants[t.variant]) == null || (r = r[t.color]) == null ? void 0 : r.color
  }, t.disabled && {
    color: (n = e.variants[`${t.variant}Disabled`]) == null || (n = n[t.color]) == null ? void 0 : n.color
  });
}), C1 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n;
  const o = xe({
    props: t,
    name: "JoyMenuButton"
  }), {
    children: a,
    color: i = "neutral",
    component: s,
    disabled: l = !1,
    endDecorator: d,
    loading: u = !1,
    loadingPosition: p = "center",
    loadingIndicator: f,
    size: g = "md",
    slotProps: h = {},
    slots: m = {},
    startDecorator: A,
    variant: b = "outlined"
  } = o, C = ee(o, m1), v = x.useContext(Ei), k = t.variant || v.variant || b, S = t.size || v.size || g, I = (n = t.disabled) != null ? n : v.disabled || l || u, {
    getRootProps: w,
    open: P,
    active: E
  } = Kh({
    rootRef: r,
    disabled: I
  }), K = f ?? /* @__PURE__ */ c.jsx(Br, {
    color: i,
    thickness: {
      sm: 2,
      md: 3,
      lg: 4
    }[S] || 3
  }), R = y({}, o, {
    active: E,
    color: i,
    disabled: I,
    open: P,
    size: S,
    variant: k
  }), B = v1(R), V = y({}, C, {
    component: s,
    slots: m,
    slotProps: h
  }), [M, j] = re("root", {
    elementType: b1,
    getSlotProps: w,
    externalForwardedProps: V,
    ref: r,
    ownerState: R,
    className: B.root
  }), [T, O] = re("startDecorator", {
    className: B.startDecorator,
    elementType: x1,
    externalForwardedProps: V,
    ownerState: R
  }), [F, N] = re("endDecorator", {
    className: B.endDecorator,
    elementType: y1,
    externalForwardedProps: V,
    ownerState: R
  }), [te, G] = re("loadingIndicatorCenter", {
    className: B.loadingIndicatorCenter,
    elementType: A1,
    externalForwardedProps: V,
    ownerState: R
  });
  return /* @__PURE__ */ c.jsxs(M, y({}, j, {
    children: [(A || u && p === "start") && /* @__PURE__ */ c.jsx(T, y({}, O, {
      children: u && p === "start" ? K : A
    })), a, u && p === "center" && /* @__PURE__ */ c.jsx(te, y({}, G, {
      children: K
    })), (d || u && p === "end") && /* @__PURE__ */ c.jsx(F, y({}, N, {
      children: u && p === "end" ? K : d
    }))]
  }));
});
function S1(e) {
  return ye("MuiModalClose", e);
}
be("MuiModalClose", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg"]);
var Js;
const k1 = ["component", "color", "variant", "size", "onClick", "slots", "slotProps"], I1 = (e) => {
  const {
    variant: t,
    color: r,
    disabled: n,
    focusVisible: o,
    size: a
  } = e, i = {
    root: ["root", n && "disabled", o && "focusVisible", t && `variant${z(t)}`, r && `color${z(r)}`, a && `size${z(a)}`]
  };
  return me(i, S1, {});
}, w1 = H(Jc, {
  name: "JoyModalClose",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e,
  theme: t
}) => {
  var r;
  return y({}, e.size === "sm" && {
    "--IconButton-size": "1.75rem"
  }, e.size === "md" && {
    "--IconButton-size": "2rem"
  }, e.size === "lg" && {
    "--IconButton-size": "2.25rem"
  }, {
    position: "absolute",
    zIndex: 1,
    // stay on top of the title in case it is positioned relatively
    top: "var(--ModalClose-inset, 0.625rem)",
    right: "var(--ModalClose-inset, 0.625rem)",
    borderRadius: `var(--ModalClose-radius, ${t.vars.radius.sm})`
  }, !((r = t.variants[e.variant]) != null && (r = r[e.color]) != null && r.backgroundColor) && {
    color: t.vars.palette.text.secondary
  });
}), P1 = {
  plain: "plain",
  outlined: "plain",
  soft: "soft",
  solid: "solid"
}, ji = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n, o, a, i, s, l;
  const d = xe({
    props: t,
    name: "JoyModalClose"
  }), {
    component: u = "button",
    color: p = "neutral",
    variant: f = "plain",
    size: g = "md",
    onClick: h,
    slots: m = {},
    slotProps: A = {}
  } = d, b = ee(d, k1), C = x.useContext(Ui), v = x.useContext(Hc), k = (n = (o = t.variant) != null ? o : P1[v == null ? void 0 : v.variant]) != null ? n : f, S = (a = (i = t.color) != null ? i : v == null ? void 0 : v.color) != null ? a : p, I = x.useContext(Gc), w = (s = (l = t.size) != null ? l : I) != null ? s : g, {
    focusVisible: P,
    getRootProps: E
  } = nr(y({}, d, {
    rootRef: r
  })), K = y({}, d, {
    color: S,
    component: u,
    variant: k,
    size: w,
    focusVisible: P
  }), R = I1(K), [B, V] = re("root", {
    ref: r,
    elementType: w1,
    getSlotProps: E,
    externalForwardedProps: y({
      onClick: (M) => {
        C == null || C(M, "closeClick"), h == null || h(M);
      }
    }, b, {
      component: u,
      slots: m,
      slotProps: A
    }),
    className: R.root,
    ownerState: K
  });
  return /* @__PURE__ */ c.jsx(B, y({}, V, {
    children: Js || (Js = /* @__PURE__ */ c.jsx(R0, {}))
  }));
}), T1 = ["className", "children", "invertedColors", "orientation", "color", "component", "variant", "size", "layout", "maxWidth", "minWidth", "slots", "slotProps"], O1 = (e) => {
  const {
    variant: t,
    color: r,
    size: n,
    layout: o
  } = e, a = {
    root: ["root", t && `variant${z(t)}`, r && `color${z(r)}`, n && `size${z(n)}`, o && `layout${z(o)}`]
  };
  return me(a, Zv, {});
};
function Ws(e, t) {
  var r, n;
  return t && (r = e.breakpoints) != null && r.values[t] ? `${(n = e.breakpoints) == null ? void 0 : n.values[t]}px` : t;
}
const V1 = H(Qc, {
  name: "JoyModalDialog",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => y({
  "--ModalDialog-minWidth": typeof t.minWidth == "number" ? `${t.minWidth}px` : Ws(e, t.minWidth),
  "--ModalDialog-maxWidth": typeof t.maxWidth == "number" ? `${t.maxWidth}px` : Ws(e, t.maxWidth),
  "--ModalClose-radius": "max((var(--Card-radius) - var(--variant-borderWidth, 0px)) - var(--ModalClose-inset), min(var(--ModalClose-inset) / 2, (var(--Card-radius) - var(--variant-borderWidth, 0px)) / 2))"
}, t.variant === "solid" && {
  "--DialogContent-color": "currentColor"
}, t.size === "sm" && {
  "--Card-padding": "1rem",
  "--ModalDialog-titleOffset": e.spacing(0.25),
  "--ModalDialog-descriptionOffset": e.spacing(0.25),
  "--ModalClose-inset": "0.375rem"
}, t.size === "md" && {
  "--Card-padding": "1.25rem",
  "--ModalDialog-titleOffset": e.spacing(0.25),
  "--ModalDialog-descriptionOffset": e.spacing(0.75),
  "--ModalClose-inset": "0.5rem"
}, t.size === "lg" && {
  "--Card-padding": "1.5rem",
  "--ModalDialog-titleOffset": e.spacing(0.5),
  "--ModalDialog-descriptionOffset": e.spacing(1),
  "--ModalClose-inset": "0.625rem"
}, {
  boxSizing: "border-box",
  boxShadow: e.shadow.md,
  minWidth: "min(calc(100vw - 2 * var(--Card-padding)), var(--ModalDialog-minWidth, 300px))",
  outline: 0,
  position: "absolute"
}, t.layout === "fullscreen" && {
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  border: 0,
  borderRadius: 0
}, t.layout === "center" && {
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "min(calc(100vw - 2 * var(--Card-padding)), var(--ModalDialog-maxWidth, 100vw))",
  maxHeight: "calc(100% - 2 * var(--Card-padding))"
}, {
  [`& [id="${t["aria-labelledby"]}"]`]: {
    "--Typography-margin": "calc(-1 * var(--ModalDialog-titleOffset)) 0 var(--ModalDialog-gap) 0",
    "--Typography-fontSize": "1.125em",
    [`& + [id="${t["aria-describedby"]}"]`]: {
      "--unstable_ModalDialog-descriptionOffset": "calc(-1 * var(--ModalDialog-descriptionOffset))"
    }
  },
  [`& [id="${t["aria-describedby"]}"]`]: {
    "--Typography-fontSize": "1em",
    "--Typography-margin": "var(--unstable_ModalDialog-descriptionOffset, var(--ModalDialog-gap)) 0 0 0",
    "&:not(:last-child)": {
      // create spacing between description and the next element.
      "--Typography-margin": "var(--unstable_ModalDialog-descriptionOffset, var(--ModalDialog-gap)) 0 var(--ModalDialog-gap) 0"
    }
  }
})), Bi = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyModalDialog"
  }), {
    className: o,
    children: a,
    invertedColors: i = !1,
    orientation: s = "vertical",
    color: l = "neutral",
    component: d = "div",
    variant: u = "outlined",
    size: p = "md",
    layout: f = "center",
    maxWidth: g,
    minWidth: h,
    slots: m = {},
    slotProps: A = {}
  } = n, b = ee(n, T1), C = y({}, n, {
    color: l,
    component: d,
    maxWidth: g,
    minWidth: h,
    layout: f,
    size: p,
    variant: u,
    invertedColors: i
  }), v = O1(C), k = y({}, b, {
    component: d,
    slots: m,
    slotProps: A
  }), S = Wt(), I = Wt(), w = x.useMemo(() => ({
    variant: u,
    color: l,
    labelledBy: S,
    describedBy: I
  }), [l, u, S, I]), [P, E] = re("root", {
    ref: r,
    className: Qe(v.root, o),
    elementType: V1,
    externalForwardedProps: k,
    ownerState: C,
    additionalProps: {
      as: d,
      role: "dialog",
      "aria-modal": "true",
      "aria-labelledby": S,
      "aria-describedby": I
    }
  });
  return /* @__PURE__ */ c.jsx(Gc.Provider, {
    value: p,
    children: /* @__PURE__ */ c.jsx(Hc.Provider, {
      value: w,
      children: /* @__PURE__ */ c.jsx(P, y({}, E, {
        children: x.Children.map(a, (K, R) => {
          if (!/* @__PURE__ */ x.isValidElement(K))
            return K;
          const B = {};
          if (kn(K, ["Divider"])) {
            var V, M;
            const j = K.props;
            B.inset = (V = j == null ? void 0 : j.inset) != null ? V : "context";
            const T = s === "vertical" ? "horizontal" : "vertical";
            B.orientation = (M = j == null ? void 0 : j.orientation) != null ? M : T;
          }
          return R === 0 && (B["data-first-child"] = ""), R === x.Children.count(a) - 1 && (B["data-last-child"] = ""), /* @__PURE__ */ x.cloneElement(K, B);
        })
      }))
    })
  });
});
function E1(e) {
  return ye("MuiModalOverflow", e);
}
be("MuiModalOverflow", ["root"]);
const K1 = ["children", "onClick"], R1 = () => me({
  root: ["root"]
}, E1, {}), U1 = H("div", {
  name: "JoyModalOverflow",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})({
  "--ModalOverflow-paddingY": "1.5rem",
  position: "absolute",
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  height: "100%",
  overflow: "hidden auto",
  outline: "none",
  display: "flex",
  flexDirection: "column",
  // required for fullscreen ModalDialog, using `row` cannot be achieved.
  padding: "var(--ModalOverflow-paddingY) 0",
  // let's not create `size` prop to only control the `padding`.
  [`& .${Pa.layoutCenter}`]: {
    position: "relative",
    margin: "auto",
    // to make the dialog stay at center when content does not overflow the screen.
    height: "max-content",
    // height is based on content, otherwise `margin: auto` will take place.
    maxHeight: "unset",
    transform: "none",
    top: "unset",
    left: "unset"
  },
  [`& .${Pa.layoutFullscreen}`]: {
    position: "relative",
    width: "100%",
    margin: "calc(-1 * var(--ModalOverflow-paddingY)) 0",
    flex: 1
  }
}), j1 = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyModalOverflow"
  }), {
    children: o,
    onClick: a
  } = n, i = ee(n, K1), s = x.useContext(Ui), l = n, d = R1(), [u, p] = re("root", {
    ref: r,
    className: d.root,
    elementType: U1,
    externalForwardedProps: i,
    ownerState: l,
    additionalProps: {
      role: "presentation",
      tabIndex: -1,
      onClick: (f) => {
        f.target === f.currentTarget && (s == null || s(f, "backdropClick")), a == null || a(f);
      }
    }
  });
  return /* @__PURE__ */ c.jsx(u, y({}, p, {
    children: o
  }));
});
function B1(e) {
  return ye("MuiOption", e);
}
const D1 = be("MuiOption", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "focusVisible", "disabled", "selected", "highlighted", "variantPlain", "variantSoft", "variantOutlined", "variantSolid"]), M1 = ["component", "children", "disabled", "value", "label", "variant", "color", "slots", "slotProps"], F1 = (e) => {
  const {
    disabled: t,
    highlighted: r,
    selected: n
  } = e;
  return me({
    root: ["root", t && "disabled", r && "highlighted", n && "selected"]
  }, B1, {});
}, q1 = H(Ti, {
  name: "JoyOption",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  const n = (r = e.variants[`${t.variant}Hover`]) == null ? void 0 : r[t.color];
  return {
    [`&.${D1.highlighted}:not([aria-selected="true"])`]: {
      backgroundColor: n == null ? void 0 : n.backgroundColor
    }
  };
}), J1 = /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(function(t, r) {
  var n;
  const o = xe({
    props: t,
    name: "JoyOption"
  }), {
    component: a = "li",
    children: i,
    disabled: s = !1,
    value: l,
    label: d,
    variant: u = "plain",
    color: p = "neutral",
    slots: f = {},
    slotProps: g = {}
  } = o, h = ee(o, M1), m = x.useContext(wi), {
    variant: A = u,
    color: b = p
  } = j0(t.variant, t.color), C = x.useRef(null), v = ke(C, r), k = d ?? (typeof i == "string" ? i : (n = C.current) == null ? void 0 : n.innerText), {
    getRootProps: S,
    selected: I,
    highlighted: w,
    index: P
  } = Wh({
    disabled: s,
    label: k,
    value: l,
    rootRef: v
  }), E = y({}, o, {
    disabled: s,
    selected: I,
    highlighted: w,
    index: P,
    component: a,
    variant: A,
    color: b,
    row: m
  }), K = F1(E), R = y({}, h, {
    component: a,
    slots: f,
    slotProps: g
  }), [B, V] = re("root", {
    ref: r,
    getSlotProps: S,
    elementType: q1,
    externalForwardedProps: R,
    className: K.root,
    ownerState: E
  });
  return /* @__PURE__ */ c.jsx(B, y({}, V, {
    children: i
  }));
})), sr = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const {
    contextValue: n
  } = Lh(t.value);
  return /* @__PURE__ */ c.jsx(wn.Provider, {
    value: n,
    children: /* @__PURE__ */ c.jsx(J1, y({}, t, {
      ref: r
    }))
  });
}), W1 = Oi(/* @__PURE__ */ c.jsx("path", {
  d: "m12 5.83 2.46 2.46c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L12.7 3.7a.9959.9959 0 0 0-1.41 0L8.12 6.88c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 5.83zm0 12.34-2.46-2.46a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l3.17 3.18c.39.39 1.02.39 1.41 0l3.17-3.17c.39-.39.39-1.02 0-1.41a.9959.9959 0 0 0-1.41 0L12 18.17z"
}), "Unfold");
function L1(e) {
  return ye("MuiSelect", e);
}
const vr = be("MuiSelect", ["root", "button", "indicator", "startDecorator", "endDecorator", "popper", "listbox", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg", "focusVisible", "disabled", "expanded", "multiple"]);
var Ls;
const z1 = ["action", "autoFocus", "children", "defaultValue", "defaultListboxOpen", "disabled", "getSerializedValue", "placeholder", "listboxId", "listboxOpen", "onChange", "onListboxOpenChange", "onClose", "renderValue", "required", "value", "size", "variant", "color", "startDecorator", "endDecorator", "indicator", "aria-describedby", "aria-label", "aria-labelledby", "id", "name", "multiple", "slots", "slotProps"];
function N1(e) {
  var t;
  return Array.isArray(e) ? /* @__PURE__ */ c.jsx(x.Fragment, {
    children: e.map((r) => r.label).join(", ")
  }) : (t = e == null ? void 0 : e.label) != null ? t : "";
}
const Q1 = [{
  name: "offset",
  options: {
    offset: [0, 4]
  }
}, {
  // popper will have the same width as root element when open
  name: "equalWidth",
  enabled: !0,
  phase: "beforeWrite",
  requires: ["computeStyles"],
  fn: ({
    state: e
  }) => {
    e.styles.popper.width = `${e.rects.reference.width}px`;
  }
}], H1 = (e) => {
  const {
    color: t,
    disabled: r,
    focusVisible: n,
    size: o,
    variant: a,
    open: i,
    multiple: s
  } = e, l = {
    root: ["root", r && "disabled", n && "focusVisible", i && "expanded", a && `variant${z(a)}`, t && `color${z(t)}`, o && `size${z(o)}`, s && "multiple"],
    button: ["button"],
    startDecorator: ["startDecorator"],
    endDecorator: ["endDecorator"],
    indicator: ["indicator", i && "expanded"],
    listbox: ["listbox", i && "expanded", r && "disabled"]
  };
  return me(l, L1, {});
}, G1 = H("div", {
  name: "JoySelect",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i;
  const s = (r = e.variants[`${t.variant}`]) == null ? void 0 : r[t.color], {
    borderRadius: l
  } = On({
    theme: e,
    ownerState: t
  }, ["borderRadius"]);
  return [y({
    "--Select-radius": e.vars.radius.sm,
    "--Select-gap": "0.5rem",
    "--Select-placeholderOpacity": 0.64,
    "--Select-decoratorColor": e.vars.palette.text.icon,
    "--Select-focusedThickness": e.vars.focus.thickness,
    "--Select-focusedHighlight": (n = e.vars.palette[t.color === "neutral" ? "primary" : t.color]) == null ? void 0 : n[500],
    '&:not([data-inverted-colors="false"])': y({}, t.instanceColor && {
      "--_Select-focusedHighlight": (o = e.vars.palette[t.instanceColor === "neutral" ? "primary" : t.instanceColor]) == null ? void 0 : o[500]
    }, {
      "--Select-focusedHighlight": e.vars.palette.focusVisible
    }),
    "--Select-indicatorColor": s != null && s.backgroundColor ? s == null ? void 0 : s.color : e.vars.palette.text.tertiary
  }, t.size === "sm" && {
    "--Select-minHeight": "2rem",
    "--Select-paddingInline": "0.5rem",
    "--Select-decoratorChildHeight": "min(1.5rem, var(--Select-minHeight))",
    "--Icon-fontSize": e.vars.fontSize.xl
  }, t.size === "md" && {
    "--Select-minHeight": "2.25rem",
    "--Select-paddingInline": "0.75rem",
    "--Select-decoratorChildHeight": "min(1.75rem, var(--Select-minHeight))",
    "--Icon-fontSize": e.vars.fontSize.xl2
  }, t.size === "lg" && {
    "--Select-minHeight": "2.75rem",
    "--Select-paddingInline": "1rem",
    "--Select-decoratorChildHeight": "min(2.375rem, var(--Select-minHeight))",
    "--Icon-fontSize": e.vars.fontSize.xl2
  }, {
    // variables for controlling child components
    "--Select-decoratorChildOffset": "min(calc(var(--Select-paddingInline) - (var(--Select-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Select-decoratorChildHeight)) / 2), var(--Select-paddingInline))",
    "--_Select-paddingBlock": "max((var(--Select-minHeight) - 2 * var(--variant-borderWidth, 0px) - var(--Select-decoratorChildHeight)) / 2, 0px)",
    "--Select-decoratorChildRadius": "max(var(--Select-radius) - var(--variant-borderWidth, 0px) - var(--_Select-paddingBlock), min(var(--_Select-paddingBlock) + var(--variant-borderWidth, 0px), var(--Select-radius) / 2))",
    "--Button-minHeight": "var(--Select-decoratorChildHeight)",
    "--Button-paddingBlock": "0px",
    // to ensure that the height of the button is equal to --Button-minHeight
    "--IconButton-size": "var(--Select-decoratorChildHeight)",
    "--Button-radius": "var(--Select-decoratorChildRadius)",
    "--IconButton-radius": "var(--Select-decoratorChildRadius)",
    boxSizing: "border-box"
  }, t.variant !== "plain" && {
    boxShadow: e.shadow.xs
  }, {
    minWidth: 0,
    minHeight: "var(--Select-minHeight)",
    position: "relative",
    display: "flex",
    alignItems: "center",
    borderRadius: "var(--Select-radius)",
    cursor: "pointer"
  }, !(s != null && s.backgroundColor) && {
    backgroundColor: e.vars.palette.background.surface
  }, t.size && {
    paddingBlock: {
      sm: 2,
      md: 3,
      lg: 4
    }[t.size]
    // the padding-block act as a minimum spacing between content and root element
  }, {
    paddingInline: "var(--Select-paddingInline)"
  }, e.typography[`body-${t.size}`], s, {
    "&::before": {
      boxSizing: "border-box",
      content: '""',
      display: "block",
      position: "absolute",
      pointerEvents: "none",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 1,
      borderRadius: "inherit",
      margin: "calc(var(--variant-borderWidth, 0px) * -1)"
      // for outlined variant
    },
    [`&.${vr.focusVisible}`]: {
      "--Select-indicatorColor": s == null ? void 0 : s.color,
      "&::before": {
        boxShadow: "inset 0 0 0 var(--Select-focusedThickness) var(--Select-focusedHighlight)"
      }
    },
    [`&.${vr.disabled}`]: {
      "--Select-indicatorColor": "inherit"
    }
  }), {
    "&:hover": (a = e.variants[`${t.variant}Hover`]) == null ? void 0 : a[t.color],
    [`&.${vr.disabled}`]: (i = e.variants[`${t.variant}Disabled`]) == null ? void 0 : i[t.color]
  }, l !== void 0 && {
    "--Select-radius": l
  }];
}), Z1 = H("button", {
  name: "JoySelect",
  slot: "Button",
  overridesResolver: (e, t) => t.button
})(({
  ownerState: e
}) => y({
  // reset user-agent button style
  border: 0,
  outline: 0,
  background: "none",
  padding: 0,
  fontSize: "inherit",
  color: "inherit",
  alignSelf: "stretch",
  // make children horizontally aligned
  display: "flex",
  alignItems: "center",
  flex: 1,
  fontFamily: "inherit",
  cursor: "pointer",
  whiteSpace: "nowrap",
  overflow: "hidden"
}, (e.value === null || e.value === void 0) && {
  opacity: "var(--Select-placeholderOpacity)"
}, {
  "&::before": {
    content: '""',
    display: "block",
    position: "absolute",
    // TODO: use https://caniuse.com/?search=inset when ~94%
    top: "calc(-1 * var(--variant-borderWidth, 0px))",
    left: "calc(-1 * var(--variant-borderWidth, 0px))",
    right: "calc(-1 * var(--variant-borderWidth, 0px))",
    bottom: "calc(-1 * var(--variant-borderWidth, 0px))",
    borderRadius: "var(--Select-radius)"
  }
})), Y1 = H(Pi, {
  name: "JoySelect",
  slot: "Listbox",
  overridesResolver: (e, t) => t.listbox
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  const n = (r = e.variants[t.variant]) == null ? void 0 : r[t.color];
  return y({
    "--focus-outline-offset": `calc(${e.vars.focus.thickness} * -1)`,
    // to prevent the focus outline from being cut by overflow
    "--ListItem-stickyBackground": (n == null ? void 0 : n.backgroundColor) || (n == null ? void 0 : n.background) || e.vars.palette.background.popup,
    "--ListItem-stickyTop": "calc(var(--List-padding, var(--ListDivider-gap)) * -1)"
  }, Kc, {
    minWidth: "max-content",
    // prevent options from shrinking if some of them is wider than the Select's root.
    maxHeight: "44vh",
    // the best value from what I tried so far which does not cause screen flicker when listbox is open.
    overflow: "auto",
    outline: 0,
    boxShadow: e.shadow.md,
    borderRadius: `var(--List-radius, ${e.vars.radius.sm})`,
    // `unstable_popup-zIndex` is a private variable that lets other component, for example Modal, to override the z-index so that the listbox can be displayed above the Modal.
    zIndex: `var(--unstable_popup-zIndex, ${e.vars.zIndex.popup})`
  }, !(n != null && n.backgroundColor) && {
    backgroundColor: e.vars.palette.background.popup
  });
}), X1 = H("span", {
  name: "JoySelect",
  slot: "StartDecorator",
  overridesResolver: (e, t) => t.startDecorator
})({
  "--Button-margin": "0 0 0 calc(var(--Select-decoratorChildOffset) * -1)",
  "--IconButton-margin": "0 0 0 calc(var(--Select-decoratorChildOffset) * -1)",
  "--Icon-margin": "0 0 0 calc(var(--Select-paddingInline) / -4)",
  display: "inherit",
  alignItems: "center",
  color: "var(--Select-decoratorColor)",
  marginInlineEnd: "var(--Select-gap)"
}), $1 = H("span", {
  name: "JoySelect",
  slot: "EndDecorator",
  overridesResolver: (e, t) => t.endDecorator
})({
  "--Button-margin": "0 calc(var(--Select-decoratorChildOffset) * -1) 0 0",
  "--IconButton-margin": "0 calc(var(--Select-decoratorChildOffset) * -1) 0 0",
  "--Icon-margin": "0 calc(var(--Select-paddingInline) / -4) 0 0",
  display: "inherit",
  alignItems: "center",
  color: "var(--Select-decoratorColor)",
  marginInlineStart: "var(--Select-gap)"
}), _1 = H("span", {
  name: "JoySelect",
  slot: "Indicator"
})(({
  ownerState: e,
  theme: t
}) => y({}, e.size === "sm" && {
  "--Icon-fontSize": t.vars.fontSize.lg
}, e.size === "md" && {
  "--Icon-fontSize": t.vars.fontSize.xl
}, e.size === "lg" && {
  "--Icon-fontSize": t.vars.fontSize.xl2
}, {
  "--Icon-color": e.color !== "neutral" || e.variant === "solid" ? "currentColor" : t.vars.palette.text.icon,
  display: "inherit",
  alignItems: "center",
  marginInlineStart: "var(--Select-gap)",
  marginInlineEnd: "calc(var(--Select-paddingInline) / -4)",
  [`.${vr.endDecorator} + &`]: {
    marginInlineStart: "calc(var(--Select-gap) / 2)"
  },
  [`&.${vr.expanded}, .${vr.disabled} > &`]: {
    "--Icon-color": "currentColor"
  }
})), eb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  var n, o, a, i, s, l, d;
  const u = xe({
    props: t,
    name: "JoySelect"
  }), p = u, {
    action: f,
    autoFocus: g,
    children: h,
    defaultValue: m,
    defaultListboxOpen: A = !1,
    disabled: b,
    getSerializedValue: C,
    placeholder: v,
    listboxId: k,
    listboxOpen: S,
    onChange: I,
    onListboxOpenChange: w,
    onClose: P,
    renderValue: E,
    required: K = !1,
    value: R,
    size: B = "md",
    variant: V = "outlined",
    color: M = "neutral",
    startDecorator: j,
    endDecorator: T,
    indicator: O = Ls || (Ls = /* @__PURE__ */ c.jsx(W1, {})),
    // props to forward to the button (all handlers should go through slotProps.button)
    "aria-describedby": F,
    "aria-label": N,
    "aria-labelledby": te,
    id: G,
    name: Z,
    multiple: ie = !1,
    slots: le = {},
    slotProps: ae = {}
  } = p, ce = ee(p, z1), q = x.useContext(Lc), D = (n = (o = t.disabled) != null ? o : q == null ? void 0 : q.disabled) != null ? n : b, W = (a = (i = t.size) != null ? i : q == null ? void 0 : q.size) != null ? a : B, Q = (s = t.color) != null ? s : q != null && q.error ? "danger" : (l = q == null ? void 0 : q.color) != null ? l : M, $ = E ?? N1, [se, X] = x.useState(null), de = x.useRef(null), Ge = x.useRef(null), nt = ke(r, de);
  x.useImperativeHandle(f, () => ({
    focusVisible: () => {
      var $e;
      ($e = Ge.current) == null || $e.focus();
    }
  }), []), x.useEffect(() => {
    X(de.current);
  }, []), x.useEffect(() => {
    g && Ge.current.focus();
  }, [g]);
  const Ke = x.useCallback(($e) => {
    w == null || w($e), $e || P == null || P();
  }, [P, w]), {
    buttonActive: Ae,
    buttonFocusVisible: ct,
    contextValue: ot,
    disabled: kt,
    getButtonProps: Kt,
    getListboxProps: De,
    getHiddenInputProps: bt,
    getOptionMetadata: xt,
    open: Rt,
    value: Ze
  } = c0({
    buttonRef: Ge,
    defaultOpen: A,
    defaultValue: m,
    disabled: D,
    getSerializedValue: C,
    listboxId: k,
    multiple: ie,
    name: Z,
    required: K,
    onChange: I,
    onOpenChange: Ke,
    open: S,
    value: R
  }), We = y({}, u, {
    active: Ae,
    defaultListboxOpen: A,
    disabled: kt,
    focusVisible: ct,
    open: Rt,
    renderValue: $,
    value: Ze,
    size: W,
    variant: V,
    color: Q
  }), Ie = H1(We), Me = y({}, ce, {
    slots: le,
    slotProps: ae
  }), yt = x.useMemo(() => {
    let $e;
    if (ie)
      $e = Ze.map((_o) => xt(_o)).filter((_o) => _o !== void 0);
    else {
      var Hi;
      $e = (Hi = xt(Ze)) != null ? Hi : null;
    }
    return $e;
  }, [xt, Ze, ie]), [L, Y] = re("root", {
    ref: nt,
    className: Ie.root,
    elementType: G1,
    externalForwardedProps: Me,
    ownerState: We
  }), [ne, Oe] = re("button", {
    additionalProps: {
      "aria-describedby": F ?? (q == null ? void 0 : q["aria-describedby"]),
      "aria-label": N,
      "aria-labelledby": te ?? (q == null ? void 0 : q.labelId),
      "aria-required": K ? "true" : void 0,
      id: G ?? (q == null ? void 0 : q.htmlFor),
      name: Z
    },
    className: Ie.button,
    elementType: Z1,
    externalForwardedProps: Me,
    getSlotProps: Kt,
    ownerState: We
  }), [Kd, Jr] = re("listbox", {
    additionalProps: {
      anchorEl: se,
      open: Rt,
      placement: "bottom",
      keepMounted: !0
    },
    className: Ie.listbox,
    elementType: Y1,
    externalForwardedProps: Me,
    getSlotProps: De,
    ownerState: y({}, We, {
      nesting: !1,
      row: !1,
      wrap: !1
    }),
    getSlotOwnerState: ($e) => ({
      size: $e.size || W,
      variant: $e.variant || V,
      color: $e.color || ($e.disablePortal ? Q : M),
      disableColorInversion: !$e.disablePortal
    })
  }), [Rd, Ud] = re("startDecorator", {
    className: Ie.startDecorator,
    elementType: X1,
    externalForwardedProps: Me,
    ownerState: We
  }), [jd, Bd] = re("endDecorator", {
    className: Ie.endDecorator,
    elementType: $1,
    externalForwardedProps: Me,
    ownerState: We
  }), [Dd, Md] = re("indicator", {
    className: Ie.indicator,
    elementType: _1,
    externalForwardedProps: Me,
    ownerState: We
  }), Fd = x.useMemo(() => [...Q1, ...Jr.modifiers || []], [Jr.modifiers]);
  let Qi = v;
  return (Array.isArray(yt) && yt.length > 0 || !Array.isArray(yt) && yt) && (Qi = $(yt)), /* @__PURE__ */ c.jsxs(x.Fragment, {
    children: [/* @__PURE__ */ c.jsxs(L, y({}, Y, {
      children: [j && /* @__PURE__ */ c.jsx(Rd, y({}, Ud, {
        children: j
      })), /* @__PURE__ */ c.jsx(ne, y({}, Oe, {
        children: Qi
      })), T && /* @__PURE__ */ c.jsx(jd, y({}, Bd, {
        children: T
      })), O && /* @__PURE__ */ c.jsx(Dd, y({}, Md, {
        children: O
      })), /* @__PURE__ */ c.jsx("input", y({}, bt()))]
    })), se && /* @__PURE__ */ c.jsx(Kd, y({}, Jr, {
      className: Qe(Jr.className),
      modifiers: Fd
    }, !((d = u.slots) != null && d.listbox) && {
      as: a0,
      slots: {
        root: Jr.as || "ul"
      }
    }, {
      children: /* @__PURE__ */ c.jsx(d0, {
        value: ot,
        children: /* @__PURE__ */ c.jsx(B0, {
          variant: V,
          color: M,
          children: /* @__PURE__ */ c.jsx(P0.Provider, {
            value: "select",
            children: /* @__PURE__ */ c.jsx(Rc, {
              nested: !0,
              children: h
            })
          })
        })
      })
    }))]
  });
});
function tb(e) {
  return ye("MuiSnackbar", e);
}
be("MuiSnackbar", ["root", "anchorOriginTopCenter", "anchorOriginBottomCenter", "anchorOriginTopRight", "anchorOriginBottomRight", "anchorOriginTopLeft", "anchorOriginBottomLeft", "colorPrimary", "colorDanger", "colorNeutral", "colorSuccess", "colorWarning", "endDecorator", "sizeSm", "sizeMd", "sizeLg", "startDecorator", "variantPlain", "variantOutlined", "variantSoft", "variantSolid"]);
const rb = ["anchorOrigin", "animationDuration", "autoHideDuration", "color", "children", "className", "component", "disableWindowBlurListener", "endDecorator", "invertedColors", "onBlur", "onClose", "onFocus", "onMouseEnter", "onMouseLeave", "onUnmount", "open", "resumeHideDuration", "size", "slots", "slotProps", "startDecorator", "variant"];
let Zc = (e) => e, zs, Ns;
const nb = (e) => {
  const {
    variant: t,
    color: r,
    size: n,
    anchorOrigin: o
  } = e, a = {
    root: ["root", n && `size${z(n)}`, r && `color${z(r)}`, t && `variant${z(t)}`, `anchorOrigin${z(o.vertical)}${z(o.horizontal)}`],
    startDecorator: ["startDecorator"],
    endDecorator: ["endDecorator"]
  };
  return me(a, tb, {});
}, ob = Po(zs || (zs = Zc`
  0% {
    transform: translateX(var(--Snackbar-translateX, 0px)) translateY(calc(var(--_Snackbar-anchorBottom, 1) * 100%));
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    transform: translateX(var(--Snackbar-translateX, 0px)) translateY(0);
  }
`)), ab = Po(Ns || (Ns = Zc`
  0% {
    transform: translateX(var(--Snackbar-translateX, 0px)) translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateX(var(--Snackbar-translateX, 0px)) translateY(calc(var(--_Snackbar-anchorBottom, 1) * 100%));
    opacity: 0;
  }
`)), ib = H("div", {
  name: "JoySnackbar",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i, s, l;
  const {
    p: d,
    padding: u,
    borderRadius: p
  } = On({
    theme: e,
    ownerState: t
  }, ["p", "padding", "borderRadius"]);
  return [y({
    "--Snackbar-radius": e.vars.radius.sm,
    "--Snackbar-decoratorChildRadius": "max((var(--Snackbar-radius) - var(--variant-borderWidth, 0px)) - var(--Snackbar-padding), min(var(--Snackbar-padding) + var(--variant-borderWidth, 0px), var(--Snackbar-radius) / 2))",
    "--Button-minHeight": "var(--Snackbar-decoratorChildHeight)",
    "--IconButton-size": "var(--Snackbar-decoratorChildHeight)",
    "--Button-radius": "var(--Snackbar-decoratorChildRadius)",
    "--IconButton-radius": "var(--Snackbar-decoratorChildRadius)",
    "--Icon-color": "currentColor"
  }, t.size === "sm" && {
    "--Snackbar-padding": "0.75rem",
    "--Snackbar-inset": "0.5rem",
    "--Snackbar-decoratorChildHeight": "1.5rem",
    "--Icon-fontSize": e.vars.fontSize.xl,
    gap: "0.5rem"
  }, t.size === "md" && {
    "--Snackbar-padding": "1rem",
    "--Snackbar-inset": "0.75rem",
    // the spacing between Snackbar and the viewport
    "--Snackbar-decoratorChildHeight": "2rem",
    "--Icon-fontSize": e.vars.fontSize.xl,
    gap: "0.625rem"
  }, t.size === "lg" && {
    "--Snackbar-padding": "1.25rem",
    "--Snackbar-inset": "1rem",
    "--Snackbar-decoratorChildHeight": "2.375rem",
    "--Icon-fontSize": e.vars.fontSize.xl2,
    gap: "0.875rem"
  }, {
    zIndex: e.vars.zIndex.snackbar,
    position: "fixed",
    display: "flex",
    alignItems: "center",
    minWidth: 300,
    top: ((r = t.anchorOrigin) == null ? void 0 : r.vertical) === "top" ? "var(--Snackbar-inset)" : void 0,
    left: ((n = t.anchorOrigin) == null ? void 0 : n.horizontal) === "left" ? "var(--Snackbar-inset)" : void 0,
    bottom: ((o = t.anchorOrigin) == null ? void 0 : o.vertical) === "bottom" ? "var(--Snackbar-inset)" : void 0,
    right: ((a = t.anchorOrigin) == null ? void 0 : a.horizontal) === "right" ? "var(--Snackbar-inset)" : void 0
  }, ((i = t.anchorOrigin) == null ? void 0 : i.horizontal) === "center" && {
    "--Snackbar-translateX": "-50%",
    left: "50%",
    transform: "translateX(var(--Snackbar-translateX))"
  }, ((s = t.anchorOrigin) == null ? void 0 : s.vertical) === "top" && {
    "--_Snackbar-anchorBottom": "-1"
  }, {
    animation: `${ob} ${t.animationDuration}ms forwards`
  }, !t.open && {
    animationName: ab
  }, {
    boxShadow: e.vars.shadow.lg,
    backgroundColor: e.vars.palette.background.surface,
    padding: "var(--Snackbar-padding)",
    borderRadius: "var(--Snackbar-radius)"
  }, e.typography[`body-${{
    sm: "xs",
    md: "sm",
    lg: "md"
  }[t.size]}`], t.variant === "solid" && t.color && t.invertedColors && Dc(t.color)(e), t.variant === "soft" && t.color && t.invertedColors && Mc(t.color)(e), (l = e.variants[t.variant]) == null ? void 0 : l[t.color]), d !== void 0 && {
    "--Snackbar-padding": d
  }, u !== void 0 && {
    "--Snackbar-padding": u
  }, p !== void 0 && {
    "--Snackbar-radius": p
  }];
}), sb = H("span", {
  name: "JoySnackbar",
  slot: "StartDecorator",
  overridesResolver: (e, t) => t.startDecorator
})({
  display: "inherit",
  flex: "none"
}), lb = H("span", {
  name: "JoySnackbar",
  slot: "EndDecorator",
  overridesResolver: (e, t) => t.endDecorator
})({
  display: "inherit",
  flex: "none",
  marginLeft: "auto"
}), cb = {
  vertical: "bottom",
  horizontal: "right"
}, db = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoySnackbar"
  }), {
    anchorOrigin: o = cb,
    animationDuration: a = 300,
    autoHideDuration: i = null,
    color: s = "neutral",
    children: l,
    className: d,
    component: u,
    disableWindowBlurListener: p = !1,
    endDecorator: f,
    invertedColors: g = !1,
    onUnmount: h,
    open: m,
    size: A = "md",
    slots: b = {},
    slotProps: C,
    startDecorator: v,
    variant: k = "outlined"
  } = n, S = ee(n, rb), [I, w] = x.useState(!0), [P, E] = x.useState(!1), K = x.useRef(h);
  K.current = h, x.useEffect(() => {
    if (m)
      E(!1), w(!1);
    else {
      E(!0);
      const le = setTimeout(() => {
        var ae;
        w(!0), E(!1), (ae = K.current) == null || ae.call(K);
      }, a);
      return () => {
        clearTimeout(le);
      };
    }
  }, [m, a]);
  const R = y({}, n, {
    anchorOrigin: o,
    autoHideDuration: i,
    color: s,
    animationDuration: a,
    disableWindowBlurListener: p,
    invertedColors: g,
    size: A,
    variant: k
  });
  delete R.onUnmount;
  const B = nb(R), {
    getRootProps: V,
    onClickAway: M
  } = u0(R), j = (le) => {
    P || M(le);
  }, T = y({}, S, {
    component: u,
    slots: b,
    slotProps: C
  }), [O, F] = re("root", {
    ref: r,
    className: Qe(B.root, d),
    elementType: ib,
    externalForwardedProps: T,
    getSlotProps: V,
    ownerState: R
  }), [N, te] = re("startDecorator", {
    className: B.startDecorator,
    elementType: sb,
    externalForwardedProps: T,
    ownerState: R
  }), [G, Z] = re("endDecorator", {
    className: B.endDecorator,
    elementType: lb,
    externalForwardedProps: T,
    ownerState: R
  }), ie = b.clickAway || Xg;
  return !m && I ? null : /* @__PURE__ */ c.jsx(ie, y({
    onClickAway: j
  }, typeof (C == null ? void 0 : C.clickAway) == "function" ? C.clickAway(R) : C == null ? void 0 : C.clickAway, {
    children: /* @__PURE__ */ c.jsxs(O, y({}, F, {
      children: [v && /* @__PURE__ */ c.jsx(N, y({}, te, {
        children: v
      })), l, f && /* @__PURE__ */ c.jsx(G, y({}, Z, {
        children: f
      }))]
    }))
  }));
}), ub = Ug({
  createStyledComponent: H("div", {
    name: "JoyStack",
    slot: "Root",
    overridesResolver: (e, t) => t.root
  }),
  useThemeProps: (e) => xe({
    props: e,
    name: "JoyStack"
  })
});
function pb(e) {
  return ye("MuiTab", e);
}
const fn = be("MuiTab", ["root", "disabled", "focusVisible", "selected", "horizontal", "vertical", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid"]), fb = ["action", "children", "value", "disabled", "onChange", "onClick", "onFocus", "component", "orientation", "variant", "color", "disableIndicator", "indicatorPlacement", "indicatorInset", "slots", "slotProps"], gb = (e) => {
  const {
    selected: t,
    disabled: r,
    focusVisible: n,
    variant: o,
    color: a,
    orientation: i
  } = e, s = {
    root: ["root", i, r && "disabled", n && "focusVisible", t && "selected", o && `variant${z(o)}`, a && `color${z(a)}`]
  };
  return me(s, pb, {});
}, hb = H(Ti, {
  name: "JoyTab",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e
}) => [
  {
    flex: "initial",
    justifyContent: e.row ? "center" : "initial",
    "--unstable_ListItemDecorator-alignItems": "center",
    "--unstable_offset": "min(calc(-1 * var(--variant-borderWidth, 0px)), -1px)"
  },
  !e.disableIndicator && {
    '&[aria-selected="true"]': {
      "--Tab-indicatorColor": "currentColor",
      zIndex: 1
      // to stay above other tab elements
    },
    // using pseudo element for showing active indicator is best for controlling the size and customization.
    // for example, developers can customize the radius, width or background.
    // (border and box-shadow are not flexible when it comes to customization).
    "&::after": {
      content: '""',
      display: "block",
      position: "absolute",
      margin: "auto",
      background: "var(--Tab-indicatorColor)",
      borderRadius: "var(--Tab-indicatorRadius)"
    }
  },
  // the padding is to account for the indicator's thickness to make the text proportional.
  !e.disableIndicator && e.indicatorPlacement === "bottom" && {
    paddingBottom: "calc(var(--ListItem-paddingY) - var(--variant-borderWidth, 0px) + var(--Tab-indicatorThickness) - 1px)",
    "&::after": {
      height: "var(--Tab-indicatorThickness)",
      width: "var(--Tab-indicatorSize)",
      left: e.indicatorInset ? "var(--ListItem-paddingLeft)" : "var(--unstable_offset)",
      right: e.indicatorInset ? "var(--ListItem-paddingRight)" : "var(--unstable_offset)",
      bottom: "calc(-1px - var(--unstable_TabList-underlineBottom, 0px))"
    }
  },
  !e.disableIndicator && e.indicatorPlacement === "top" && {
    paddingTop: "calc(var(--ListItem-paddingY) - var(--variant-borderWidth, 0px) + var(--Tab-indicatorThickness) - 1px)",
    "&::after": {
      height: "var(--Tab-indicatorThickness)",
      width: "var(--Tab-indicatorSize)",
      left: e.indicatorInset ? "var(--ListItem-paddingLeft)" : "var(--unstable_offset)",
      right: e.indicatorInset ? "var(--ListItem-paddingRight)" : "var(--unstable_offset)",
      top: "calc(-1px - var(--unstable_TabList-underlineTop, 0px))"
    }
  },
  !e.disableIndicator && e.indicatorPlacement === "right" && {
    paddingRight: "calc(var(--ListItem-paddingRight) + var(--Tab-indicatorThickness) - 1px)",
    "&::after": {
      height: "var(--Tab-indicatorSize)",
      width: "var(--Tab-indicatorThickness)",
      top: e.indicatorInset ? "var(--ListItem-paddingY)" : "var(--unstable_offset)",
      bottom: e.indicatorInset ? "var(--ListItem-paddingY)" : "var(--unstable_offset)",
      right: "calc(-1px - var(--unstable_TabList-underlineRight, 0px))"
    }
  },
  !e.disableIndicator && e.indicatorPlacement === "left" && {
    paddingLeft: "calc(var(--ListItem-paddingLeft) + var(--Tab-indicatorThickness) - 1px)",
    "&::after": {
      height: "var(--Tab-indicatorSize)",
      width: "var(--Tab-indicatorThickness)",
      top: e.indicatorInset ? "var(--ListItem-paddingY)" : "var(--unstable_offset)",
      bottom: e.indicatorInset ? "var(--ListItem-paddingY)" : "var(--unstable_offset)",
      left: "calc(-1px - var(--unstable_TabList-underlineLeft, 0px))"
    }
  }
]), Yt = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyTab"
  }), o = x.useContext(wi), {
    action: a,
    children: i,
    disabled: s = !1,
    component: l = "button",
    orientation: d = "horizontal",
    variant: u = "plain",
    color: p = "neutral",
    disableIndicator: f = !1,
    indicatorPlacement: g = o ? "bottom" : "right",
    indicatorInset: h = !1,
    slots: m = {},
    slotProps: A = {}
  } = n, b = ee(n, fb), C = x.useRef(null), v = ke(C, r), {
    active: k,
    focusVisible: S,
    setFocusVisible: I,
    selected: w,
    getRootProps: P
  } = y0(y({}, n, {
    rootRef: v
  }));
  x.useImperativeHandle(a, () => ({
    focusVisible: () => {
      I(!0), C.current.focus();
    }
  }), [I]);
  const E = y({}, n, {
    disableIndicator: f,
    indicatorPlacement: g,
    indicatorInset: h,
    orientation: d,
    row: o,
    active: k,
    focusVisible: S,
    disabled: s,
    selected: w,
    variant: u,
    color: p
  }), K = gb(E), R = y({}, b, {
    component: l,
    slots: m,
    slotProps: A
  }), [B, V] = re("root", {
    ref: r,
    elementType: hb,
    getSlotProps: P,
    externalForwardedProps: R,
    ownerState: E,
    className: K.root
  });
  return /* @__PURE__ */ c.jsx(Uc.Provider, {
    value: d,
    children: /* @__PURE__ */ c.jsx(B, y({}, V, {
      children: i
    }))
  });
});
function mb(e) {
  return ye("MuiTable", e);
}
be("MuiTable", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg", "stickyHeader", "stickyFooter", "noWrap", "hoverRow", "borderAxisNone", "borderAxisX", "borderAxisXBetween", "borderAxisY", "borderAxisYBetween", "borderAxisBoth", "borderAxisBothBetween"]);
const vb = ["className", "component", "children", "borderAxis", "hoverRow", "noWrap", "size", "variant", "color", "stripe", "stickyHeader", "stickyFooter", "slots", "slotProps"], bb = (e) => {
  const {
    size: t,
    variant: r,
    color: n,
    borderAxis: o,
    stickyHeader: a,
    stickyFooter: i,
    noWrap: s,
    hoverRow: l
  } = e, d = {
    root: ["root", a && "stickyHeader", i && "stickyFooter", s && "noWrap", l && "hoverRow", o && `borderAxis${z(o)}`, r && `variant${z(r)}`, n && `color${z(n)}`, t && `size${z(t)}`]
  };
  return me(d, mb, {});
}, Fe = {
  /**
   * According to https://www.w3.org/TR/2014/REC-html5-20141028/tabular-data.html#the-tr-element,
   * `tr` can only have `td | th` as children, so using :first-of-type is better than :first-child to prevent emotion SSR warning
   */
  getColumnExceptFirst() {
    return "& tr > *:not(:first-of-type), & tr > th + td, & tr > td + th";
  },
  /**
   * Every cell in the table
   */
  getCell() {
    return "& th, & td";
  },
  /**
   * `th` cell of the table (could exist in the body)
   */
  getHeadCell() {
    return "& th";
  },
  /**
   * Only the cell of `thead`
   */
  getHeaderCell() {
    return "& thead th";
  },
  getHeaderCellOfRow(e) {
    return `& thead tr:nth-of-type(${e}) th`;
  },
  getBottomHeaderCell() {
    return "& thead th:not([colspan])";
  },
  getHeaderNestedFirstColumn() {
    return "& thead tr:not(:first-of-type) th:not([colspan]):first-of-type";
  },
  /**
   * The body cell that contains data
   */
  getDataCell() {
    return "& td";
  },
  getDataCellExceptLastRow() {
    return "& tr:not(:last-of-type) > td";
  },
  /**
   * The body cell either `td` or `th`
   */
  getBodyCellExceptLastRow() {
    return `${this.getDataCellExceptLastRow()}, & tr:not(:last-of-type) > th[scope="row"]`;
  },
  getBodyCellOfRow(e) {
    return typeof e == "number" && e < 0 ? `& tbody tr:nth-last-of-type(${Math.abs(e)}) td, & tbody tr:nth-last-of-type(${Math.abs(e)}) th[scope="row"]` : `& tbody tr:nth-of-type(${e}) td, & tbody tr:nth-of-type(${e}) th[scope="row"]`;
  },
  getBodyRow(e) {
    return e === void 0 ? "& tbody tr" : `& tbody tr:nth-of-type(${e})`;
  },
  getFooterCell() {
    return "& tfoot th, & tfoot td";
  },
  getFooterFirstRowCell() {
    return "& tfoot tr:not(:last-of-type) th, & tfoot tr:not(:last-of-type) td";
  }
}, xb = H("table", {
  name: "JoyTable",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i, s, l;
  const d = (r = e.variants[t.variant]) == null ? void 0 : r[t.color];
  return [y({
    "--Table-headerUnderlineThickness": "2px",
    "--TableCell-borderColor": (n = d == null ? void 0 : d.borderColor) != null ? n : e.vars.palette.divider,
    "--TableCell-headBackground": `var(--Sheet-background, ${e.vars.palette.background.surface})`
  }, t.size === "sm" && {
    "--unstable_TableCell-height": "var(--TableCell-height, 32px)",
    "--TableCell-paddingX": "0.25rem",
    "--TableCell-paddingY": "0.25rem"
  }, t.size === "md" && {
    "--unstable_TableCell-height": "var(--TableCell-height, 40px)",
    "--TableCell-paddingX": "0.5rem",
    "--TableCell-paddingY": "0.375rem"
  }, t.size === "lg" && {
    "--unstable_TableCell-height": "var(--TableCell-height, 48px)",
    "--TableCell-paddingX": "0.75rem",
    "--TableCell-paddingY": "0.5rem"
  }, {
    tableLayout: "fixed",
    width: "100%",
    borderSpacing: "0px",
    borderCollapse: "separate",
    borderRadius: "var(--TableCell-cornerRadius, var(--unstable_actionRadius))"
  }, e.typography[`body-${{
    sm: "xs",
    md: "sm",
    lg: "md"
  }[t.size]}`], (o = e.variants[t.variant]) == null ? void 0 : o[t.color], {
    "& caption": {
      color: e.vars.palette.text.tertiary,
      padding: "calc(2 * var(--TableCell-paddingY)) var(--TableCell-paddingX)"
    },
    [Fe.getDataCell()]: y({
      padding: "var(--TableCell-paddingY) var(--TableCell-paddingX)",
      height: "var(--unstable_TableCell-height)",
      borderColor: "var(--TableCell-borderColor)",
      // must come after border bottom
      backgroundColor: "var(--TableCell-dataBackground)"
    }, t.noWrap && {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    }),
    [Fe.getHeadCell()]: {
      textAlign: "left",
      padding: "var(--TableCell-paddingY) var(--TableCell-paddingX)",
      backgroundColor: "var(--TableCell-headBackground)",
      // use `background-color` in case the Sheet has gradient background
      height: "var(--unstable_TableCell-height)",
      fontWeight: e.vars.fontWeight.lg,
      borderColor: "var(--TableCell-borderColor)",
      color: e.vars.palette.text.secondary,
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden"
    },
    [Fe.getHeaderCell()]: {
      verticalAlign: "bottom",
      // Automatic radius adjustment with Sheet
      "&:first-of-type": {
        borderTopLeftRadius: "var(--TableCell-cornerRadius, var(--unstable_actionRadius))"
      },
      "&:last-of-type": {
        borderTopRightRadius: "var(--TableCell-cornerRadius, var(--unstable_actionRadius))"
      }
    },
    "& tfoot tr > *": {
      backgroundColor: `var(--TableCell-footBackground, ${e.vars.palette.background.level1})`,
      // Automatic radius adjustment with Sheet
      "&:first-of-type": {
        borderBottomLeftRadius: "var(--TableCell-cornerRadius, var(--unstable_actionRadius))"
      },
      "&:last-of-type": {
        borderBottomRightRadius: "var(--TableCell-cornerRadius, var(--unstable_actionRadius))"
      }
    }
  }), (((a = t.borderAxis) == null ? void 0 : a.startsWith("x")) || ((i = t.borderAxis) == null ? void 0 : i.startsWith("both"))) && {
    // insert border between rows
    [Fe.getHeaderCell()]: {
      borderBottomWidth: 1,
      borderBottomStyle: "solid"
    },
    [Fe.getBottomHeaderCell()]: {
      borderBottomWidth: "var(--Table-headerUnderlineThickness)",
      borderBottomStyle: "solid"
    },
    [Fe.getBodyCellExceptLastRow()]: {
      borderBottomWidth: 1,
      borderBottomStyle: "solid"
    },
    [Fe.getFooterCell()]: {
      borderTopWidth: 1,
      borderTopStyle: "solid"
    }
  }, (((s = t.borderAxis) == null ? void 0 : s.startsWith("y")) || ((l = t.borderAxis) == null ? void 0 : l.startsWith("both"))) && {
    // insert border between columns
    [`${Fe.getColumnExceptFirst()}, ${Fe.getHeaderNestedFirstColumn()}`]: {
      borderLeftWidth: 1,
      borderLeftStyle: "solid"
    }
  }, (t.borderAxis === "x" || t.borderAxis === "both") && {
    // insert border at the top of header and bottom of body
    [Fe.getHeaderCellOfRow(1)]: {
      borderTopWidth: 1,
      borderTopStyle: "solid"
    },
    [Fe.getBodyCellOfRow(-1)]: {
      borderBottomWidth: 1,
      borderBottomStyle: "solid"
    },
    [Fe.getFooterCell()]: {
      borderBottomWidth: 1,
      borderBottomStyle: "solid"
    }
  }, (t.borderAxis === "y" || t.borderAxis === "both") && {
    // insert border on the left of first column and right of the last column
    "& tr > *:first-of-type": {
      borderLeftWidth: 1,
      borderLeftStyle: "solid"
    },
    "& tr > *:last-of-type:not(:first-of-type)": {
      borderRightWidth: 1,
      borderRightStyle: "solid"
    }
  }, t.stripe && {
    [Fe.getBodyRow(t.stripe)]: {
      // For customization, a table cell can look for this variable with a fallback value.
      background: `var(--TableRow-stripeBackground, ${e.vars.palette.background.level2})`,
      color: e.vars.palette.text.primary
    }
  }, t.hoverRow && {
    [Fe.getBodyRow()]: {
      "&:hover": {
        background: `var(--TableRow-hoverBackground, ${e.vars.palette.background.level3})`
      }
    }
  }, t.stickyHeader && {
    // The column header
    [Fe.getHeaderCell()]: {
      position: "sticky",
      top: 0,
      zIndex: e.vars.zIndex.table
    },
    [Fe.getHeaderCellOfRow(2)]: {
      // support upto 2 rows for the sticky header
      top: "var(--unstable_TableCell-height)"
    }
  }, t.stickyFooter && {
    // The column header
    [Fe.getFooterCell()]: {
      position: "sticky",
      bottom: 0,
      zIndex: e.vars.zIndex.table,
      color: e.vars.palette.text.secondary,
      fontWeight: e.vars.fontWeight.lg
    },
    [Fe.getFooterFirstRowCell()]: {
      // support upto 2 rows for the sticky footer
      bottom: "var(--unstable_TableCell-height)"
    }
  }];
}), yb = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyTable"
  }), {
    className: o,
    component: a,
    children: i,
    borderAxis: s = "xBetween",
    hoverRow: l = !1,
    noWrap: d = !1,
    size: u = "md",
    variant: p = "plain",
    color: f = "neutral",
    stripe: g,
    stickyHeader: h = !1,
    stickyFooter: m = !1,
    slots: A = {},
    slotProps: b = {}
  } = n, C = ee(n, vb), v = y({}, n, {
    borderAxis: s,
    hoverRow: l,
    noWrap: d,
    component: a,
    size: u,
    color: f,
    variant: p,
    stripe: g,
    stickyHeader: h,
    stickyFooter: m
  }), k = bb(v), S = y({}, C, {
    component: a,
    slots: A,
    slotProps: b
  }), [I, w] = re("root", {
    ref: r,
    className: Qe(k.root, o),
    elementType: xb,
    externalForwardedProps: S,
    ownerState: v
  });
  return /* @__PURE__ */ c.jsx(zc.Provider, {
    value: !0,
    children: /* @__PURE__ */ c.jsx(I, y({}, w, {
      children: i
    }))
  });
}), Di = /* @__PURE__ */ x.createContext("md");
function Ab(e) {
  return ye("MuiTabList", e);
}
be("MuiTabList", ["root", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg"]);
const Cb = ["component", "children", "variant", "color", "size", "disableUnderline", "underlinePlacement", "tabFlex", "sticky", "slots", "slotProps"], Sb = (e) => {
  const {
    orientation: t,
    size: r,
    variant: n,
    color: o
  } = e, a = {
    root: ["root", t, n && `variant${z(n)}`, o && `color${z(o)}`, r && `size${z(r)}`]
  };
  return me(a, Ab, {});
}, kb = H(Pi, {
  name: "JoyTabList",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  const n = (r = e.variants[t.variant]) == null ? void 0 : r[t.color];
  return y({
    "--List-gap": "0px",
    "--ListDivider-gap": "0px",
    "--ListItem-paddingX": "var(--Tabs-spacing)",
    "--ListItem-gap": "0.375rem",
    // the `var(--unknown,)` is a workaround because emotion does not support space toggle.
    "--unstable_TabList-hasUnderline": t.disableUnderline ? "var(--unknown,)" : "initial"
  }, Kc, {
    flexGrow: "initial",
    flexDirection: t.orientation === "vertical" ? "column" : "row",
    borderRadius: "var(--List-radius, 0px)",
    padding: "var(--List-padding, 0px)",
    zIndex: 1
  }, t.sticky && {
    // sticky in list item can be found in grouped options
    position: "sticky",
    top: t.sticky === "top" ? "calc(-1 * var(--Tabs-padding, 0px))" : "initial",
    bottom: t.sticky === "bottom" ? "calc(-1 * var(--Tabs-padding, 0px))" : "initial",
    backgroundColor: (n == null ? void 0 : n.backgroundColor) || `var(--TabList-stickyBackground, ${e.vars.palette.background.body})`
  }, !t.disableUnderline && y({}, t.underlinePlacement === "bottom" && {
    "--unstable_TabList-underlineBottom": "1px",
    paddingBottom: 1,
    boxShadow: `inset 0 -1px ${e.vars.palette.divider}`
  }, t.underlinePlacement === "top" && {
    "--unstable_TabList-underlineTop": "1px",
    paddingTop: 1,
    boxShadow: `inset 0 1px ${e.vars.palette.divider}`
  }, t.underlinePlacement === "right" && {
    "--unstable_TabList-underlineRight": "1px",
    paddingRight: 1,
    boxShadow: `inset -1px 0 ${e.vars.palette.divider}`
  }, t.underlinePlacement === "left" && {
    "--unstable_TabList-underlineLeft": "1px",
    paddingLeft: 1,
    boxShadow: `inset 1px 0 ${e.vars.palette.divider}`
  }), t.tabFlex && {
    [`& .${fn.root}`]: {
      flex: t.tabFlex
    }
  });
}), Mi = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyTabList"
  }), o = x.useContext(Di), {
    isRtl: a,
    orientation: i,
    getRootProps: s,
    contextValue: l
  } = v0({
    rootRef: r
  }), {
    component: d = "div",
    children: u,
    variant: p = "plain",
    color: f = "neutral",
    size: g,
    disableUnderline: h = !1,
    underlinePlacement: m = i === "horizontal" ? "bottom" : "right",
    tabFlex: A,
    sticky: b,
    slots: C = {},
    slotProps: v = {}
  } = n, k = ee(n, Cb), I = y({}, n, {
    isRtl: a,
    orientation: i,
    variant: p,
    color: f,
    size: g ?? o,
    sticky: b,
    tabFlex: A,
    nesting: !1,
    disableUnderline: h,
    underlinePlacement: m
  }), w = Sb(I), P = y({}, k, {
    component: d,
    slots: C,
    slotProps: v
  }), [E, K] = re("root", {
    ref: r,
    elementType: kb,
    getSlotProps: s,
    externalForwardedProps: P,
    ownerState: I,
    className: w.root
  });
  return (
    // @ts-ignore conflicted ref types
    /* @__PURE__ */ c.jsx(E, y({}, K, {
      children: /* @__PURE__ */ c.jsx(b0, {
        value: l,
        children: /* @__PURE__ */ c.jsx(Rc, {
          row: i === "horizontal",
          nested: !0,
          children: u
        })
      })
    }))
  );
});
function Ib(e) {
  return ye("MuiTabPanel", e);
}
be("MuiTabPanel", ["root", "hidden", "sizeSm", "sizeMd", "sizeLg", "horizontal", "vertical", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid"]);
const wb = ["children", "value", "component", "color", "variant", "size", "slots", "slotProps", "keepMounted"], Pb = (e) => {
  const {
    hidden: t,
    size: r,
    variant: n,
    color: o,
    orientation: a
  } = e, i = {
    root: ["root", t && "hidden", r && `size${z(r)}`, a, n && `variant${z(n)}`, o && `color${z(o)}`, r && `size${z(r)}`]
  };
  return me(i, Ib, {});
}, Tb = H("div", {
  name: "JoyTabPanel",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  theme: e,
  ownerState: t
}) => {
  var r;
  return y({
    display: t.hidden ? "none" : "block",
    padding: "var(--Tabs-spacing)",
    flexGrow: 1,
    fontFamily: e.vars.fontFamily.body
  }, e.typography[`body-${t.size}`], (r = e.variants[t.variant]) == null ? void 0 : r[t.color]);
}), Xt = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyTabPanel"
  }), {
    orientation: o
  } = Zo() || {
    orientation: "horizontal"
  }, a = x.useContext(Di), {
    children: i,
    value: s = 0,
    component: l,
    color: d = "neutral",
    variant: u = "plain",
    size: p,
    slots: f = {},
    slotProps: g = {},
    keepMounted: h = !1
  } = n, m = ee(n, wb), {
    hidden: A,
    getRootProps: b
  } = h0(y({}, n, {
    value: s
  })), v = y({}, n, {
    orientation: o,
    hidden: A,
    size: p ?? a,
    color: d,
    variant: u
  }), k = Pb(v), S = y({}, m, {
    component: l,
    slots: f,
    slotProps: g
  }), [I, w] = re("root", {
    ref: r,
    elementType: Tb,
    getSlotProps: b,
    externalForwardedProps: S,
    additionalProps: {
      role: "tabpanel",
      ref: r,
      as: l
    },
    ownerState: v,
    className: k.root
  });
  return h ? /* @__PURE__ */ c.jsx(I, y({}, w, {
    children: i
  })) : /* @__PURE__ */ c.jsx(I, y({}, w, {
    children: !A && i
  }));
});
function Ob(e) {
  return ye("MuiTabs", e);
}
be("MuiTabs", ["root", "horizontal", "vertical", "colorPrimary", "colorNeutral", "colorDanger", "colorSuccess", "colorWarning", "colorContext", "variantPlain", "variantOutlined", "variantSoft", "variantSolid", "sizeSm", "sizeMd", "sizeLg"]);
const Vb = ["children", "value", "defaultValue", "orientation", "direction", "component", "onChange", "selectionFollowsFocus", "variant", "color", "size", "slots", "slotProps"], Eb = (e) => {
  const {
    orientation: t,
    variant: r,
    color: n,
    size: o
  } = e, a = {
    root: ["root", t, r && `variant${z(r)}`, n && `color${z(n)}`, o && `size${z(o)}`]
  };
  return me(a, Ob, {});
}, Kb = H("div", {
  name: "JoyTabs",
  slot: "Root",
  overridesResolver: (e, t) => t.root
})(({
  ownerState: e,
  theme: t
}) => {
  var r, n;
  const o = (r = t.variants[e.variant]) == null ? void 0 : r[e.color], {
    bgcolor: a,
    backgroundColor: i,
    background: s,
    p: l,
    padding: d
  } = On({
    theme: t,
    ownerState: e
  }, ["bgcolor", "backgroundColor", "background", "p", "padding"]), u = Cr(t, `palette.${a}`) || a || Cr(t, `palette.${i}`) || i || s || (o == null ? void 0 : o.backgroundColor) || (o == null ? void 0 : o.background) || t.vars.palette.background.surface;
  return y({}, e.size === "sm" && {
    "--Tabs-spacing": "0.75rem"
  }, e.size === "md" && {
    "--Tabs-spacing": "1rem"
  }, e.size === "lg" && {
    "--Tabs-spacing": "1.25rem"
  }, {
    "--Tab-indicatorThickness": "2px",
    "--Icon-color": e.color !== "neutral" || e.variant === "solid" ? "currentColor" : t.vars.palette.text.icon,
    "--TabList-stickyBackground": u === "transparent" ? "initial" : u,
    // for sticky TabList
    display: "flex",
    flexDirection: "column"
  }, e.orientation === "vertical" && {
    flexDirection: "row"
  }, {
    backgroundColor: t.vars.palette.background.surface,
    position: "relative"
  }, t.typography[`body-${e.size}`], (n = t.variants[e.variant]) == null ? void 0 : n[e.color], l !== void 0 && {
    "--Tabs-padding": l
  }, d !== void 0 && {
    "--Tabs-padding": d
  });
}), Fi = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = xe({
    props: t,
    name: "JoyTabs"
  }), {
    children: o,
    value: a,
    defaultValue: i,
    orientation: s = "horizontal",
    direction: l = "ltr",
    component: d,
    variant: u = "plain",
    color: p = "neutral",
    size: f = "md",
    slots: g = {},
    slotProps: h = {}
  } = n, m = ee(n, Vb), A = i || (a === void 0 ? 0 : void 0), {
    contextValue: b
  } = p0(y({}, n, {
    orientation: s,
    defaultValue: A
  })), C = y({}, n, {
    orientation: s,
    direction: l,
    variant: u,
    color: p,
    size: f
  }), v = Eb(C), k = y({}, m, {
    component: d,
    slots: g,
    slotProps: h
  }), [S, I] = re("root", {
    ref: r,
    elementType: Kb,
    externalForwardedProps: k,
    additionalProps: {
      ref: r,
      as: d
    },
    ownerState: C,
    className: v.root
  });
  return (
    // @ts-ignore `defaultValue` between HTMLDiv and TabsProps is conflicted.
    /* @__PURE__ */ c.jsx(S, y({}, I, {
      children: /* @__PURE__ */ c.jsx(f0, {
        value: b,
        children: /* @__PURE__ */ c.jsx(Di.Provider, {
          value: f,
          children: o
        })
      })
    }))
  );
}), Ft = tr({
  selectedGameWeek: {},
  selectedGameWeekPrediction: null,
  refreshPrediction: async () => {
  },
  isNavigating: !1
}), Yc = {
  meta: {
    filters: {
      templateId: ""
    }
  },
  data: [
    {
      playerId: "",
      playerModel: {},
      points: 0,
      rank: 0
    }
  ]
}, St = tr({
  template: {},
  templateMatches: [],
  templateGroupMatches: [],
  templatePlayerPoints: Yc
}), Rb = (e, t, r, n) => {
  var a, i, s, l;
  const o = [r, {
    code: t,
    ...n || {}
  }];
  if ((i = (a = e == null ? void 0 : e.services) == null ? void 0 : a.logger) != null && i.forward)
    return e.services.logger.forward(o, "warn", "react-i18next::", !0);
  $t(o[0]) && (o[0] = `react-i18next:: ${o[0]}`), (l = (s = e == null ? void 0 : e.services) == null ? void 0 : s.logger) != null && l.warn ? e.services.logger.warn(...o) : console != null && console.warn && console.warn(...o);
}, Qs = {}, Ta = (e, t, r, n) => {
  $t(r) && Qs[r] || ($t(r) && (Qs[r] = /* @__PURE__ */ new Date()), Rb(e, t, r, n));
}, Xc = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const r = () => {
      setTimeout(() => {
        e.off("initialized", r);
      }, 0), t();
    };
    e.on("initialized", r);
  }
}, Oa = (e, t, r) => {
  e.loadNamespaces(t, Xc(e, r));
}, Hs = (e, t, r, n) => {
  if ($t(r) && (r = [r]), e.options.preload && e.options.preload.indexOf(t) > -1) return Oa(e, r, n);
  r.forEach((o) => {
    e.options.ns.indexOf(o) < 0 && e.options.ns.push(o);
  }), e.loadLanguages(t, Xc(e, n));
}, Ub = (e, t, r = {}) => !t.languages || !t.languages.length ? (Ta(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: r.lng,
  precheck: (n, o) => {
    if (r.bindI18n && r.bindI18n.indexOf("languageChanging") > -1 && n.services.backendConnector.backend && n.isLanguageChangingTo && !o(n.isLanguageChangingTo, e)) return !1;
  }
}), $t = (e) => typeof e == "string", jb = (e) => typeof e == "object" && e !== null, Bb = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, Db = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, Mb = (e) => Db[e], Fb = (e) => e.replace(Bb, Mb);
let Va = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: Fb
};
const qb = (e = {}) => {
  Va = {
    ...Va,
    ...e
  };
}, Jb = () => Va;
let $c;
const Wb = (e) => {
  $c = e;
}, Lb = () => $c, zb = {
  type: "3rdParty",
  init(e) {
    qb(e.options.react), Wb(e);
  }
}, Nb = tr();
class Qb {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((r) => {
      this.usedNamespaces[r] || (this.usedNamespaces[r] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Hb = (e, t) => {
  const r = Jt();
  return Te(() => {
    r.current = e;
  }, [e, t]), r.current;
}, _c = (e, t, r, n) => e.getFixedT(t, r, n), Gb = (e, t, r, n) => Gt(_c(e, t, r, n), [e, t, r, n]), Zb = (e, t = {}) => {
  var k, S, I, w;
  const {
    i18n: r
  } = t, {
    i18n: n,
    defaultNS: o
  } = ue(Nb) || {}, a = r || n || Lb();
  if (a && !a.reportNamespaces && (a.reportNamespaces = new Qb()), !a) {
    Ta(a, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const P = (K, R) => $t(R) ? R : jb(R) && $t(R.defaultValue) ? R.defaultValue : Array.isArray(K) ? K[K.length - 1] : K, E = [P, {}, !1];
    return E.t = P, E.i18n = {}, E.ready = !1, E;
  }
  (k = a.options.react) != null && k.wait && Ta(a, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Jb(),
    ...a.options.react,
    ...t
  }, {
    useSuspense: s,
    keyPrefix: l
  } = i;
  let d = o || ((S = a.options) == null ? void 0 : S.defaultNS);
  d = $t(d) ? [d] : d || ["translation"], (w = (I = a.reportNamespaces).addUsedNamespaces) == null || w.call(I, d);
  const u = (a.isInitialized || a.initializedStoreOnce) && d.every((P) => Ub(P, a, i)), p = Gb(a, t.lng || null, i.nsMode === "fallback" ? d : d[0], l), f = () => p, g = () => _c(a, t.lng || null, i.nsMode === "fallback" ? d : d[0], l), [h, m] = _(f);
  let A = d.join();
  t.lng && (A = `${t.lng}${A}`);
  const b = Hb(A), C = Jt(!0);
  Te(() => {
    const {
      bindI18n: P,
      bindI18nStore: E
    } = i;
    C.current = !0, !u && !s && (t.lng ? Hs(a, t.lng, d, () => {
      C.current && m(g);
    }) : Oa(a, d, () => {
      C.current && m(g);
    })), u && b && b !== A && C.current && m(g);
    const K = () => {
      C.current && m(g);
    };
    return P && (a == null || a.on(P, K)), E && (a == null || a.store.on(E, K)), () => {
      C.current = !1, a && P && (P == null || P.split(" ").forEach((R) => a.off(R, K))), E && a && E.split(" ").forEach((R) => a.store.off(R, K));
    };
  }, [a, A]), Te(() => {
    C.current && u && m(f);
  }, [a, l, u]);
  const v = [h, a, u];
  if (v.t = h, v.i18n = a, v.ready = u, u || !u && !s) return v;
  throw new Promise((P) => {
    t.lng ? Hs(a, t.lng, d, () => P()) : Oa(a, d, () => P());
  });
}, oe = (e) => typeof e == "string", Qr = () => {
  let e, t;
  const r = new Promise((n, o) => {
    e = n, t = o;
  });
  return r.resolve = e, r.reject = t, r;
}, Gs = (e) => e == null ? "" : "" + e, Yb = (e, t, r) => {
  e.forEach((n) => {
    t[n] && (r[n] = t[n]);
  });
}, Xb = /###/g, Zs = (e) => e && e.indexOf("###") > -1 ? e.replace(Xb, ".") : e, Ys = (e) => !e || oe(e), nn = (e, t, r) => {
  const n = oe(t) ? t.split(".") : t;
  let o = 0;
  for (; o < n.length - 1; ) {
    if (Ys(e)) return {};
    const a = Zs(n[o]);
    !e[a] && r && (e[a] = new r()), Object.prototype.hasOwnProperty.call(e, a) ? e = e[a] : e = {}, ++o;
  }
  return Ys(e) ? {} : {
    obj: e,
    k: Zs(n[o])
  };
}, Xs = (e, t, r) => {
  const {
    obj: n,
    k: o
  } = nn(e, t, Object);
  if (n !== void 0 || t.length === 1) {
    n[o] = r;
    return;
  }
  let a = t[t.length - 1], i = t.slice(0, t.length - 1), s = nn(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    a = `${i[i.length - 1]}.${a}`, i = i.slice(0, i.length - 1), s = nn(e, i, Object), s != null && s.obj && typeof s.obj[`${s.k}.${a}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${a}`] = r;
}, $b = (e, t, r, n) => {
  const {
    obj: o,
    k: a
  } = nn(e, t, Object);
  o[a] = o[a] || [], o[a].push(r);
}, so = (e, t) => {
  const {
    obj: r,
    k: n
  } = nn(e, t);
  if (r && Object.prototype.hasOwnProperty.call(r, n))
    return r[n];
}, _b = (e, t, r) => {
  const n = so(e, r);
  return n !== void 0 ? n : so(t, r);
}, ed = (e, t, r) => {
  for (const n in t)
    n !== "__proto__" && n !== "constructor" && (n in e ? oe(e[n]) || e[n] instanceof String || oe(t[n]) || t[n] instanceof String ? r && (e[n] = t[n]) : ed(e[n], t[n], r) : e[n] = t[n]);
  return e;
}, lr = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var e2 = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const t2 = (e) => oe(e) ? e.replace(/[&<>"'\/]/g, (t) => e2[t]) : e;
class r2 {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const r = this.regExpMap.get(t);
    if (r !== void 0)
      return r;
    const n = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, n), this.regExpQueue.push(t), n;
  }
}
const n2 = [" ", ",", "?", "!", ";"], o2 = new r2(20), a2 = (e, t, r) => {
  t = t || "", r = r || "";
  const n = n2.filter((i) => t.indexOf(i) < 0 && r.indexOf(i) < 0);
  if (n.length === 0) return !0;
  const o = o2.getRegExp(`(${n.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let a = !o.test(e);
  if (!a) {
    const i = e.indexOf(r);
    i > 0 && !o.test(e.substring(0, i)) && (a = !0);
  }
  return a;
}, Ea = (e, t, r = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const n = t.split(r);
  let o = e;
  for (let a = 0; a < n.length; ) {
    if (!o || typeof o != "object")
      return;
    let i, s = "";
    for (let l = a; l < n.length; ++l)
      if (l !== a && (s += r), s += n[l], i = o[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < n.length - 1)
          continue;
        a += l - a + 1;
        break;
      }
    o = i;
  }
  return o;
}, gn = (e) => e == null ? void 0 : e.replace("_", "-"), i2 = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    var r, n;
    (n = (r = console == null ? void 0 : console[e]) == null ? void 0 : r.apply) == null || n.call(r, console, t);
  }
};
class lo {
  constructor(t, r = {}) {
    this.init(t, r);
  }
  init(t, r = {}) {
    this.prefix = r.prefix || "i18next:", this.logger = t || i2, this.options = r, this.debug = r.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, r, n, o) {
    return o && !this.debug ? null : (oe(t[0]) && (t[0] = `${n}${this.prefix} ${t[0]}`), this.logger[r](t));
  }
  create(t) {
    return new lo(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new lo(this.logger, t);
  }
}
var Pt = new lo();
class Xo {
  constructor() {
    this.observers = {};
  }
  on(t, r) {
    return t.split(" ").forEach((n) => {
      this.observers[n] || (this.observers[n] = /* @__PURE__ */ new Map());
      const o = this.observers[n].get(r) || 0;
      this.observers[n].set(r, o + 1);
    }), this;
  }
  off(t, r) {
    if (this.observers[t]) {
      if (!r) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(r);
    }
  }
  emit(t, ...r) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, a]) => {
      for (let i = 0; i < a; i++)
        o(...r);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, a]) => {
      for (let i = 0; i < a; i++)
        o.apply(o, [t, ...r]);
    });
  }
}
class $s extends Xo {
  constructor(t, r = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const r = this.options.ns.indexOf(t);
    r > -1 && this.options.ns.splice(r, 1);
  }
  getResource(t, r, n, o = {}) {
    var d, u;
    const a = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, i = o.ignoreJSONStructure !== void 0 ? o.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, r], n && (Array.isArray(n) ? s.push(...n) : oe(n) && a ? s.push(...n.split(a)) : s.push(n)));
    const l = so(this.data, s);
    return !l && !r && !n && t.indexOf(".") > -1 && (t = s[0], r = s[1], n = s.slice(2).join(".")), l || !i || !oe(n) ? l : Ea((u = (d = this.data) == null ? void 0 : d[t]) == null ? void 0 : u[r], n, a);
  }
  addResource(t, r, n, o, a = {
    silent: !1
  }) {
    const i = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let s = [t, r];
    n && (s = s.concat(i ? n.split(i) : n)), t.indexOf(".") > -1 && (s = t.split("."), o = r, r = s[1]), this.addNamespaces(r), Xs(this.data, s, o), a.silent || this.emit("added", t, r, n, o);
  }
  addResources(t, r, n, o = {
    silent: !1
  }) {
    for (const a in n)
      (oe(n[a]) || Array.isArray(n[a])) && this.addResource(t, r, a, n[a], {
        silent: !0
      });
    o.silent || this.emit("added", t, r, n);
  }
  addResourceBundle(t, r, n, o, a, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, r];
    t.indexOf(".") > -1 && (s = t.split("."), o = n, n = r, r = s[1]), this.addNamespaces(r);
    let l = so(this.data, s) || {};
    i.skipCopy || (n = JSON.parse(JSON.stringify(n))), o ? ed(l, n, a) : l = {
      ...l,
      ...n
    }, Xs(this.data, s, l), i.silent || this.emit("added", t, r, n);
  }
  removeResourceBundle(t, r) {
    this.hasResourceBundle(t, r) && delete this.data[t][r], this.removeNamespaces(r), this.emit("removed", t, r);
  }
  hasResourceBundle(t, r) {
    return this.getResource(t, r) !== void 0;
  }
  getResourceBundle(t, r) {
    return r || (r = this.options.defaultNS), this.getResource(t, r);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const r = this.getDataByLanguage(t);
    return !!(r && Object.keys(r) || []).find((o) => r[o] && Object.keys(r[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var td = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, r, n, o) {
    return e.forEach((a) => {
      var i;
      t = ((i = this.processors[a]) == null ? void 0 : i.process(t, r, n, o)) ?? t;
    }), t;
  }
};
const rd = Symbol("i18next/PATH_KEY");
function s2() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let r;
  return t.get = (n, o) => {
    var a;
    return (a = r == null ? void 0 : r.revoke) == null || a.call(r), o === rd ? e : (e.push(o), r = Proxy.revocable(n, t), r.proxy);
  }, Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function Ka(e, t) {
  const {
    [rd]: r
  } = e(s2());
  return r.join((t == null ? void 0 : t.keySeparator) ?? ".");
}
const _s = {}, el = (e) => !oe(e) && typeof e != "boolean" && typeof e != "number";
class co extends Xo {
  constructor(t, r = {}) {
    super(), Yb(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = r, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Pt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, r = {
    interpolation: {}
  }) {
    const n = {
      ...r
    };
    if (t == null) return !1;
    const o = this.resolve(t, n);
    return (o == null ? void 0 : o.res) !== void 0;
  }
  extractFromKey(t, r) {
    let n = r.nsSeparator !== void 0 ? r.nsSeparator : this.options.nsSeparator;
    n === void 0 && (n = ":");
    const o = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let a = r.ns || this.options.defaultNS || [];
    const i = n && t.indexOf(n) > -1, s = !this.options.userDefinedKeySeparator && !r.keySeparator && !this.options.userDefinedNsSeparator && !r.nsSeparator && !a2(t, n, o);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: oe(a) ? [a] : a
        };
      const d = t.split(n);
      (n !== o || n === o && this.options.ns.indexOf(d[0]) > -1) && (a = d.shift()), t = d.join(o);
    }
    return {
      key: t,
      namespaces: oe(a) ? [a] : a
    };
  }
  translate(t, r, n) {
    let o = typeof r == "object" ? {
      ...r
    } : r;
    if (typeof o != "object" && this.options.overloadTranslationOptionHandler && (o = this.options.overloadTranslationOptionHandler(arguments)), typeof o == "object" && (o = {
      ...o
    }), o || (o = {}), t == null) return "";
    typeof t == "function" && (t = Ka(t, {
      ...this.options,
      ...o
    })), Array.isArray(t) || (t = [String(t)]);
    const a = o.returnDetails !== void 0 ? o.returnDetails : this.options.returnDetails, i = o.keySeparator !== void 0 ? o.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], o), d = l[l.length - 1];
    let u = o.nsSeparator !== void 0 ? o.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const p = o.lng || this.language, f = o.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if ((p == null ? void 0 : p.toLowerCase()) === "cimode")
      return f ? a ? {
        res: `${d}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: p,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(o)
      } : `${d}${u}${s}` : a ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: p,
        usedNS: d,
        usedParams: this.getUsedParamsDetails(o)
      } : s;
    const g = this.resolve(t, o);
    let h = g == null ? void 0 : g.res;
    const m = (g == null ? void 0 : g.usedKey) || s, A = (g == null ? void 0 : g.exactUsedKey) || s, b = ["[object Number]", "[object Function]", "[object RegExp]"], C = o.joinArrays !== void 0 ? o.joinArrays : this.options.joinArrays, v = !this.i18nFormat || this.i18nFormat.handleAsObject, k = o.count !== void 0 && !oe(o.count), S = co.hasDefaultValue(o), I = k ? this.pluralResolver.getSuffix(p, o.count, o) : "", w = o.ordinal && k ? this.pluralResolver.getSuffix(p, o.count, {
      ordinal: !1
    }) : "", P = k && !o.ordinal && o.count === 0, E = P && o[`defaultValue${this.options.pluralSeparator}zero`] || o[`defaultValue${I}`] || o[`defaultValue${w}`] || o.defaultValue;
    let K = h;
    v && !h && S && (K = E);
    const R = el(K), B = Object.prototype.toString.apply(K);
    if (v && K && R && b.indexOf(B) < 0 && !(oe(C) && Array.isArray(K))) {
      if (!o.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const V = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, K, {
          ...o,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return a ? (g.res = V, g.usedParams = this.getUsedParamsDetails(o), g) : V;
      }
      if (i) {
        const V = Array.isArray(K), M = V ? [] : {}, j = V ? A : m;
        for (const T in K)
          if (Object.prototype.hasOwnProperty.call(K, T)) {
            const O = `${j}${i}${T}`;
            S && !h ? M[T] = this.translate(O, {
              ...o,
              defaultValue: el(E) ? E[T] : void 0,
              joinArrays: !1,
              ns: l
            }) : M[T] = this.translate(O, {
              ...o,
              joinArrays: !1,
              ns: l
            }), M[T] === O && (M[T] = K[T]);
          }
        h = M;
      }
    } else if (v && oe(C) && Array.isArray(h))
      h = h.join(C), h && (h = this.extendTranslation(h, t, o, n));
    else {
      let V = !1, M = !1;
      !this.isValidLookup(h) && S && (V = !0, h = E), this.isValidLookup(h) || (M = !0, h = s);
      const T = (o.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && M ? void 0 : h, O = S && E !== h && this.options.updateMissing;
      if (M || V || O) {
        if (this.logger.log(O ? "updateKey" : "missingKey", p, d, s, O ? E : h), i) {
          const G = this.resolve(s, {
            ...o,
            keySeparator: !1
          });
          G && G.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let F = [];
        const N = this.languageUtils.getFallbackCodes(this.options.fallbackLng, o.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && N && N[0])
          for (let G = 0; G < N.length; G++)
            F.push(N[G]);
        else this.options.saveMissingTo === "all" ? F = this.languageUtils.toResolveHierarchy(o.lng || this.language) : F.push(o.lng || this.language);
        const te = (G, Z, ie) => {
          var ae;
          const le = S && ie !== h ? ie : T;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(G, d, Z, le, O, o) : (ae = this.backendConnector) != null && ae.saveMissing && this.backendConnector.saveMissing(G, d, Z, le, O, o), this.emit("missingKey", G, d, Z, h);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? F.forEach((G) => {
          const Z = this.pluralResolver.getSuffixes(G, o);
          P && o[`defaultValue${this.options.pluralSeparator}zero`] && Z.indexOf(`${this.options.pluralSeparator}zero`) < 0 && Z.push(`${this.options.pluralSeparator}zero`), Z.forEach((ie) => {
            te([G], s + ie, o[`defaultValue${ie}`] || E);
          });
        }) : te(F, s, E));
      }
      h = this.extendTranslation(h, t, o, g, n), M && h === s && this.options.appendNamespaceToMissingKey && (h = `${d}${u}${s}`), (M || V) && this.options.parseMissingKeyHandler && (h = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${d}${u}${s}` : s, V ? h : void 0, o));
    }
    return a ? (g.res = h, g.usedParams = this.getUsedParamsDetails(o), g) : h;
  }
  extendTranslation(t, r, n, o, a) {
    var l, d;
    if ((l = this.i18nFormat) != null && l.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...n
      }, n.lng || this.language || o.usedLng, o.usedNS, o.usedKey, {
        resolved: o
      });
    else if (!n.skipInterpolation) {
      n.interpolation && this.interpolator.init({
        ...n,
        interpolation: {
          ...this.options.interpolation,
          ...n.interpolation
        }
      });
      const u = oe(t) && (((d = n == null ? void 0 : n.interpolation) == null ? void 0 : d.skipOnVariables) !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let p;
      if (u) {
        const g = t.match(this.interpolator.nestingRegexp);
        p = g && g.length;
      }
      let f = n.replace && !oe(n.replace) ? n.replace : n;
      if (this.options.interpolation.defaultVariables && (f = {
        ...this.options.interpolation.defaultVariables,
        ...f
      }), t = this.interpolator.interpolate(t, f, n.lng || this.language || o.usedLng, n), u) {
        const g = t.match(this.interpolator.nestingRegexp), h = g && g.length;
        p < h && (n.nest = !1);
      }
      !n.lng && o && o.res && (n.lng = this.language || o.usedLng), n.nest !== !1 && (t = this.interpolator.nest(t, (...g) => (a == null ? void 0 : a[0]) === g[0] && !n.context ? (this.logger.warn(`It seems you are nesting recursively key: ${g[0]} in key: ${r[0]}`), null) : this.translate(...g, r), n)), n.interpolation && this.interpolator.reset();
    }
    const i = n.postProcess || this.options.postProcess, s = oe(i) ? [i] : i;
    return t != null && (s != null && s.length) && n.applyPostProcessor !== !1 && (t = td.handle(s, t, r, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...o,
        usedParams: this.getUsedParamsDetails(n)
      },
      ...n
    } : n, this)), t;
  }
  resolve(t, r = {}) {
    let n, o, a, i, s;
    return oe(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(n)) return;
      const d = this.extractFromKey(l, r), u = d.key;
      o = u;
      let p = d.namespaces;
      this.options.fallbackNS && (p = p.concat(this.options.fallbackNS));
      const f = r.count !== void 0 && !oe(r.count), g = f && !r.ordinal && r.count === 0, h = r.context !== void 0 && (oe(r.context) || typeof r.context == "number") && r.context !== "", m = r.lngs ? r.lngs : this.languageUtils.toResolveHierarchy(r.lng || this.language, r.fallbackLng);
      p.forEach((A) => {
        var b, C;
        this.isValidLookup(n) || (s = A, !_s[`${m[0]}-${A}`] && ((b = this.utils) != null && b.hasLoadedNamespace) && !((C = this.utils) != null && C.hasLoadedNamespace(s)) && (_s[`${m[0]}-${A}`] = !0, this.logger.warn(`key "${o}" for languages "${m.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((v) => {
          var I;
          if (this.isValidLookup(n)) return;
          i = v;
          const k = [u];
          if ((I = this.i18nFormat) != null && I.addLookupKeys)
            this.i18nFormat.addLookupKeys(k, u, v, A, r);
          else {
            let w;
            f && (w = this.pluralResolver.getSuffix(v, r.count, r));
            const P = `${this.options.pluralSeparator}zero`, E = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (f && (r.ordinal && w.indexOf(E) === 0 && k.push(u + w.replace(E, this.options.pluralSeparator)), k.push(u + w), g && k.push(u + P)), h) {
              const K = `${u}${this.options.contextSeparator || "_"}${r.context}`;
              k.push(K), f && (r.ordinal && w.indexOf(E) === 0 && k.push(K + w.replace(E, this.options.pluralSeparator)), k.push(K + w), g && k.push(K + P));
            }
          }
          let S;
          for (; S = k.pop(); )
            this.isValidLookup(n) || (a = S, n = this.getResource(v, A, S, r));
        }));
      });
    }), {
      res: n,
      usedKey: o,
      exactUsedKey: a,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, r, n, o = {}) {
    var a;
    return (a = this.i18nFormat) != null && a.getResource ? this.i18nFormat.getResource(t, r, n, o) : this.resourceStore.getResource(t, r, n, o);
  }
  getUsedParamsDetails(t = {}) {
    const r = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], n = t.replace && !oe(t.replace);
    let o = n ? t.replace : t;
    if (n && typeof t.count < "u" && (o.count = t.count), this.options.interpolation.defaultVariables && (o = {
      ...this.options.interpolation.defaultVariables,
      ...o
    }), !n) {
      o = {
        ...o
      };
      for (const a of r)
        delete o[a];
    }
    return o;
  }
  static hasDefaultValue(t) {
    const r = "defaultValue";
    for (const n in t)
      if (Object.prototype.hasOwnProperty.call(t, n) && r === n.substring(0, r.length) && t[n] !== void 0)
        return !0;
    return !1;
  }
}
class tl {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Pt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = gn(t), !t || t.indexOf("-") < 0) return null;
    const r = t.split("-");
    return r.length === 2 || (r.pop(), r[r.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(r.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = gn(t), !t || t.indexOf("-") < 0) return t;
    const r = t.split("-");
    return this.formatLanguageCode(r[0]);
  }
  formatLanguageCode(t) {
    if (oe(t) && t.indexOf("-") > -1) {
      let r;
      try {
        r = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return r && this.options.lowerCaseLng && (r = r.toLowerCase()), r || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let r;
    return t.forEach((n) => {
      if (r) return;
      const o = this.formatLanguageCode(n);
      (!this.options.supportedLngs || this.isSupportedCode(o)) && (r = o);
    }), !r && this.options.supportedLngs && t.forEach((n) => {
      if (r) return;
      const o = this.getScriptPartFromCode(n);
      if (this.isSupportedCode(o)) return r = o;
      const a = this.getLanguagePartFromCode(n);
      if (this.isSupportedCode(a)) return r = a;
      r = this.options.supportedLngs.find((i) => {
        if (i === a) return i;
        if (!(i.indexOf("-") < 0 && a.indexOf("-") < 0) && (i.indexOf("-") > 0 && a.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === a || i.indexOf(a) === 0 && a.length > 1))
          return i;
      });
    }), r || (r = this.getFallbackCodes(this.options.fallbackLng)[0]), r;
  }
  getFallbackCodes(t, r) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(r)), oe(t) && (t = [t]), Array.isArray(t)) return t;
    if (!r) return t.default || [];
    let n = t[r];
    return n || (n = t[this.getScriptPartFromCode(r)]), n || (n = t[this.formatLanguageCode(r)]), n || (n = t[this.getLanguagePartFromCode(r)]), n || (n = t.default), n || [];
  }
  toResolveHierarchy(t, r) {
    const n = this.getFallbackCodes((r === !1 ? [] : r) || this.options.fallbackLng || [], t), o = [], a = (i) => {
      i && (this.isSupportedCode(i) ? o.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return oe(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && a(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && a(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && a(this.getLanguagePartFromCode(t))) : oe(t) && a(this.formatLanguageCode(t)), n.forEach((i) => {
      o.indexOf(i) < 0 && a(this.formatLanguageCode(i));
    }), o;
  }
}
const rl = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, nl = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class l2 {
  constructor(t, r = {}) {
    this.languageUtils = t, this.options = r, this.logger = Pt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, r) {
    this.rules[t] = r;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, r = {}) {
    const n = gn(t === "dev" ? "en" : t), o = r.ordinal ? "ordinal" : "cardinal", a = JSON.stringify({
      cleanedCode: n,
      type: o
    });
    if (a in this.pluralRulesCache)
      return this.pluralRulesCache[a];
    let i;
    try {
      i = new Intl.PluralRules(n, {
        type: o
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), nl;
      if (!t.match(/-|_/)) return nl;
      const l = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(l, r);
    }
    return this.pluralRulesCache[a] = i, i;
  }
  needsPlural(t, r = {}) {
    let n = this.getRule(t, r);
    return n || (n = this.getRule("dev", r)), (n == null ? void 0 : n.resolvedOptions().pluralCategories.length) > 1;
  }
  getPluralFormsOfKey(t, r, n = {}) {
    return this.getSuffixes(t, n).map((o) => `${r}${o}`);
  }
  getSuffixes(t, r = {}) {
    let n = this.getRule(t, r);
    return n || (n = this.getRule("dev", r)), n ? n.resolvedOptions().pluralCategories.sort((o, a) => rl[o] - rl[a]).map((o) => `${this.options.prepend}${r.ordinal ? `ordinal${this.options.prepend}` : ""}${o}`) : [];
  }
  getSuffix(t, r, n = {}) {
    const o = this.getRule(t, n);
    return o ? `${this.options.prepend}${n.ordinal ? `ordinal${this.options.prepend}` : ""}${o.select(r)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", r, n));
  }
}
const ol = (e, t, r, n = ".", o = !0) => {
  let a = _b(e, t, r);
  return !a && o && oe(r) && (a = Ea(e, r, n), a === void 0 && (a = Ea(t, r, n))), a;
}, da = (e) => e.replace(/\$/g, "$$$$");
class c2 {
  constructor(t = {}) {
    var r;
    this.logger = Pt.create("interpolator"), this.options = t, this.format = ((r = t == null ? void 0 : t.interpolation) == null ? void 0 : r.format) || ((n) => n), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: r,
      escapeValue: n,
      useRawValueToEscape: o,
      prefix: a,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: d,
      unescapeSuffix: u,
      unescapePrefix: p,
      nestingPrefix: f,
      nestingPrefixEscaped: g,
      nestingSuffix: h,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: A,
      maxReplaces: b,
      alwaysFormat: C
    } = t.interpolation;
    this.escape = r !== void 0 ? r : t2, this.escapeValue = n !== void 0 ? n : !0, this.useRawValueToEscape = o !== void 0 ? o : !1, this.prefix = a ? lr(a) : i || "{{", this.suffix = s ? lr(s) : l || "}}", this.formatSeparator = d || ",", this.unescapePrefix = u ? "" : p || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = f ? lr(f) : g || lr("$t("), this.nestingSuffix = h ? lr(h) : m || lr(")"), this.nestingOptionsSeparator = A || ",", this.maxReplaces = b || 1e3, this.alwaysFormat = C !== void 0 ? C : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (r, n) => (r == null ? void 0 : r.source) === n ? (r.lastIndex = 0, r) : new RegExp(n, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, r, n, o) {
    var g;
    let a, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, d = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const C = ol(r, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(C, void 0, n, {
          ...o,
          ...r,
          interpolationkey: h
        }) : C;
      }
      const m = h.split(this.formatSeparator), A = m.shift().trim(), b = m.join(this.formatSeparator).trim();
      return this.format(ol(r, l, A, this.options.keySeparator, this.options.ignoreJSONStructure), b, n, {
        ...o,
        ...r,
        interpolationkey: A
      });
    };
    this.resetRegExp();
    const u = (o == null ? void 0 : o.missingInterpolationHandler) || this.options.missingInterpolationHandler, p = ((g = o == null ? void 0 : o.interpolation) == null ? void 0 : g.skipOnVariables) !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => da(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? da(this.escape(h)) : da(h)
    }].forEach((h) => {
      for (s = 0; a = h.regex.exec(t); ) {
        const m = a[1].trim();
        if (i = d(m), i === void 0)
          if (typeof u == "function") {
            const b = u(t, a, o);
            i = oe(b) ? b : "";
          } else if (o && Object.prototype.hasOwnProperty.call(o, m))
            i = "";
          else if (p) {
            i = a[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${m} for interpolating ${t}`), i = "";
        else !oe(i) && !this.useRawValueToEscape && (i = Gs(i));
        const A = h.safeValue(i);
        if (t = t.replace(a[0], A), p ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= a[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, r, n = {}) {
    let o, a, i;
    const s = (l, d) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const p = l.split(new RegExp(`${u}[ ]*{`));
      let f = `{${p[1]}`;
      l = p[0], f = this.interpolate(f, i);
      const g = f.match(/'/g), h = f.match(/"/g);
      (((g == null ? void 0 : g.length) ?? 0) % 2 === 0 && !h || h.length % 2 !== 0) && (f = f.replace(/'/g, '"'));
      try {
        i = JSON.parse(f), d && (i = {
          ...d,
          ...i
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${f}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; o = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...n
      }, i = i.replace && !oe(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const d = /{.*}/.test(o[1]) ? o[1].lastIndexOf("}") + 1 : o[1].indexOf(this.formatSeparator);
      if (d !== -1 && (l = o[1].slice(d).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), o[1] = o[1].slice(0, d)), a = r(s.call(this, o[1].trim(), i), i), a && o[0] === t && !oe(a)) return a;
      oe(a) || (a = Gs(a)), a || (this.logger.warn(`missed to resolve ${o[1]} for nesting ${t}`), a = ""), l.length && (a = l.reduce((u, p) => this.format(u, p, n.lng, {
        ...n,
        interpolationkey: o[1].trim()
      }), a.trim())), t = t.replace(o[0], a), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const d2 = (e) => {
  let t = e.toLowerCase().trim();
  const r = {};
  if (e.indexOf("(") > -1) {
    const n = e.split("(");
    t = n[0].toLowerCase().trim();
    const o = n[1].substring(0, n[1].length - 1);
    t === "currency" && o.indexOf(":") < 0 ? r.currency || (r.currency = o.trim()) : t === "relativetime" && o.indexOf(":") < 0 ? r.range || (r.range = o.trim()) : o.split(";").forEach((i) => {
      if (i) {
        const [s, ...l] = i.split(":"), d = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        r[u] || (r[u] = d), d === "false" && (r[u] = !1), d === "true" && (r[u] = !0), isNaN(d) || (r[u] = parseInt(d, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: r
  };
}, al = (e) => {
  const t = {};
  return (r, n, o) => {
    let a = o;
    o && o.interpolationkey && o.formatParams && o.formatParams[o.interpolationkey] && o[o.interpolationkey] && (a = {
      ...a,
      [o.interpolationkey]: void 0
    });
    const i = n + JSON.stringify(a);
    let s = t[i];
    return s || (s = e(gn(n), o), t[i] = s), s(r);
  };
}, u2 = (e) => (t, r, n) => e(gn(r), n)(t);
class p2 {
  constructor(t = {}) {
    this.logger = Pt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, r = {
    interpolation: {}
  }) {
    this.formatSeparator = r.interpolation.formatSeparator || ",";
    const n = r.cacheInBuiltFormats ? al : u2;
    this.formats = {
      number: n((o, a) => {
        const i = new Intl.NumberFormat(o, {
          ...a
        });
        return (s) => i.format(s);
      }),
      currency: n((o, a) => {
        const i = new Intl.NumberFormat(o, {
          ...a,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: n((o, a) => {
        const i = new Intl.DateTimeFormat(o, {
          ...a
        });
        return (s) => i.format(s);
      }),
      relativetime: n((o, a) => {
        const i = new Intl.RelativeTimeFormat(o, {
          ...a
        });
        return (s) => i.format(s, a.range || "day");
      }),
      list: n((o, a) => {
        const i = new Intl.ListFormat(o, {
          ...a
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, r) {
    this.formats[t.toLowerCase().trim()] = r;
  }
  addCached(t, r) {
    this.formats[t.toLowerCase().trim()] = al(r);
  }
  format(t, r, n, o = {}) {
    const a = r.split(this.formatSeparator);
    if (a.length > 1 && a[0].indexOf("(") > 1 && a[0].indexOf(")") < 0 && a.find((s) => s.indexOf(")") > -1)) {
      const s = a.findIndex((l) => l.indexOf(")") > -1);
      a[0] = [a[0], ...a.splice(1, s)].join(this.formatSeparator);
    }
    return a.reduce((s, l) => {
      var p;
      const {
        formatName: d,
        formatOptions: u
      } = d2(l);
      if (this.formats[d]) {
        let f = s;
        try {
          const g = ((p = o == null ? void 0 : o.formatParams) == null ? void 0 : p[o.interpolationkey]) || {}, h = g.locale || g.lng || o.locale || o.lng || n;
          f = this.formats[d](s, h, {
            ...u,
            ...o,
            ...g
          });
        } catch (g) {
          this.logger.warn(g);
        }
        return f;
      } else
        this.logger.warn(`there was no format function for ${d}`);
      return s;
    }, t);
  }
}
const f2 = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class g2 extends Xo {
  constructor(t, r, n, o = {}) {
    var a, i;
    super(), this.backend = t, this.store = r, this.services = n, this.languageUtils = n.languageUtils, this.options = o, this.logger = Pt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = o.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = o.maxRetries >= 0 ? o.maxRetries : 5, this.retryTimeout = o.retryTimeout >= 1 ? o.retryTimeout : 350, this.state = {}, this.queue = [], (i = (a = this.backend) == null ? void 0 : a.init) == null || i.call(a, n, o.backend, o);
  }
  queueLoad(t, r, n, o) {
    const a = {}, i = {}, s = {}, l = {};
    return t.forEach((d) => {
      let u = !0;
      r.forEach((p) => {
        const f = `${d}|${p}`;
        !n.reload && this.store.hasResourceBundle(d, p) ? this.state[f] = 2 : this.state[f] < 0 || (this.state[f] === 1 ? i[f] === void 0 && (i[f] = !0) : (this.state[f] = 1, u = !1, i[f] === void 0 && (i[f] = !0), a[f] === void 0 && (a[f] = !0), l[p] === void 0 && (l[p] = !0)));
      }), u || (s[d] = !0);
    }), (Object.keys(a).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: o
    }), {
      toLoad: Object.keys(a),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, r, n) {
    const o = t.split("|"), a = o[0], i = o[1];
    r && this.emit("failedLoading", a, i, r), !r && n && this.store.addResourceBundle(a, i, n, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = r ? -1 : 2, r && n && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      $b(l.loaded, [a], i), f2(l, t), r && l.errors.push(r), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((d) => {
        s[d] || (s[d] = {});
        const u = l.loaded[d];
        u.length && u.forEach((p) => {
          s[d][p] === void 0 && (s[d][p] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, r, n, o = 0, a = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: r,
        fcName: n,
        tried: o,
        wait: a,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (d, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const p = this.waitingReads.shift();
        this.read(p.lng, p.ns, p.fcName, p.tried, p.wait, p.callback);
      }
      if (d && u && o < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, r, n, o + 1, a * 2, i);
        }, a);
        return;
      }
      i(d, u);
    }, l = this.backend[n].bind(this.backend);
    if (l.length === 2) {
      try {
        const d = l(t, r);
        d && typeof d.then == "function" ? d.then((u) => s(null, u)).catch(s) : s(null, d);
      } catch (d) {
        s(d);
      }
      return;
    }
    return l(t, r, s);
  }
  prepareLoading(t, r, n = {}, o) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), o && o();
    oe(t) && (t = this.languageUtils.toResolveHierarchy(t)), oe(r) && (r = [r]);
    const a = this.queueLoad(t, r, n, o);
    if (!a.toLoad.length)
      return a.pending.length || o(), null;
    a.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, r, n) {
    this.prepareLoading(t, r, {}, n);
  }
  reload(t, r, n) {
    this.prepareLoading(t, r, {
      reload: !0
    }, n);
  }
  loadOne(t, r = "") {
    const n = t.split("|"), o = n[0], a = n[1];
    this.read(o, a, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${r}loading namespace ${a} for language ${o} failed`, i), !i && s && this.logger.log(`${r}loaded namespace ${a} for language ${o}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, r, n, o, a, i = {}, s = () => {
  }) {
    var l, d, u, p, f;
    if ((d = (l = this.services) == null ? void 0 : l.utils) != null && d.hasLoadedNamespace && !((p = (u = this.services) == null ? void 0 : u.utils) != null && p.hasLoadedNamespace(r))) {
      this.logger.warn(`did not save key "${n}" as the namespace "${r}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(n == null || n === "")) {
      if ((f = this.backend) != null && f.create) {
        const g = {
          ...i,
          isUpdate: a
        }, h = this.backend.create.bind(this.backend);
        if (h.length < 6)
          try {
            let m;
            h.length === 5 ? m = h(t, r, n, o, g) : m = h(t, r, n, o), m && typeof m.then == "function" ? m.then((A) => s(null, A)).catch(s) : s(null, m);
          } catch (m) {
            s(m);
          }
        else
          h(t, r, n, o, s, g);
      }
      !t || !t[0] || this.store.addResource(t[0], r, n, o);
    }
  }
}
const il = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), oe(e[1]) && (t.defaultValue = e[1]), oe(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const r = e[3] || e[2];
      Object.keys(r).forEach((n) => {
        t[n] = r[n];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), sl = (e) => {
  var t, r;
  return oe(e.ns) && (e.ns = [e.ns]), oe(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), oe(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), ((r = (t = e.supportedLngs) == null ? void 0 : t.indexOf) == null ? void 0 : r.call(t, "cimode")) < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e;
}, Mn = () => {
}, h2 = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((r) => {
    typeof e[r] == "function" && (e[r] = e[r].bind(e));
  });
};
class hn extends Xo {
  constructor(t = {}, r) {
    if (super(), this.options = sl(t), this.services = {}, this.logger = Pt, this.modules = {
      external: []
    }, h2(this), r && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, r), this;
      setTimeout(() => {
        this.init(t, r);
      }, 0);
    }
  }
  init(t = {}, r) {
    this.isInitializing = !0, typeof t == "function" && (r = t, t = {}), t.defaultNS == null && t.ns && (oe(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const n = il();
    this.options = {
      ...n,
      ...this.options,
      ...sl(t)
    }, this.options.interpolation = {
      ...n.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const o = (d) => d ? typeof d == "function" ? new d() : d : null;
    if (!this.options.isClone) {
      this.modules.logger ? Pt.init(o(this.modules.logger), this.options) : Pt.init(null, this.options);
      let d;
      this.modules.formatter ? d = this.modules.formatter : d = p2;
      const u = new tl(this.options);
      this.store = new $s(this.options.resources, this.options);
      const p = this.services;
      p.logger = Pt, p.resourceStore = this.store, p.languageUtils = u, p.pluralResolver = new l2(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== n.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), d && (!this.options.interpolation.format || this.options.interpolation.format === n.interpolation.format) && (p.formatter = o(d), p.formatter.init && p.formatter.init(p, this.options), this.options.interpolation.format = p.formatter.format.bind(p.formatter)), p.interpolator = new c2(this.options), p.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, p.backendConnector = new g2(o(this.modules.backend), p.resourceStore, p, this.options), p.backendConnector.on("*", (g, ...h) => {
        this.emit(g, ...h);
      }), this.modules.languageDetector && (p.languageDetector = o(this.modules.languageDetector), p.languageDetector.init && p.languageDetector.init(p, this.options.detection, this.options)), this.modules.i18nFormat && (p.i18nFormat = o(this.modules.i18nFormat), p.i18nFormat.init && p.i18nFormat.init(this)), this.translator = new co(this.services, this.options), this.translator.on("*", (g, ...h) => {
        this.emit(g, ...h);
      }), this.modules.external.forEach((g) => {
        g.init && g.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, r || (r = Mn), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const d = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      d.length > 0 && d[0] !== "dev" && (this.options.lng = d[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((d) => {
      this[d] = (...u) => this.store[d](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((d) => {
      this[d] = (...u) => (this.store[d](...u), this);
    });
    const s = Qr(), l = () => {
      const d = (u, p) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), s.resolve(p), r(u, p);
      };
      if (this.languages && !this.isInitialized) return d(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, d);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), s;
  }
  loadResources(t, r = Mn) {
    var a, i;
    let n = r;
    const o = oe(t) ? t : this.language;
    if (typeof t == "function" && (n = t), !this.options.resources || this.options.partialBundledLanguages) {
      if ((o == null ? void 0 : o.toLowerCase()) === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return n();
      const s = [], l = (d) => {
        if (!d || d === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(d).forEach((p) => {
          p !== "cimode" && s.indexOf(p) < 0 && s.push(p);
        });
      };
      o ? l(o) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((u) => l(u)), (i = (a = this.options.preload) == null ? void 0 : a.forEach) == null || i.call(a, (d) => l(d)), this.services.backendConnector.load(s, this.options.ns, (d) => {
        !d && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), n(d);
      });
    } else
      n(null);
  }
  reloadResources(t, r, n) {
    const o = Qr();
    return typeof t == "function" && (n = t, t = void 0), typeof r == "function" && (n = r, r = void 0), t || (t = this.languages), r || (r = this.options.ns), n || (n = Mn), this.services.backendConnector.reload(t, r, (a) => {
      o.resolve(), n(a);
    }), o;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && td.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let r = 0; r < this.languages.length; r++) {
        const n = this.languages[r];
        if (!(["cimode", "dev"].indexOf(n) > -1) && this.store.hasLanguageSomeTranslations(n)) {
          this.resolvedLanguage = n;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, r) {
    this.isLanguageChangingTo = t;
    const n = Qr();
    this.emit("languageChanging", t);
    const o = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, a = (s, l) => {
      l ? this.isLanguageChangingTo === t && (o(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, n.resolve((...d) => this.t(...d)), r && r(s, (...d) => this.t(...d));
    }, i = (s) => {
      var u, p;
      !t && !s && this.services.languageDetector && (s = []);
      const l = oe(s) ? s : s && s[0], d = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(oe(s) ? [s] : s);
      d && (this.language || o(d), this.translator.language || this.translator.changeLanguage(d), (p = (u = this.services.languageDetector) == null ? void 0 : u.cacheUserLanguage) == null || p.call(u, d)), this.loadResources(d, (f) => {
        a(f, d);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), n;
  }
  getFixedT(t, r, n) {
    const o = (a, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([a, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || o.lng, l.lngs = l.lngs || o.lngs, l.ns = l.ns || o.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || n || o.keyPrefix);
      const d = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(a) ? u = a.map((p) => (typeof p == "function" && (p = Ka(p, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${d}${p}`)) : (typeof a == "function" && (a = Ka(a, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${d}${a}` : a), this.t(u, l);
    };
    return oe(t) ? o.lng = t : o.lngs = t, o.ns = r, o.keyPrefix = n, o;
  }
  t(...t) {
    var r;
    return (r = this.translator) == null ? void 0 : r.translate(...t);
  }
  exists(...t) {
    var r;
    return (r = this.translator) == null ? void 0 : r.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, r = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const n = r.lng || this.resolvedLanguage || this.languages[0], o = this.options ? this.options.fallbackLng : !1, a = this.languages[this.languages.length - 1];
    if (n.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const d = this.services.backendConnector.state[`${s}|${l}`];
      return d === -1 || d === 0 || d === 2;
    };
    if (r.precheck) {
      const s = r.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(n, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(n, t) && (!o || i(a, t)));
  }
  loadNamespaces(t, r) {
    const n = Qr();
    return this.options.ns ? (oe(t) && (t = [t]), t.forEach((o) => {
      this.options.ns.indexOf(o) < 0 && this.options.ns.push(o);
    }), this.loadResources((o) => {
      n.resolve(), r && r(o);
    }), n) : (r && r(), Promise.resolve());
  }
  loadLanguages(t, r) {
    const n = Qr();
    oe(t) && (t = [t]);
    const o = this.options.preload || [], a = t.filter((i) => o.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return a.length ? (this.options.preload = o.concat(a), this.loadResources((i) => {
      n.resolve(), r && r(i);
    }), n) : (r && r(), Promise.resolve());
  }
  dir(t) {
    var o, a;
    if (t || (t = this.resolvedLanguage || (((o = this.languages) == null ? void 0 : o.length) > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const i = new Intl.Locale(t);
      if (i && i.getTextInfo) {
        const s = i.getTextInfo();
        if (s && s.direction) return s.direction;
      }
    } catch {
    }
    const r = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], n = ((a = this.services) == null ? void 0 : a.languageUtils) || new tl(il());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : r.indexOf(n.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, r) {
    return new hn(t, r);
  }
  cloneInstance(t = {}, r = Mn) {
    const n = t.forkResourceStore;
    n && delete t.forkResourceStore;
    const o = {
      ...this.options,
      ...t,
      isClone: !0
    }, a = new hn(o);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (a.logger = a.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      a[s] = this[s];
    }), a.services = {
      ...this.services
    }, a.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, n) {
      const s = Object.keys(this.store.data).reduce((l, d) => (l[d] = {
        ...this.store.data[d]
      }, l[d] = Object.keys(l[d]).reduce((u, p) => (u[p] = {
        ...l[d][p]
      }, u), l[d]), l), {});
      a.store = new $s(s, o), a.services.resourceStore = a.store;
    }
    return a.translator = new co(a.services, o), a.translator.on("*", (s, ...l) => {
      a.emit(s, ...l);
    }), a.init(o, r), a.translator.options = o, a.translator.backendConnector.services.utils = {
      hasLoadedNamespace: a.hasLoadedNamespace.bind(a)
    }, a;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const He = hn.createInstance();
He.createInstance = hn.createInstance;
He.createInstance;
He.dir;
He.init;
He.loadResources;
He.reloadResources;
He.use;
He.changeLanguage;
He.getFixedT;
He.t;
He.exists;
He.setDefaultNamespace;
He.hasLoadedNamespace;
He.loadNamespaces;
He.loadLanguages;
const m2 = {
  en: {
    translation: {
      // Common
      yes: "Yes",
      no: "No",
      loading: "Loading...",
      saving: "Saving...",
      save: "Save",
      cancel: "Cancel",
      confirm: "Confirm",
      close: "Close",
      edit: "Edit",
      delete: "Delete",
      back: "Back",
      next: "Next",
      previous: "Previous",
      all: "All",
      filter: "Filter",
      retry: "Retry",
      list: "List",
      select: "Select",
      remove: "Remove",
      action: "Action",
      total: "Total",
      // Navigation & Gameweek
      gameweek: "Gameweek",
      round: "Round",
      upcoming: "Upcoming",
      past: "Past",
      active: "Active",
      deadline: "Deadline",
      transferDeadline: "Transfer Deadline",
      teamSelectionDeadline: "Team Selection Deadline",
      // Time units
      days: "DAYS",
      hours: "HOURS",
      minutes: "MIN.",
      seconds: "SEC.",
      // Team Management
      team: "Team",
      myTeam: "My Team",
      pickTeam: "Pick Team",
      pickYourTeam: "Pick your team",
      editTeam: "Edit Team",
      saveTeam: "Save Team",
      updateTeam: "Update Team",
      deleteTeam: "Delete Team",
      teamSaved: "Team Saved",
      teamUpdated: "Team Updated",
      failedToSubmitTeam: "Failed to submit team. Please try again.",
      yourFormation: "Your formation",
      changingFormation: "Changing Formation?",
      selectFormation: "Select Formation",
      saveFormation: "Save Formation",
      saveNewFormation: "Save new formation ({{formation}})",
      keepCurrentFormation: "Keep current formation ({{formation}})",
      chooseNewFormation: "Choose a new formation to continue or revert back to the previous formation.",
      removePlayerToChangeFormation: "You have changed the formation from {{oldFormation}} to {{newFormation}}. To continue, please remove one {{position}} player.",
      confirmDeleteTeam: "Are you sure you want to delete your current team? This action cannot be undone.",
      goodJob: "Good Job, {{username}}!",
      teamReady: "Your BW Fantasy Football team is ready!",
      accountNotRequired: "You do not need to have a Betway account to play BW Fantasy Football, however to redeem a weekly cash prize for coming in the Top 10 in any week, you need to have a Betway account for those cash prizes to be deposited into.",
      seeRulesForPrizes: "See the Rules and Ts & Cs of the game for details of the weekly and overall cash prizes.",
      openBetwayAccount: "Open a Betway Account",
      skipForNow: "Skip for now",
      fetchMyLatestTeam: "Fetch my latest team",
      fetchingTeam: "Fetching team...",
      addPlayer: "Add Player",
      // Players
      player: "Player",
      players: "Players",
      searchPlayers: "Search Players",
      searchPlayer: "Search player",
      playerSelection: "Player Selection",
      captain: "Captain",
      viceCaptain: "Vice Captain",
      selectCaptain: "Select Captain",
      selectViceCaptain: "Select Vice Captain",
      selectCaptainAndViceCaptain: "Select Captain & Vice-Captain",
      position: "Position",
      points: "Points",
      totalPoints: "Total Points",
      pts: "pts",
      totalPts: "Total pts",
      matchweekPts: "MW pts",
      maxPlayersPerTeam: "You can select a maximum of 2 players from each team",
      noPlayersFound: "No players found matching your criteria",
      saveSelection: "Save Selection",
      // Positions
      goalkeeper: "Goalkeeper",
      goalkeepers: "Goalkeepers",
      defender: "Defender",
      defenders: "Defenders",
      midfielder: "Midfielder",
      midfielders: "Midfielders",
      forward: "Forward",
      forwards: "Forwards",
      // Stats & Performance
      stats: "Stats",
      matches: "Matches",
      profile: "Profile",
      performance: "Performance",
      form: "Form",
      average: "Average",
      myPoints: "My Points",
      highest: "Highest",
      // Messages & Notifications
      noDataAvailable: "No data available",
      seasonComplete: "Season Complete!",
      checkFinalStandings: "Check your final standings in the leaderboard.",
      noPredictionMade: "No prediction made for this round",
      matchweekNotActive: "Matchweek is not active",
      gameWeekNotActiveMessage: "This game week is not yet active. Once it becomes active, you will be able to place your predictions.",
      goBackTo: "Go back to",
      deadlineMissed: "Deadline Missed",
      noTeamSelectedMessage: "You didn't select a team for this match week, so you have not earned any points.",
      removePlayer: "Remove Player?",
      confirmRemovePlayer: "Are you sure you want to remove",
      yesRemove: "Yes, remove",
      noCancel: "No, cancel",
      // Errors
      error: "Error",
      somethingWentWrong: "Something went wrong",
      tryAgain: "Try again"
    }
  },
  bg: {
    translation: {
      // Common
      yes: "Да",
      no: "Не",
      loading: "Зареждане...",
      saving: "Запазване...",
      save: "Запази",
      cancel: "Отказ",
      confirm: "Потвърди",
      close: "Затвори",
      edit: "Редактирай",
      delete: "Изтрий",
      back: "Назад",
      next: "Напред",
      previous: "Предишен",
      all: "Всички",
      filter: "Филтър",
      retry: "Опитай отново",
      list: "Списък",
      select: "Избери",
      remove: "Премахни",
      action: "Действие",
      total: "Общо",
      // Navigation & Gameweek
      gameweek: "Кръг",
      round: "Кръг",
      upcoming: "Предстоящ",
      past: "Минал",
      active: "Активен",
      deadline: "Краен срок",
      transferDeadline: "Краен срок за трансфери",
      teamSelectionDeadline: "Краен срок за избор на отбор",
      // Time units
      days: "ДНИ",
      hours: "ЧАСОВЕ",
      minutes: "МИН.",
      seconds: "СЕК.",
      // Team Management
      team: "Отбор",
      myTeam: "Моят отбор",
      pickTeam: "Избери отбор",
      pickYourTeam: "Изберете вашия отбор",
      editTeam: "Редактирай отбор",
      saveTeam: "Запази отбор",
      updateTeam: "Обнови отбор",
      deleteTeam: "Изтрий отбор",
      teamSaved: "Отборът е запазен",
      teamUpdated: "Отборът е обновен",
      failedToSubmitTeam: "Неуспешно изпращане на отбора. Моля, опитайте отново.",
      yourFormation: "Вашата формация",
      changingFormation: "Смяна на формацията?",
      selectFormation: "Изберете формация",
      saveFormation: "Запази формация",
      saveNewFormation: "Запази нова формация ({{formation}})",
      keepCurrentFormation: "Запази текуща формация ({{formation}})",
      chooseNewFormation: "Изберете нова формация, за да продължите, или се върнете към предишната формация.",
      removePlayerToChangeFormation: "Променихте формацията от {{oldFormation}} на {{newFormation}}. За да продължите, моля премахнете един {{position}} играч.",
      confirmDeleteTeam: "Сигурни ли сте, че искате да изтриете текущия си отбор? Това действие не може да бъде отменено.",
      goodJob: "Браво, {{username}}!",
      teamReady: "Вашият BW Fantasy Football отбор е готов!",
      accountNotRequired: "Не е необходимо да имате Betway акаунт, за да играете BW Fantasy Football, но за да получите седмичната парична награда за влизане в топ 10 в която и да е седмица, трябва да имате Betway акаунт, в който да бъдат депозирани паричните награди.",
      seeRulesForPrizes: "Вижте правилата и общите условия на играта за подробности относно седмичните и общите парични награди.",
      openBetwayAccount: "Отворете Betway акаунт",
      skipForNow: "Пропусни засега",
      fetchMyLatestTeam: "Зареди последния ми отбор",
      fetchingTeam: "Зареждане на отбор...",
      addPlayer: "Добави играч",
      // Players
      player: "Играч",
      players: "Играчи",
      searchPlayers: "Търси играчи",
      searchPlayer: "Търси играч",
      playerSelection: "Избор на играчи",
      captain: "Капитан",
      viceCaptain: "Вице-капитан",
      selectCaptain: "Избери капитан",
      selectViceCaptain: "Избери вице-капитан",
      selectCaptainAndViceCaptain: "Избери капитан и вице-капитан",
      position: "Позиция",
      points: "Точки",
      totalPoints: "Общо точки",
      pts: "т.",
      totalPts: "Общо т.",
      matchweekPts: "Кръг т.",
      maxPlayersPerTeam: "Можете да изберете максимум 2 играча от всеки отбор",
      noPlayersFound: "Няма намерени играчи, отговарящи на критериите",
      saveSelection: "Запази избора",
      // Positions
      goalkeeper: "Вратар",
      goalkeepers: "Вратари",
      defender: "Защитник",
      defenders: "Защитници",
      midfielder: "Халф",
      midfielders: "Халфове",
      forward: "Нападател",
      forwards: "Нападатели",
      // Stats & Performance
      stats: "Статистики",
      matches: "Мачове",
      profile: "Профил",
      performance: "Представяне",
      form: "Форма",
      average: "Средно",
      myPoints: "Моите точки",
      highest: "Най-високо",
      // Messages & Notifications
      noDataAvailable: "Няма налични данни",
      seasonComplete: "Сезонът приключи!",
      checkFinalStandings: "Проверете финалното си класиране в таблицата.",
      noPredictionMade: "Няма направена прогноза за този кръг",
      matchweekNotActive: "Кръгът не е активен",
      gameWeekNotActiveMessage: "Този кръг все още не е активен. След като стане активен, ще можете да направите прогнозите си.",
      goBackTo: "Върни се към",
      deadlineMissed: "Пропуснат краен срок",
      noTeamSelectedMessage: "Не сте избрали отбор за този кръг, затова не сте спечелили точки.",
      removePlayer: "Премахни играч?",
      confirmRemovePlayer: "Сигурни ли сте, че искате да премахнете",
      yesRemove: "Да, премахни",
      noCancel: "Не, отказ",
      // Errors
      error: "Грешка",
      somethingWentWrong: "Нещо се обърка",
      tryAgain: "Опитай отново"
    }
  },
  es: {
    translation: {
      // Common
      yes: "Sí",
      no: "No",
      loading: "Cargando...",
      saving: "Guardando...",
      save: "Guardar",
      cancel: "Cancelar",
      confirm: "Confirmar",
      close: "Cerrar",
      edit: "Editar",
      delete: "Eliminar",
      back: "Atrás",
      next: "Siguiente",
      previous: "Anterior",
      all: "Todos",
      filter: "Filtro",
      retry: "Reintentar",
      list: "Lista",
      select: "Seleccionar",
      remove: "Eliminar",
      action: "Acción",
      total: "Total",
      // Navigation & Gameweek
      gameweek: "Jornada",
      round: "Ronda",
      week: "Semana",
      leaderboard: "Clasificación",
      myTeam: "Mi Equipo",
      pickYourTeam: "Elige tu equipo",
      viewTeam: "Ver equipo",
      editTeam: "Editar equipo",
      team: "Equipo",
      field: "Campo",
      // Team Management
      saveTeam: "Guardar equipo",
      updateTeam: "Actualizar equipo",
      deleteTeam: "Eliminar equipo",
      teamSaved: "Equipo guardado",
      teamUpdated: "Equipo actualizado",
      failedToSubmitTeam: "Error al enviar el equipo. Por favor, inténtalo de nuevo.",
      yourFormation: "Tu formación",
      changingFormation: "¿Cambiar formación?",
      selectFormation: "Seleccionar formación",
      saveFormation: "Guardar formación",
      saveNewFormation: "Guardar nueva formación ({{formation}})",
      keepCurrentFormation: "Mantener formación actual ({{formation}})",
      chooseNewFormation: "Elige una nueva formación para continuar o vuelve a la formación anterior.",
      removePlayerToChangeFormation: "Has cambiado la formación de {{oldFormation}} a {{newFormation}}. Para continuar, por favor elimina un jugador {{position}}.",
      confirmDeleteTeam: "¿Estás seguro de que quieres eliminar tu equipo actual? Esta acción no se puede deshacer.",
      goodJob: "¡Buen trabajo, {{username}}!",
      teamReady: "¡Tu equipo de BW Fantasy Football está listo!",
      accountNotRequired: "No necesitas tener una cuenta de Betway para jugar BW Fantasy Football, sin embargo, para canjear un premio en efectivo semanal por estar en el Top 10 en cualquier semana, necesitas tener una cuenta de Betway para que los premios en efectivo se depositen en ella.",
      seeRulesForPrizes: "Consulta las Reglas y Términos y Condiciones del juego para obtener detalles sobre los premios en efectivo semanales y generales.",
      openBetwayAccount: "Abrir una cuenta de Betway",
      skipForNow: "Omitir por ahora",
      fetchMyLatestTeam: "Cargar mi último equipo",
      fetchingTeam: "Cargando equipo...",
      addPlayer: "Añadir jugador",
      // Players
      player: "Jugador",
      players: "Jugadores",
      searchPlayer: "Buscar jugador",
      playerSelection: "Selección de jugadores",
      captain: "Capitán",
      viceCaptain: "Vicecapitán",
      selectCaptain: "Seleccionar capitán",
      selectViceCaptain: "Seleccionar vicecapitán",
      selectCaptainAndViceCaptain: "Seleccionar capitán y vicecapitán",
      position: "Posición",
      points: "Puntos",
      totalPoints: "Puntos totales",
      pts: "pts.",
      totalPts: "Total pts.",
      matchweekPts: "Pts. jornada",
      maxPlayersPerTeam: "Puedes seleccionar un máximo de 2 jugadores de cada equipo",
      noPlayersFound: "No se encontraron jugadores que coincidan con tus criterios",
      saveSelection: "Guardar selección",
      // Positions
      goalkeeper: "Portero",
      goalkeepers: "Porteros",
      defender: "Defensa",
      defenders: "Defensas",
      midfielder: "Centrocampista",
      midfielders: "Centrocampistas",
      forward: "Delantero",
      forwards: "Delanteros",
      // Stats & Performance
      stats: "Estadísticas",
      matches: "Partidos",
      profile: "Perfil",
      performance: "Rendimiento",
      form: "Forma",
      average: "Promedio",
      myPoints: "Mis puntos",
      highest: "Más alto",
      // Messages & Notifications
      noDataAvailable: "No hay datos disponibles",
      seasonComplete: "¡Temporada completada!",
      checkFinalStandings: "Consulta tu clasificación final en la tabla de posiciones.",
      noPredictionMade: "No se hizo ninguna predicción para esta jornada",
      matchweekNotActive: "La jornada no está activa",
      gameWeekNotActiveMessage: "Esta jornada aún no está activa. Una vez que esté activa, podrás hacer tus predicciones.",
      goBackTo: "Volver a",
      deadlineMissed: "Plazo perdido",
      noTeamSelectedMessage: "No seleccionaste un equipo para esta jornada, por lo que no has ganado puntos.",
      removePlayer: "¿Eliminar jugador?",
      confirmRemovePlayer: "¿Estás seguro de que quieres eliminar a",
      yesRemove: "Sí, eliminar",
      noCancel: "No, cancelar",
      // Errors
      error: "Error",
      somethingWentWrong: "Algo salió mal",
      tryAgain: "Intentar de nuevo"
    }
  }
}, v2 = () => {
  const e = "en";
  return ["en", "bg", "es"].includes(e) ? e : "en";
};
He.use(zb).init({
  resources: m2,
  lng: v2(),
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
    // React already escapes values
  },
  // Enable debug mode in development
  debug: !1,
  // Namespace configuration
  defaultNS: "translation",
  ns: ["translation"]
});
const b2 = (e) => {
  ["en", "bg", "es"].includes(e) && He.changeLanguage(e);
}, nd = tr(void 0), x2 = ({ children: e, language: t }) => {
  const { t: r, i18n: n } = Zb();
  Te(() => {
    t && t !== n.language && b2(t);
  }, [t, n.language]);
  const o = {
    t: r,
    currentLanguage: n.language
  };
  return /* @__PURE__ */ c.jsx(nd.Provider, { value: o, children: e });
}, y2 = () => {
  const e = ue(nd);
  if (!e)
    throw new Error("useTranslationContext must be used within a TranslationProvider");
  return e;
}, Be = () => {
  const { t: e } = y2();
  return e;
}, Dr = tr(""), A2 = { BASE_URL: "/", DEV: !1, MODE: "production", PROD: !0, SSR: !1, VITE_DEV: "true", VITE_FANS_UNITED_API_KEY: "AIzaSyD5zoNgXowU9tJjUUONGwwIxsFOfYaKpdc", VITE_FANS_UNITED_CLIENT_ID: "blog_betway_com", VITE_FANS_UNITED_ENV: "prod", VITE_FANS_UNITED_ID_SCHEMA: "native", VITE_FANS_UNITED_ID_TOKEN: "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICIwZF9RRWdnUjRWUmFVYXpoNEtSVlBidVVUMVN4dG1NWnYtY0JudHM2TVlrIn0.eyJleHAiOjE3NjU4NzI5OTYsImlhdCI6MTc2NTc4NjU5NiwiYXV0aF90aW1lIjoxNzY1Nzg2NTI4LCJqdGkiOiI5YjgxYjQzMC0zMWVkLTRlYTEtYWNjMS0wOWE2YjNjODQ0YTMiLCJpc3MiOiJodHRwczovL2F1dGguYmV0d2F5c2NvcmVzLmNvbS9yZWFsbXMvYndzY29yZXMiLCJhdWQiOiJhY2NvdW50LWNvbnNvbGUiLCJzdWIiOiI3NjQ5YWQ2Ni05MzkyLTQyMTYtYjk4ZS03MmEyNTJmOTVhNjkiLCJ0eXAiOiJJRCIsImF6cCI6ImFjY291bnQtY29uc29sZSIsIm5vbmNlIjoiMGY0NmQ5YjYtODc0Yy00MTFkLWI1MjEtOGU3YWQ5ZDhiMWEzIiwic2lkIjoiYWE1Yzc5NmUtN2I3Ni00M2U5LThkNTAtMWQ0MmM1YjM0NmJkIiwiYXRfaGFzaCI6Ikl6aXozYWVIMk9HWW1GRXNXdmxXcnciLCJhY3IiOiIwIn0.FS2jj3pPXjriBVIFnYeHX1iCSWn12DYIhIi9iUiWtLldD5YJMCpvuMHKBEiljJ7009gDReIA-F_DcEbYAg-xW8TUD8nrAX_Ls1-2NXgVMHS0KUFwd-GhuEeH9U251pv9Va_B5MZPavSBwWefxfQghmUqFEdU2dBQ2elD1d96Q3wY2qR5df0C_irjh1hNV1SFoHIrfxhLu-gX-VAkiVtmayzabEiVSmTUERttjTRZL5fQSQ9M0-CdM71AfdrreJhW8WoAIh4nr2b5EdDlp9KTTVfEjf0xeQlZdPer5Fr5hIJmFGNFw59n_kVp-rVDFn5qgdYlmsNN6irEQtzw4Dm41A", VITE_FANS_UNITED_LANGUAGE: "en", VITE_FIREBASE_API_KEY: "AIzaSyCPIT64ew7sjt3gkOX8LN4y8LEpsHdBU-o", VITE_FIREBASE_APP_ID: "1:1002265506806:web:bda05e54c83989a4098dd7", VITE_FIREBASE_AUTH_DOMAIN: "fans-united-client-blog-betway.firebaseapp.com", VITE_GAME_TEMPLATE_ID: "257FxYRDvcbsBVxOKOY6s8", VITE_GA_MEASUREMENT_ID: "G-L4L6BHWS7M", VITE_GOOGLE_CLOUD_CREDENTIALS: '{"type":"service_account","project_id":"example","private_key_id":"xxx","private_key":"-----BEGIN PRIVATE KEY-----\\nxxxxx\\n-----END PRIVATE KEY-----\\n","client_email":"application@exmaple.iam.gserviceaccount.com","client_id":"xxxxx","auth_uri":"https://accounts.google.com/o/oauth2/auth","token_uri":"https://oauth2.googleapis.com/token","auth_provider_x509_cert_url":"https://www.googleapis.com/oauth2/v1/certs","client_x509_cert_url":"https://www.googleapis.com/robot/v1/metadata/x509/application%40example.iam.gserviceaccount.com"}', VITE_GOOGLE_CLOUD_DATABASE: "(default)", VITE_GOOGLE_CLOUD_PROJECT: "fans-united-client-blog-betway", VITE_GOOGLE_CLOUD_REGION: "us-central1", VITE_LANGUAGE: "en" }, C2 = (e) => A2[e], Or = (e) => {
  const t = e ? e.trim() : "", r = t.split(" ");
  let n = t;
  return r.length > 1 && (n = `${r[0].charAt(0)}. ${r.slice(-1)}`), n.length > 11 && r.slice(-1)[0].length < 10 ? r.slice(-1)[0] : n;
}, S2 = (e) => {
  const t = new Date(e), r = /* @__PURE__ */ new Date(), n = t.getTime() - r.getTime();
  let o = {
    days: "00",
    hours: "00",
    minutes: "00"
  };
  return n > 0 && (o = {
    days: String(Math.floor(n / (1e3 * 60 * 60 * 24))).padStart(2, "0"),
    hours: String(Math.floor(n / (1e3 * 60 * 60) % 24)).padStart(2, "0"),
    minutes: String(Math.floor(n / 1e3 / 60 % 60)).padStart(2, "0")
  }), o;
}, Ra = (e) => {
  if (e.length === 0)
    return (/* @__PURE__ */ new Date()).toISOString();
  const t = e.map((n) => new Date(n.kickoffAt)), r = new Date(Math.min(...t.map((n) => n.getTime())));
  return r.setMinutes(r.getMinutes() - 15), r.toISOString();
}, od = (e) => {
  const t = { day: "2-digit", month: "short" }, r = e.toLocaleDateString("en-GB", t), n = e.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" });
  return `${r} at ${n}`;
}, k2 = (e) => e ? e.nickname && e.nickname.trim() ? e.nickname.trim() : e.name && e.name.trim() ? I2(e.name.trim()) : "Anonymous" : "Anonymous", I2 = (e) => {
  if (!e || !e.trim()) return "Anonymous";
  const r = e.trim().split(/\s+/);
  if (r.length === 1)
    return r[0];
  const n = r[0], o = r[r.length - 1].charAt(0).toUpperCase();
  return `${n} ${o}.`;
}, w2 = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20width='256'%20height='256'%20viewBox='0%200%20256%20256'%3e%3cdefs%3e%3cclipPath%20id='clip-path'%3e%3cpath%20id='Path_190'%20data-name='Path%20190'%20d='M190.044,146.03c-1.243,11.218,4.625,30.859,2.451,43.527l-.208,1.035c-1.518,7.007,1.209,37.176,3.625,47.255-15.533,11.045-39.937,18.191-67.586,18.191a149.006,149.006,0,0,1-31.549-3.28c-14.359-3.141-26.751-8.318-36-14.911,1.035-4.28,2.727-27.821,3.348-32.033.828-5.764,1.139-11.149.242-15.222-1.657-7.732.035-13.22,1.346-25.4.794-7.7,1.415-14.7.932-19.192q-.207-1.863-.414-4.245c-.414-4.453-.794-9.941-1.139-15.257-.449-6.628-.828-12.979-1.035-16.5-.1-1.829-.138-2.9-.138-2.9L58.6,117.208c-1.968-.346-3.97-.76-5.9-1.208a145.327,145.327,0,0,1-31.2-11.909s11.149-30.79,12.5-37.107c1.346-6.248,2.623-38.8,24.473-43.975,15.706-3.728,31.273-11.7,39.454-16.948a1.5,1.5,0,0,0,.242-.138c2.692-1.726,4.556-2.8,5.316-3.624l.241-.242a.942.942,0,0,1,.242-.276,5.392,5.392,0,0,1,.449-.449c2.278-1.933,5.868-.656,10.044.759C119.11,3.645,128.4,3.4,128.4,3.4s9.32.242,13.98-1.312C147,.538,150.866-1.222,153.11,1.746S176.651,17.9,198.363,23.078c21.849,5.178,23.126,37.728,24.473,43.975,1.38,6.282,12.495,37.107,12.495,37.107s-18.26,9.941-37.107,13.151L192.909,107.2s-.863,15.74-1.83,28.3C190.665,139.541,190.354,143.268,190.044,146.03Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23134fba'/%3e%3c/clipPath%3e%3cclipPath%20id='clip-path-2'%3e%3cpath%20id='Path_188'%20data-name='Path%20188'%20d='M158.715,6.033c-.069-.069-.173-.1-.242-.173-2.108-1.377-4.55-2.987-5.719-4.534a6.71,6.71,0,0,1,.187,3.956A14.958,14.958,0,0,1,150.9,9.6c-5.523,8.836-12.841,17.19-22.678,22.229A32.914,32.914,0,0,0,143.4,28.177,32.918,32.918,0,0,0,155.185,17.95l.31-.414c1.795-2.589,3.349-5.419,3.521-8.491A12.124,12.124,0,0,0,158.715,6.033Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23fff'/%3e%3c/clipPath%3e%3cclipPath%20id='clip-path-3'%3e%3cpath%20id='Path_189'%20data-name='Path%20189'%20d='M97.736,6.192c.069-.069.173-.1.242-.173,2.108-1.377,4.646-2.7,5.976-4.262a6.2,6.2,0,0,0-.186,3.8,12.829,12.829,0,0,0,1.78,4.042c5.523,8.837,12.841,17.19,22.679,22.229a32.916,32.916,0,0,1-15.173-3.649A32.919,32.919,0,0,1,101.268,17.95l-.31-.414c-1.8-2.589-3.349-5.419-3.521-8.491A10.915,10.915,0,0,1,97.736,6.192Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23fff'/%3e%3c/clipPath%3e%3cclipPath%20id='clip-France_fc_t-shirt_-_No_Logo'%3e%3crect%20width='256'%20height='256'/%3e%3c/clipPath%3e%3c/defs%3e%3cg%20id='France_fc_t-shirt_-_No_Logo'%20data-name='France%20fc%20t-shirt%20-%20No%20Logo'%20clip-path='url(%23clip-France_fc_t-shirt_-_No_Logo)'%3e%3cg%20id='Group_81'%20data-name='Group%2081'%3e%3cpath%20id='Path_132'%20data-name='Path%20132'%20d='M190.044,146.03c-1.243,11.218,4.625,30.859,2.451,43.527l-.208,1.035c-1.518,7.007,1.209,37.176,3.625,47.255-15.533,11.045-39.937,18.191-67.586,18.191a149.006,149.006,0,0,1-31.549-3.28c-14.359-3.141-26.751-8.318-36-14.911,1.035-4.28,2.727-27.821,3.348-32.033.828-5.764,1.139-11.149.242-15.222-1.657-7.732.035-13.22,1.346-25.4.794-7.7,1.415-14.7.932-19.192q-.207-1.863-.414-4.245c-.414-4.453-.794-9.941-1.139-15.257-.449-6.628-.828-12.979-1.035-16.5-.1-1.829-.138-2.9-.138-2.9L58.6,117.208c-1.968-.346-3.97-.76-5.9-1.208a145.327,145.327,0,0,1-31.2-11.909s11.149-30.79,12.5-37.107c1.346-6.248,2.623-38.8,24.473-43.975,15.706-3.728,31.273-11.7,39.454-16.948a1.5,1.5,0,0,0,.242-.138c2.692-1.726,4.556-2.8,5.316-3.624l.241-.242a.942.942,0,0,1,.242-.276,5.392,5.392,0,0,1,.449-.449c2.278-1.933,5.868-.656,10.044.759C119.11,3.645,128.4,3.4,128.4,3.4s9.32.242,13.98-1.312C147,.538,150.866-1.222,153.11,1.746S176.651,17.9,198.363,23.078c21.849,5.178,23.126,37.728,24.473,43.975,1.38,6.282,12.495,37.107,12.495,37.107s-18.26,9.941-37.107,13.151L192.909,107.2s-.863,15.74-1.83,28.3C190.665,139.541,190.354,143.268,190.044,146.03Z'%20transform='translate(-0.412%20-0.138)'%20fill='%23134fba'/%3e%3cg%20id='Mask_Group_12'%20data-name='Mask%20Group%2012'%20transform='translate(0%20-0.05)'%20clip-path='url(%23clip-path)'%3e%3cg%20id='Group_80'%20data-name='Group%2080'%3e%3cg%20id='Group_59'%20data-name='Group%2059'%20transform='translate(-0.412%20-0.088)'%3e%3cg%20id='Group_58'%20data-name='Group%2058'%20opacity='0.2'%3e%3cg%20id='Group_56'%20data-name='Group%2056'%20opacity='0.5'%3e%3cpath%20id='Path_133'%20data-name='Path%20133'%20d='M50.967,229.584c5.908,3.559,36.9,22.889,76.329,22.687,39.362-.208,72.3-18.354,79.342-22.1'%20fill='none'%20stroke='%23000'%20stroke-linecap='round'%20stroke-width='1.333'/%3e%3c/g%3e%3cg%20id='Group_57'%20data-name='Group%2057'%20opacity='0.7'%3e%3cpath%20id='Path_134'%20data-name='Path%20134'%20d='M51.225,227.684c5.892,3.56,36.778,22.889,76.09,22.687,38.768-.2,71.292-17.974,78.945-22.019'%20fill='none'%20stroke='%23000'%20stroke-linecap='round'%20stroke-width='1.333'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cpath%20id='Path_135'%20data-name='Path%20135'%20d='M103.574,2.18A34.949,34.949,0,0,1,101.2,7.8a46.419,46.419,0,0,1-3.762,6.389,44.7,44.7,0,0,1-5.64,6.685c-.356.345-.725.689-1.092,1.009a62.158,62.158,0,0,1-8.965,6.555,103.427,103.427,0,0,1-10.058,5.379c-3.824,1.817-7.956,3.681-10.153,7.315-2.755,4.548-1.579,10.331-.617,15.568,3.052,16.6,3.024,33.521,3,50.395L58.6,117.205a117.837,117.837,0,0,1-23.8-7.012c-1.176-.463-2.414-.983-3.459-1.434-1.314-.572-2.4-1.042-3.527-1.568-1.245-.568-2.3-1.07-3.254-1.544C22.609,104.7,21.5,104.1,21.5,104.1S32.65,73.325,34,67.032c1.342-6.246,2.575-38.812,24.424-43.99,15.71-3.728,31.042-11.58,39.224-16.817A47.042,47.042,0,0,0,103.574,2.18Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23174caa'%20opacity='0.7'/%3e%3cpath%20id='Path_136'%20data-name='Path%20136'%20d='M153.465,2.148a35,35,0,0,0,2.159,5.711,46.478,46.478,0,0,0,3.762,6.389,44.771,44.771,0,0,0,5.641,6.685c.356.345.725.689,1.092,1.009a62.176,62.176,0,0,0,8.966,6.555,103.4,103.4,0,0,0,10.057,5.379c3.824,1.817,7.956,3.681,10.153,7.315,2.755,4.548,1.58,10.331.618,15.567-3.052,16.6-3.031,33.561-3.007,50.435l5.315,10.116a117.65,117.65,0,0,0,23.787-7.03c1.175-.463,2.466-1.006,3.512-1.457,1.314-.572,2.363-1.028,3.492-1.554,1.244-.569,2.324-1.089,3.281-1.563,1.947-.95,3.037-1.548,3.037-1.548S224.2,73.394,222.848,67.1c-1.342-6.246-2.585-38.831-24.434-44.009-15.743-3.77-31-11.584-39.246-16.789A33.338,33.338,0,0,1,153.465,2.148Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23174caa'%20opacity='0.7'/%3e%3cg%20id='Group_60'%20data-name='Group%2060'%20transform='translate(-0.412%20-0.088)'%3e%3cpath%20id='Path_137'%20data-name='Path%20137'%20d='M193.92,115.043c2.181-.369,7.234-1.3,9.363-1.812a137.717,137.717,0,0,0,19.167-6.247c1.267-.5,2.659-1.084,3.785-1.57,1.417-.617,2.548-1.108,3.765-1.676,1.341-.613,2.505-1.174,3.537-1.684,2.1-1.024,5.443-2.744,5.443-2.744'%20fill='none'%20stroke='%231c5ac9'%20stroke-width='10'/%3e%3c/g%3e%3cg%20id='Group_61'%20data-name='Group%2061'%20transform='translate(-0.412%20-0.088)'%3e%3cpath%20id='Path_138'%20data-name='Path%20138'%20d='M62.906,115.043c-2.181-.369-7.234-1.3-9.362-1.812a137.7,137.7,0,0,1-19.167-6.247c-1.267-.5-2.659-1.084-3.785-1.57-1.417-.617-2.548-1.108-3.764-1.676-1.342-.613-2.505-1.174-3.537-1.684-2.1-1.024-5.444-2.744-5.444-2.744'%20fill='none'%20stroke='%231c5ac9'%20stroke-width='10'/%3e%3c/g%3e%3cpath%20id='Path_139'%20data-name='Path%20139'%20d='M60.781,237.849c1.036-4.246,2.728-27.794,3.35-32.006.828-5.764,1.139-11.149.242-15.222-1.657-7.732.035-13.22,1.346-25.4.767-7.669,1.433-14.583.95-19.07-.138-1.243-.294-2.78-.432-4.367-.414-4.453-.794-9.941-1.139-15.257,8.043,11.046,16.187,22.053,24.23,33.075-1.691,1.623-4.453.1-6.041-1.622s-3.417-3.866-5.7-3.452c-2.727.518-3.348,4.073-3.176,6.835a52.116,52.116,0,0,0,18.156,35.726c1.139.966,2.416,2.554,1.484,3.693-1,1.277-2.934.138-4.384-.518-3.279-1.484-7.352.242-9.458,3.107-2.14,2.9-2.658,6.662-2.623,10.252.069,8.9,3.245,17.569,7.974,25.094a84.082,84.082,0,0,0,11.388,14.079C82.659,249.714,70.032,244.442,60.781,237.849Zm124.175-68.643c.1-1.657-.069-3.693-1.554-4.418-1.38-.656-2.934.241-4.176,1.139-11.426,8.042-22.609,17.086-36.071,20.779,11.632-8.008,23.4-16.119,32.9-26.578a64.369,64.369,0,0,0,15.025-24.623c-.366,3.786-.734,7.847-1.045,10.609-1.159,11.93,4.645,30.709,2.451,43.526a48.305,48.305,0,0,1-10.77,11.564c-6.489,5.074-13.98,8.767-21.573,11.978A59.227,59.227,0,0,0,184.956,169.206Zm-39.143-11.563a77.39,77.39,0,0,0,21.3-15.188,123.7,123.7,0,0,0,10.7-12.15c1.208-1.554,2.416-3.107,3.589-4.695.346-.483,2.348-3.969,3.107-2.45a1.919,1.919,0,0,1-.069,1.38c-3.383,9.734-9.769,19.848-18.087,26.1-6.213,4.694-13.359,6.972-20.849,8.525a3.8,3.8,0,0,1-.656.069C143.673,159.3,144.984,158.057,145.813,157.643Z'%20transform='translate(-0.412%20-0.088)'%20opacity='0.1'/%3e%3cpath%20id='Path_140'%20data-name='Path%20140'%20d='M192.9,107.153s-.08.987-.149,2.816a29.605,29.605,0,0,0-5.444-8.763.457.457,0,0,1-.108-.343.467.467,0,0,1,.056-.175.459.459,0,0,1,.121-.138.376.376,0,0,1,.2-.1.372.372,0,0,1,.218.031,11.008,11.008,0,0,0,2.124.362.924.924,0,0,0,1-.829,1.011,1.011,0,0,0-.069-.449c-2.278-5.212-4.644-14.583-3.746-14.134a4.321,4.321,0,0,1,2.5,3.054c.311,1.312.311,2.692.656,3.97a3.979,3.979,0,0,0,2.52,2.934c1.312.311,2.9-.863,2.589-2.175,1.519.759.034,6.351,1.1,3.141a75.888,75.888,0,0,1,8.147-16.638.482.482,0,0,1,.621-.138.4.4,0,0,1,.173.483l-6.662,21.953c-.346,1.174-.587,2.693.414,3.383,1.173.794,2.658-.483,3.383-1.726s1.622-2.761,3.072-2.623c1.139,0-1.588,8.94-1.485,15.049-1.933.484-3.935.9-5.9,1.208ZM52.6,115.977c.1-6.11-2.658-14.962-1.484-14.962,1.415-.138,2.347,1.416,3.072,2.624s2.209,2.52,3.383,1.726c1.035-.656.794-2.209.414-3.383L51.322,80.029a.443.443,0,0,1,.311-.552.4.4,0,0,1,.483.173,77.45,77.45,0,0,1,8.146,16.637c1.07,3.245-.449-2.382,1.1-3.141-.345,1.312,1.277,2.485,2.589,2.175a3.978,3.978,0,0,0,2.52-2.934c.345-1.277.345-2.658.656-3.97a4.114,4.114,0,0,1,2.313-3.107c.9-.414-1.277,8.975-3.555,14.187a.909.909,0,0,0,.185,1.007.922.922,0,0,0,.3.2,1.026,1.026,0,0,0,.449.069,9.19,9.19,0,0,0,1.933-.414.479.479,0,0,1,.587.31.564.564,0,0,1-.069.414,30.05,30.05,0,0,0-5.212,8.906c-.1-1.829-.138-2.9-.138-2.9L58.605,117.2C56.612,116.846,54.638,116.458,52.6,115.977Zm162.171-8.438c-1.105-.242-.622-9.009-.587-10.183.069-2.865.173-5.7.276-8.56.035-1.312-.207-3.314-1.381-3.245a1.973,1.973,0,0,0-1.208.69c-1,.932-2,1.864-2.968,2.8-.345.311-2.106,2.209-2.209.759a2.307,2.307,0,0,1,.241-1.07A33.656,33.656,0,0,1,214.7,76.853a1.7,1.7,0,0,1,.794-.483c.379-.1.69.1.759.967a161.16,161.16,0,0,1-.1,25.819c-.138,1.346-.207,3.072-.9,4.108-.1.138-.242.276-.38.276Zm-173.286-.31c-.69-1-.759-2.762-.9-4.108a153.553,153.553,0,0,1-.1-25.819c.069-.828.38-1.036.759-.967a2.339,2.339,0,0,1,.794.483A34.128,34.128,0,0,1,49.8,88.693a2.312,2.312,0,0,1,.242,1.07c-.1,1.45-1.864-.449-2.209-.759-1-.932-2-1.829-2.969-2.8a2.239,2.239,0,0,0-1.208-.69c-1.174-.069-1.415,1.933-1.381,3.245.1,2.865.207,5.7.276,8.56.035,1.174.518,9.941-.587,10.183h-.035C41.726,107.539,41.588,107.4,41.484,107.229Z'%20transform='translate(-0.412%20-0.088)'%20opacity='0.1'/%3e%3cpath%20id='Path_141'%20data-name='Path%20141'%20d='M98.922,5.456a37.442,37.442,0,0,0,4.469-3.078c.317-.317.73-.764,1.067-1.064,2.213-1.972,6.086-.537,10.262.878,5.107,1.5,14.042,1.206,14.042,1.206s9.452.21,13.959-1.406c4.785-1.715,8.334-3.095,10.485-.12a10.8,10.8,0,0,0,1.384,1.252c.5.4,1.039.812,1.574,1.184a16.961,16.961,0,0,1-1.3,4.686c-4.13,8.986-16.677,20.369-26.626,22.834A45.346,45.346,0,0,1,108,20.141C104.518,16.529,99.929,10.539,98.922,5.456Z'%20transform='translate(-0.412%20-0.088)'%20fill='%230d3f98'/%3e%3cpath%20id='Path_142'%20data-name='Path%20142'%20d='M158.445,5.844a46.465,46.465,0,0,1-3.876-2.738,13.662,13.662,0,0,1-2-1.971,4.456,4.456,0,0,0-1.017-.662c-2.341-1-5.493.377-9.137,1.612-4.626,1.553-14.161,1.309-14.161,1.309s-9.275.247-13.931-1.345c-4.185-1.405-7.637-2.606-9.876-.752a3.385,3.385,0,0,0-.5.491,1.986,1.986,0,0,0-.242.276c-.587.759-2.867,2.17-5.46,3.805l4.919,1.967c-1.381-4.453,6.282-3,10.666-1.07,4.383,1.9,14.428,1.553,14.428,1.553s10.394.355,14.777-1.544c4.384-1.933,12.047-3.348,10.666,1.07Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23134fba'/%3e%3cpath%20id='Path_143'%20data-name='Path%20143'%20d='M158.715,6.033c-.069-.069-.173-.1-.242-.173-2.108-1.377-4.55-2.987-5.719-4.534a6.71,6.71,0,0,1,.187,3.956A14.958,14.958,0,0,1,150.9,9.6c-5.523,8.836-12.841,17.19-22.678,22.229A32.914,32.914,0,0,0,143.4,28.177,32.918,32.918,0,0,0,155.185,17.95l.31-.414c1.795-2.589,3.349-5.419,3.521-8.491A12.124,12.124,0,0,0,158.715,6.033Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23fff'/%3e%3cpath%20id='Path_144'%20data-name='Path%20144'%20d='M97.736,6.192c.069-.069.173-.1.242-.173,2.108-1.377,4.646-2.7,5.976-4.262a6.2,6.2,0,0,0-.186,3.8,12.829,12.829,0,0,0,1.78,4.042c5.523,8.837,12.841,17.19,22.679,22.229a32.916,32.916,0,0,1-15.173-3.649A32.919,32.919,0,0,1,101.268,17.95l-.31-.414c-1.8-2.589-3.349-5.419-3.521-8.491A10.915,10.915,0,0,1,97.736,6.192Z'%20transform='translate(-0.412%20-0.088)'%20fill='%23fff'/%3e%3cg%20id='Mask_Group_10'%20data-name='Mask%20Group%2010'%20clip-path='url(%23clip-path-2)'%3e%3cg%20id='Group_62'%20data-name='Group%2062'%20transform='translate(-0.412%20-0.088)'%3e%3cpath%20id='Path_145'%20data-name='Path%20145'%20d='M157.653,4.507a16.721,16.721,0,0,1,.363,3.537c-.172,3.072-1.726,5.9-3.521,8.491l-.31.414A32.919,32.919,0,0,1,142.4,27.177c-4.692,2.415-9.9,4.666-15.172,4.649'%20fill='none'%20stroke='%23dc2937'%20stroke-width='3'/%3e%3cpath%20id='Path_146'%20data-name='Path%20146'%20d='M153.653.507a16.721,16.721,0,0,1,.363,3.537A30.161,30.161,0,0,1,138.4,24.177c-4.692,2.415-9.9,4.666-15.172,4.649'%20fill='none'%20stroke='%23134fba'%20stroke-width='3'/%3e%3c/g%3e%3c/g%3e%3cg%20id='Mask_Group_11'%20data-name='Mask%20Group%2011'%20clip-path='url(%23clip-path-3)'%3e%3cg%20id='Group_63'%20data-name='Group%2063'%20transform='translate(-0.412%20-0.088)'%3e%3cpath%20id='Path_147'%20data-name='Path%20147'%20d='M98.821,4.405a17.738,17.738,0,0,0-.384,3.64c.173,3.072,1.726,5.9,3.521,8.491l.31.414a32.918,32.918,0,0,0,11.786,10.227c4.692,2.415,9.9,4.667,15.173,4.649'%20fill='none'%20stroke='%23dc2937'%20stroke-width='3'/%3e%3cpath%20id='Path_148'%20data-name='Path%20148'%20d='M102.821-1.595a17.71,17.71,0,0,0-.384,3.64c.384,10.233,10.034,19.744,16.617,23.133,4.692,2.415,9.9,4.667,15.173,4.649'%20fill='none'%20stroke='%23134fba'%20stroke-width='3'/%3e%3c/g%3e%3c/g%3e%3c/g%3e%3c/g%3e%3cpath%20id='Path_149'%20data-name='Path%20149'%20d='M189.545,145.974h0c-.575,5.189.35,12.127,1.3,19.265l.07.525c.98,7.363,1.955,14.922,1.407,21.171a32.84,32.84,0,0,1-.527,3.555,46.272,46.272,0,0,0-.425,9.033c.08,3.985.355,8.738.753,13.584.777,9.476,2.027,19.347,3.222,24.525-15.44,10.86-39.61,17.9-67.022,17.9h0a148.466,148.466,0,0,1-31.443-3.268c-14.17-3.1-26.393-8.185-35.547-14.638.249-1.2.525-3.345.809-5.949.314-2.879.643-6.359.958-9.832.152-1.672.3-3.34.442-4.94.45-5.064.839-9.437,1.073-11.023v0a50.677,50.677,0,0,0,.224-10.773c-.071-1.075-.156-2.143-.241-3.211-.191-2.4-.382-4.813-.42-7.32a57.646,57.646,0,0,1,.624-8.262c.113-.875.236-1.788.366-2.75.327-2.423.7-5.151,1.038-8.329v0c.792-7.679,1.422-14.745.932-19.3v0q-.206-1.857-.413-4.234v0c-.413-4.445-.793-9.927-1.138-15.243h0c-.449-6.625-.828-12.974-1.035-16.494-.052-.912-.086-1.635-.107-2.129-.011-.247-.018-.437-.023-.565l-.005-.145v-.048h0l-.061-1.894-.881,1.677-5.146,9.79c-1.841-.33-3.708-.719-5.515-1.138A135.867,135.867,0,0,1,31.08,108.1c-2.856-1.237-5.2-2.35-6.82-3.153-.812-.4-1.446-.726-1.875-.949l-.274-.143.334-.928c.308-.855.749-2.083,1.282-3.576,1.067-2.986,2.5-7.033,3.981-11.279,2.95-8.47,6.088-17.785,6.769-20.982.173-.8.343-2.018.548-3.507l.033-.241c.2-1.449.435-3.162.742-5.055a85.8,85.8,0,0,1,3.209-13.531c3.2-9.515,8.9-18.732,19.567-21.259h0c15.757-3.74,31.359-11.728,39.58-17a2,2,0,0,0,.278-.161c.6-.386,1.169-.743,1.693-1.073.63-.4,1.2-.754,1.685-1.073a11.335,11.335,0,0,0,2.02-1.548l.235-.234.047-.047.033-.058a.418.418,0,0,1,.112-.128l.038-.029.031-.035a5.066,5.066,0,0,1,.4-.4A4.674,4.674,0,0,1,108.64.95a33.58,33.58,0,0,1,5.4,1.531l.247.084h0a36.569,36.569,0,0,0,8.855,1.263c1.461.067,2.775.086,3.724.087.474,0,.858,0,1.123-.006L128.3,3.9l.08,0h.031l.08,0,.307.005c.266,0,.651.007,1.127.006.952,0,2.27-.02,3.736-.087a36.652,36.652,0,0,0,8.872-1.263h0c.484-.162.954-.325,1.412-.484A27.8,27.8,0,0,1,148.705.718a5.27,5.27,0,0,1,2.284.09,3.321,3.321,0,0,1,1.72,1.24A10.5,10.5,0,0,0,154.5,3.7c.853.666,1.966,1.453,3.3,2.325,2.668,1.745,6.233,3.842,10.406,6.006a136.621,136.621,0,0,0,30.041,11.537h0c10.667,2.528,16.365,11.744,19.567,21.259a85.9,85.9,0,0,1,3.209,13.531c.307,1.892.543,3.605.742,5.055l.033.242c.206,1.49.376,2.7.549,3.508v0c.7,3.178,3.836,12.491,6.782,20.966,1.476,4.247,2.909,8.3,3.973,11.286.532,1.494.971,2.723,1.278,3.579l.1.27c.1.268.176.489.237.66-.118.062-.264.139-.435.227-.533.277-1.316.676-2.315,1.165-2,.979-4.862,2.317-8.311,3.756a122.433,122.433,0,0,1-25.155,7.686l-5.147-9.791-.842-1.6-.1,1.809h0v.01l0,.034-.007.134-.029.521c-.026.455-.063,1.119-.111,1.954-.1,1.672-.234,4.031-.4,6.783-.336,5.5-.793,12.573-1.276,18.85-.186,1.821-.352,3.572-.5,5.2C189.886,142.648,189.716,144.453,189.545,145.974Z'%20transform='translate(-0.412%20-0.137)'%20fill='none'%20stroke='%23000'%20stroke-width='1'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e", Ue = (e) => {
  if (!e || !e.teams) return null;
  const t = e.teams.filter((r) => r.national === !1)[0];
  return t || null;
}, P2 = (e, t) => {
  if (!e) return 0;
  const r = t.data.find((n) => n.playerId === e);
  return (r == null ? void 0 : r.points) ?? 0;
}, ad = (e, t) => {
  var a;
  if (!e || !e.filters)
    return !1;
  const r = /* @__PURE__ */ new Date(), n = new Date(r.getFullYear(), r.getMonth(), r.getDate()), o = /* @__PURE__ */ new Map();
  if (t == null || t.forEach((i) => {
    o.set(i.id, i.status.type);
  }), e.filters.fromDate) {
    const i = new Date(e.filters.fromDate), s = new Date(i.getFullYear(), i.getMonth(), i.getDate());
    let l = null;
    if (e.filters.toDate) {
      const f = new Date(e.filters.toDate);
      l = new Date(f.getFullYear(), f.getMonth(), f.getDate());
    }
    const d = s.getTime() <= n.getTime(), u = !l || n.getTime() <= l.getTime();
    return d && u;
  } else if ((a = e.filters.matchIds) != null && a.length)
    return e.filters.matchIds.some((i) => o.get(i) === "notstarted");
  return !1;
}, Lt = (e, t) => {
  var a;
  if (!(e != null && e.groups))
    return null;
  const r = /* @__PURE__ */ new Date(), n = new Date(r.getFullYear(), r.getMonth(), r.getDate()), o = /* @__PURE__ */ new Map();
  t == null || t.forEach((i) => {
    o.set(i.id, i.status.type);
  });
  for (const i of e.groups)
    if (ad(i, t))
      return i;
  for (const i of e.groups)
    if (i.filters.fromDate) {
      const s = new Date(i.filters.fromDate);
      if (new Date(s.getFullYear(), s.getMonth(), s.getDate()).getTime() > n.getTime())
        return i;
    } else if ((a = i.filters.matchIds) != null && a.length && i.filters.matchIds.some((l) => o.get(l) === "notstarted"))
      return i;
  return null;
}, br = (e, t) => {
  const r = t.split("-").map(Number);
  if (r.length === 3) {
    if (e === "defender") return Number(r[0]);
    if (e === "midfielder") return Number(r[1]);
    if (e === "forward") return Number(r[2]);
  }
  return 0;
}, En = (e) => {
  var r, n;
  const t = w2;
  return e ? ((n = (r = Ue(e)) == null ? void 0 : r.assets) == null ? void 0 : n.logo) ?? t : t;
}, T2 = (e) => e === "keeper" ? "GK" : e === "defender" ? "DEF" : e === "midfielder" ? "MID" : e === "forward" ? "FWD" : "", O2 = (e) => {
  const t = /* @__PURE__ */ new Date(), r = new Date(e);
  let n = t.getFullYear() - r.getFullYear();
  const o = t.getMonth() - r.getMonth();
  return (o < 0 || o === 0 && t.getDate() < r.getDate()) && n--, n;
}, V2 = (e, t) => {
  if (!e)
    return [];
  let r = [];
  switch (t.toLowerCase()) {
    case "keeper":
      r = [
        "minutesPlayed",
        "cleanSheets",
        "concededGoals",
        "saves",
        "penaltySaved",
        "penaltyCommitted",
        "yellowCards",
        "redCards",
        "assists",
        "foulsCommitted",
        "ownGoals",
        "goals",
        "offsides"
      ];
      break;
    case "defender":
      r = [
        "minutesPlayed",
        "cleanSheets",
        "concededGoals",
        "goals",
        "assists",
        "tackles",
        "shotsOn",
        "yellowCards",
        "redCards",
        "ownGoals",
        "penaltyWon",
        "penaltyCommitted",
        "foulsCommitted",
        "offsides"
      ];
      break;
    case "midfielder":
      r = [
        "minutesPlayed",
        "cleanSheets",
        "concededGoals",
        "goals",
        "assists",
        "tackles",
        "shotsOn",
        "yellowCards",
        "redCards",
        "ownGoals",
        "penaltyWon",
        "penaltyCommitted",
        "foulsCommitted",
        "offsides"
      ];
      break;
    case "forward":
      r = [
        "minutesPlayed",
        "goals",
        "assists",
        "shotsOn",
        "yellowCards",
        "redCards",
        "ownGoals",
        "penaltyWon",
        "penaltyCommitted",
        "foulsCommitted",
        "concededGoals",
        "offsides"
      ];
      break;
    default:
      r = [];
      break;
  }
  return r.map((o) => {
    const a = e.find((i) => i.key === o);
    if (a)
      return a;
  }).filter((o) => o !== void 0);
}, Hr = (e, t) => {
  if (t && t.groups && e) {
    const r = t.groups.findIndex((n) => n.groupId === e.groupId);
    if (r > 0)
      return t.groups[r - 1];
  }
  return null;
}, Gr = (e, t) => {
  if (t && t.groups && e) {
    const r = t.groups.findIndex((n) => n.groupId === e.groupId);
    if (r < t.groups.length - 1)
      return t.groups[r + 1];
  }
  return null;
}, id = (e, t, r) => {
  if (!e || !t)
    return !1;
  const n = r == null ? void 0 : r.groups.findIndex((a) => a.groupId === (t == null ? void 0 : t.groupId)), o = r == null ? void 0 : r.groups.findIndex((a) => a.groupId === e.groupId);
  return n == null || o == null ? !1 : o < n;
}, Fn = (e, t) => {
  var r, n;
  return e.homeTeam.id === (t == null ? void 0 : t.id) ? {
    name: e.awayTeam.name,
    id: e.awayTeam.id,
    logo: (r = e.awayTeam.assets) == null ? void 0 : r.logo,
    homeOrAway: "H"
  } : {
    name: e.homeTeam.name,
    id: e.homeTeam.id,
    logo: (n = e.homeTeam.assets) == null ? void 0 : n.logo,
    homeOrAway: "A"
  };
}, E2 = (e) => {
  if (!e)
    return [];
  const t = [];
  return e.forEach((r) => {
    r.homeTeam && !t.find((n) => n.id === r.homeTeam.id) && t.push(r.homeTeam), r.awayTeam && !t.find((n) => n.id === r.awayTeam.id) && t.push(r.awayTeam);
  }), t;
}, qi = (e, t) => {
  if (!t)
    return console.warn("No matches provided"), null;
  if (!e)
    return console.warn("No team ID provided"), null;
  const r = /* @__PURE__ */ new Date(), a = t.filter(
    (i) => new Date(i.kickoffAt) > r && (i.homeTeam.id === e || i.awayTeam.id === e)
  ).sort(
    (i, s) => new Date(i.kickoffAt).getTime() - new Date(s.kickoffAt).getTime()
  )[0];
  if (a) {
    if (a.homeTeam.id === e)
      return a.awayTeam;
    if (a.awayTeam.id === e)
      return a.homeTeam;
  } else
    console.warn("No future matches found for the team ID " + e);
  return null;
}, K2 = (e, t, r, n) => {
  const o = {}, a = (i) => {
    if (!i) return;
    const s = Ue(i);
    s && s.id && (o[s.id] = (o[s.id] || 0) + 1);
  };
  return a(e), [...t, ...r, ...n].forEach(a), o;
}, sd = (e, t, r = 2) => e ? (t[e] || 0) >= r : !1, R2 = (e, t, r, n, o, a, i) => {
  var m, A;
  if (!i || !i.fixtures || i.fixtures.length === 0)
    return { hasPrediction: !1, hasChanges: !1 };
  const s = i.fixtures.map((b) => b.prediction.playerModel), l = (m = i.fixtures.find((b) => b.prediction.playerRole === "CAPTAIN")) == null ? void 0 : m.prediction.playerModel, d = (A = i.fixtures.find(
    (b) => b.prediction.playerRole === "VICE_CAPTAIN"
  )) == null ? void 0 : A.prediction.playerModel, u = [e, ...t, ...r, ...n].filter(
    (b) => b !== null
  ), p = u.length !== s.length || !u.every((b) => s.some((C) => C.id === b.id)) || !s.every((b) => u.some((C) => C.id === b.id)), f = (o == null ? void 0 : o.id) !== (l == null ? void 0 : l.id), g = (a == null ? void 0 : a.id) !== (d == null ? void 0 : d.id);
  return { hasPrediction: !0, hasChanges: p || f || g };
}, U2 = (e, t) => {
  window.fuSDK && window.fuSDK.loyalty.getTemplateById(e).then((r) => {
    t(r);
  });
}, on = (e, t, r) => {
  if (!(t != null && t.groupId) || !window.fuSDK) {
    r(null);
    return;
  }
  window.fuSDK.fantasy.getMyPrediction(e, t == null ? void 0 : t.groupId).then((n) => {
    if (!n) {
      r(null);
      return;
    }
    r(n);
  }).catch((n) => {
    console.warn("[getUserPrediction] Error fetching prediction:", n), r(null);
  });
}, j2 = (e, t) => {
  window.fuSDK && window.fuSDK.loyalty.getTemplateMatches(e).then((r) => {
    t(r);
  });
}, ll = (e, t, r) => {
  var o;
  if (!e || !e.id) {
    console.error("Template data is not available or invalid");
    return;
  }
  const n = (o = e.groups) == null ? void 0 : o.find((a) => a.groupId === t);
  if (!n) {
    console.error(`Group with ID ${t} not found in template`);
    return;
  }
  n.filters.matchIds && n.filters.matchIds.length > 0 && n.filters.matchIds[0] !== "" ? window.fuSDK && window.fuSDK.football.getMatches({ matchIds: n.filters.matchIds }).then((a) => {
    console.log("Matches Response for predefined IDs:", a.data), r(a.data);
  }).catch((a) => {
    console.error("Error fetching matches by IDs:", a);
  }) : window.fuSDK && window.fuSDK.loyalty.getTemplateMatches(e.id, t).then((a) => {
    r(a);
  }).catch((a) => {
    console.error("Error fetching template matches:", a);
  });
}, B2 = (e, t) => {
  window.fuSDK && window.fuSDK.fantasy.getPlayersPoints(e).then((r) => {
    t(r);
  });
}, D2 = (e, t, r) => {
  window.fuSDK && window.fuSDK.fantasy.getPlayerStatistics(e, t).then((n) => {
    r(n);
  });
}, ld = (e) => {
  const [t, r] = _({}), [n, o] = _([]), [a, i] = _(Yc), [s, l] = _([]), [d, u] = _({}), [p, f] = _(null), [g, h] = _(!1), [m, A] = _(!1), b = Jt(/* @__PURE__ */ new Map()), C = 5 * 60 * 1e3, v = Jt(/* @__PURE__ */ new Map());
  Te(() => {
    (async () => {
      try {
        const [P, E, K] = await Promise.all([
          new Promise((B) => U2(e, B)),
          new Promise(
            (B) => B2(e, B)
          ),
          new Promise((B) => j2(e, B))
        ]);
        r(P), o(K), i(E);
        const R = Lt(P, K);
        if (R) {
          u(R);
          const [B, V] = await Promise.all([
            new Promise(
              (M) => ll(P, R.groupId, M)
            ),
            new Promise(
              (M) => on(e, R, M)
            )
          ]);
          l(B), f(V);
        }
        h(!0);
      } catch (P) {
        console.error("Error loading game week data:", P);
      }
    })();
  }, [e]);
  const k = async (w) => {
    const P = `${e}-${w.groupId}`, E = Date.now(), K = v.current.get(P);
    if (K && E - K < C) {
      const B = b.current.get(P);
      if (B !== void 0)
        return B;
    }
    const R = await new Promise(
      (B) => on(e, w, B)
    );
    return b.current.set(P, R), v.current.set(P, E), R;
  };
  return {
    template: t,
    templateMatches: n,
    templatePlayerPoints: a,
    templateGroupMatches: s,
    selectedGameWeek: d,
    selectedGameWeekPrediction: p,
    setSelectedGameWeek: async (w, P) => {
      A(!0);
      try {
        const [E, K] = await Promise.all([
          new Promise(
            (R) => ll(P, w.groupId, R)
          ),
          k(w)
        ]);
        u(w), l(E), f(K);
      } catch (E) {
        console.error("Error changing game week:", E), u(w), f(null);
      } finally {
        A(!1);
      }
    },
    refreshPrediction: async () => {
      if (d && d.groupId) {
        const w = await new Promise(
          (E) => on(e, d, E)
        ), P = `${e}-${d.groupId}`;
        b.current.set(P, w), v.current.set(P, Date.now()), f(w);
      }
    },
    isLoaded: g,
    isNavigating: m
  };
};
function M2(e) {
  return Yf(e);
}
var Kn = {}, cd = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(cd);
var $o = cd.exports;
const F2 = /* @__PURE__ */ Et(Gd);
var ua = { exports: {} }, cl;
function q2() {
  return cl || (cl = 1, function(e) {
    function t(r, n) {
      if (r == null) return {};
      var o = {};
      for (var a in r) if ({}.hasOwnProperty.call(r, a)) {
        if (n.indexOf(a) !== -1) continue;
        o[a] = r[a];
      }
      return o;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(ua)), ua.exports;
}
const J2 = /* @__PURE__ */ Et(ep), W2 = /* @__PURE__ */ Et(tp), L2 = /* @__PURE__ */ Et(sp), z2 = /* @__PURE__ */ Et(sf), N2 = /* @__PURE__ */ Et(Hp), Q2 = /* @__PURE__ */ Et($p);
var Mr = $o;
Object.defineProperty(Kn, "__esModule", {
  value: !0
});
var H2 = Kn.default = ix;
Kn.shouldForwardProp = Xn;
Kn.systemDefaultTheme = void 0;
var dt = Mr(F2), Ua = Mr(q2()), uo = ex(J2), G2 = W2;
Mr(L2);
Mr(z2);
var Z2 = Mr(N2), Y2 = Mr(Q2);
const X2 = ["ownerState"], $2 = ["variants"], _2 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"];
function dd(e) {
  if (typeof WeakMap != "function") return null;
  var t = /* @__PURE__ */ new WeakMap(), r = /* @__PURE__ */ new WeakMap();
  return (dd = function(n) {
    return n ? r : t;
  })(e);
}
function ex(e, t) {
  if (e && e.__esModule) return e;
  if (e === null || typeof e != "object" && typeof e != "function") return { default: e };
  var r = dd(t);
  if (r && r.has(e)) return r.get(e);
  var n = { __proto__: null }, o = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in e) if (a !== "default" && Object.prototype.hasOwnProperty.call(e, a)) {
    var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, a, i) : n[a] = e[a];
  }
  return n.default = e, r && r.set(e, n), n;
}
function tx(e) {
  return Object.keys(e).length === 0;
}
function rx(e) {
  return typeof e == "string" && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  e.charCodeAt(0) > 96;
}
function Xn(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
function dl(e, t) {
  return t && e && typeof e == "object" && e.styles && !e.styles.startsWith("@layer") && (e.styles = `@layer ${t}{${String(e.styles)}}`), e;
}
const nx = Kn.systemDefaultTheme = (0, Z2.default)(), ox = (e) => e && e.charAt(0).toLowerCase() + e.slice(1);
function qn({
  defaultTheme: e,
  theme: t,
  themeId: r
}) {
  return tx(t) ? e : t[r] || t;
}
function ax(e) {
  return e ? (t, r) => r[e] : null;
}
function $n(e, t, r) {
  let {
    ownerState: n
  } = t, o = (0, Ua.default)(t, X2);
  const a = typeof e == "function" ? e((0, dt.default)({
    ownerState: n
  }, o)) : e;
  if (Array.isArray(a))
    return a.flatMap((i) => $n(i, (0, dt.default)({
      ownerState: n
    }, o), r));
  if (a && typeof a == "object" && Array.isArray(a.variants)) {
    const {
      variants: i = []
    } = a;
    let l = (0, Ua.default)(a, $2);
    return i.forEach((d) => {
      let u = !0;
      if (typeof d.props == "function" ? u = d.props((0, dt.default)({
        ownerState: n
      }, o, n)) : Object.keys(d.props).forEach((p) => {
        (n == null ? void 0 : n[p]) !== d.props[p] && o[p] !== d.props[p] && (u = !1);
      }), u) {
        Array.isArray(l) || (l = [l]);
        const p = typeof d.style == "function" ? d.style((0, dt.default)({
          ownerState: n
        }, o, n)) : d.style;
        l.push(r ? dl((0, uo.internal_serializeStyles)(p), r) : p);
      }
    }), l;
  }
  return r ? dl((0, uo.internal_serializeStyles)(a), r) : a;
}
function ix(e = {}) {
  const {
    themeId: t,
    defaultTheme: r = nx,
    rootShouldForwardProp: n = Xn,
    slotShouldForwardProp: o = Xn
  } = e, a = (i) => (0, Y2.default)((0, dt.default)({}, i, {
    theme: qn((0, dt.default)({}, i, {
      defaultTheme: r,
      themeId: t
    }))
  }));
  return a.__mui_systemSx = !0, (i, s = {}) => {
    (0, uo.internal_processStyles)(i, (I) => I.filter((w) => !(w != null && w.__mui_systemSx)));
    const {
      name: l,
      slot: d,
      skipVariantsResolver: u,
      skipSx: p,
      // TODO v6: remove `lowercaseFirstLetter()` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      overridesResolver: f = ax(ox(d))
    } = s, g = (0, Ua.default)(s, _2), h = l && l.startsWith("Mui") || d ? "components" : "custom", m = u !== void 0 ? u : (
      // TODO v6: remove `Root` in the next major release
      // For more details: https://github.com/mui/material-ui/pull/37908
      d && d !== "Root" && d !== "root" || !1
    ), A = p || !1;
    let b, C = Xn;
    d === "Root" || d === "root" ? C = n : d ? C = o : rx(i) && (C = void 0);
    const v = (0, uo.default)(i, (0, dt.default)({
      shouldForwardProp: C,
      label: b
    }, g)), k = (I) => typeof I == "function" && I.__emotion_real !== I || (0, G2.isPlainObject)(I) ? (w) => {
      const P = qn({
        theme: w.theme,
        defaultTheme: r,
        themeId: t
      });
      return $n(I, (0, dt.default)({}, w, {
        theme: P
      }), P.modularCssLayers ? h : void 0);
    } : I, S = (I, ...w) => {
      let P = k(I);
      const E = w ? w.map(k) : [];
      l && f && E.push((B) => {
        const V = qn((0, dt.default)({}, B, {
          defaultTheme: r,
          themeId: t
        }));
        if (!V.components || !V.components[l] || !V.components[l].styleOverrides)
          return null;
        const M = V.components[l].styleOverrides, j = {};
        return Object.entries(M).forEach(([T, O]) => {
          j[T] = $n(O, (0, dt.default)({}, B, {
            theme: V
          }), V.modularCssLayers ? "theme" : void 0);
        }), f(B, j);
      }), l && !m && E.push((B) => {
        var V;
        const M = qn((0, dt.default)({}, B, {
          defaultTheme: r,
          themeId: t
        })), j = M == null || (V = M.components) == null || (V = V[l]) == null ? void 0 : V.variants;
        return $n({
          variants: j
        }, (0, dt.default)({}, B, {
          theme: M
        }), M.modularCssLayers ? "theme" : void 0);
      }), A || E.push(a);
      const K = E.length - w.length;
      if (Array.isArray(I) && K > 0) {
        const B = new Array(K).fill("");
        P = [...I, ...B], P.raw = [...I.raw, ...B];
      }
      const R = v(P, ...E);
      return i.muiName && (R.muiName = i.muiName), R;
    };
    return v.withConfig && (S.withConfig = v.withConfig), S;
  };
}
function sx(e, t) {
  return y({
    toolbar: {
      minHeight: 56,
      [e.up("xs")]: {
        "@media (orientation: landscape)": {
          minHeight: 48
        }
      },
      [e.up("sm")]: {
        minHeight: 64
      }
    }
  }, t);
}
var Ee = {};
const lx = /* @__PURE__ */ Et(Hd), cx = /* @__PURE__ */ Et(bf);
var ud = $o;
Object.defineProperty(Ee, "__esModule", {
  value: !0
});
Ee.alpha = hd;
Ee.blend = Cx;
Ee.colorChannel = void 0;
var dx = Ee.darken = Wi;
Ee.decomposeColor = ht;
Ee.emphasize = md;
var ux = Ee.getContrastRatio = vx;
Ee.getLuminance = po;
Ee.hexToRgb = pd;
Ee.hslToRgb = gd;
var px = Ee.lighten = Li;
Ee.private_safeAlpha = bx;
Ee.private_safeColorChannel = void 0;
Ee.private_safeDarken = xx;
Ee.private_safeEmphasize = Ax;
Ee.private_safeLighten = yx;
Ee.recomposeColor = Fr;
Ee.rgbToHex = mx;
var ul = ud(lx), fx = ud(cx);
function Ji(e, t = 0, r = 1) {
  return (0, fx.default)(e, t, r);
}
function pd(e) {
  e = e.slice(1);
  const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
  let r = e.match(t);
  return r && r[0].length === 1 && (r = r.map((n) => n + n)), r ? `rgb${r.length === 4 ? "a" : ""}(${r.map((n, o) => o < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1e3) / 1e3).join(", ")})` : "";
}
function gx(e) {
  const t = e.toString(16);
  return t.length === 1 ? `0${t}` : t;
}
function ht(e) {
  if (e.type)
    return e;
  if (e.charAt(0) === "#")
    return ht(pd(e));
  const t = e.indexOf("("), r = e.substring(0, t);
  if (["rgb", "rgba", "hsl", "hsla", "color"].indexOf(r) === -1)
    throw new Error((0, ul.default)(9, e));
  let n = e.substring(t + 1, e.length - 1), o;
  if (r === "color") {
    if (n = n.split(" "), o = n.shift(), n.length === 4 && n[3].charAt(0) === "/" && (n[3] = n[3].slice(1)), ["srgb", "display-p3", "a98-rgb", "prophoto-rgb", "rec-2020"].indexOf(o) === -1)
      throw new Error((0, ul.default)(10, o));
  } else
    n = n.split(",");
  return n = n.map((a) => parseFloat(a)), {
    type: r,
    values: n,
    colorSpace: o
  };
}
const fd = (e) => {
  const t = ht(e);
  return t.values.slice(0, 3).map((r, n) => t.type.indexOf("hsl") !== -1 && n !== 0 ? `${r}%` : r).join(" ");
};
Ee.colorChannel = fd;
const hx = (e, t) => {
  try {
    return fd(e);
  } catch {
    return e;
  }
};
Ee.private_safeColorChannel = hx;
function Fr(e) {
  const {
    type: t,
    colorSpace: r
  } = e;
  let {
    values: n
  } = e;
  return t.indexOf("rgb") !== -1 ? n = n.map((o, a) => a < 3 ? parseInt(o, 10) : o) : t.indexOf("hsl") !== -1 && (n[1] = `${n[1]}%`, n[2] = `${n[2]}%`), t.indexOf("color") !== -1 ? n = `${r} ${n.join(" ")}` : n = `${n.join(", ")}`, `${t}(${n})`;
}
function mx(e) {
  if (e.indexOf("#") === 0)
    return e;
  const {
    values: t
  } = ht(e);
  return `#${t.map((r, n) => gx(n === 3 ? Math.round(255 * r) : r)).join("")}`;
}
function gd(e) {
  e = ht(e);
  const {
    values: t
  } = e, r = t[0], n = t[1] / 100, o = t[2] / 100, a = n * Math.min(o, 1 - o), i = (d, u = (d + r / 30) % 12) => o - a * Math.max(Math.min(u - 3, 9 - u, 1), -1);
  let s = "rgb";
  const l = [Math.round(i(0) * 255), Math.round(i(8) * 255), Math.round(i(4) * 255)];
  return e.type === "hsla" && (s += "a", l.push(t[3])), Fr({
    type: s,
    values: l
  });
}
function po(e) {
  e = ht(e);
  let t = e.type === "hsl" || e.type === "hsla" ? ht(gd(e)).values : e.values;
  return t = t.map((r) => (e.type !== "color" && (r /= 255), r <= 0.03928 ? r / 12.92 : ((r + 0.055) / 1.055) ** 2.4)), Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3));
}
function vx(e, t) {
  const r = po(e), n = po(t);
  return (Math.max(r, n) + 0.05) / (Math.min(r, n) + 0.05);
}
function hd(e, t) {
  return e = ht(e), t = Ji(t), (e.type === "rgb" || e.type === "hsl") && (e.type += "a"), e.type === "color" ? e.values[3] = `/${t}` : e.values[3] = t, Fr(e);
}
function bx(e, t, r) {
  try {
    return hd(e, t);
  } catch {
    return e;
  }
}
function Wi(e, t) {
  if (e = ht(e), t = Ji(t), e.type.indexOf("hsl") !== -1)
    e.values[2] *= 1 - t;
  else if (e.type.indexOf("rgb") !== -1 || e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] *= 1 - t;
  return Fr(e);
}
function xx(e, t, r) {
  try {
    return Wi(e, t);
  } catch {
    return e;
  }
}
function Li(e, t) {
  if (e = ht(e), t = Ji(t), e.type.indexOf("hsl") !== -1)
    e.values[2] += (100 - e.values[2]) * t;
  else if (e.type.indexOf("rgb") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (255 - e.values[r]) * t;
  else if (e.type.indexOf("color") !== -1)
    for (let r = 0; r < 3; r += 1)
      e.values[r] += (1 - e.values[r]) * t;
  return Fr(e);
}
function yx(e, t, r) {
  try {
    return Li(e, t);
  } catch {
    return e;
  }
}
function md(e, t = 0.15) {
  return po(e) > 0.5 ? Wi(e, t) : Li(e, t);
}
function Ax(e, t, r) {
  try {
    return md(e, t);
  } catch {
    return e;
  }
}
function Cx(e, t, r, n = 1) {
  const o = (l, d) => Math.round((l ** (1 / n) * (1 - r) + d ** (1 / n) * r) ** n), a = ht(e), i = ht(t), s = [o(a.values[0], i.values[0]), o(a.values[1], i.values[1]), o(a.values[2], i.values[2])];
  return Fr({
    type: "rgb",
    values: s
  });
}
const mn = {
  black: "#000",
  white: "#fff"
}, Sx = {
  50: "#fafafa",
  100: "#f5f5f5",
  200: "#eeeeee",
  300: "#e0e0e0",
  400: "#bdbdbd",
  500: "#9e9e9e",
  600: "#757575",
  700: "#616161",
  800: "#424242",
  900: "#212121",
  A100: "#f5f5f5",
  A200: "#eeeeee",
  A400: "#bdbdbd",
  A700: "#616161"
}, cr = {
  50: "#f3e5f5",
  200: "#ce93d8",
  300: "#ba68c8",
  400: "#ab47bc",
  500: "#9c27b0",
  700: "#7b1fa2"
}, dr = {
  300: "#e57373",
  400: "#ef5350",
  500: "#f44336",
  700: "#d32f2f",
  800: "#c62828"
}, Zr = {
  300: "#ffb74d",
  400: "#ffa726",
  500: "#ff9800",
  700: "#f57c00",
  900: "#e65100"
}, ur = {
  50: "#e3f2fd",
  200: "#90caf9",
  400: "#42a5f5",
  700: "#1976d2",
  800: "#1565c0"
}, pr = {
  300: "#4fc3f7",
  400: "#29b6f6",
  500: "#03a9f4",
  700: "#0288d1",
  900: "#01579b"
}, fr = {
  300: "#81c784",
  400: "#66bb6a",
  500: "#4caf50",
  700: "#388e3c",
  800: "#2e7d32",
  900: "#1b5e20"
}, kx = ["mode", "contrastThreshold", "tonalOffset"], pl = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: "rgba(0, 0, 0, 0.87)",
    // Secondary text.
    secondary: "rgba(0, 0, 0, 0.6)",
    // Disabled text have even lower visual prominence.
    disabled: "rgba(0, 0, 0, 0.38)"
  },
  // The color used to divide different elements.
  divider: "rgba(0, 0, 0, 0.12)",
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: mn.white,
    default: mn.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: "rgba(0, 0, 0, 0.54)",
    // The color of an hovered action.
    hover: "rgba(0, 0, 0, 0.04)",
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: "rgba(0, 0, 0, 0.08)",
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: "rgba(0, 0, 0, 0.26)",
    // The background color of a disabled action.
    disabledBackground: "rgba(0, 0, 0, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(0, 0, 0, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
}, pa = {
  text: {
    primary: mn.white,
    secondary: "rgba(255, 255, 255, 0.7)",
    disabled: "rgba(255, 255, 255, 0.5)",
    icon: "rgba(255, 255, 255, 0.5)"
  },
  divider: "rgba(255, 255, 255, 0.12)",
  background: {
    paper: "#121212",
    default: "#121212"
  },
  action: {
    active: mn.white,
    hover: "rgba(255, 255, 255, 0.08)",
    hoverOpacity: 0.08,
    selected: "rgba(255, 255, 255, 0.16)",
    selectedOpacity: 0.16,
    disabled: "rgba(255, 255, 255, 0.3)",
    disabledBackground: "rgba(255, 255, 255, 0.12)",
    disabledOpacity: 0.38,
    focus: "rgba(255, 255, 255, 0.12)",
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};
function fl(e, t, r, n) {
  const o = n.light || n, a = n.dark || n * 1.5;
  e[t] || (e.hasOwnProperty(r) ? e[t] = e[r] : t === "light" ? e.light = px(e.main, o) : t === "dark" && (e.dark = dx(e.main, a)));
}
function Ix(e = "light") {
  return e === "dark" ? {
    main: ur[200],
    light: ur[50],
    dark: ur[400]
  } : {
    main: ur[700],
    light: ur[400],
    dark: ur[800]
  };
}
function wx(e = "light") {
  return e === "dark" ? {
    main: cr[200],
    light: cr[50],
    dark: cr[400]
  } : {
    main: cr[500],
    light: cr[300],
    dark: cr[700]
  };
}
function Px(e = "light") {
  return e === "dark" ? {
    main: dr[500],
    light: dr[300],
    dark: dr[700]
  } : {
    main: dr[700],
    light: dr[400],
    dark: dr[800]
  };
}
function Tx(e = "light") {
  return e === "dark" ? {
    main: pr[400],
    light: pr[300],
    dark: pr[700]
  } : {
    main: pr[700],
    light: pr[500],
    dark: pr[900]
  };
}
function Ox(e = "light") {
  return e === "dark" ? {
    main: fr[400],
    light: fr[300],
    dark: fr[700]
  } : {
    main: fr[800],
    light: fr[500],
    dark: fr[900]
  };
}
function Vx(e = "light") {
  return e === "dark" ? {
    main: Zr[400],
    light: Zr[300],
    dark: Zr[700]
  } : {
    main: "#ed6c02",
    // closest to orange[800] that pass 3:1.
    light: Zr[500],
    dark: Zr[900]
  };
}
function Ex(e) {
  const {
    mode: t = "light",
    contrastThreshold: r = 3,
    tonalOffset: n = 0.2
  } = e, o = ee(e, kx), a = e.primary || Ix(t), i = e.secondary || wx(t), s = e.error || Px(t), l = e.info || Tx(t), d = e.success || Ox(t), u = e.warning || Vx(t);
  function p(m) {
    return ux(m, pa.text.primary) >= r ? pa.text.primary : pl.text.primary;
  }
  const f = ({
    color: m,
    name: A,
    mainShade: b = 500,
    lightShade: C = 300,
    darkShade: v = 700
  }) => {
    if (m = y({}, m), !m.main && m[b] && (m.main = m[b]), !m.hasOwnProperty("main"))
      throw new Error(jt(11, A ? ` (${A})` : "", b));
    if (typeof m.main != "string")
      throw new Error(jt(12, A ? ` (${A})` : "", JSON.stringify(m.main)));
    return fl(m, "light", C, n), fl(m, "dark", v, n), m.contrastText || (m.contrastText = p(m.main)), m;
  }, g = {
    dark: pa,
    light: pl
  };
  return je(y({
    // A collection of common colors.
    common: y({}, mn),
    // prevent mutable object.
    // The palette mode, can be light or dark.
    mode: t,
    // The colors used to represent primary interface elements for a user.
    primary: f({
      color: a,
      name: "primary"
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: f({
      color: i,
      name: "secondary",
      mainShade: "A400",
      lightShade: "A200",
      darkShade: "A700"
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: f({
      color: s,
      name: "error"
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: f({
      color: u,
      name: "warning"
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: f({
      color: l,
      name: "info"
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: f({
      color: d,
      name: "success"
    }),
    // The grey colors.
    grey: Sx,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: r,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText: p,
    // Generate a rich color object.
    augmentColor: f,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: n
  }, g[t]), o);
}
const Kx = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];
function Rx(e) {
  return Math.round(e * 1e5) / 1e5;
}
const gl = {
  textTransform: "uppercase"
}, hl = '"Roboto", "Helvetica", "Arial", sans-serif';
function Ux(e, t) {
  const r = typeof t == "function" ? t(e) : t, {
    fontFamily: n = hl,
    // The default font size of the Material Specification.
    fontSize: o = 14,
    // px
    fontWeightLight: a = 300,
    fontWeightRegular: i = 400,
    fontWeightMedium: s = 500,
    fontWeightBold: l = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize: d = 16,
    // Apply the CSS properties to all the variants.
    allVariants: u,
    pxToRem: p
  } = r, f = ee(r, Kx), g = o / 14, h = p || ((b) => `${b / d * g}rem`), m = (b, C, v, k, S) => y({
    fontFamily: n,
    fontWeight: b,
    fontSize: h(C),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight: v
  }, n === hl ? {
    letterSpacing: `${Rx(k / C)}em`
  } : {}, S, u), A = {
    h1: m(a, 96, 1.167, -1.5),
    h2: m(a, 60, 1.2, -0.5),
    h3: m(i, 48, 1.167, 0),
    h4: m(i, 34, 1.235, 0.25),
    h5: m(i, 24, 1.334, 0),
    h6: m(s, 20, 1.6, 0.15),
    subtitle1: m(i, 16, 1.75, 0.15),
    subtitle2: m(s, 14, 1.57, 0.1),
    body1: m(i, 16, 1.5, 0.15),
    body2: m(i, 14, 1.43, 0.15),
    button: m(s, 14, 1.75, 0.4, gl),
    caption: m(i, 12, 1.66, 0.4),
    overline: m(i, 12, 2.66, 1, gl),
    // TODO v6: Remove handling of 'inherit' variant from the theme as it is already handled in Material UI's Typography component. Also, remember to remove the associated types.
    inherit: {
      fontFamily: "inherit",
      fontWeight: "inherit",
      fontSize: "inherit",
      lineHeight: "inherit",
      letterSpacing: "inherit"
    }
  };
  return je(y({
    htmlFontSize: d,
    pxToRem: h,
    fontFamily: n,
    fontSize: o,
    fontWeightLight: a,
    fontWeightRegular: i,
    fontWeightMedium: s,
    fontWeightBold: l
  }, A), f, {
    clone: !1
    // No need to clone deep
  });
}
const jx = 0.2, Bx = 0.14, Dx = 0.12;
function Ce(...e) {
  return [`${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,${jx})`, `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,${Bx})`, `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,${Dx})`].join(",");
}
const Mx = ["none", Ce(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), Ce(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), Ce(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), Ce(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), Ce(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), Ce(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), Ce(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), Ce(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), Ce(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), Ce(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), Ce(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), Ce(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), Ce(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), Ce(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), Ce(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), Ce(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), Ce(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), Ce(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), Ce(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), Ce(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), Ce(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), Ce(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), Ce(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), Ce(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)], Fx = ["duration", "easing", "delay"], qx = {
  // This is the most common easing curve.
  easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: "cubic-bezier(0.4, 0, 1, 1)",
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: "cubic-bezier(0.4, 0, 0.6, 1)"
}, Jx = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
function ml(e) {
  return `${Math.round(e)}ms`;
}
function Wx(e) {
  if (!e)
    return 0;
  const t = e / 36;
  return Math.round((4 + 15 * t ** 0.25 + t / 5) * 10);
}
function Lx(e) {
  const t = y({}, qx, e.easing), r = y({}, Jx, e.duration);
  return y({
    getAutoHeightDuration: Wx,
    create: (o = ["all"], a = {}) => {
      const {
        duration: i = r.standard,
        easing: s = t.easeInOut,
        delay: l = 0
      } = a;
      return ee(a, Fx), (Array.isArray(o) ? o : [o]).map((d) => `${d} ${typeof i == "string" ? i : ml(i)} ${s} ${typeof l == "string" ? l : ml(l)}`).join(",");
    }
  }, e, {
    easing: t,
    duration: r
  });
}
const zx = {
  mobileStepper: 1e3,
  fab: 1050,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
}, Nx = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];
function Qx(e = {}, ...t) {
  const {
    mixins: r = {},
    palette: n = {},
    transitions: o = {},
    typography: a = {}
  } = e, i = ee(e, Nx);
  if (e.vars && // The error should throw only for the root theme creation because user is not allowed to use a custom node `vars`.
  // `generateCssVars` is the closest identifier for checking that the `options` is a result of `extendTheme` with CSS variables so that user can create new theme for nested ThemeProvider.
  e.generateCssVars === void 0)
    throw new Error(jt(18));
  const s = Ex(n), l = Rr(e);
  let d = je(l, {
    mixins: sx(l.breakpoints, r),
    palette: s,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: Mx.slice(),
    typography: Ux(s, a),
    transitions: Lx(o),
    zIndex: y({}, zx)
  });
  return d = je(d, i), d = t.reduce((u, p) => je(u, p), d), d.unstable_sxConfig = y({}, Kr, i == null ? void 0 : i.unstable_sxConfig), d.unstable_sx = function(p) {
    return rr({
      sx: p,
      theme: this
    });
  }, d;
}
const Hx = Qx(), Gx = "$$material";
function Zx(e) {
  return e !== "ownerState" && e !== "theme" && e !== "sx" && e !== "as";
}
const Yx = (e) => Zx(e) && e !== "classes", Xx = H2({
  themeId: Gx,
  defaultTheme: Hx,
  rootShouldForwardProp: Yx
});
function $x(e) {
  return Sn("MuiSvgIcon", e);
}
oi("MuiSvgIcon", ["root", "colorPrimary", "colorSecondary", "colorAction", "colorError", "colorDisabled", "fontSizeInherit", "fontSizeSmall", "fontSizeMedium", "fontSizeLarge"]);
const _x = ["children", "className", "color", "component", "fontSize", "htmlColor", "inheritViewBox", "titleAccess", "viewBox"], ey = (e) => {
  const {
    color: t,
    fontSize: r,
    classes: n
  } = e, o = {
    root: ["root", t !== "inherit" && `color${z(t)}`, `fontSize${z(r)}`]
  };
  return me(o, $x, n);
}, ty = Xx("svg", {
  name: "MuiSvgIcon",
  slot: "Root",
  overridesResolver: (e, t) => {
    const {
      ownerState: r
    } = e;
    return [t.root, r.color !== "inherit" && t[`color${z(r.color)}`], t[`fontSize${z(r.fontSize)}`]];
  }
})(({
  theme: e,
  ownerState: t
}) => {
  var r, n, o, a, i, s, l, d, u, p, f, g, h;
  return {
    userSelect: "none",
    width: "1em",
    height: "1em",
    display: "inline-block",
    // the <svg> will define the property that has `currentColor`
    // for example heroicons uses fill="none" and stroke="currentColor"
    fill: t.hasSvgAsChild ? void 0 : "currentColor",
    flexShrink: 0,
    transition: (r = e.transitions) == null || (n = r.create) == null ? void 0 : n.call(r, "fill", {
      duration: (o = e.transitions) == null || (o = o.duration) == null ? void 0 : o.shorter
    }),
    fontSize: {
      inherit: "inherit",
      small: ((a = e.typography) == null || (i = a.pxToRem) == null ? void 0 : i.call(a, 20)) || "1.25rem",
      medium: ((s = e.typography) == null || (l = s.pxToRem) == null ? void 0 : l.call(s, 24)) || "1.5rem",
      large: ((d = e.typography) == null || (u = d.pxToRem) == null ? void 0 : u.call(d, 35)) || "2.1875rem"
    }[t.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (p = (f = (e.vars || e).palette) == null || (f = f[t.color]) == null ? void 0 : f.main) != null ? p : {
      action: (g = (e.vars || e).palette) == null || (g = g.action) == null ? void 0 : g.active,
      disabled: (h = (e.vars || e).palette) == null || (h = h.action) == null ? void 0 : h.disabled,
      inherit: void 0
    }[t.color]
  };
}), ja = /* @__PURE__ */ x.forwardRef(function(t, r) {
  const n = M2({
    props: t,
    name: "MuiSvgIcon"
  }), {
    children: o,
    className: a,
    color: i = "inherit",
    component: s = "svg",
    fontSize: l = "medium",
    htmlColor: d,
    inheritViewBox: u = !1,
    titleAccess: p,
    viewBox: f = "0 0 24 24"
  } = n, g = ee(n, _x), h = /* @__PURE__ */ x.isValidElement(o) && o.type === "svg", m = y({}, n, {
    color: i,
    component: s,
    fontSize: l,
    instanceFontSize: t.fontSize,
    inheritViewBox: u,
    viewBox: f,
    hasSvgAsChild: h
  }), A = {};
  u || (A.viewBox = f);
  const b = ey(m);
  return /* @__PURE__ */ c.jsxs(ty, y({
    as: s,
    className: Qe(b.root, a),
    focusable: "false",
    color: d,
    "aria-hidden": p ? void 0 : !0,
    role: p ? "img" : void 0,
    ref: r
  }, A, g, h && o.props, {
    ownerState: m,
    children: [h ? o.props.children : o, p ? /* @__PURE__ */ c.jsx("title", {
      children: p
    }) : null]
  }));
});
ja.muiName = "SvgIcon";
function qr(e, t) {
  function r(n, o) {
    return /* @__PURE__ */ c.jsx(ja, y({
      "data-testid": `${t}Icon`,
      ref: o
    }, n, {
      children: e
    }));
  }
  return r.muiName = ja.muiName, /* @__PURE__ */ x.memo(/* @__PURE__ */ x.forwardRef(r));
}
const ry = {
  configure: (e) => {
    ni.configure(e);
  }
}, ny = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  capitalize: z,
  createChainedFunction: Aa,
  createSvgIcon: qr,
  debounce: yf,
  deprecatedPropType: Af,
  isMuiElement: kn,
  ownerDocument: _e,
  ownerWindow: zo,
  requirePropFactory: Cf,
  setRef: no,
  unstable_ClassNameGenerator: ry,
  unstable_useEnhancedEffect: Bt,
  unstable_useId: Wt,
  unsupportedProp: kf,
  useControlled: oc,
  useEventCallback: Sr,
  useForkRef: ke,
  useIsFocusVisible: ac
}, Symbol.toStringTag, { value: "Module" })), vd = qr(/* @__PURE__ */ c.jsx("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z"
}), "Add"), oy = qr(/* @__PURE__ */ c.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8z"
}), "CheckCircle"), ay = qr(/* @__PURE__ */ c.jsx("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), "ChevronLeft"), iy = qr(/* @__PURE__ */ c.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), "ChevronRight"), bd = qr(/* @__PURE__ */ c.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 11H7v-2h10z"
}), "RemoveCircle"), sy = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3crect%20width='24'%20height='24'%20fill='url(%23pattern0_466_21848)'/%3e%3cdefs%3e%3cpattern%20id='pattern0_466_21848'%20patternContentUnits='objectBoundingBox'%20width='1'%20height='1'%3e%3cuse%20xlink:href='%23image0_466_21848'%20transform='translate(-0.1)%20scale(0.00526316)'/%3e%3c/pattern%3e%3cimage%20id='image0_466_21848'%20width='228'%20height='190'%20preserveAspectRatio='none'%20xlink:href='data:image/png;base64,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'/%3e%3c/defs%3e%3c/svg%3e", ly = ({ setSelectedGameWeek: e }) => {
  const t = ue(St).template, r = ue(Ft).selectedGameWeek, n = (o) => {
    o && e(o, t);
  };
  return Te(() => {
    n(Lt(t));
  }, [t]), /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsxs(
    U,
    {
      bgcolor: "rgba(30, 30, 30, 1)",
      p: 1,
      mb: 1,
      borderRadius: "md",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      children: [
        /* @__PURE__ */ c.jsx(
          ge,
          {
            size: "xs",
            color: "neutral",
            variant: "plain",
            disabled: !Hr(r, t),
            onClick: () => {
              Hr(r, t) && n(Hr(r, t));
            },
            sx: {
              backgroundColor: "transparent !important",
              "&:hover": {
                backgroundColor: "transparent !important"
              },
              "&:active": {
                backgroundColor: "transparent !important"
              },
              "&:focus": {
                backgroundColor: "transparent !important"
              },
              "&:focus-visible": {
                backgroundColor: "transparent !important"
              }
            },
            children: /* @__PURE__ */ c.jsx(
              ay,
              {
                sx: {
                  color: (Hr(r, t), "#ffffff"),
                  opacity: Hr(r, t) ? 1 : 0.25
                }
              }
            )
          }
        ),
        /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "center", alignItems: "center", children: [
          /* @__PURE__ */ c.jsx("img", { src: sy, style: { marginRight: "3px", width: "14px" } }),
          /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", textColor: "neutral.100", textTransform: "uppercase", children: r == null ? void 0 : r.label })
        ] }),
        /* @__PURE__ */ c.jsx(
          ge,
          {
            size: "xs",
            color: "neutral",
            variant: "plain",
            disabled: !Gr(r, t),
            onClick: () => {
              Gr(r, t) && n(Gr(r, t));
            },
            sx: {
              backgroundColor: "transparent !important",
              "&:hover": {
                backgroundColor: "transparent !important"
              },
              "&:active": {
                backgroundColor: "transparent !important"
              },
              "&:focus": {
                backgroundColor: "transparent !important"
              },
              "&:focus-visible": {
                backgroundColor: "transparent !important"
              }
            },
            children: /* @__PURE__ */ c.jsx(
              iy,
              {
                sx: {
                  color: (Gr(r, t), "#ffffff"),
                  opacity: Gr(r, t) ? 1 : 0.25
                }
              }
            )
          }
        )
      ]
    }
  ) });
}, Jn = ({ value: e, maxValue: t, label: r, size: n = 80 }) => {
  const o = isNaN(e) ? 0 : Math.max(0, e), a = Math.min(o / t, 1), i = 2 * Math.PI * 38, s = i * (1 - a);
  return /* @__PURE__ */ c.jsxs(U, { textAlign: "center", mx: 1, sx: { display: "flex", flexDirection: "column", alignItems: "center" }, children: [
    /* @__PURE__ */ c.jsxs(U, { position: "relative", width: n, height: n, mb: 1, children: [
      /* @__PURE__ */ c.jsxs("svg", { width: n, height: n, viewBox: "0 0 100 100", children: [
        /* @__PURE__ */ c.jsx("circle", { cx: "50", cy: "50", r: "38", fill: "none", stroke: "#e0e0e0", strokeWidth: "4" }),
        /* @__PURE__ */ c.jsx(
          "circle",
          {
            cx: "50",
            cy: "50",
            r: "38",
            fill: "none",
            stroke: "#4f7bf2",
            strokeWidth: "4",
            strokeLinecap: "round",
            strokeDasharray: i,
            strokeDashoffset: s,
            transform: "rotate(-90 50 50)"
          }
        )
      ] }),
      /* @__PURE__ */ c.jsx(U, { position: "absolute", top: "50%", left: "50%", sx: { transform: "translate(-50%, -50%)" }, children: /* @__PURE__ */ c.jsx(J, { level: "h4", fontWeight: "bold", children: isNaN(e) ? 0 : e }) })
    ] }),
    /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "neutral.900", textTransform: "uppercase", fontWeight: 700, children: r })
  ] });
}, xd = ({
  timeLeft: e = { days: 0, hours: 0, minutes: 0, seconds: 0 },
  deadline: t,
  deadlineColor: r
}) => {
  const n = Be(), [o, a] = _({
    days: (e == null ? void 0 : e.days) || 0,
    hours: (e == null ? void 0 : e.hours) || 0,
    minutes: (e == null ? void 0 : e.minutes) || 0,
    seconds: (e == null ? void 0 : e.seconds) || 0
  });
  return Te(() => {
    e && a({
      days: e.days || 0,
      hours: e.hours || 0,
      minutes: e.minutes || 0,
      seconds: e.seconds || 0
    });
    const i = setInterval(() => {
      a((s) => {
        let l = s.seconds - 1, d = s.minutes, u = s.hours, p = s.days;
        return l < 0 && (l = 59, d -= 1), d < 0 && (d = 59, u -= 1), u < 0 && (u = 23, p -= 1), p < 0 ? (clearInterval(i), { days: 0, hours: 0, minutes: 0, seconds: 0 }) : { days: p, hours: u, minutes: d, seconds: l };
      });
    }, 1e3);
    return () => clearInterval(i);
  }, [e]), /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsxs(Ct, { variant: "plain", sx: { bgcolor: "#fff", mb: 1, pt: 0 }, children: [
    /* @__PURE__ */ c.jsxs(U, { pt: 2, sx: { display: "flex", justifyContent: "space-between" }, children: [
      /* @__PURE__ */ c.jsx(J, { level: "body-md", fontWeight: 700, children: n("teamSelectionDeadline") }),
      /* @__PURE__ */ c.jsx(J, { level: "body-md", fontWeight: "bold", mr: 1.5, textColor: r ?? "primary.500", children: t })
    ] }),
    /* @__PURE__ */ c.jsx(Ne, { sx: { bgcolor: "#f2f2f2" } }),
    /* @__PURE__ */ c.jsx(Ki, { children: /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", children: [
      /* @__PURE__ */ c.jsx(Jn, { value: o.days, maxValue: 100, label: n("days"), size: 65 }),
      /* @__PURE__ */ c.jsx(Jn, { value: o.hours, maxValue: 24, label: n("hours"), size: 65 }),
      /* @__PURE__ */ c.jsx(Jn, { value: o.minutes, maxValue: 60, label: n("minutes"), size: 65 }),
      /* @__PURE__ */ c.jsx(Jn, { value: o.seconds, maxValue: 60, label: n("seconds"), size: 65 })
    ] }) })
  ] }) });
}, vl = ({ deadline: e }) => {
  const t = Be(), r = ue(Ft).selectedGameWeek;
  return /* @__PURE__ */ c.jsxs(U, { bgcolor: "#fff", borderRadius: "lg", children: [
    /* @__PURE__ */ c.jsx(
      xd,
      {
        currentGameweekLabel: (r == null ? void 0 : r.label) ?? "",
        timeLeft: {
          days: "00",
          hours: "00",
          minutes: "00"
        },
        deadline: e,
        deadlineColor: "danger.500"
      }
    ),
    /* @__PURE__ */ c.jsxs(U, { px: 2, pb: 2, children: [
      /* @__PURE__ */ c.jsx(J, { level: "body-sm", textAlign: "center", fontWeight: "bold", mb: 1, children: t("deadlineMissed") }),
      /* @__PURE__ */ c.jsx(J, { level: "body-sm", textAlign: "center", children: t("noTeamSelectedMessage") })
    ] })
  ] });
}, cy = (e, t) => {
  if (!e || !t || t.groupId !== "3" || !e.fixtures || e.fixtures.length <= 11)
    return e;
  const r = /* @__PURE__ */ new Map();
  e.fixtures.forEach((i) => {
    var d, u;
    const s = i.prediction.playerId, l = ((d = i.result) == null ? void 0 : d.points) || 0;
    if (r.has(s)) {
      const f = ((u = r.get(s).result) == null ? void 0 : u.points) || 0;
      l > f && r.set(s, i);
    } else
      r.set(s, i);
  });
  const o = Array.from(r.values()).slice(0, 11), a = o.reduce((i, s) => {
    var l;
    return i + (((l = s.result) == null ? void 0 : l.points) || 0);
  }, 0);
  return {
    ...e,
    fixtures: o,
    totalFixtures: o.length,
    points: a
  };
}, dy = ({
  selectedGameWeekPrediction: e,
  templateId: t,
  groupId: r
}) => {
  const n = Be(), [o, a] = _({ averagePoints: 0, highestPoints: 0 });
  return Te(() => {
    t && r && (async () => {
      try {
        if (!window.fuSDK)
          throw new Error("SDK not initialized");
        const l = (await window.fuSDK.fantasy.getGameWeekStatistics(t)).data.find((d) => d.groupId === r);
        l && a({
          averagePoints: Math.round(l.averagePoints),
          highestPoints: l.highestPoints
        });
      } catch (s) {
        console.error("Error fetching game week statistics:", s);
      }
    })();
  }, [t, r]), /* @__PURE__ */ c.jsx(Ct, { variant: "plain", sx: { bgcolor: "#fff", py: 0 }, children: /* @__PURE__ */ c.jsx(Ki, { sx: { mt: 2 }, children: /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", alignItems: "baseline", mb: 3, children: [
    /* @__PURE__ */ c.jsxs(U, { textAlign: "center", mx: 1, minWidth: "60px", children: [
      /* @__PURE__ */ c.jsx(J, { level: "h2", fontWeight: "normal", children: o.averagePoints }),
      /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "neutral.400", children: n("average") })
    ] }),
    /* @__PURE__ */ c.jsx(Ne, { orientation: "vertical" }),
    /* @__PURE__ */ c.jsxs(U, { textAlign: "center", mx: 1, minWidth: "60px", children: [
      /* @__PURE__ */ c.jsx(J, { level: "h1", children: (e == null ? void 0 : e.points) || 0 }),
      /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "neutral.400", children: n("myPoints") })
    ] }),
    /* @__PURE__ */ c.jsx(Ne, { orientation: "vertical" }),
    /* @__PURE__ */ c.jsxs(U, { textAlign: "center", mx: 1, minWidth: "60px", children: [
      /* @__PURE__ */ c.jsx(J, { level: "h2", fontWeight: "normal", children: o.highestPoints }),
      /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "neutral.400", children: n("highest") })
    ] })
  ] }) }) });
}, yd = "data:image/png;base64,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", Ad = "data:image/svg+xml,%3csvg%20width='37'%20height='40'%20viewBox='0%200%2037%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_3074_4659)'%3e%3cpath%20d='M13.8721%200C13.8721%200%2018.3893%201.52515%2022.3106%200C22.3106%202.21313%2020.2889%204.00767%2018.0789%204.00767C15.8689%204.00767%2013.8721%202.21313%2013.8721%200.00207222V0Z'%20fill='white'/%3e%3cg%20style='mix-blend-mode:multiply'%20opacity='0.3'%3e%3cpath%20d='M13.8721%200C13.8721%200%2018.3893%201.52515%2022.3106%200C22.3106%202.21313%2020.2889%204.00767%2018.0789%204.00767C15.8689%204.00767%2013.8721%202.21313%2013.8721%200.00207222V0Z'%20fill='white'/%3e%3c/g%3e%3cpath%20d='M33.4932%207.93451C32.6221%205.55146%2030.7577%203.66781%2028.3883%202.77262C26.5012%202.0577%2024.3119%201.24747%2022.9068%200.785361C22.9068%200.785361%2021.0611%203.39221%2018.0627%203.39221C15.0643%203.39221%2013.2206%200.779144%2013.2206%200.779144C11.8011%201.24747%209.60142%202.07014%207.72045%202.78919C5.40494%203.6761%203.57363%205.50587%202.69005%207.82675C1.6699%2010.4999%200.409716%2013.9916%200%2015.9416C1.42159%2017.9392%203.80746%2018.8178%206.20782%2018.9836C6.55338%2018.3329%207.19072%2016.8057%207.64182%2015.5541C7.79702%2016.443%207.95221%2017.3362%208.1012%2018.1796C8.3371%2019.5223%208.41987%2020.8838%208.34744%2022.2452C8.12189%2026.4891%207.26108%2034.4092%206.96103%2037.9319C6.96103%2037.9319%2012.2563%2040%2018.0565%2040C23.8566%2040%2029.2347%2037.9319%2029.2347%2037.9319C28.9346%2034.4029%2028.0738%2026.4746%2027.8483%2022.2287C27.7779%2020.9004%2027.8565%2019.5721%2028.078%2018.2604C28.2435%2017.2864%2028.409%2016.2752%2028.5684%2015.2867C28.8808%2016.5031%2029.3423%2017.7775%2029.8203%2018.967C32.4979%2018.7556%2034.7576%2017.9371%2036.1212%2015.9333C35.6122%2013.8735%2034.443%2010.5269%2033.4953%207.93244L33.4932%207.93451Z'%20fill='%23F8F6F3'/%3e%3cpath%20d='M3.11839%2013.4093C2.98389%2011.8966%202.6466%2010.4191%202.26585%208.94989C1.34503%2011.4158%200.353846%2014.2548%200%2015.9415C0.736661%2016.9756%201.72991%2017.7092%202.85146%2018.2003C3.16599%2016.6275%203.26117%2015.0091%203.11839%2013.4093Z'%20fill='white'/%3e%3cpath%20d='M36.1216%2015.9353C35.6767%2014.1325%2034.7269%2011.3454%2033.8599%208.93954C33.477%2010.4129%2033.1398%2011.8945%2033.0032%2013.4093C32.8604%2015.0111%2032.9556%2016.6295%2033.2722%2018.2065C34.4248%2017.7237%2035.3994%2016.9963%2036.1216%2015.9353Z'%20fill='white'/%3e%3cg%20style='mix-blend-mode:multiply'%20opacity='0.6'%3e%3cpath%20d='M23.3416%200.92627C23.3416%200.92627%2020.2418%204.41174%2018.0753%204.41174C15.9087%204.41174%2012.7676%200.92627%2012.7676%200.92627C12.7676%200.92627%2017.0096%202.81406%2018.0753%202.81406C19.1409%202.81406%2023.3416%200.92627%2023.3416%200.92627Z'%20fill='%23CADEE5'/%3e%3c/g%3e%3cpath%20d='M12.7676%200.938711C12.7676%200.938711%2016.2543%203.89576%2018.0753%203.89576C19.8962%203.89576%2023.3416%200.924206%2023.3416%200.924206L22.3111%20-0.0020752C22.3111%20-0.0020752%2019.2734%202.25871%2018.0753%202.25871C16.4488%202.26079%2013.8726%20-2.97849e-06%2013.8726%20-2.97849e-06L12.7676%200.936639V0.938711Z'%20fill='white'/%3e%3cg%20style='mix-blend-mode:multiply'%20opacity='0.6'%3e%3cpath%20d='M29.82%2018.9691C31.2105%2018.8592%2032.4893%2018.5836%2033.5881%2018.0656C30.9953%2017.4522%2029.0833%2012.8705%2028.7129%2011.3578C28.4998%2011.8261%2028.0776%2014.5801%2028.5701%2015.2867C28.8826%2016.5031%2029.344%2017.7775%2029.822%2018.967L29.82%2018.9691Z'%20fill='%23CADEE5'/%3e%3cpath%20d='M2.28418%2017.9247C3.46987%2018.5608%204.83559%2018.8903%206.20752%2018.9836C6.55309%2018.3329%207.19042%2016.8057%207.64153%2015.5541C7.77189%2014.6319%207.71395%2012.0416%207.64773%2011.6293C6.38134%2014.1201%203.93339%2017.2429%202.28625%2017.9226L2.28418%2017.9247Z'%20fill='%23CADEE5'/%3e%3c/g%3e%3cpath%20d='M29.233%2037.9319C28.9329%2034.4029%2028.0721%2026.4746%2027.8465%2022.2287C27.7762%2020.9004%2027.8548%2019.5721%2028.0762%2018.2604C28.2418%2017.2864%2028.4073%2016.2752%2028.5667%2015.2867C28.5708%2015.3054%2028.5004%2013.0985%2028.8957%2010.2533C29.1502%208.42562%2029.8351%205.89545%2030.6049%204.00558C29.9365%203.49375%2029.1916%203.07516%2028.3866%202.77054C28.1135%202.66693%2027.8341%202.56125%2027.5506%202.45557C26.0442%206.43215%2025.4152%2010.3631%2025.4152%2010.3631C24.842%2013.6331%2024.8606%2017.0067%2025.4731%2020.2683C26.1291%2023.7538%2027.4534%2027.1149%2027.77%2030.6481C28.0142%2033.3792%2027.6189%2036.1602%2026.665%2038.7297C28.2397%2038.3008%2029.233%2037.9298%2029.233%2037.9298V37.9319Z'%20fill='white'/%3e%3cpath%20d='M8.45139%2030.5465C8.76799%2027.0134%2010.0923%2023.6523%2010.7483%2020.1668C11.3608%2016.9051%2011.3815%2013.5316%2010.8062%2010.2616C10.8062%2010.2616%2010.1834%206.37206%208.69557%202.41827C8.36448%202.54468%208.03754%202.66901%207.71887%202.7892C6.96566%203.07724%206.2621%203.46682%205.62891%203.93928C6.33867%205.92654%206.94496%207.73973%207.38779%2010.3051C7.88234%2013.1772%207.64024%2015.5561%207.64024%2015.5541C7.79543%2016.443%207.95063%2017.3362%208.09962%2018.1796C8.33551%2019.5224%208.41828%2020.8838%208.34586%2022.2452C8.12031%2026.4891%207.25949%2034.4092%206.95945%2037.9319C6.95945%2037.9319%207.9796%2038.3298%209.61432%2038.7774C8.619%2036.1664%208.20308%2033.3316%208.45139%2030.5465Z'%20fill='white'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_3074_4659'%3e%3crect%20width='36.1212'%20height='40'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e", Wn = ({ player: e, points: t, isCaptain: r = !1, isViceCaptain: n = !1 }) => {
  var i, s;
  const o = Be(), a = (l) => l >= 1 ? "#B8FFB8" : l === 0 ? "#FFF" : "#FFB8B8";
  return /* @__PURE__ */ c.jsxs(U, { sx: { width: "70px", height: 80, p: 0 }, position: "relative", zIndex: 1, children: [
    /* @__PURE__ */ c.jsxs(
      U,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        py: 1,
        sx: {
          borderRadius: "50%",
          background: "rgba(0, 100, 0, 1)",
          width: "60px",
          height: "60px",
          mx: "auto"
        },
        children: [
          /* @__PURE__ */ c.jsx(
            "img",
            {
              src: ((s = (i = Ue(e)) == null ? void 0 : i.assets) == null ? void 0 : s.logo) ?? Ad,
              style: {
                filter: `grayscale(${e ? 0 : 1})`,
                zIndex: 1,
                position: "relative",
                width: "40px",
                height: "40px"
              }
            }
          ),
          (r || n) && /* @__PURE__ */ c.jsx(
            U,
            {
              position: "absolute",
              top: -2,
              right: -2,
              sx: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                bgcolor: r ? "#FFD700" : "#C0C0C0",
                // Gold for captain, silver for vice-captain
                border: "2px solid #fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 3
              },
              children: /* @__PURE__ */ c.jsx(
                J,
                {
                  fontSize: 9,
                  fontWeight: "bold",
                  textColor: r ? "#000" : "#333",
                  lineHeight: 1,
                  children: r ? "C" : "V"
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ c.jsxs(U, { position: "absolute", left: 0, right: 0, bottom: 8, children: [
      /* @__PURE__ */ c.jsx(
        U,
        {
          textAlign: "center",
          bgcolor: "neutral.500",
          zIndex: 2,
          position: "relative",
          sx: { borderTopRightRadius: "5px", borderTopLeftRadius: "5px", overflow: "hidden" },
          children: /* @__PURE__ */ c.jsx(
            J,
            {
              fontSize: 11,
              lineHeight: 1.5,
              textColor: "#fff",
              sx: { bgcolor: "#3b3b3b" },
              fontWeight: "bold",
              noWrap: !!(e && Or(e == null ? void 0 : e.name).length > 11),
              children: e ? Or(e == null ? void 0 : e.name) : "Add Player"
            }
          )
        }
      ),
      /* @__PURE__ */ c.jsx(
        U,
        {
          textAlign: "center",
          zIndex: 2,
          position: "relative",
          sx: {
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
            backgroundColor: a(t ?? 0)
          },
          children: /* @__PURE__ */ c.jsxs(J, { fontSize: 11, lineHeight: 1.5, fontWeight: "bold", sx: { color: "#000" }, children: [
            t ?? "N/A",
            " ",
            o("pts")
          ] })
        }
      )
    ] })
  ] });
}, uy = ({
  selectedGameWeekPrediction: e
}) => {
  const [t, r] = _(null), [n, o] = _([]), [a, i] = _([]), [s, l] = _([]), d = (f) => (f == null ? void 0 : f.prediction.playerRole) === "CAPTAIN", u = (f) => (f == null ? void 0 : f.prediction.playerRole) === "VICE_CAPTAIN";
  Te(() => {
    p((e == null ? void 0 : e.fixtures) ?? []);
  }, [e]);
  const p = (f) => {
    const g = f.find((b) => b.prediction.playerModel.position === "keeper") ?? null, h = f.filter((b) => b.prediction.playerModel.position === "defender"), m = f.filter((b) => b.prediction.playerModel.position === "midfielder"), A = f.filter((b) => b.prediction.playerModel.position === "forward");
    r(g), o(h), i(m), l(A);
  };
  return /* @__PURE__ */ c.jsxs(
    Ri,
    {
      sx: {
        mx: 0,
        p: 0,
        marginBottom: "calc(140px + env(safe-area-inset-bottom))",
        position: "relative",
        overflow: "hidden",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
      },
      children: [
        /* @__PURE__ */ c.jsx("img", { src: yd, style: { width: "100%" }, loading: "lazy", alt: "Football pitch" }),
        /* @__PURE__ */ c.jsxs(
          U,
          {
            position: "absolute",
            top: "10px",
            left: 0,
            right: 0,
            bottom: "30px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: /* @__PURE__ */ c.jsx(
                Wn,
                {
                  player: (t == null ? void 0 : t.prediction.playerModel) ?? {},
                  points: (t == null ? void 0 : t.result.points) ?? 0,
                  isCaptain: d(t),
                  isViceCaptain: u(t)
                }
              ) }),
              /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: n.map((f, g) => /* @__PURE__ */ c.jsx(
                Wn,
                {
                  player: f == null ? void 0 : f.prediction.playerModel,
                  points: f == null ? void 0 : f.result.points,
                  isCaptain: d(f),
                  isViceCaptain: u(f)
                },
                `defender-${g}`
              )) }),
              /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: a.map((f, g) => /* @__PURE__ */ c.jsx(
                Wn,
                {
                  player: f == null ? void 0 : f.prediction.playerModel,
                  points: f == null ? void 0 : f.result.points,
                  isCaptain: d(f),
                  isViceCaptain: u(f)
                },
                `midfielder-${g}`
              )) }),
              /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: s.map((f, g) => /* @__PURE__ */ c.jsx(
                Wn,
                {
                  player: f == null ? void 0 : f.prediction.playerModel,
                  points: f == null ? void 0 : f.result.points,
                  isCaptain: d(f),
                  isViceCaptain: u(f)
                },
                `forward-${g}`
              )) })
            ]
          }
        )
      ]
    }
  );
}, Ln = ({ fixtures: e, positionLabel: t, templatePlayerPoints: r }) => /* @__PURE__ */ c.jsx(c.Fragment, { children: e && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
  /* @__PURE__ */ c.jsx(U, { bgcolor: "neutral.50", py: 0.5, px: 1, children: /* @__PURE__ */ c.jsx(J, { level: "body-xs", fontWeight: "bold", textTransform: "uppercase", children: t }) }),
  e.map((n, o) => {
    var s;
    const a = n.prediction.playerRole === "CAPTAIN", i = n.prediction.playerRole === "VICE_CAPTAIN";
    return /* @__PURE__ */ c.jsxs(U, { display: "flex", p: 1, children: [
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyItems: "flex-start", alignItems: "center", width: "60%", children: [
        /* @__PURE__ */ c.jsxs(U, { position: "relative", mr: 1, children: [
          /* @__PURE__ */ c.jsx(
            Vn,
            {
              sx: {
                p: 0.5
              },
              src: En(n.prediction.playerModel)
            }
          ),
          (a || i) && /* @__PURE__ */ c.jsx(
            U,
            {
              position: "absolute",
              top: -2,
              right: -2,
              sx: {
                width: "16px",
                height: "16px",
                borderRadius: "50%",
                bgcolor: a ? "#FFD700" : "#C0C0C0",
                // Gold for captain, silver for vice-captain
                border: "1px solid #fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 2
              },
              children: /* @__PURE__ */ c.jsx(
                J,
                {
                  fontSize: 8,
                  fontWeight: "bold",
                  textColor: a ? "#000" : "#333",
                  lineHeight: 1,
                  children: a ? "C" : "V"
                }
              )
            }
          )
        ] }),
        /* @__PURE__ */ c.jsxs(U, { children: [
          /* @__PURE__ */ c.jsx(U, { display: "flex", alignItems: "center", gap: 0.5, children: /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", fontSize: "sm", lineHeight: 1.3, children: n.prediction.playerModel.name }) }),
          /* @__PURE__ */ c.jsx(J, { fontSize: "xs", children: ((s = Ue(n.prediction.playerModel)) == null ? void 0 : s.name) ?? "" })
        ] })
      ] }),
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", flexGrow: 1, children: [
        /* @__PURE__ */ c.jsx(U, { display: "flex", alignItems: "center", children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: P2(n.prediction.playerModel.id, r) }) }),
        /* @__PURE__ */ c.jsx(U, { display: "flex", alignItems: "center", children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: n.result.points }) })
      ] })
    ] }, `forward-${o}`);
  })
] }) }), py = ({ selectedGameWeekPrediction: e, templatePlayerPoints: t }) => {
  const r = Be(), n = (e == null ? void 0 : e.fixtures) ?? [], o = n.find((l) => l.prediction.playerModel.position === "keeper") ?? null, a = n.filter((l) => l.prediction.playerModel.position === "defender"), i = n.filter((l) => l.prediction.playerModel.position === "midfielder"), s = n.filter((l) => l.prediction.playerModel.position === "forward");
  return /* @__PURE__ */ c.jsxs(U, { sx: { marginBottom: "calc(140px + env(safe-area-inset-bottom))" }, children: [
    /* @__PURE__ */ c.jsx(Ne, { sx: { bgcolor: "#f2f2f2" } }),
    /* @__PURE__ */ c.jsxs(U, { display: "flex", px: 1, my: 1, children: [
      /* @__PURE__ */ c.jsx(U, { width: "60%", children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", fontWeight: "bold", children: r("player") }) }),
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", width: "40%", children: [
        /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", fontWeight: "bold", children: r("totalPts") }) }),
        /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", fontWeight: "bold", children: r("matchweekPts") }) })
      ] })
    ] }),
    /* @__PURE__ */ c.jsx(
      Ln,
      {
        fixtures: [o],
        positionLabel: r("goalkeeper"),
        templatePlayerPoints: t
      }
    ),
    /* @__PURE__ */ c.jsx(
      Ln,
      {
        fixtures: a,
        positionLabel: r("defenders"),
        templatePlayerPoints: t
      }
    ),
    /* @__PURE__ */ c.jsx(
      Ln,
      {
        fixtures: i,
        positionLabel: r("midfielders"),
        templatePlayerPoints: t
      }
    ),
    /* @__PURE__ */ c.jsx(
      Ln,
      {
        fixtures: s,
        positionLabel: r("forwards"),
        templatePlayerPoints: t
      }
    )
  ] });
}, fy = ({
  view: e,
  setView: t
}) => {
  const r = Be();
  return /* @__PURE__ */ c.jsxs(
    U,
    {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      bgcolor: "#fff",
      px: 1.5,
      py: 2,
      display: "flex",
      zIndex: 20,
      boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.1)",
      children: [
        /* @__PURE__ */ c.jsx(
          ge,
          {
            fullWidth: !0,
            variant: e === "squad" ? "solid" : "outlined",
            color: "primary",
            sx: { mr: 1 },
            onClick: () => {
              t("squad");
            },
            children: r("team")
          }
        ),
        /* @__PURE__ */ c.jsx(
          ge,
          {
            fullWidth: !0,
            variant: e === "table" ? "solid" : "outlined",
            color: "primary",
            sx: { mr: 1 },
            onClick: () => {
              t("table");
            },
            children: r("list")
          }
        )
      ]
    }
  );
}, Cd = () => /* @__PURE__ */ c.jsx(Ct, { variant: "plain", sx: { bgcolor: "#fff", mb: 1, pt: 0 }, children: /* @__PURE__ */ c.jsx(
  U,
  {
    position: "relative",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 220,
    children: /* @__PURE__ */ c.jsx(Br, { size: "lg" })
  }
) }), bl = () => {
  const {
    selectedGameWeek: e,
    selectedGameWeekPrediction: t,
    isNavigating: r
  } = ue(Ft), n = yr(() => cy(t, e), [t, e]), o = ue(St).templatePlayerPoints, a = ue(St).template, [i, s] = _("squad");
  return r ? /* @__PURE__ */ c.jsx(Cd, {}) : /* @__PURE__ */ c.jsxs(U, { bgcolor: "#fff", borderRadius: "lg", children: [
    /* @__PURE__ */ c.jsx(
      dy,
      {
        selectedGameWeekPrediction: n,
        templateId: a.id,
        groupId: e.groupId
      }
    ),
    i === "squad" ? /* @__PURE__ */ c.jsx(uy, { selectedGameWeekPrediction: n }) : /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(
      py,
      {
        selectedGameWeekPrediction: n,
        templatePlayerPoints: o
      }
    ) }),
    /* @__PURE__ */ c.jsx(fy, { view: i, setView: s })
  ] });
}, gy = ["3-4-3", "3-5-2", "4-3-3", "4-4-2", "4-5-1", "5-3-2", "5-4-1"], hy = "4-3-3", or = tr({
  formation: "",
  selectedGoalkeeper: null,
  selectedDefenders: [],
  selectedMidfielders: [],
  selectedForwards: [],
  selectedCaptain: null,
  selectedViceCaptain: null,
  setGoalKeeper: () => {
  },
  setDefenders: () => {
  },
  setMidfielders: () => {
  },
  setForwards: () => {
  },
  setCaptain: () => {
  },
  setViceCaptain: () => {
  }
}), Sd = {
  bgcolor: "#fff",
  pb: 0,
  borderBottomLeftRadius: "8px",
  borderBottomRightRadius: "8px",
  overflow: "hidden",
  mb: 9
}, my = {
  position: "absolute",
  top: "20px",
  color: "#fff",
  fontSize: "9px",
  width: "100%"
}, vy = {
  position: "absolute",
  top: "-10px",
  right: "-5px",
  zIndex: 10,
  cursor: "pointer",
  color: "#f00"
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const by = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), xy = (e) => e.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (t, r, n) => n ? n.toUpperCase() : r.toLowerCase()
), xl = (e) => {
  const t = xy(e);
  return t.charAt(0).toUpperCase() + t.slice(1);
}, kd = (...e) => e.filter((t, r, n) => !!t && t.trim() !== "" && n.indexOf(t) === r).join(" ").trim(), yy = (e) => {
  for (const t in e)
    if (t.startsWith("aria-") || t === "role" || t === "title")
      return !0;
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var Ay = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cy = Ba(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: r = 2,
    absoluteStrokeWidth: n,
    className: o = "",
    children: a,
    iconNode: i,
    ...s
  }, l) => ha(
    "svg",
    {
      ref: l,
      ...Ay,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: n ? Number(r) * 24 / Number(t) : r,
      className: kd("lucide", o),
      ...!a && !yy(s) && { "aria-hidden": "true" },
      ...s
    },
    [
      ...i.map(([d, u]) => ha(d, u)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Id = (e, t) => {
  const r = Ba(
    ({ className: n, ...o }, a) => ha(Cy, {
      ref: a,
      iconNode: t,
      className: kd(
        `lucide-${by(xl(e))}`,
        `lucide-${e}`,
        n
      ),
      ...o
    })
  );
  return r.displayName = xl(e), r;
};
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sy = [
  ["path", { d: "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8", key: "v9h5vc" }],
  ["path", { d: "M21 3v5h-5", key: "1q7to0" }],
  ["path", { d: "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16", key: "3uifl3" }],
  ["path", { d: "M8 16H3v5", key: "1cv678" }]
], ky = Id("refresh-cw", Sy);
/**
 * @license lucide-react v0.511.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Iy = [
  ["path", { d: "M3 6h18", key: "d0wm0j" }],
  ["path", { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", key: "4alrt4" }],
  ["path", { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", key: "v07s0e" }],
  ["line", { x1: "10", x2: "10", y1: "11", y2: "17", key: "1uufr5" }],
  ["line", { x1: "14", x2: "14", y1: "11", y2: "17", key: "xtxkd" }]
], wy = Id("trash-2", Iy), Py = ({
  makePrediction: e,
  selectedPlayersCount: t,
  openPlayerSelectionModal: r,
  isPastGameWeek: n,
  onOpenDeleteConfirmation: o,
  openCaptainSelectionModal: a,
  captain: i,
  viceCaptain: s,
  isSaving: l = !1
}) => {
  const d = Be(), { selectedGameWeekPrediction: u } = ue(Ft), { selectedGoalkeeper: p, selectedDefenders: f, selectedMidfielders: g, selectedForwards: h } = ue(or);
  if (n) return /* @__PURE__ */ c.jsx(c.Fragment, {});
  const A = t() === 11, b = i !== null && s !== null, { hasPrediction: C, hasChanges: v } = R2(
    p,
    f,
    g,
    h,
    i,
    s,
    u
  ), S = A && b ? C && !v ? {
    variant: "soft",
    color: "neutral",
    text: d("editTeam"),
    action: "edit"
  } : {
    variant: "solid",
    color: "success",
    text: d(l ? "saving" : "saveTeam"),
    action: "save"
  } : null;
  return /* @__PURE__ */ c.jsx(
    U,
    {
      position: "fixed",
      bottom: 0,
      left: 0,
      right: 0,
      bgcolor: "#fff",
      px: 1.5,
      py: 1.5,
      display: "flex",
      zIndex: 20,
      sx: {
        boxShadow: "0px -2px 20px -9px rgba(0,0,0,0.9)"
      },
      children: A && b ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
        /* @__PURE__ */ c.jsx(
          ge,
          {
            fullWidth: !0,
            variant: S == null ? void 0 : S.variant,
            color: S == null ? void 0 : S.color,
            sx: { mr: 1 },
            disabled: l,
            onClick: () => {
              (S == null ? void 0 : S.action) === "edit" ? r() : e();
            },
            startDecorator: l && (S == null ? void 0 : S.action) === "save" ? /* @__PURE__ */ c.jsx(Br, { size: "sm" }) : void 0,
            children: S == null ? void 0 : S.text
          }
        ),
        /* @__PURE__ */ c.jsx(ge, { variant: "outlined", color: "neutral", onClick: o, disabled: l, children: /* @__PURE__ */ c.jsx(wy, {}) })
      ] }) : A && !b ? /* @__PURE__ */ c.jsx(
        ge,
        {
          fullWidth: !0,
          variant: "solid",
          color: "success",
          disabled: l,
          onClick: () => {
            a();
          },
          children: d("selectCaptainAndViceCaptain")
        }
      ) : /* @__PURE__ */ c.jsx(
        ge,
        {
          fullWidth: !0,
          variant: "outlined",
          color: "primary",
          disabled: l,
          onClick: () => {
            r();
          },
          children: d("searchPlayers")
        }
      )
    }
  );
}, Ty = "data:image/png;base64,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", Oy = ({
  formation: e,
  selected: t,
  changeFormation: r
}) => /* @__PURE__ */ c.jsxs(
  U,
  {
    bgcolor: t ? "white" : "neutral.100",
    minWidth: "110px",
    borderColor: t ? "primary.500" : "neutral.300",
    p: 2,
    mr: 1,
    borderRadius: "lg",
    display: "flex",
    justifyContent: "center",
    position: "relative",
    overflow: "visible",
    zIndex: 5,
    onClick: () => r(e),
    sx: {
      "&:first-of-type": { ml: 1 },
      borderWidth: t ? 2 : 1.4,
      borderStyle: "solid",
      opacity: t ? 1 : 0.6
    },
    children: [
      t && /* @__PURE__ */ c.jsx(
        oy,
        {
          color: "primary",
          sx: { position: "absolute", top: "-12px", zIndex: 10, bgcolor: "white" }
        }
      ),
      /* @__PURE__ */ c.jsxs(U, { textAlign: "center", children: [
        /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx("img", { src: Ty, width: "50px", alt: "formation" }) }),
        /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", textAlign: "center", fontSize: "xs", children: e }) })
      ] })
    ]
  }
), Vy = ({
  showFormationDialog: e,
  setShowFormationDialog: t,
  changeFormation: r,
  changeFormationConfirmation: n,
  setChangeFormationConfirmation: o,
  desiredFormation: a,
  deselectPlayer: i
}) => {
  const s = Be(), [l, d] = _(""), { formation: u, selectedDefenders: p, selectedMidfielders: f, selectedForwards: g } = ue(or), h = Gt(() => {
    const b = parseInt(u.split("-")[0], 10), C = parseInt(u.split("-")[1], 10), v = parseInt(u.split("-")[2], 10), k = parseInt(a.split("-")[0], 10), S = parseInt(a.split("-")[1], 10), I = parseInt(a.split("-")[2], 10);
    b > k && p.length > k ? d("DEF") : C > S && f.length > S ? d("MID") : v > I && g.length > I ? d("FWD") : d("");
  }, [u, a, p, f, g]);
  Te(() => {
    h();
  }, [h]);
  const A = (() => {
    switch (l) {
      case "DEF":
        return p;
      case "MID":
        return f;
      case "FOR":
        return g;
      default:
        return [];
    }
  })();
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(
      U,
      {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        bgcolor: "rgba(0, 0, 0, 0.6)",
        zIndex: 19,
        sx: {
          opacity: e ? 1 : 0,
          visibility: e ? "visible" : "hidden",
          transition: "opacity 0.3s ease, visibility 0.3s ease"
        },
        onClick: () => t(!1)
      }
    ),
    /* @__PURE__ */ c.jsxs(
      U,
      {
        bgcolor: n ? "neutral.600" : "#fff",
        position: "fixed",
        bottom: e ? 0 : "-600px",
        left: 0,
        right: 0,
        zIndex: 20,
        sx: { borderTopLeftRadius: "15px", borderTopRightRadius: "15px", transition: "bottom 0.3s ease 0s" },
        children: [
          /* @__PURE__ */ c.jsxs(U, { textAlign: "center", mt: 2, mb: 1.3, children: [
            n && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
              /* @__PURE__ */ c.jsx(J, { level: "body-lg", fontWeight: "bold", textColor: "#fff", mb: 1, children: s("changingFormation") }),
              l === "" ? /* @__PURE__ */ c.jsx(J, { level: "body-sm", textColor: "neutral.100", lineHeight: 1.3, mb: 4, children: s("chooseNewFormation") }) : /* @__PURE__ */ c.jsx(J, { level: "body-sm", textColor: "neutral.100", lineHeight: 1.3, mb: 4, children: s("removePlayerToChangeFormation", {
                oldFormation: u,
                newFormation: a,
                position: l
              }) })
            ] }),
            !n && /* @__PURE__ */ c.jsx(J, { level: "body-lg", fontWeight: "bold", textColor: "neutral.900", children: s("selectFormation") })
          ] }),
          n && /* @__PURE__ */ c.jsx(U, { display: "flex", mb: 2, overflow: "scroll", children: A.map((b, C) => /* @__PURE__ */ c.jsxs(
            U,
            {
              bgcolor: "neutral.100",
              borderRadius: "sm",
              minWidth: "100px",
              minHeight: "100px",
              mt: 1.2,
              mr: 1,
              position: "relative",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              sx: { "&:first-of-type": { ml: 1 } },
              children: [
                /* @__PURE__ */ c.jsx(
                  bd,
                  {
                    color: "danger",
                    sx: vy,
                    onClick: () => i(b)
                  }
                ),
                /* @__PURE__ */ c.jsx("img", { src: En(b), width: "50px", alt: "player" }),
                /* @__PURE__ */ c.jsx(
                  J,
                  {
                    fontWeight: "bold",
                    level: "body-xs",
                    textAlign: "center",
                    bgcolor: "neutral.300",
                    py: 0.1,
                    px: 1,
                    zIndex: 4,
                    mt: -1.5,
                    borderRadius: "sm",
                    children: Or(b.name)
                  }
                )
              ]
            },
            C
          )) }),
          !n && /* @__PURE__ */ c.jsx(
            U,
            {
              pb: 1,
              display: "flex",
              overflow: "scroll",
              pt: 1.5,
              bgcolor: n ? "neutral.600" : "#fff",
              children: gy.map((b, C) => /* @__PURE__ */ c.jsx(
                Oy,
                {
                  formation: b,
                  selected: u === b,
                  changeFormation: r
                },
                `formation-box-${C}`
              ))
            }
          ),
          /* @__PURE__ */ c.jsx(Ne, { sx: { bgcolor: "#f2f2f2" } }),
          /* @__PURE__ */ c.jsx(U, { p: 2, bgcolor: "#fff", children: n ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
            /* @__PURE__ */ c.jsx(
              ge,
              {
                fullWidth: !0,
                sx: { mb: 1 },
                disabled: l !== "",
                onClick: () => {
                  r(a), o(!1);
                },
                children: s("saveNewFormation", { formation: a })
              }
            ),
            /* @__PURE__ */ c.jsx(
              ge,
              {
                fullWidth: !0,
                variant: "outlined",
                onClick: () => {
                  o(!1);
                },
                children: s("keepCurrentFormation", { formation: u })
              }
            )
          ] }) : /* @__PURE__ */ c.jsx(
            ge,
            {
              fullWidth: !0,
              onClick: () => {
                r(u), t(!1);
              },
              children: s("saveFormation")
            }
          ) })
        ]
      }
    )
  ] });
}, wd = ({
  open: e,
  dialogTitle: t,
  dialogDescription: r,
  confirmLabel: n,
  denyLabel: o,
  confirmAction: a,
  denyAction: i
}) => /* @__PURE__ */ c.jsx(
  U,
  {
    position: "fixed",
    zIndex: 49,
    bottom: 0,
    top: 0,
    left: 0,
    right: 0,
    sx: {
      background: "rgba(0, 0, 0, 0.8)",
      opacity: e ? 1 : 0,
      visibility: e ? "visible" : "hidden",
      transition: "opacity 0.2s ease-in-out, visibility 0.2s ease-in-out"
    },
    children: /* @__PURE__ */ c.jsxs(
      U,
      {
        position: "fixed",
        zIndex: 50,
        bottom: 0,
        left: 0,
        right: 0,
        bgcolor: "#fff",
        p: 2,
        sx: {
          borderTopLeftRadius: "8px",
          borderTopRightRadius: "8px",
          transform: e ? "translateY(0)" : "translateY(100%)",
          transition: "transform 0.25s ease-out"
        },
        children: [
          /* @__PURE__ */ c.jsx(J, { textAlign: "center", level: "h4", children: t }),
          /* @__PURE__ */ c.jsx(J, { textAlign: "center", level: "body-sm", children: r }),
          /* @__PURE__ */ c.jsxs(U, { mt: 2, display: "flex", flexDirection: "row", gap: 1.5, children: [
            /* @__PURE__ */ c.jsx(
              ge,
              {
                variant: "soft",
                color: "neutral",
                fullWidth: !0,
                onClick: () => {
                  i();
                },
                children: o
              }
            ),
            /* @__PURE__ */ c.jsx(
              ge,
              {
                variant: "solid",
                color: "primary",
                fullWidth: !0,
                onClick: () => {
                  a();
                },
                children: n
              }
            )
          ] })
        ]
      }
    )
  }
), Ey = ({ open: e, onClose: t, onConfirm: r }) => {
  const n = Be();
  return /* @__PURE__ */ c.jsx(
    wd,
    {
      open: e,
      dialogTitle: n("deleteTeam"),
      dialogDescription: n("confirmDeleteTeam"),
      confirmLabel: n("deleteTeam"),
      denyLabel: n("cancel"),
      confirmAction: r,
      denyAction: t
    }
  );
}, Ky = ({
  selectedPlayersCount: e,
  setGoalKeeper: t,
  setDefenders: r,
  setMidfielders: n,
  setForwards: o,
  setCaptain: a,
  setViceCaptain: i
}) => {
  const s = Be(), [l, d] = _(!1), [u, p] = _(null), [f, g] = _(!1), [h, m] = _(!1), A = ue(Dr), { template: b } = ue(St), { selectedGameWeek: C } = ue(Ft);
  vn.useEffect(() => {
    (async () => {
      if (!(!b || !C || f))
        try {
          const S = Lt(b);
          if (!S) return;
          const I = b.groups.findIndex((w) => w.groupId === S.groupId);
          if (I <= 0) return;
          for (let w = I - 1; w >= 0; w--) {
            const P = b.groups[w], E = await new Promise(
              (K) => on(A, P, K)
            );
            if (E && E.fixtures && E.fixtures.length === 11) {
              m(!0);
              break;
            }
          }
        } catch (S) {
          console.error("Error checking for previous predictions:", S);
        } finally {
          g(!0);
        }
    })();
  }, [b, C, A, f]), console.log("FetchPreviousTeamButton visibility check:", {
    selectedPlayersCount: e(),
    hasCheckedForPreviousPredictions: f,
    hasPreviousPredictions: h,
    shouldShow: e() === 0 && f && h
  });
  const v = async () => {
    d(!0), p(null);
    try {
      const k = Lt(b);
      if (!k) {
        p("Current gameweek not found");
        return;
      }
      const S = b.groups.findIndex((M) => M.groupId === k.groupId);
      if (S <= 0) {
        p("No previous gameweeks available");
        return;
      }
      let I = null, w = null;
      for (let M = S - 1; M >= 0; M--) {
        const j = b.groups[M], T = await new Promise(
          (O) => on(A, j, O)
        );
        if (T && T.fixtures && T.fixtures.length === 11) {
          I = T, w = j;
          break;
        }
      }
      if (!I || !w) {
        p("No previous team found");
        return;
      }
      console.log("Fetching team from gameweek:", w.label), console.log("Latest prediction:", I);
      let P = null;
      const E = [], K = [], R = [];
      let B = null, V = null;
      I.fixtures.forEach((M) => {
        const j = M.prediction.playerModel, T = M.prediction.playerRole;
        switch (T === "CAPTAIN" ? B = j : T === "VICE_CAPTAIN" && (V = j), j.position) {
          case "keeper":
            P || (P = j);
            break;
          case "defender":
            E.push(j);
            break;
          case "midfielder":
            K.push(j);
            break;
          case "forward":
            R.push(j);
            break;
        }
      }), console.log("Setting team players:", {
        defendersCount: E.length,
        midfieldersCount: K.length,
        forwardsCount: R.length,
        hasGoalKeeper: !!P,
        hasCaptain: !!B,
        hasViceCaptain: !!V
      }), t(P), r(E), n(K), o(R), a(B), i(V), console.log(
        "Team successfully set with",
        E.length + K.length + R.length + (P ? 1 : 0),
        "players"
      );
    } catch (k) {
      console.error("Error fetching previous team:", k), p("Failed to fetch previous team. Please try again.");
    } finally {
      d(!1);
    }
  };
  return /* @__PURE__ */ c.jsxs(U, { sx: { display: "flex", flexDirection: "column", alignItems: "center" }, children: [
    u && /* @__PURE__ */ c.jsx(J, { level: "body-sm", color: "danger", mb: 2, textAlign: "center", children: u }),
    /* @__PURE__ */ c.jsx(
      ge,
      {
        variant: "outlined",
        color: "primary",
        onClick: v,
        disabled: l,
        startDecorator: l ? /* @__PURE__ */ c.jsx(Br, { size: "sm" }) : /* @__PURE__ */ c.jsx(ky, { size: 16 }),
        fullWidth: !0,
        sx: { minWidth: 200 },
        children: s(l ? "fetchingTeam" : "fetchMyLatestTeam")
      }
    )
  ] });
}, yl = ({ match: e, club: t }) => {
  var n, o, a, i;
  const r = (s, l) => {
    const d = s.homeTeam.id === l.id, u = s.scores.ftScore.homeGoals, p = s.scores.ftScore.awayGoals;
    let f;
    u === p ? f = "draw" : d && u > p || !d && p > u ? f = "win" : f = "loss";
    const g = f === "win" ? "#008500" : f === "draw" ? "#E97A03" : "#DB0007", h = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], m = new Date(s.kickoffAt), A = `${m.getDate()} ${h[m.getMonth()]}`;
    return s.status.type === "finished" ? /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
      /* @__PURE__ */ c.jsx(J, { level: "body-sm", fontWeight: "bold", textColor: "#3B3B3B", children: `${s.scores.ftScore.homeGoals}:${s.scores.ftScore.awayGoals}` }),
      /* @__PURE__ */ c.jsx(
        U,
        {
          bgcolor: g,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "20px",
          height: "20px",
          ml: 1,
          borderRadius: "50%",
          children: f === "draw" ? /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "#fff", fontWeight: "bold", children: "D" }) : f === "win" ? /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "#fff", fontWeight: "bold", children: "W" }) : /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "#fff", fontWeight: "bold", children: "L" })
        }
      )
    ] }) : /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(J, { level: "body-xs", children: A }) });
  };
  return /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
    /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", py: 1, children: [
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ c.jsx(
          Vn,
          {
            size: "sm",
            src: (n = Fn(e, t)) == null ? void 0 : n.logo,
            alt: (o = Fn(e, t)) == null ? void 0 : o.name,
            sx: { mr: 1 }
          }
        ),
        /* @__PURE__ */ c.jsxs(J, { level: "body-xs", children: [
          (a = Fn(e, t)) == null ? void 0 : a.name,
          " (",
          (i = Fn(e, t)) == null ? void 0 : i.homeOrAway,
          ")"
        ] })
      ] }),
      /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "flex-end", alignItems: "center", children: r(e, t) })
    ] })
  ] });
}, Ry = ({ player: e, templateMatches: t }) => {
  const [r, n] = _([]), [o, a] = _(null);
  Te(() => {
    if (e.id && t.length > 0) {
      const l = Ue(e);
      a(l);
      const d = t.filter((u) => u.homeTeam.id === (l == null ? void 0 : l.id) || u.awayTeam.id === (l == null ? void 0 : l.id));
      n(d);
    }
  }, [e]);
  const i = (r == null ? void 0 : r.filter((l) => l.status.type === "finished").reverse()) ?? [], s = (r == null ? void 0 : r.filter((l) => l.status.type !== "finished")) ?? [];
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(U, { mb: 2, children: /* @__PURE__ */ c.jsxs(Fi, { "aria-label": "tabs", defaultValue: 0, sx: { bgcolor: "transparent" }, children: [
    /* @__PURE__ */ c.jsxs(
      Mi,
      {
        disableUnderline: !0,
        sx: {
          p: 0.4,
          gap: 0.4,
          borderRadius: "md",
          bgcolor: "white",
          [`& .${fn.root}[aria-selected="true"]`]: {
            // boxShadow: "sm",
            bgcolor: "neutral.900",
            color: "white",
            fontWeight: "bold"
          },
          [`& .${fn.root}[aria-selected="true"] p`]: {
            // boxShadow: "sm",
            color: "white"
          },
          "& > div": {
            display: "flex",
            justifyContent: "center"
          }
        },
        children: [
          /* @__PURE__ */ c.jsx(Yt, { disableIndicator: !0, sx: { width: "100%" }, children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: "Results" }) }),
          /* @__PURE__ */ c.jsx(Yt, { disableIndicator: !0, sx: { width: "100%" }, children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: "Upcoming" }) })
        ]
      }
    ),
    /* @__PURE__ */ c.jsx(Xt, { value: 0, sx: { mx: 0, px: 0 }, children: /* @__PURE__ */ c.jsxs(Ct, { sx: { bgcolor: "white", border: "none" }, children: [
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", children: [
        /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: "Opponent" }),
        /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: "Result" })
      ] }),
      /* @__PURE__ */ c.jsx(U, { children: i == null ? void 0 : i.map((l, d) => /* @__PURE__ */ c.jsx(yl, { match: l, club: o }, d)) })
    ] }) }),
    /* @__PURE__ */ c.jsx(Xt, { value: 1, sx: { mx: 0, px: 0 }, children: /* @__PURE__ */ c.jsxs(Ct, { sx: { bgcolor: "white", border: "none" }, children: [
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", children: [
        /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: "Opponent" }),
        /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: "Date" })
      ] }),
      /* @__PURE__ */ c.jsx(U, { children: s == null ? void 0 : s.map((l, d) => /* @__PURE__ */ c.jsx(yl, { match: l, club: o }, d)) })
    ] }) })
  ] }) }) });
}, Uy = ({ player: e }) => /* @__PURE__ */ c.jsxs(Ct, { sx: { bgcolor: "white", border: "none" }, children: [
  /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: "Info" }) }),
  /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
  /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: "Country" }) }),
    /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: e == null ? void 0 : e.country.name }) })
  ] }),
  (e == null ? void 0 : e.birthDate) && /* @__PURE__ */ c.jsxs(c.Fragment, { children: [
    /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
    /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: "Birth Date" }) }),
      /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: e == null ? void 0 : e.birthDate }) })
    ] }),
    /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
    /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
      /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: "Age" }) }),
      /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsxs(J, { level: "body-sm", children: [
        O2(e == null ? void 0 : e.birthDate),
        " years"
      ] }) })
    ] })
  ] })
] }), jy = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAAoCAYAAAB5ADPdAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPnSURBVHgBtVjrsdM6EN71I697Zm74dX/iWwGHCkgHCR2ECoAK4FTAUAFQAUMFHDoIHQRmYIbh5ZOT2LFjS+z6Fdl5yInNN6NYllarT7vrlRSEEyGlHNLjBZVLKjMqH6m4iohD5QEVlnuIiHP4W/D921HoLV+sV7e/12tf6rD0POmtFjJYLV8Fq8XklLnwWGdqFfE48LwnJDlU+8JYQq/XB9uySmOEELD0VmAbAAaq6nFuWfa1aXeudNbDw2QSF00TAusVt+3ILYMQJJpwMRiASQSWvk+kIrjo2PvUgt0dgGEYXH1N5SC5HVK+7zsmwnu723PytmgTQBxt4BC8cENkJAy6dsU6ykRoQKc3KN43YTAHjB52Ohezo6SYEMr4PdnKsbt9WpWZtAsRwybwoQlM0war0y3ew7VH0whXoHW/3+/PVVmj9CLiZ0yI6zKOt+20SsSj4aeFocQeL1JKARQQQ5TRqx3ZvMJWkiin6sACTAgNaEQqs3qiO47UrhF/2SXZopJYaYt0NVJRej4plVCqW5TeUcKzvaTQMkdVZWzior+i+BRgxcpS9QIkpEfZF78lRQ0Tw7ScqjKprKiJpVAZW7VSottM4m1aIkUY75s0VlaE2BIpKQ71jwtSmdkm+yZdeEF58JnEUMk8a85plUSc9Rcu5FlGkG6epUldIhTGMbSBsqUk3K6DQ/3TnNS4qiSKBdz4613/N8xVORZ+uGOtDOOc1AgqhL4tVkm9Y1kutAxaqMuEbiqhkeGSXcik3mwHSPh+60GUWUgiXJWG7F/dSfin23/KzwW5cBns7KfvaOdwaf/E5/Ry5W8i96u72MYRwvy/4fA1tAA1tdi2OacguOb6z6VHYRLk/S+Jy5QrSYQxsW9fftwPY/EoG+CSHB8t2H3zQvmez7kWqfLrjBre8KJ5rl+ef/Xp8+c7NNeTXEAbueTjt/SYcNBvAg/OgWX3wEw3ZJcmv6OTr5N4blJ251kpHVqkllofTu1sKMT5OetUt9ch9S//7Nuz6kL8BVJDTgWygaV4fGppOawjXst9TVyXIz3JYmuknDZI5Troa3Z0svVIxe2QkjV3hKOkkqMEx1ODdFDWl+hxdHI6Sw1FS4QY2Xbi6OR0pBwp2iOVxZU22LWWki2cDAqkuhqTcmSb7ktJ3dXJaS0F7aPxhuxgS0dgRqarsaXuYsPr+h40D/R2LZVM5+jktO4zGlzXdyYzU126rUYf6GQpbImYcr876kILjuN/KhO60o/pCj+CBjDQvCb3faAqPXF2TPakgOH/kShvXZpo3pP851riBnTKUnJOdzMXDZzFMv5IRGa9XjSjo3ntO+Qfd9bweNGCqk0AAAAASUVORK5CYII=", By = ({ player: e }) => {
  const [t, r] = _([]), n = ue(Dr);
  return Te(() => {
    e && D2(n, e.id, r);
  }, [e, n]), /* @__PURE__ */ c.jsxs(Ct, { sx: { bgcolor: "white", mb: 6, border: "none" }, children: [
    /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: "Season Stats" }) }),
    V2(t, e.position).map((o, a) => /* @__PURE__ */ c.jsxs(vn.Fragment, { children: [
      /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
      /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
        /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: o.label }) }),
        /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: o.value }) })
      ] })
    ] }, a))
  ] });
}, Dy = ({
  player: e,
  isCaptain: t,
  isViceCaptain: r,
  onOpenCaptainSelection: n
}) => {
  var l, d;
  const [o, a] = _("TBD"), { templateMatches: i } = ue(St);
  Te(() => {
    !i || !e || s(e);
  }, [e, i]);
  const s = (u) => {
    var f;
    if (!u) {
      a("TBD");
      return;
    }
    const p = ((f = Ue(u)) == null ? void 0 : f.id) ?? null;
    if (p) {
      const g = qi(p, i);
      a((g == null ? void 0 : g.code) ?? "TBD");
    }
  };
  return /* @__PURE__ */ c.jsxs(U, { sx: { display: "flex", flexDirection: "column", gap: 2 }, children: [
    (t || r) && /* @__PURE__ */ c.jsxs(Ct, { sx: { bgcolor: "white", border: "none" }, children: [
      /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", level: "body-sm", children: t ? "Captain" : "Vice Captain" }) }),
      /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
      /* @__PURE__ */ c.jsxs(ub, { direction: "row", alignItems: "center", gap: 2, justifyContent: "space-between", children: [
        /* @__PURE__ */ c.jsxs(U, { display: "flex", alignItems: "center", gap: 1, children: [
          /* @__PURE__ */ c.jsx(
            U,
            {
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              position: "relative",
              py: 1,
              sx: {
                borderRadius: "50%",
                background: "rgba(0, 0, 0, 0.05)",
                width: "55px",
                height: "55px"
              },
              children: /* @__PURE__ */ c.jsx(
                "img",
                {
                  src: ((d = (l = Ue(e)) == null ? void 0 : l.assets) == null ? void 0 : d.logo) ?? jy,
                  style: {
                    filter: `grayscale(${e ? 0 : 1})`,
                    marginBottom: "-1.5rem",
                    zIndex: 1,
                    position: "relative",
                    width: "40px"
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ c.jsxs(U, { children: [
            /* @__PURE__ */ c.jsx(J, { level: "body-sm", fontWeight: "bold", children: e.name }),
            /* @__PURE__ */ c.jsxs(J, { level: "body-xs", children: [
              "vs. ",
              o
            ] })
          ] })
        ] }),
        /* @__PURE__ */ c.jsx(
          ge,
          {
            variant: "soft",
            size: "sm",
            color: "neutral",
            onClick: () => {
              n && n();
            },
            children: "Change"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ c.jsx(By, { player: e })
  ] });
}, My = ({
  player: e,
  deselectPlayer: t,
  setSelectedPlayer: r,
  templateMatches: n,
  onOpenCaptainSelection: o
}) => {
  var A, b, C;
  const a = Be(), [i, s] = _(!1), [l, d] = _(!1), { selectedCaptain: u, selectedViceCaptain: p } = ue(or);
  Te(() => {
    e.id && s(!0);
  }, [e]);
  const f = () => {
    t(e), r(null), s(!1), d(!1);
  }, g = () => {
    d(!1), r(null);
  }, h = (u == null ? void 0 : u.id) === e.id, m = (p == null ? void 0 : p.id) === e.id;
  return /* @__PURE__ */ c.jsx(
    Yo,
    {
      open: i,
      onClose: () => {
        s(!1), r(null);
      },
      children: /* @__PURE__ */ c.jsxs(Bi, { layout: "fullscreen", sx: { p: 0 }, children: [
        /* @__PURE__ */ c.jsxs(
          U,
          {
            sx: {
              display: "flex",
              flexDirection: "column",
              height: "100vh"
            },
            children: [
              /* @__PURE__ */ c.jsxs(
                U,
                {
                  sx: {
                    bgcolor: "#000",
                    color: "white",
                    pt: 5,
                    pb: 3,
                    position: "relative",
                    textAlign: "center"
                  },
                  children: [
                    /* @__PURE__ */ c.jsx(
                      ji,
                      {
                        sx: {
                          position: "absolute",
                          top: 8,
                          right: 8,
                          color: "white",
                          bgcolor: "#212527",
                          borderRadius: "50%",
                          "& svg": {
                            fill: "white"
                          }
                        }
                      }
                    ),
                    /* @__PURE__ */ c.jsx(
                      U,
                      {
                        sx: {
                          width: 80,
                          height: 80,
                          borderRadius: "50%",
                          bgcolor: "white",
                          mx: "auto",
                          mb: 1,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          p: 1
                        },
                        children: /* @__PURE__ */ c.jsx(
                          Vn,
                          {
                            src: ((b = (A = Ue(e)) == null ? void 0 : A.assets) == null ? void 0 : b.logo) ?? "",
                            alt: e.name,
                            sx: {
                              width: "100%",
                              height: "100%",
                              borderRadius: 0,
                              bgcolor: "white",
                              "& > div": {
                                bgcolor: "white"
                              }
                            }
                          }
                        )
                      }
                    ),
                    /* @__PURE__ */ c.jsx(
                      J,
                      {
                        level: "h4",
                        textColor: "white",
                        sx: {
                          fontWeight: "800",
                          mb: 0.5
                        },
                        children: e.name
                      }
                    ),
                    /* @__PURE__ */ c.jsxs(J, { level: "body-md", textColor: "white", children: [
                      (C = Ue(e)) == null ? void 0 : C.name,
                      " | ",
                      T2(e.position),
                      e != null && e.shirtNumber ? `| #${e.shirtNumber}` : ""
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ c.jsxs(
                Fi,
                {
                  sx: {
                    flex: 1,
                    display: "flex",
                    flexDirection: "column"
                  },
                  children: [
                    /* @__PURE__ */ c.jsxs(
                      Mi,
                      {
                        sx: {
                          bgcolor: "neutral.900",
                          justifyContent: "space-around",
                          [`& .${fn.root}[aria-selected="true"]`]: {
                            bgcolor: "neutral.900",
                            color: "#fff",
                            fontWeight: "bold",
                            "&:after": {
                              bgcolor: "#20B620",
                              height: "3px"
                            }
                          },
                          [`& .${fn.root}[aria-selected="true"] p`]: {
                            color: "white"
                          }
                        },
                        children: [
                          /* @__PURE__ */ c.jsx(Yt, { sx: { flex: 1, color: "neutral.300" }, children: a("stats") }),
                          /* @__PURE__ */ c.jsx(Yt, { sx: { flex: 1, color: "neutral.300" }, children: a("matches") }),
                          /* @__PURE__ */ c.jsx(Yt, { sx: { flex: 1, color: "neutral.300" }, children: a("profile") })
                        ]
                      }
                    ),
                    /* @__PURE__ */ c.jsxs(j1, { sx: { p: 2, mt: 5, bgcolor: "neutral.50" }, children: [
                      /* @__PURE__ */ c.jsx(Xt, { value: 0, sx: { p: 0, flex: 1 }, children: /* @__PURE__ */ c.jsx(
                        Dy,
                        {
                          player: e,
                          isCaptain: h,
                          isViceCaptain: m,
                          onOpenCaptainSelection: () => {
                            s(!1), r(null), o && o();
                          }
                        }
                      ) }),
                      /* @__PURE__ */ c.jsx(Xt, { value: 1, sx: { p: 0, flex: 1 }, children: /* @__PURE__ */ c.jsx(Ry, { player: e, templateMatches: n }) }),
                      /* @__PURE__ */ c.jsx(Xt, { value: 2, sx: { p: 0, flex: 1 }, children: /* @__PURE__ */ c.jsx(Uy, { player: e }) })
                    ] })
                  ]
                }
              ),
              /* @__PURE__ */ c.jsx(
                U,
                {
                  sx: {
                    bgcolor: "#fff",
                    height: "70px",
                    boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.1)",
                    px: 1,
                    py: 2,
                    display: "flex",
                    zIndex: 5
                  },
                  children: /* @__PURE__ */ c.jsxs(mr, { container: !0, spacing: 2, sx: { width: "100%", mx: "auto" }, children: [
                    /* @__PURE__ */ c.jsx(mr, { xs: 6, children: /* @__PURE__ */ c.jsx(
                      ge,
                      {
                        variant: "soft",
                        color: "neutral",
                        fullWidth: !0,
                        sx: { py: 1.2 },
                        onClick: () => {
                          d(!0);
                        },
                        children: "Remove Player"
                      }
                    ) }),
                    /* @__PURE__ */ c.jsx(mr, { xs: 6, children: /* @__PURE__ */ c.jsx(
                      ge,
                      {
                        variant: "solid",
                        color: "primary",
                        fullWidth: !0,
                        sx: { py: 1.2 },
                        onClick: () => {
                          s(!1), r(null);
                        },
                        children: "See Team"
                      }
                    ) })
                  ] })
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ c.jsx(
          wd,
          {
            open: l,
            dialogTitle: a("removePlayer"),
            dialogDescription: `${a("confirmRemovePlayer")} ${e == null ? void 0 : e.name}?`,
            confirmLabel: a("yesRemove"),
            denyLabel: a("noCancel"),
            confirmAction: f,
            denyAction: g
          }
        )
      ] })
    }
  );
}, Qt = ({
  position: e,
  onClick: t,
  player: r,
  templateMatches: n,
  isCaptain: o = !1,
  isViceCaptain: a = !1
}) => {
  var u, p;
  const i = Be(), [s, l] = _("TBD");
  Te(() => {
    d(r);
  }, [r]);
  const d = (f) => {
    var h;
    if (!f) {
      l("TBD");
      return;
    }
    const g = ((h = Ue(f)) == null ? void 0 : h.id) ?? null;
    if (g) {
      const m = qi(g, n);
      l((m == null ? void 0 : m.code) ?? "TBD");
    }
  };
  return /* @__PURE__ */ c.jsxs(U, { sx: { width: "70px", height: 80, p: 0 }, position: "relative", zIndex: 1, onClick: () => t(e), children: [
    /* @__PURE__ */ c.jsxs(
      U,
      {
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        position: "relative",
        py: 1,
        sx: {
          borderRadius: "50%",
          background: "rgba(0, 100, 0, 1)",
          width: "60px",
          height: "60px",
          mx: "auto"
        },
        children: [
          r && (o || a) && /* @__PURE__ */ c.jsx(
            U,
            {
              sx: {
                position: "absolute",
                top: "-3px",
                right: "-2px",
                zIndex: 20,
                backgroundColor: o ? "#FFD700" : "#C0C0C0",
                borderRadius: "50%",
                width: "22px",
                height: "22px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "2px solid white",
                boxShadow: "0 2px 4px rgba(0,0,0,0.3)"
              },
              children: /* @__PURE__ */ c.jsx(
                J,
                {
                  sx: {
                    fontSize: "12px",
                    fontWeight: "bold",
                    color: o ? "#000" : "#333",
                    lineHeight: 1
                  },
                  children: o ? "C" : "V"
                }
              )
            }
          ),
          /* @__PURE__ */ c.jsx(
            "img",
            {
              src: ((p = (u = Ue(r)) == null ? void 0 : u.assets) == null ? void 0 : p.logo) ?? Ad,
              style: {
                filter: `grayscale(${r ? 0 : 1})`,
                zIndex: 1,
                position: "relative",
                width: "40px",
                height: "40px"
              }
            }
          ),
          !r && /* @__PURE__ */ c.jsx(
            vd,
            {
              sx: {
                color: "black",
                position: "absolute",
                top: "17px",
                zIndex: 10,
                width: 16,
                height: 16
              }
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ c.jsxs(U, { position: "absolute", left: 0, right: 0, bottom: 8, children: [
      /* @__PURE__ */ c.jsx(
        U,
        {
          textAlign: "center",
          bgcolor: "neutral.500",
          zIndex: 2,
          position: "relative",
          sx: { borderTopRightRadius: "5px", borderTopLeftRadius: "5px", overflow: "hidden" },
          children: /* @__PURE__ */ c.jsx(
            J,
            {
              fontSize: 11,
              lineHeight: 1.5,
              textColor: "#fff",
              sx: { bgcolor: "#3b3b3b" },
              fontWeight: "bold",
              noWrap: !!(r && Or(r == null ? void 0 : r.name).length > 11),
              children: r ? Or(r == null ? void 0 : r.name) : i("addPlayer")
            }
          )
        }
      ),
      /* @__PURE__ */ c.jsx(
        U,
        {
          textAlign: "center",
          bgcolor: "neutral.100",
          zIndex: 2,
          position: "relative",
          sx: { borderBottomRightRadius: "5px", borderBottomLeftRadius: "5px" },
          children: /* @__PURE__ */ c.jsxs(J, { fontSize: 11, lineHeight: 1.5, fontWeight: "light", children: [
            "vs. ",
            /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", children: s })
          ] })
        }
      )
    ] })
  ] });
}, Yr = ["keeper", "defender", "midfielder", "forward"], Fy = "Failed to fetch players", qy = (e, t, r, n, o, a, i, s, l, d, u) => ({
  keeper: { selected: e, setter: o, maxCount: 1 },
  defender: { selected: t, setter: a, maxCount: l },
  midfielder: { selected: r, setter: i, maxCount: d },
  forward: { selected: n, setter: s, maxCount: u },
  "": { selected: null, setter: () => {
  }, maxCount: 0 }
}), Jy = (e, t, r, n) => {
  const [o, a] = _([]), [i, s] = _([]), [l, d] = _(!1), [u, p] = _(null), f = Jt({}), g = 5 * 60 * 1e3, h = Gt((v, k) => v.filter((S) => {
    const I = Ue(S.playerModel);
    return (I == null ? void 0 : I.id) && k.includes(I.id);
  }), []), m = Gt(
    async (v) => {
      if (!e) {
        console.error("No game template ID available"), p("Configuration error"), d(!1);
        return;
      }
      if (t.length === 0) {
        console.error("No teams available"), p("No teams found in competition"), d(!1);
        return;
      }
      p(null), d(!0);
      const k = v === "" ? null : v, S = `${e}-${k}`;
      try {
        let I;
        const w = f.current[S], P = Date.now();
        if (w && P - w.timestamp < g)
          I = w.data, console.log("Using cached data for", S);
        else {
          if (!window.fuSDK)
            throw new Error("SDK not initialized");
          I = await window.fuSDK.fantasy.getPlayersPoints(e, k), f.current[S] = {
            data: I,
            timestamp: P
          }, console.log("Fetched fresh data for", S);
        }
        const E = h(I.data, t);
        s(E), a(E);
      } catch (I) {
        console.error("Error fetching players:", I), p(I instanceof Error ? I.message : Fy);
      } finally {
        d(!1);
      }
    },
    [e, t, h]
  ), A = Gt(() => {
    f.current = {};
  }, []);
  Te(() => {
    r && t.length > 0 && m(n);
  }, [r, t, n, m]);
  const b = Gt(
    (v) => {
      if (v) {
        const k = v.toLowerCase(), S = i.filter((I) => {
          var K;
          const w = I.playerModel.name.toLowerCase(), P = Ue(I.playerModel), E = ((K = P == null ? void 0 : P.name) == null ? void 0 : K.toLowerCase()) || "";
          return w.includes(k) || E.includes(k);
        });
        a(S);
      } else
        a(i);
    },
    [i]
  ), C = Gt(() => {
    const v = `${e}-${n === "" ? null : n}`;
    delete f.current[v], m(n);
  }, [m, n, e]);
  return {
    players: o,
    loading: l,
    error: u,
    searchPlayers: b,
    fetchPlayers: m,
    retryFetch: C,
    clearCache: A
    // Added clearCache function in case you need to manually clear the cache
  };
}, Wy = (e) => {
  const { teamsInCompetition: t, teamsInCompetitionIds: r } = yr(() => {
    const o = E2(e ?? []).sort((a, i) => a.name.localeCompare(i.name));
    return {
      teamsInCompetition: o,
      teamsInCompetitionIds: o.map((a) => a.id)
    };
  }, [e]);
  return {
    teamsInCompetition: t,
    teamsInCompetitionIds: r
  };
}, zn = {
  playerList: {
    overflowY: "auto",
    mx: 2.5,
    pb: "410px"
    // Add bottom padding to account for fixed footer height
  },
  footerContainer: {
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0"
  },
  filterSection: {
    marginX: -2.5,
    paddingY: 2,
    paddingX: 2.3,
    bgcolor: "neutral.200"
  },
  saveButton: {
    width: "100%"
  }
}, Xr = {
  fullscreenCenteredFlex: {
    position: "fixed",
    top: 0,
    bottom: "280px",
    left: 0,
    right: 0,
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100vh",
    margin: " 15px 0"
  },
  textCenter: {
    textAlign: "center",
    py: 4
  },
  sliderContainer: {
    mx: -2.5
  }
}, fa = {
  playerNameCell: {
    width: "60%",
    bgcolor: "#fff"
  },
  totalCell: {
    textAlign: "center",
    bgcolor: "#fff"
  },
  actionCell: {
    textAlign: "right",
    width: "80px",
    bgcolor: "#fff"
  }
}, Ht = ({
  position: e,
  player: t,
  onClick: r,
  deselectPlayer: n,
  isActive: o = !1
}) => {
  const a = Ue(t), i = () => a && a.id === "fb:t:889" || a && a.id === "fb:t:898" ? { color: "#000" } : {};
  return /* @__PURE__ */ c.jsxs(
    U,
    {
      bgcolor: "#ccc",
      minWidth: "160px",
      p: 2,
      px: 1,
      mr: 1,
      borderRadius: "lg",
      border: "2px solid",
      borderColor: o ? "primary.500" : "#999",
      display: "flex",
      justifyContent: "center",
      position: "relative",
      onClick: () => r(),
      children: [
        t && /* @__PURE__ */ c.jsx(
          bd,
          {
            color: "danger",
            sx: { position: "absolute", top: "-15px", right: "-10px", zIndex: 12 },
            onClick: () => {
              n(t);
            }
          }
        ),
        /* @__PURE__ */ c.jsxs(
          U,
          {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            children: [
              /* @__PURE__ */ c.jsxs(U, { position: "relative", children: [
                /* @__PURE__ */ c.jsx(
                  "img",
                  {
                    src: En(t),
                    width: "50px",
                    alt: "player",
                    style: { filter: `grayscale(${t ? 0 : 1})` }
                  }
                ),
                /* @__PURE__ */ c.jsx(
                  J,
                  {
                    fontWeight: "bold",
                    textAlign: "center",
                    sx: { ...my, ...i() },
                    children: e
                  }
                )
              ] }),
              /* @__PURE__ */ c.jsx(
                U,
                {
                  bgcolor: "#3B3B3B",
                  borderRadius: "md",
                  px: 2,
                  py: 0,
                  mt: -2,
                  zIndex: 1,
                  display: "flex",
                  alignItems: "center",
                  children: t ? /* @__PURE__ */ c.jsx(J, { level: "body-xs", lineHeight: 1.2, py: 0.6, textColor: "#fff", children: Or(t == null ? void 0 : t.name) }) : /* @__PURE__ */ c.jsx(vd, { width: "10px", height: "6px", sx: { color: "#fff" } })
                }
              )
            ]
          }
        )
      ]
    }
  );
}, Ly = ({
  setPosition: e,
  defendersCount: t,
  midfieldersCount: r,
  forwardsCount: n,
  deselectPlayer: o,
  currentPosition: a
}) => {
  const { selectedGoalkeeper: i, selectedDefenders: s, selectedMidfielders: l, selectedForwards: d } = ue(or), u = Jt(null), p = Jt(null), f = () => i ? s.length < t ? "defender" : l.length < r ? "midfielder" : d.length < n ? "forward" : null : "keeper";
  Te(() => {
    if (u.current && p.current) {
      const h = u.current, m = p.current, A = h.clientWidth, b = m.clientWidth, v = m.offsetLeft - A / 2 + b / 2;
      h.scrollTo({
        left: v,
        behavior: "smooth"
      });
    }
  }, [i, s, l, d]);
  const g = f();
  return /* @__PURE__ */ c.jsx(U, { boxShadow: "0px -4px 4px rgba(0, 0, 0, 0.1)", borderRadius: "md", children: /* @__PURE__ */ c.jsxs(
    U,
    {
      ref: u,
      px: 2.5,
      pt: 2.4,
      display: "flex",
      bgcolor: "#fff",
      gap: 1,
      sx: {
        overflowX: "auto",
        scrollbarWidth: "none",
        // Firefox
        "&::-webkit-scrollbar": {
          // Chrome, Safari
          display: "none"
        },
        msOverflowStyle: "none",
        // IE, Edge
        scrollSnapType: "x mandatory"
      },
      children: [
        /* @__PURE__ */ c.jsx(U, { ref: g === "keeper" ? p : void 0, children: /* @__PURE__ */ c.jsx(
          Ht,
          {
            position: "GK",
            player: i,
            onClick: () => e("keeper"),
            deselectPlayer: o,
            isActive: a === "keeper" && !i
          },
          "list-gk"
        ) }),
        s.map((h) => /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(
          Ht,
          {
            position: "DEF",
            player: h,
            onClick: () => e("defender"),
            deselectPlayer: o,
            isActive: !1
          }
        ) }, `list-def-${h.id}`)),
        Array.from({ length: t - s.length }, (h, m) => /* @__PURE__ */ c.jsx(
          U,
          {
            ref: g === "defender" && m === 0 ? p : void 0,
            children: /* @__PURE__ */ c.jsx(
              Ht,
              {
                position: "DEF",
                player: null,
                onClick: () => e("defender"),
                deselectPlayer: o,
                isActive: a === "defender" && m === 0
              }
            )
          },
          `list-def-${m}`
        )),
        l.map((h) => /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(
          Ht,
          {
            position: "MID",
            player: h,
            onClick: () => e("midfielder"),
            deselectPlayer: o,
            isActive: !1
          }
        ) }, `list-mid-${h.id}`)),
        Array.from({ length: r - l.length }, (h, m) => /* @__PURE__ */ c.jsx(
          U,
          {
            ref: g === "midfielder" && m === 0 ? p : void 0,
            children: /* @__PURE__ */ c.jsx(
              Ht,
              {
                position: "MID",
                player: null,
                onClick: () => e("midfielder"),
                deselectPlayer: o,
                isActive: a === "midfielder" && m === 0
              }
            )
          },
          `list-mid-${m}`
        )),
        d.map((h) => /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(
          Ht,
          {
            position: "FWD",
            player: h,
            onClick: () => e("forward"),
            deselectPlayer: o,
            isActive: !1
          }
        ) }, `list-fwd-${h.id}`)),
        Array.from({ length: n - d.length }, (h, m) => /* @__PURE__ */ c.jsx(
          U,
          {
            ref: g === "forward" && m === 0 ? p : void 0,
            children: /* @__PURE__ */ c.jsx(
              Ht,
              {
                position: "FWD",
                player: null,
                onClick: () => e("forward"),
                deselectPlayer: o,
                isActive: a === "forward" && m === 0
              }
            )
          },
          `list-fwd-${m}`
        ))
      ]
    }
  ) });
};
var zi = {}, ga = {};
const zy = /* @__PURE__ */ Et(ny);
var Al;
function Pd() {
  return Al || (Al = 1, function(e) {
    "use client";
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "default", {
      enumerable: !0,
      get: function() {
        return t.createSvgIcon;
      }
    });
    var t = zy;
  }(ga)), ga;
}
var Ny = $o;
Object.defineProperty(zi, "__esModule", {
  value: !0
});
var Td = zi.default = void 0, Qy = Ny(Pd()), Cl = c;
Td = zi.default = (0, Qy.default)([/* @__PURE__ */ (0, Cl.jsx)("path", {
  d: "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27zM19 14.9 14.9 19H9.1L5 14.9V9.1L9.1 5h5.8L19 9.1z"
}, "0"), /* @__PURE__ */ (0, Cl.jsx)("path", {
  d: "M11 7h2v6h-2zm0 8h2v2h-2z"
}, "1")], "ReportGmailerrorred");
const Hy = ({
  player: e,
  isPlayerAlreadySelected: t,
  isPlayerAvailableToSelect: r,
  selectPlayer: n,
  deselectPlayer: o,
  handlePlayerClick: a,
  teamCounts: i
}) => {
  var h, m;
  const s = Be(), { templateMatches: l } = ue(St);
  let d = {};
  l.length > 0 && e && (d = qi(((h = Ue(e.playerModel)) == null ? void 0 : h.id) ?? null, l) ?? {});
  const u = Ue(e.playerModel), p = u ? sd(u.id, i) : !1, f = t(e.playerModel), g = r(e.playerModel);
  return /* @__PURE__ */ c.jsxs(
    "tr",
    {
      style: {
        backgroundColor: f ? "rgba(0, 133, 0, 0.05)" : !g && !f ? "rgba(154, 91, 19, 0.05)" : "#fff",
        opacity: !g && !f ? 0.7 : 1
      },
      children: [
        /* @__PURE__ */ c.jsx("td", { children: /* @__PURE__ */ c.jsxs(
          U,
          {
            display: "flex",
            justifyItems: "flex-start",
            alignItems: "center",
            onClick: () => {
              a(e.playerModel);
            },
            children: [
              /* @__PURE__ */ c.jsx(
                Vn,
                {
                  sx: {
                    mr: 1,
                    p: 0.5
                  },
                  src: En(e.playerModel)
                }
              ),
              /* @__PURE__ */ c.jsxs(U, { children: [
                /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", fontSize: "sm", lineHeight: 1.3, children: e.playerModel.name }),
                /* @__PURE__ */ c.jsxs(J, { fontSize: "xs", textColor: "#666", children: [
                  ((m = Ue(e.playerModel)) == null ? void 0 : m.name) ?? "",
                  " ",
                  d != null && d.code ? `(vs ${d.code})` : ""
                ] })
              ] })
            ]
          }
        ) }),
        /* @__PURE__ */ c.jsx("td", { style: { textAlign: "center" }, children: e.points }),
        /* @__PURE__ */ c.jsx("td", { style: { textAlign: "right", width: "80px" }, children: f ? /* @__PURE__ */ c.jsx(
          ge,
          {
            size: "xs",
            variant: "soft",
            color: "neutral",
            sx: { py: 0.6, width: "65px", bgcolor: "#D4D4D4" },
            onClick: () => {
              o(e.playerModel);
            },
            children: s("remove")
          }
        ) : p && !g ? /* @__PURE__ */ c.jsx(
          ge,
          {
            size: "xs",
            color: "warning",
            variant: "solid",
            sx: { py: 0.6, width: "65px", alignItems: "center" },
            startDecorator: /* @__PURE__ */ c.jsx(Td, { sx: { fontSize: "18px", mr: 0.5 } }),
            children: /* @__PURE__ */ c.jsx(J, { fontSize: "xs", children: "2/2" })
          }
        ) : /* @__PURE__ */ c.jsx(
          ge,
          {
            size: "xs",
            variant: "solid",
            sx: { py: 0.6, width: "65px", alignItems: "center" },
            onClick: () => {
              n(e.playerModel);
            },
            children: s("select")
          }
        ) })
      ]
    },
    `player-${e.playerModel.id}`
  );
}, Od = ({
  modalOpen: e,
  position: t,
  setPosition: r,
  controlModalState: n,
  defendersCount: o,
  midfieldersCount: a,
  forwardsCount: i,
  handlePlayerClick: s = () => {
  }
}) => {
  const l = Be(), d = ue(Dr), { templateMatches: u } = ue(St), {
    setGoalKeeper: p,
    setDefenders: f,
    setMidfielders: g,
    setForwards: h,
    selectedGoalkeeper: m,
    selectedDefenders: A,
    selectedMidfielders: b,
    selectedForwards: C
  } = ue(or), [v, k] = _(""), [S, I] = _(null), { teamsInCompetition: w, teamsInCompetitionIds: P } = Wy(u), { players: E, loading: K, error: R, searchPlayers: B, fetchPlayers: V, retryFetch: M } = Jy(
    d,
    P,
    e,
    t
  ), j = yr(() => K2(m, A, b, C), [m, A, b, C]), T = () => (m ? 1 : 0) + A.length + b.length + C.length, O = qy(
    m,
    A,
    b,
    C,
    p,
    f,
    g,
    h,
    o,
    a,
    i
  ), F = (q) => {
    const D = O[q.position];
    if (!D) return !1;
    const { selected: W } = D;
    return Array.isArray(W) ? W.some((Q) => Q.id === q.id) : (W == null ? void 0 : W.id) === q.id;
  }, N = (q) => {
    if (F(q)) return !1;
    const W = Ue(q);
    return W ? !sd(W.id, j) : !0;
  }, te = () => {
    const q = Yr.indexOf(t);
    if (q === -1) return Yr[0];
    const D = {
      keeper: m ? 1 : 0,
      defender: (A == null ? void 0 : A.length) || 0,
      midfielder: (b == null ? void 0 : b.length) || 0,
      forward: (C == null ? void 0 : C.length) || 0,
      "": 0
    }, W = {
      keeper: 1,
      defender: o,
      midfielder: a,
      forward: i,
      "": 0
    };
    for (let Q = 1; Q <= Yr.length; Q++) {
      const $ = (q + Q) % Yr.length, se = Yr[$];
      if (D[se] < W[se])
        return se;
    }
    return null;
  }, G = (q) => {
    const D = O[q.position];
    if (!D) return;
    const { selected: W, setter: Q, maxCount: $ } = D;
    if (Array.isArray(W)) {
      if (W.length < $ && !W.some((se) => se.id === q.id) && N(q) && (Q([...W, q]), W.length + 1 === $)) {
        const se = te();
        se && (r(se), V(se));
      }
    } else if (N(q)) {
      Q(q);
      const se = te();
      se && (r(se), V(se));
    }
  }, Z = (q) => {
    const D = O[q.position];
    if (!D) return;
    const { selected: W, setter: Q } = D;
    Array.isArray(W) ? Q(W.filter(($) => $.id !== q.id)) : Q(null);
  }, ie = (q) => {
    const D = q.target.value;
    k(D), B(D);
  }, le = (q) => {
    q !== null && (P.includes(q) ? (I(q), r(""), V("")) : (I(null), r(q), V(q)));
  }, ce = (S ? E.filter((q) => {
    const D = Ue(q.playerModel);
    return (D == null ? void 0 : D.id) === S;
  }) : E).sort((q, D) => q.points !== D.points ? D.points - q.points : q.playerModel.name.localeCompare(D.playerModel.name));
  return /* @__PURE__ */ c.jsx(Yo, { open: e, onClose: () => n(!1), children: /* @__PURE__ */ c.jsxs(
    Bi,
    {
      "aria-labelledby": "modal-dialog-overflow",
      layout: "fullscreen",
      sx: {
        position: "relative",
        bgcolor: "black",
        p: 0,
        gap: 0
      },
      children: [
        /* @__PURE__ */ c.jsxs(
          U,
          {
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            position: "relative",
            px: 2.5,
            py: 1.5,
            height: "50px",
            boxSizing: "content-box",
            children: [
              /* @__PURE__ */ c.jsx(ji, { sx: { color: "#fff", "& > svg": { fill: "#fff" }, mt: "4px" } }),
              /* @__PURE__ */ c.jsxs(U, { py: 2, children: [
                /* @__PURE__ */ c.jsxs(J, { id: "modal-dialog-overflow", level: "h3", textColor: "#fff", children: [
                  l("playerSelection"),
                  " ",
                  T(),
                  "/11"
                ] }),
                /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "#fff", children: l("maxPlayersPerTeam") })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ c.jsx(U, { sx: zn.filterSection, children: /* @__PURE__ */ c.jsxs(mr, { container: !0, spacing: 2, sx: { mx: 1.6 }, children: [
          /* @__PURE__ */ c.jsx(mr, { xs: 6, children: /* @__PURE__ */ c.jsxs(
            eb,
            {
              value: S || t,
              onChange: (q, D) => le(D),
              placeholder: l("filter"),
              children: [
                /* @__PURE__ */ c.jsx(sr, { value: "", children: l("all") }),
                /* @__PURE__ */ c.jsx(sr, { value: "keeper", children: l("goalkeepers") }),
                /* @__PURE__ */ c.jsx(sr, { value: "defender", children: l("defenders") }),
                /* @__PURE__ */ c.jsx(sr, { value: "midfielder", children: l("midfielders") }),
                /* @__PURE__ */ c.jsx(sr, { value: "forward", children: l("forwards") }),
                /* @__PURE__ */ c.jsx(Ne, { sx: { my: 1, bgcolor: "#f2f2f2" } }),
                w.map((q) => {
                  var D;
                  return /* @__PURE__ */ c.jsxs(sr, { value: q.id, children: [
                    /* @__PURE__ */ c.jsx(g1, { children: /* @__PURE__ */ c.jsx(Vn, { size: "sm", src: ((D = q.assets) == null ? void 0 : D.logo) || "" }) }),
                    q.name
                  ] }, q.id);
                })
              ]
            }
          ) }),
          /* @__PURE__ */ c.jsx(mr, { xs: 6, children: /* @__PURE__ */ c.jsx(pv, { placeholder: l("searchPlayer"), value: v, onChange: ie }) })
        ] }) }),
        /* @__PURE__ */ c.jsx(U, { bgcolor: "#f2f2f2", children: /* @__PURE__ */ c.jsxs(U, { sx: Xr.mainContainer, children: [
          /* @__PURE__ */ c.jsx(U, { sx: zn.playerList, children: K ? /* @__PURE__ */ c.jsx(U, { sx: Xr.fullscreenCenteredFlex, children: /* @__PURE__ */ c.jsx(ge, { loading: !0, variant: "plain", size: "lg" }) }) : R ? /* @__PURE__ */ c.jsxs(U, { sx: Xr.textCenter, children: [
            /* @__PURE__ */ c.jsx(J, { color: "danger", children: R }),
            /* @__PURE__ */ c.jsx(ge, { onClick: () => M(), variant: "outlined", sx: { mt: 2 }, children: l("retry") })
          ] }) : ce.length === 0 ? /* @__PURE__ */ c.jsx(U, { sx: Xr.textCenter, children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: l("noPlayersFound") }) }) : /* @__PURE__ */ c.jsxs(yb, { variant: "outlined", sx: { bgcolor: "#fff", overflow: "hidden" }, children: [
            /* @__PURE__ */ c.jsx("thead", { children: /* @__PURE__ */ c.jsxs("tr", { children: [
              /* @__PURE__ */ c.jsx("th", { style: fa.playerNameCell, children: l("players") }),
              /* @__PURE__ */ c.jsx("th", { style: fa.totalCell, children: l("total") }),
              /* @__PURE__ */ c.jsx("th", { style: fa.actionCell, children: l("action") })
            ] }) }),
            /* @__PURE__ */ c.jsx("tbody", { children: ce.map((q) => /* @__PURE__ */ c.jsx(
              Hy,
              {
                player: q,
                isPlayerAlreadySelected: F,
                isPlayerAvailableToSelect: N,
                selectPlayer: G,
                deselectPlayer: Z,
                handlePlayerClick: s,
                teamCounts: j
              },
              `player-${q.playerModel.id}`
            )) })
          ] }) }),
          /* @__PURE__ */ c.jsx(U, { sx: zn.footerContainer, children: /* @__PURE__ */ c.jsxs(U, { children: [
            /* @__PURE__ */ c.jsx(U, { px: 2, bgcolor: "#fff", sx: Xr.sliderContainer, children: /* @__PURE__ */ c.jsx(
              Ly,
              {
                setPosition: r,
                defendersCount: o,
                midfieldersCount: a,
                forwardsCount: i,
                deselectPlayer: Z,
                selectPlayer: G,
                fetchPlayers: V,
                currentPosition: t
              }
            ) }),
            /* @__PURE__ */ c.jsx(U, { p: 2, sx: { bgcolor: "#fff" }, children: /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(ge, { sx: zn.saveButton, onClick: () => n(!1), children: l("saveSelection") }) }) })
          ] }) })
        ] }) })
      ]
    }
  ) });
}, Gy = ({
  position: e,
  setPosition: t,
  deselectPlayer: r,
  changeFormation: n,
  captain: o,
  viceCaptain: a,
  onOpenCaptainSelection: i
}) => {
  const [s, l] = _(!1), {
    formation: d,
    selectedGoalkeeper: u,
    selectedDefenders: p,
    selectedMidfielders: f,
    selectedForwards: g,
    setGoalKeeper: h,
    setDefenders: m,
    setMidfielders: A,
    setForwards: b,
    setCaptain: C,
    setViceCaptain: v
  } = ue(or), { selectedGameWeekPrediction: k, isNavigating: S } = ue(Ft), { templateMatches: I } = ue(St), w = br("defender", d), P = br("midfielder", d), E = br("forward", d), [K, R] = _(null), B = Jt(null);
  Te(() => {
    S && (h(null), m([]), A([]), b([]), C(null), v(null), B.current = null);
  }, [S, h, m, A, b, C, v]);
  const V = (O) => {
    R(O);
  }, M = (O) => {
    l(!0), t(O);
  };
  Te(() => {
    if (!S)
      if (k && k.fixtures && k.fixtures.length > 0) {
        const O = `${k.id || ""}-${k.fixtures.length}`;
        if (B.current === O)
          return;
        B.current = O;
        const F = k.fixtures, N = F.flatMap((ce) => ce.prediction.playerModel).filter((ce, q, D) => q === D.findIndex((W) => W.id === ce.id)), te = N.find((ce) => ce.position === "keeper"), G = N.filter((ce) => ce.position === "defender"), Z = N.filter((ce) => ce.position === "midfielder"), ie = N.filter((ce) => ce.position === "forward"), le = F.find(
          (ce) => ce.prediction.playerRole === "CAPTAIN"
        ), ae = F.find(
          (ce) => ce.prediction.playerRole === "VICE_CAPTAIN"
        );
        h(te), m(G), A(Z), b(ie), le && C(le.prediction.playerModel), ae && v(ae.prediction.playerModel), G.length + Z.length + ie.length === 10 && n(`${G.length}-${Z.length}-${ie.length}`);
      } else k && k.fixtures && k.fixtures.length === 0 && (B.current = "empty");
  }, [
    k,
    S,
    h,
    m,
    A,
    b,
    C,
    v,
    n
  ]);
  const j = (O) => O !== null && (o == null ? void 0 : o.id) === O.id, T = (O) => O !== null && (a == null ? void 0 : a.id) === O.id;
  return /* @__PURE__ */ c.jsxs(
    Ri,
    {
      sx: {
        mx: -2,
        p: 0,
        position: "relative",
        overflow: "hidden",
        borderBottomLeftRadius: "8px",
        borderBottomRightRadius: "8px"
      },
      children: [
        /* @__PURE__ */ c.jsx("img", { src: yd, style: { width: "100%" }, loading: "lazy", alt: "Football pitch" }),
        /* @__PURE__ */ c.jsxs(
          U,
          {
            position: "absolute",
            top: "10px",
            left: 0,
            right: 0,
            bottom: "30px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            children: [
              /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: /* @__PURE__ */ c.jsx(
                Qt,
                {
                  position: "keeper",
                  onClick: () => {
                    u ? V(u) : M("keeper");
                  },
                  player: u,
                  templateMatches: I,
                  isCaptain: j(u),
                  isViceCaptain: T(u)
                }
              ) }),
              /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: [
                p.map((O, F) => /* @__PURE__ */ c.jsx(
                  Qt,
                  {
                    position: "defender",
                    onClick: () => V(O),
                    player: O,
                    templateMatches: I,
                    isCaptain: j(O),
                    isViceCaptain: T(O)
                  },
                  `defender-${F}`
                )),
                Array.from({ length: w - p.length }, (O, F) => /* @__PURE__ */ c.jsx(
                  Qt,
                  {
                    position: "defender",
                    onClick: () => M("defender"),
                    player: null,
                    templateMatches: I
                  },
                  `defender-placeholder-${F}`
                ))
              ] }),
              /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: [
                f.map((O, F) => /* @__PURE__ */ c.jsx(
                  Qt,
                  {
                    position: "midfielder",
                    onClick: () => V(O),
                    player: O,
                    templateMatches: I,
                    isCaptain: j(O),
                    isViceCaptain: T(O)
                  },
                  `midfielder-${F}`
                )),
                Array.from({ length: P - f.length }, (O, F) => /* @__PURE__ */ c.jsx(
                  Qt,
                  {
                    position: "midfielder",
                    onClick: () => M("midfielder"),
                    player: null,
                    templateMatches: I
                  },
                  `midfielder-placeholder-${F}`
                ))
              ] }),
              /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-around", alignItems: "flex-start", children: [
                g.map((O, F) => /* @__PURE__ */ c.jsx(
                  Qt,
                  {
                    position: "forward",
                    onClick: () => V(O),
                    player: O,
                    templateMatches: I,
                    isCaptain: j(O),
                    isViceCaptain: T(O)
                  },
                  `forward-${F}`
                )),
                Array.from({ length: E - g.length }, (O, F) => /* @__PURE__ */ c.jsx(
                  Qt,
                  {
                    position: "forward",
                    onClick: () => M("forward"),
                    player: null,
                    templateMatches: I
                  },
                  `forward-placeholder-${F}`
                ))
              ] })
            ]
          }
        ),
        K && /* @__PURE__ */ c.jsx(
          My,
          {
            player: K,
            deselectPlayer: r,
            setSelectedPlayer: R,
            templateMatches: I,
            onOpenCaptainSelection: i
          }
        ),
        /* @__PURE__ */ c.jsx(
          Od,
          {
            position: e,
            setPosition: t,
            modalOpen: s,
            controlModalState: l,
            defendersCount: w,
            midfieldersCount: P,
            forwardsCount: E,
            handlePlayerClick: V
          }
        )
      ]
    }
  );
};
var Ni = {}, Zy = $o;
Object.defineProperty(Ni, "__esModule", {
  value: !0
});
var Vd = Ni.default = void 0, Yy = Zy(Pd()), Xy = c;
Vd = Ni.default = (0, Yy.default)(/* @__PURE__ */ (0, Xy.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6z"
}), "KeyboardArrowDown");
const $y = ({ currentFormation: e, setShowFormationDialog: t }) => {
  const r = Be();
  return /* @__PURE__ */ c.jsx(c.Fragment, { children: /* @__PURE__ */ c.jsx(Ki, { children: /* @__PURE__ */ c.jsxs(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: [
    /* @__PURE__ */ c.jsx(U, { children: /* @__PURE__ */ c.jsx(J, { level: "body-sm", children: r("yourFormation") }) }),
    /* @__PURE__ */ c.jsx(U, { display: "flex", justifyContent: "space-between", alignItems: "center", children: /* @__PURE__ */ c.jsx(rh, { children: /* @__PURE__ */ c.jsx(
      C1,
      {
        size: "sm",
        endDecorator: /* @__PURE__ */ c.jsx(Vd, {}),
        slotProps: { root: { variant: "plain", color: "neutral" } },
        onClick: () => t(!0),
        variant: "plain",
        children: e
      }
    ) }) })
  ] }) }) });
}, _y = ({
  open: e,
  onClose: t,
  players: r,
  onSelectCaptain: n,
  onSelectViceCaptain: o,
  captain: a,
  viceCaptain: i
}) => {
  const [s, l] = _("captain"), d = () => {
    t();
  }, u = a !== null && i !== null, p = (g, h) => {
    h === "captain" ? (n(g), g && !i && l("vice-captain")) : o(g);
  }, f = (g) => {
    const h = g === "captain" ? a : i, m = g === "captain" ? i : a;
    return /* @__PURE__ */ c.jsx(U, { sx: { py: 1, mb: "80px" }, children: /* @__PURE__ */ c.jsxs(
      Ct,
      {
        sx: {
          bgcolor: "white",
          border: "none",
          boxShadow: "none",
          px: 0,
          overflowX: "hidden",
          overflowY: "scroll"
        },
        children: [
          /* @__PURE__ */ c.jsxs(U, { sx: { px: 2 }, children: [
            /* @__PURE__ */ c.jsxs(J, { fontWeight: "bold", level: "body-sm", children: [
              "Select ",
              g === "captain" ? "Captain" : "Vice Captain"
            ] }),
            /* @__PURE__ */ c.jsx(J, { level: "body-xs", textColor: "#666", children: g === "captain" ? "Your Captain will earn you tripple points" : "Your Vice-Captain will earn you double points" })
          ] }),
          /* @__PURE__ */ c.jsx(Ne, { sx: { bgcolor: "#f2f2f2" } }),
          /* @__PURE__ */ c.jsx(U, { sx: { overflowY: "scroll" }, children: r.map((A, b) => {
            const C = (h == null ? void 0 : h.id) === A.id, v = (m == null ? void 0 : m.id) === A.id, k = Ue(A);
            return /* @__PURE__ */ c.jsxs(vn.Fragment, { children: [
              b > 0 && /* @__PURE__ */ c.jsx(Ne, { sx: { bgcolor: "#f2f2f2" } }),
              /* @__PURE__ */ c.jsxs(
                U,
                {
                  display: "flex",
                  alignItems: "center",
                  py: 1,
                  px: 2,
                  sx: {
                    backgroundColor: C ? "rgba(0, 133, 0, 0.1)" : v ? "rgba(0, 133, 0, 0.05)" : "#fff",
                    opacity: v ? 0.7 : 1
                  },
                  children: [
                    /* @__PURE__ */ c.jsxs(U, { display: "flex", alignItems: "center", flex: 1, children: [
                      /* @__PURE__ */ c.jsx(U, { sx: { mr: 1.5 }, children: /* @__PURE__ */ c.jsx(
                        "img",
                        {
                          src: En(A),
                          style: {
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%"
                          },
                          alt: A.name
                        }
                      ) }),
                      /* @__PURE__ */ c.jsxs(U, { children: [
                        /* @__PURE__ */ c.jsx(J, { fontWeight: "bold", fontSize: "sm", lineHeight: 1.3, children: A.name }),
                        /* @__PURE__ */ c.jsx(J, { fontSize: "xs", children: (k == null ? void 0 : k.name) || A.position })
                      ] })
                    ] }),
                    /* @__PURE__ */ c.jsxs(U, { display: "flex", alignItems: "center", gap: 1, children: [
                      C && /* @__PURE__ */ c.jsx(
                        U,
                        {
                          sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            bgcolor: g === "captain" ? "#FFD700" : "#d4d4d4",
                            color: "black",
                            fontSize: "0.75rem",
                            fontWeight: "bold"
                          },
                          children: g === "captain" ? "C" : "V"
                        }
                      ),
                      v && /* @__PURE__ */ c.jsx(
                        U,
                        {
                          sx: {
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            width: 24,
                            height: 24,
                            borderRadius: "50%",
                            bgcolor: g === "captain" ? "#d4d4d4" : "#FFD700",
                            color: "black",
                            fontSize: "0.75rem",
                            fontWeight: "bold"
                          },
                          children: g === "captain" ? "V" : "C"
                        }
                      ),
                      C ? /* @__PURE__ */ c.jsx(
                        ge,
                        {
                          size: "xs",
                          variant: "soft",
                          color: "neutral",
                          sx: {
                            py: 0.5,
                            px: 1.5,
                            minHeight: "unset",
                            width: "65px",
                            bgcolor: "#d4d4d4"
                          },
                          onClick: () => p(null, g),
                          children: "Remove"
                        }
                      ) : /* @__PURE__ */ c.jsx(
                        ge,
                        {
                          size: "xs",
                          variant: "solid",
                          color: "success",
                          disabled: v,
                          sx: { py: 0.5, px: 1.5, minHeight: "unset", width: "65px" },
                          onClick: () => p(A, g),
                          children: "Select"
                        }
                      )
                    ] })
                  ]
                }
              )
            ] }, A.id);
          }) })
        ]
      }
    ) });
  };
  return /* @__PURE__ */ c.jsx(Yo, { open: e, onClose: t, children: /* @__PURE__ */ c.jsxs(Bi, { layout: "fullscreen", sx: { position: "relative", height: "100vh", bgcolor: "black", p: 0 }, children: [
    /* @__PURE__ */ c.jsx(ji, {}),
    /* @__PURE__ */ c.jsx(U, { p: 1.5, pb: 0, children: /* @__PURE__ */ c.jsx(J, { level: "body-md", fontWeight: "bold", textColor: "white", children: "Select Captain & Vice-Captain" }) }),
    /* @__PURE__ */ c.jsxs(
      Fi,
      {
        value: s,
        onChange: (g, h) => l(h),
        sx: {
          flex: 1,
          display: "flex",
          flexDirection: "column",
          height: "calc(100vh - 300px)"
        },
        children: [
          /* @__PURE__ */ c.jsxs(
            Mi,
            {
              sx: {
                bgcolor: "#2c2c2c",
                borderRadius: 0,
                "--TabList-gap": "0px",
                minHeight: 48,
                "& .MuiTab-root": {
                  flex: 1,
                  color: "#ddd",
                  fontWeight: "bold",
                  fontSize: ".85rem",
                  "&.Mui-selected": {
                    bgcolor: "#2c2c2c",
                    color: "white",
                    fontSize: ".85rem",
                    "&:after": {
                      bgcolor: "#00A826"
                    }
                  }
                }
              },
              children: [
                /* @__PURE__ */ c.jsx(Yt, { value: "captain", children: "Captain" }),
                /* @__PURE__ */ c.jsx(Yt, { value: "vice-captain", children: "Vice-Captain" })
              ]
            }
          ),
          /* @__PURE__ */ c.jsx(Xt, { value: "captain", sx: { px: 1.5, flex: 1, overflow: "auto" }, children: f("captain") }),
          /* @__PURE__ */ c.jsx(Xt, { value: "vice-captain", sx: { p: 1.5, flex: 1, overflow: "auto" }, children: f("vice-captain") })
        ]
      }
    ),
    /* @__PURE__ */ c.jsx(
      U,
      {
        sx: {
          position: "fixed",
          bottom: "0",
          left: "0",
          right: "0",
          bgcolor: "#fff",
          p: 2,
          boxShadow: "0px -2px 15px -9px rgba(0,0,0,0.5)"
        },
        children: /* @__PURE__ */ c.jsx(
          ge,
          {
            fullWidth: !0,
            disabled: !u,
            onClick: d,
            sx: {
              fontSize: "1rem",
              fontWeight: 600
            },
            children: "Save Selection"
          }
        )
      }
    )
  ] }) });
}, eA = "data:image/jpeg;base64,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", xr = {
  ZA: "https://new.betway.co.za/?btag=P87216-PR37784-CM109294-TS2078304&utm_source=BetwayScoresGames&utm_medium=Betway_Scores_Fantasy_Game&utm_campaign=Betway_Scores&utm_content=Fantasy_Football_Scores",
  GH: "https://www.betway.com.gh/?btag=P87216-PR38046-CM112327-TS2078310&utm_source=BetwayScoresGames&utm_medium=Betway_Scores_GH_Fantasy_Game&utm_campaign=Betway_Scores&utm_content=Fantasy_Football_Scores",
  // Rest of World (RoW) - default fallback
  ROW: "https://betway.com/en/sports?s=bw219941&a=DB4501775225688466&utm_source=219941&utm_medium=Affiliate&utm_campaign=DB4501775225688466"
}, Ed = () => {
  const t = new URLSearchParams(window.location.search).get("country");
  let r = null;
  try {
    const n = localStorage.getItem("persist:root");
    if (n) {
      const o = JSON.parse(n);
      r = JSON.parse(o.user || "{}").country;
    }
  } catch {
  }
  return r || t || null;
}, Rn = () => {
  var r, n, o, a;
  const e = (r = Ed()) == null ? void 0 : r.toUpperCase();
  let t;
  e === "ZA" ? t = xr.ZA : e === "GH" ? t = xr.GH : t = xr.ROW;
  try {
    (a = (o = (n = window.webkit) == null ? void 0 : n.messageHandlers) == null ? void 0 : o.openExternal) == null || a.postMessage({ url: t });
  } catch {
    window.open(t, "_blank", "noopener,noreferrer");
  }
}, Un = () => {
  var r;
  const e = (r = Ed()) == null ? void 0 : r.toUpperCase();
  let t;
  e === "ZA" ? t = xr.ZA : e === "GH" ? t = xr.GH : t = xr.ROW, window.Android && typeof window.Android.openExternal == "function" && window.Android.openExternal(t);
};
window.openExternalUrl = Rn;
window.openExternalUrlAndroid = Un;
typeof document < "u" && (document.openExternalUrl = Rn, document.openExternalUrlAndroid = Un);
window.BetwayUtils = window.BetwayUtils || {
  openExternalUrl: Rn,
  openExternalUrlAndroid: Un
};
window.BetwayUtils.openExternalUrl = Rn;
window.BetwayUtils.openExternalUrlAndroid = Un;
const tA = ({ open: e, onClose: t }) => {
  const r = Be(), [n, o] = _("");
  Te(() => {
    window.fuSDK && window.fuSDK.profile.getOwn().getInfo().then((i) => {
      o(k2(i));
    });
  }, []);
  const a = () => {
    window.Android && typeof window.Android.openExternal == "function" ? Un() : Rn();
  };
  return /* @__PURE__ */ c.jsx(
    Yo,
    {
      open: e,
      onClose: t,
      sx: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      },
      children: /* @__PURE__ */ c.jsxs(
        U,
        {
          sx: {
            width: "90%",
            maxWidth: 370,
            borderRadius: "md",
            p: 0,
            boxShadow: "lg",
            bgcolor: "background.surface",
            position: "relative",
            overflow: "hidden"
          },
          children: [
            /* @__PURE__ */ c.jsx(
              U,
              {
                sx: {
                  width: "100%",
                  height: 240,
                  position: "relative",
                  backgroundImage: `url(${eA})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center"
                }
              }
            ),
            /* @__PURE__ */ c.jsxs(U, { sx: { p: 3, display: "flex", flexDirection: "column", alignItems: "center" }, children: [
              /* @__PURE__ */ c.jsx(J, { level: "h4", sx: { fontWeight: "bold", mb: 1, textAlign: "center" }, children: r("goodJob", { username: n }) }),
              /* @__PURE__ */ c.jsx(J, { level: "body-sm", sx: { textAlign: "center", mb: 2, fontWeight: "500" }, children: r("teamReady") }),
              /* @__PURE__ */ c.jsx(J, { level: "body-sm", sx: { textAlign: "center", mb: 2, color: "neutral.500" }, children: r("accountNotRequired") }),
              /* @__PURE__ */ c.jsx(J, { level: "body-sm", sx: { textAlign: "center", mb: 3, color: "neutral.500" }, children: r("seeRulesForPrizes") }),
              /* @__PURE__ */ c.jsx(
                ge,
                {
                  fullWidth: !0,
                  onClick: a,
                  sx: {
                    bgcolor: "#008500",
                    color: "white",
                    fontWeight: "bold",
                    mb: 1,
                    py: 1.5,
                    "&:hover": { bgcolor: "#008500" }
                  },
                  children: r("openBetwayAccount")
                }
              ),
              /* @__PURE__ */ c.jsx(
                ge,
                {
                  fullWidth: !0,
                  variant: "outlined",
                  color: "neutral",
                  onClick: t,
                  sx: {
                    bgcolor: "neutral.200",
                    color: "neutral.700",
                    fontWeight: "bold",
                    border: "none",
                    py: 1.5,
                    "&:hover": { bgcolor: "neutral.300" }
                  },
                  children: r("skipForNow")
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, rA = () => {
  const e = Be(), [t, r] = _(!1), [n, o] = _(!1), [a, i] = _(!1), [s, l] = _(!1), [d, u] = _(!1), [p, f] = _(hy), [g, h] = _(null), [m, A] = _([]), [b, C] = _([]), [v, k] = _([]), [S, I] = _(!1), [w, P] = _(!1), [E, K] = _(""), [R, B] = _("keeper"), [V, M] = _(null), [j, T] = _(null), { selectedGameWeek: O, selectedGameWeekPrediction: F, refreshPrediction: N, isNavigating: te } = ue(Ft), { template: G, templateMatches: Z } = ue(St);
  Te(() => {
    te && (M(null), T(null));
  }, [te]), Te(() => {
    if (!te)
      if (F && F.fixtures && F.fixtures.length > 0) {
        const X = F.fixtures.find(
          (Ge) => Ge.prediction.playerRole === "CAPTAIN"
        ), de = F.fixtures.find(
          (Ge) => Ge.prediction.playerRole === "VICE_CAPTAIN"
        );
        M((X == null ? void 0 : X.prediction.playerModel) || null), T((de == null ? void 0 : de.prediction.playerModel) || null);
      } else F && F.fixtures && F.fixtures.length === 0 && (M(null), T(null));
  }, [F, te]);
  const [ie, le] = _({
    open: !1,
    message: ""
  }), ae = () => {
    const X = m.length + b.length + v.length, de = g && Object.keys(g).length > 0 ? 1 : 0;
    return X + de;
  }, ce = () => {
    const X = [];
    return g && X.push(g), [...X, ...m, ...b, ...v];
  }, q = (X) => {
    const de = m.length, Ge = b.length, nt = v.length, Ke = parseInt(X.split("-")[0]), Ae = parseInt(X.split("-")[1]), ct = parseInt(X.split("-")[2]);
    de <= Ke && Ge <= Ae && nt <= ct ? (f(X), P(!1)) : (P(!0), K(X));
  }, D = (X) => {
    (V == null ? void 0 : V.id) === X.id && M(null), (j == null ? void 0 : j.id) === X.id && T(null), X.position === "keeper" && h(null), X.position === "defender" && A(m.filter((de) => de.id !== X.id)), X.position === "midfielder" && C(b.filter((de) => de.id !== X.id)), X.position === "forward" && k(v.filter((de) => de.id !== X.id));
  }, W = () => {
    h(null), A([]), C([]), k([]), M(null), T(null), i(!1);
  }, Q = (X) => {
    if (X === null) {
      M(null);
      return;
    }
    (j == null ? void 0 : j.id) === X.id && T(null), M(X);
  }, $ = (X) => {
    if (X === null) {
      T(null);
      return;
    }
    (V == null ? void 0 : V.id) === X.id && M(null), T(X);
  }, se = () => {
    if (!G) return !1;
    const X = G == null ? void 0 : G.id, de = Lt(G, Z), nt = [g, ...m, ...b, ...v].map((Ae) => Ae == null ? void 0 : Ae.id);
    console.log("templateId for prediction:", X), console.log("currentGameWeek for prediction:", de);
    const Ke = /* @__PURE__ */ new Map();
    V != null && V.id && Ke.set(V.id, "CAPTAIN"), j != null && j.id && Ke.set(j.id, "VICE_CAPTAIN"), window.fuSDK && X && (de != null && de.groupId) && (u(!0), window.fuSDK.fantasy.play(X, de == null ? void 0 : de.groupId, nt, Ke).then(async () => {
      o(!0), N && await N();
    }).catch((Ae) => {
      let ct = e("failedToSubmitTeam");
      Ae.data.error.message && (ct = e("error") + "! " + Ae.data.error.message.split("Field:")[0].trim()), le({
        open: !0,
        message: ct
      });
    }).finally(() => {
      u(!1);
    }));
  };
  return /* @__PURE__ */ c.jsx(
    or.Provider,
    {
      value: {
        formation: p,
        selectedGoalkeeper: g,
        selectedDefenders: m,
        selectedMidfielders: b,
        selectedForwards: v,
        selectedCaptain: V,
        selectedViceCaptain: j,
        setGoalKeeper: h,
        setDefenders: A,
        setMidfielders: C,
        setForwards: k,
        setCaptain: M,
        setViceCaptain: T
      },
      children: /* @__PURE__ */ c.jsxs(Ct, { variant: "plain", sx: { ...Sd, mb: 20 }, children: [
        /* @__PURE__ */ c.jsxs(U, { sx: { display: "flex", justifyContent: "space-between" }, children: [
          /* @__PURE__ */ c.jsx(J, { level: "body-md", fontWeight: 700, children: e("pickYourTeam") }),
          /* @__PURE__ */ c.jsxs(J, { level: "body-md", fontWeight: "bold", mr: 1.5, children: [
            ae(),
            /* @__PURE__ */ c.jsx(J, { component: "span", fontWeight: "bold", textColor: "#999", children: "/11" })
          ] })
        ] }),
        /* @__PURE__ */ c.jsx(
          Ky,
          {
            selectedPlayersCount: ae,
            setGoalKeeper: h,
            setDefenders: A,
            setMidfielders: C,
            setForwards: k,
            setCaptain: M,
            setViceCaptain: T
          }
        ),
        /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
        /* @__PURE__ */ c.jsx($y, { currentFormation: p, setShowFormationDialog: I }),
        /* @__PURE__ */ c.jsx(
          Gy,
          {
            position: R,
            setPosition: B,
            deselectPlayer: D,
            changeFormation: q,
            captain: V,
            viceCaptain: j,
            onOpenCaptainSelection: () => l(!0)
          }
        ),
        /* @__PURE__ */ c.jsx(tA, { open: n, onClose: () => o(!1) }),
        /* @__PURE__ */ c.jsx(
          Py,
          {
            makePrediction: se,
            selectedPlayersCount: ae,
            openPlayerSelectionModal: () => r(!0),
            isPastGameWeek: id(O, Lt(G), G),
            onOpenDeleteConfirmation: () => i(!0),
            openCaptainSelectionModal: () => l(!0),
            captain: V,
            viceCaptain: j,
            isSaving: d
          }
        ),
        /* @__PURE__ */ c.jsx(
          Vy,
          {
            changeFormation: q,
            showFormationDialog: S,
            setShowFormationDialog: I,
            changeFormationConfirmation: w,
            setChangeFormationConfirmation: P,
            desiredFormation: E,
            deselectPlayer: D
          }
        ),
        /* @__PURE__ */ c.jsx(
          Od,
          {
            position: R,
            setPosition: B,
            modalOpen: t,
            controlModalState: r,
            defendersCount: br("defender", p),
            midfieldersCount: br("midfielder", p),
            forwardsCount: br("forward", p)
          }
        ),
        /* @__PURE__ */ c.jsx(
          Ey,
          {
            open: a,
            onClose: () => i(!1),
            onConfirm: W
          }
        ),
        /* @__PURE__ */ c.jsx(
          _y,
          {
            open: s,
            onClose: () => l(!1),
            players: ce(),
            onSelectCaptain: Q,
            onSelectViceCaptain: $,
            captain: V,
            viceCaptain: j
          }
        ),
        /* @__PURE__ */ c.jsx(
          db,
          {
            open: ie.open,
            onClose: () => le({ open: !1, message: "" }),
            color: "danger",
            variant: "soft",
            autoHideDuration: 6e3,
            anchorOrigin: { vertical: "bottom", horizontal: "center" },
            children: ie.message
          }
        )
      ] })
    }
  );
}, nA = ({ currentGameWeek: e, setSelectedGameWeek: t }) => {
  const r = Be(), n = ue(Dr), { template: o } = ld(n);
  return /* @__PURE__ */ c.jsxs(Ct, { variant: "plain", sx: Sd, children: [
    /* @__PURE__ */ c.jsx(U, { sx: { display: "flex", justifyContent: "space-between" }, children: /* @__PURE__ */ c.jsx(J, { level: "body-md", fontWeight: 700, children: r("matchweekNotActive") }) }),
    /* @__PURE__ */ c.jsx(Ne, { inset: "context", sx: { bgcolor: "#f2f2f2" } }),
    /* @__PURE__ */ c.jsxs(U, { mb: 2, children: [
      /* @__PURE__ */ c.jsx(J, { sx: { mb: 2 }, children: r("gameWeekNotActiveMessage") }),
      /* @__PURE__ */ c.jsxs(
        ge,
        {
          variant: "outlined",
          color: "primary",
          onClick: () => {
            t(e || {}, o);
          },
          children: [
            r("goBackTo"),
            " ",
            e == null ? void 0 : e.label
          ]
        }
      )
    ] })
  ] });
}, oA = ({ setSelectedGameWeek: e }) => {
  const { template: t, templateGroupMatches: r } = ue(St), { selectedGameWeek: n, isNavigating: o } = ue(Ft), { earliestKickOff: a, currentGW: i, isSelectedGameWeekInFuture: s } = yr(() => {
    var f, g;
    const d = r != null && r.length ? new Date(Ra(r)) : void 0, u = Lt(t), p = (f = n == null ? void 0 : n.filters) != null && f.fromDate && ((g = u == null ? void 0 : u.filters) != null && g.toDate) ? new Date(n.filters.fromDate) > new Date(u.filters.toDate) : !1;
    return {
      earliestKickOff: d,
      currentGW: u,
      isSelectedGameWeekInFuture: p
    };
  }, [t, r, n]);
  return !!!a || o ? /* @__PURE__ */ c.jsx(Cd, {}) : /* @__PURE__ */ c.jsxs(U, { children: [
    /* @__PURE__ */ c.jsx(
      xd,
      {
        currentGameweekLabel: (n == null ? void 0 : n.label) ?? "",
        timeLeft: S2(a.toISOString()),
        deadline: od(a)
      }
    ),
    s ? /* @__PURE__ */ c.jsx(nA, { currentGameWeek: i, setSelectedGameWeek: e }) : /* @__PURE__ */ c.jsx(rA, {})
  ] });
}, aA = () => {
  const e = Be(), t = ue(Dr), {
    template: r,
    templateMatches: n,
    templatePlayerPoints: o,
    templateGroupMatches: a,
    selectedGameWeek: i,
    setSelectedGameWeek: s,
    selectedGameWeekPrediction: l,
    refreshPrediction: d,
    isLoaded: u,
    isNavigating: p
  } = ld(t), f = yr(() => {
    const C = new Date(Ra(a));
    return od(C);
  }, [a]), g = Lt(r, n), h = id(i, g, r), m = i && ad(i, n), A = yr(() => {
    if (!(a != null && a.length)) return !1;
    const C = new Date(Ra(a));
    return /* @__PURE__ */ new Date() >= C;
  }, [a]), b = () => u ? !i || Object.keys(i).length === 0 : !1;
  return /* @__PURE__ */ c.jsx(St.Provider, { value: { template: r, templateMatches: n, templateGroupMatches: a, templatePlayerPoints: o }, children: /* @__PURE__ */ c.jsx(
    Ft.Provider,
    {
      value: { selectedGameWeek: i, selectedGameWeekPrediction: l, refreshPrediction: d, isNavigating: p },
      children: /* @__PURE__ */ c.jsxs(U, { sx: { overflowY: "scroll", p: 1.5, bgcolor: "#efefef", height: "100vh" }, children: [
        !b() && /* @__PURE__ */ c.jsx(ly, { setSelectedGameWeek: s }),
        b() ? /* @__PURE__ */ c.jsxs(U, { bgcolor: "#fff", borderRadius: "lg", p: 2, textAlign: "center", children: [
          /* @__PURE__ */ c.jsx(J, { level: "h3", sx: { mb: 2 }, children: e("seasonComplete") }),
          /* @__PURE__ */ c.jsx(J, { level: "h4", children: e("checkFinalStandings") })
        ] }) : h ? l ? /* @__PURE__ */ c.jsx(bl, {}) : /* @__PURE__ */ c.jsx(vl, { deadline: f }) : m && A ? l ? /* @__PURE__ */ c.jsx(bl, {}) : /* @__PURE__ */ c.jsx(vl, { deadline: f }) : /* @__PURE__ */ c.jsx(oA, { setSelectedGameWeek: s })
      ] })
    }
  ) });
}, iA = tr({}), sA = ({ country: e, children: t }) => /* @__PURE__ */ c.jsx(iA.Provider, { value: { country: e }, children: t });
function lA({
  fansUnitedSDK: e,
  mainBoxBorder: t,
  mainBoxBorderRadius: r,
  mainBoxBorderColor: n,
  mainBoxMargin: o,
  mainBoxPadding: a,
  mainBoxBackgroundColor: i,
  gameTemplateId: s,
  country: l,
  language: d
}) {
  return window.fuSDK = e, window.fuSDK ? /* @__PURE__ */ c.jsx(x2, { language: d, children: /* @__PURE__ */ c.jsx(sA, { country: l, children: /* @__PURE__ */ c.jsx(Dr.Provider, { value: s ?? C2("VITE_GAME_TEMPLATE_ID"), children: /* @__PURE__ */ c.jsx(
    U,
    {
      m: o,
      p: a,
      border: t,
      borderColor: n,
      borderRadius: r,
      bgcolor: i,
      children: /* @__PURE__ */ c.jsx(aA, {})
    }
  ) }) }) }) : (console.warn("Fans United SDK not found! Returning nothing."), /* @__PURE__ */ c.jsx(c.Fragment, {}));
}
const cA = gc({
  fontFamily: {
    display: 'InterFace, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
    body: 'Roboto, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif'
  },
  colorSchemes: {
    light: {
      palette: {
        primary: {
          50: "#E6F5E6",
          100: "#CCEACC",
          200: "#99D699",
          300: "#66C166",
          400: "#33AD33",
          500: "#008300",
          600: "#006900",
          700: "#004F00",
          800: "#003400",
          900: "#001A00"
        },
        neutral: {
          50: "#F6F6F6",
          100: "#EEEEEE",
          200: "#DDDDDD",
          300: "#CCCCCC",
          400: "#999999",
          500: "#666666",
          600: "#555555",
          700: "#444444",
          800: "#333333",
          900: "#222222"
        }
      }
    },
    dark: {
      palette: {
        primary: {
          50: "#E6F6E9",
          100: "#CCEED4",
          200: "#99DCA8",
          300: "#66CB7D",
          400: "#33B951",
          500: "#00A826",
          600: "#00861E",
          700: "#006517",
          800: "#00430F",
          900: "#002208"
        },
        neutral: {
          50: "#F6F6F6",
          100: "#EEEEEE",
          200: "#DDDDDD",
          300: "#CCCCCC",
          400: "#999999",
          500: "#666666",
          600: "#555555",
          700: "#444444",
          800: "#333333",
          900: "#222222"
        }
      }
    }
  },
  shadow: {},
  typography: {
    h1: {
      fontFamily: 'InterFace, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    },
    h2: {
      fontFamily: 'InterFace, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    },
    h3: {
      fontFamily: 'InterFace, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    },
    h4: {
      fontFamily: 'InterFace, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif'
    }
  }
}), uA = ({
  fansUnitedSDK: e,
  mainBoxBorder: t,
  mainBoxBorderRadius: r,
  mainBoxBorderColor: n,
  mainBoxMargin: o,
  mainBoxPadding: a,
  mainBoxBackgroundColor: i,
  contentId: s,
  country: l
}) => /* @__PURE__ */ c.jsx(vn.StrictMode, { children: /* @__PURE__ */ c.jsxs(Jg, { theme: cA, children: [
  /* @__PURE__ */ c.jsx(_v, {}),
  /* @__PURE__ */ c.jsx(
    lA,
    {
      fansUnitedSDK: e,
      mainBoxBackgroundColor: i,
      mainBoxBorder: t,
      mainBoxBorderRadius: r,
      mainBoxBorderColor: n,
      mainBoxMargin: o,
      mainBoxPadding: a,
      contentId: s,
      country: l
    }
  )
] }) });
export {
  uA as default
};
